(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms',
            [
                // 3rd Party Dependencies
                'angular-bind-html-compile',
                'ui.mask',
                'xeditable',
                'nvd3',
                'datatables',
                'flow'
            ]
        )
        .run(function(editableOptions) {
            editableOptions.theme = 'bs3';
        })
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.my-company_my-forms', {
                url      : '/my-company/:companyKey/my-forms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/my-forms/my-forms.html',
                        controller : 'MyFormsController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    companyKey: function ($stateParams)
                    {
                        return ($stateParams.companyKey);
                    }
                },
                bodyClass: 'my-forms'
            })
            .state('app.my-company_my-forms.detail', {
                abstract: true,
                url      : '/:designFormKey',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/myform.html',
                        controller : 'MyFormController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: function ($stateParams)
                    {
                        return ($stateParams);
                    }
                },
                bodyClass: 'my-form'
            })
            .state('app.my-company_my-forms.detail.main', {
                url      : '/main',
                views    : {
                    'main': {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/main/myformmain.html',
                        controller : 'MyFormController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: ['$stateParams', function($stateParams) {
                        return ($stateParams);
                    }]
                },
                bodyClass: 'my-form'
            })
            .state('app.my-company_my-forms.detail.users', {
                url      : '/users',
                views    : {
                    'users': {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/users/myformusers.html',
                        controller : 'MyFormUsersController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: ['$stateParams', function($stateParams) {
                        return ($stateParams);
                    }]
                },
                bodyClass: 'my-form-users'
            })
            .state('app.my-company_my-forms.detail.design', {
                url      : '/design',
                views    : {
                    'design': {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/design/myformdesign.html',
                        controller : 'MyFormDesignController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: ['$stateParams', function($stateParams) {
                        return ($stateParams);
                    }]
                },
                bodyClass: 'my-form-design'
            })
            .state('app.my-company_my-forms.detail.process', {
                url      : '/process',
                views    : {
                    'process': {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/process/myformprocess.html',
                        controller : 'MyFormProcessController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: ['$stateParams', function($stateParams) {
                        return ($stateParams);
                    }]
                },
                bodyClass: 'my-form-process'
            })
            .state('app.my-company_my-forms.detail.submissions', {
                url      : '/submissions',
                views    : {
                    'content@app' : {
                        templateUrl: 'app/main/apps/my-company/my-forms/views/form/submissions/myformsubmissions.html',
                        controller : 'MyFormSubmissionsController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }],
                    statePrm: ['$stateParams', function($stateParams) {
                        return ($stateParams);
                    }]
                },
                bodyClass: 'my-form-submissions'
            })

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormViewDialogController', MyFormViewDialogController);

    /** @ngInject */
    function MyFormViewDialogController($mdDialog, $mdToast, $timeout, formInfo, nfviewForm)
    {
        var vm = this;
        vm.title = formInfo.DesignFormName+' ('+formInfo.FormKey+')';
        var formItems=[];
        vm.formItems=formItems;

        // Methods
        vm.closeDialog = closeDialog;
        //

        showForm();
        
        function showForm() {
            firebase.database().ref('/FormItems/' + formInfo.FormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                            '<label>{{item.LabelText}}</label>' +
                                            '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                            '<div ng-messages="viewForm.' + formdivId + '.$error">' +
                                                '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                                '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                            '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: value, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Value: value, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        var optSelected = data.Options[key].Selected;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq, Selected: optSelected});
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                            '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" '+
                                                'aria-label="opt.Value" '+
                                                'ng-checked="opt.Selected">{{opt.Value}}'+
                                            '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var fileName = data.FileName;
                                    var fileURL = data.FileURL;
                                    var element = ''+
                                        '<div>'+
                                            '<md-button class="md-icon-button" aria-label="attach file" ng-disabled>'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label>{{item.FileName}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="item.FileURL" class="md-icon-button md-primary" aria-label="remove" ng-href="{{item.FileURL}}" target="_blank">'+
                                                '<md-icon md-font-icon="icon-download"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, FileName: fileName, FileURL: fileURL });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate==null) {
                                        var maxDate=null;
                                    } else {
                                        var maxDate=data.MaxDate;
                                    }
                                    if (data.minDate==null) {
                                        var minDate=null;
                                    } else {
                                        var minDate=data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var timeValue= new Date(value);
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: timeValue, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required">' +
                                        '<span translate="MF.REQUIRED">Required</span>' +
                                        '</div>' +
                                        '<div ng-message="pattern">' +
                                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead><tr><th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th></tr></thead>';
                                    var tbody = '<tbody>'+
                                                    '<tr ng-repeat="row in item.Rows track by $index">'+
                                                        '<td ng-repeat="col in row.Cols">' +
                                                            '<input ng-value="col.Value">' +
                                                        '</td>'+
                                                    '</tr>'+
                                                '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, RowCounter: rowCounter, Columns: columns, Rows:rows, ColCounter: colCounter });
                                    break;
                            }

                        });
                    });
                });
        };


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormUsersController', MyFormUsersController);

    /** @ngInject */
    function MyFormUsersController($scope, $state, $timeout, $mdDialog, $document, $mdToast, $translate, $firebaseArray, statePrm, formatTimeStamp)
    {
        var vm = this;

        // Methods
        vm.formatDate=formatDate;
        vm.filterChange = filterChange;
        vm.openAddUserDialog=openAddUserDialog;
        vm.deleteUserConfirm = deleteUserConfirm;

        //////////
        var designFormKey=statePrm.designFormKey;
        var companyKey=statePrm.companyKey;



        // firebase//
        vm.filterIds = null;
        vm.listOrderAsc = false;
        //vm.users=[];
        vm.selectedUsers = [];

        var db=firebase.database();
        var ref=db.ref('/DesignForm/'+companyKey+'/'+designFormKey+'/Users');

        vm.users = $firebaseArray(ref);

        //format date
        function formatDate(date) {
            return formatTimeStamp.format(date);
        };

        $scope.$on("$destroy", function() {
            vm.users.$destroy();
        });

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }

            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.userIds;
            }

            vm.selectedUsers = [];

        }

        /**
         * Delete User Confirm Dialog
         */
        function deleteUserConfirm(user, ev)
        {
			var title = $translate.instant('MF.USER_DELETE_CONFIRM');
			var textContent = $translate.instant('MF.USER_DELETE_CONFIRM_MSG');

            var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent('<b>' + user.Email + '</b>' +textContent )
                .ariaLabel('delete user')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                vm.users.$remove(user)
                    .then(function (ref) {
                        var textContent = $translate.instant('MF.USER_DELETED');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(1000)
                                .position('top right')
                        );
                    })
                    .catch(function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Error:' + error)
                                .hideDelay(1000)
                                .position('top right')
                        );
                    });
            }, function ()
            {
                //md dialog cancelled
            });
        }


        /**
         * Open new user dialog
         *
         * @param ev
         */
        function openAddUserDialog(ev)
        {
            $mdDialog.show({
                controller         : 'AddUserDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/myform/adduser-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    //
                }
            }).then(function(newUser) {

                function userExists(email) {
                    var count=vm.users.length;
                    for (var i=0;i<count;i++) {
                        if(vm.users[i].Email===email) {return true;}
                    }
                    return false;
                }

                if (userExists(newUser)) {
                    var title = $translate.instant('MF.USER_EXISTS');
                    var textContent = $translate.instant('MF.USER_EXISTS_MSG');
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#my-form')))
                            .clickOutsideToClose(true)
                            .title(title)
                            .textContent('"' + newUser + '" ' + textContent)
                            .ariaLabel('Form User Alert')
                            .ok('OK')
                            .targetEvent(ev)
                    );
                } else {
                    vm.users.$add({ 'Email': newUser })
                        .then(function() {
                            var textContent = $translate.instant('MF.USER_ADDED');
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(textContent)                       
                                .hideDelay(1000)
                                .position('top right')
                            );
                        }).catch(function(error) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent('Error:'+error)                       
                                .hideDelay(1000)
                                .position('top right')
                            );
                        });
                }

            }, function() {
                
            });
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormSubmissionsController', MyFormSubmissionsController);

    /** @ngInject */
    function MyFormSubmissionsController($mdSidenav, $state, $timeout, $mdDialog, $document, $mdToast, statePrm, formatTimeStamp)
    {
        var vm = this;

        //firebase
        var db=firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        ///

        var formSubmissions = [];
        var formUsers = {};
        var formTransactions = {};
        var designFormKey=statePrm.designFormKey;
        var companyKey=statePrm.companyKey;
        //

        loadDesignFormData();

        function loadDesignFormData() {
            db.ref('/DesignForm/' + companyKey +'/'+ designFormKey).once('value', function (snapshot) {
                $timeout(function () {
                    vm.designForm = snapshot.val();
                });
            }).then(function () {
                loadFormSubmissions();
            })
        };

        function loadFormSubmissions() {
            var formRef = db.ref('/Form/' + companyKey + '/' + designFormKey);
            formRef.once('value', function (snap) {
                snap.forEach(function (formSnap) {
                    var formKey = formSnap.key;
                    var formUserUID = formSnap.val().UID;
                    var dateCreated = formSnap.val().DateCreated;
                    var designFormName= formSnap.val().DesignFormName;
                    var status= formSnap.val().Status;
                    var userName = '';
                    if (!formUsers.formUserUID) {
                        loadFormUser(formUserUID)
                            .then(function (response) {
                                userName = response.DisplayName;
                                pushData();
                            });
                    } else {
                        userName=formUsers.formUserUID.DisplayName;
                    }

                    function pushData() {
                        $timeout(function () {
                            formSubmissions.push(
                                {
                                    "FormKey": formKey,
                                    "DesignFormKey": designFormKey,
                                    "DesignFormName": designFormName,
                                    "UserName": userName,
                                    "Status": status,
                                    "DateCreated": dateCreated
                                });
                        });                        
                    };
                });
            });
        };

        function loadFormUser(formUserUID) {
            return new Promise(function(resolve, reject) {
                db.ref('/Users/').child(formUserUID)
                .once('value', function (userSnap) {
                    var displayName = userSnap.val().DisplayName;
                    var photoURL = userSnap.val().Photo.PhotoURL;
                    formUsers[formUserUID]={};
                    formUsers[formUserUID]["DisplayName"]=displayName;
                    formUsers[formUserUID]["PhotoURL"]=photoURL;
                    resolve(formUsers[formUserUID]);
                });
            });
        };




        // Data
        vm.showDetails = true;

        vm.formSubmissions = formSubmissions;
        vm.formTransactions = formTransactions;
        vm.selected = vm.formSubmissions[0];


        // Methods

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;
        vm.gotoForms=gotoForms;
        vm.openViewFormDialog=openViewFormDialog;

        //////////


        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
            if (!formTransactions[item.FormKey]) {
                loadFormTransactions(item.DesignFormKey, item.FormKey);
            }
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('process-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };


        /**
         * Go to forms page
         */
        function gotoForms()
        {
            $state.go('app.my-company_my-forms');
        }


        /**
         * Open new form dialog
         *
         * @param ev
         */
        function openAddFormDialog(ev)
        {
            $mdDialog.show({
                controller         : 'MyFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/myform/myform-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    UID : UID
                }
            });
        };


        /**
         * Open new form dialog
         *
         * @param ev
         */
        function openViewFormDialog(item,ev)
        {
            vm.selected = item;
            $mdDialog.show({
                controller         : 'MyFormViewDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/views/form/submissions/dialog/myformview-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    formInfo :   vm.selected
                }
            });
        };

        function loadFormTransactions(designFormKey, formKey) {
            db.ref('/FormTransactions/' + designFormKey + '/' + formKey).once('value', function (snap) {
                snap.forEach(function(snapTransaction){
                    var data=snapTransaction.val();
                    var dateTime=data.DateTime,
                        action=data.Action,
                        formUserUID=data.UID;
                        vm.formTransactions[formKey] = [];

                    if (!formUsers.formUserUID) {
                        loadFormUser(formUserUID)
                            .then(function (response) {
                                var userName = response.DisplayName;
                                var photoURL = response.PhotoURL;
                                $timeout(function () {
                                    vm.formTransactions[formKey].push({'DateTime': dateTime, 'Action': action, 'UserName': userName, 'PhotoURL': photoURL});
                                });
                            });
                    } else {
                        var userName = formUsers.formUserUID.DisplayName;
                        $timeout(function () {
                            vm.formTransactions[formKey].push({'DateTime':dateTime, 'Action':action, 'UserName': userName, 'PhotoURL': photoURL});
                        });
                    }
                })
            })
        };




    }

})();
(function () {
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormProcessController', MyFormProcessController);       

    /** @ngInject */
    function MyFormProcessController($scope, $state, $timeout, $mdDialog, $document, $mdToast, $translate, $mdSidenav, statePrm) {
        var vm = this;
        // Methods
        vm.startFirstProcess = startFirstProcess;
        vm.addApprovalDialog = addApprovalDialog;
        vm.editApprovalDialog = editApprovalDialog;
        vm.deleteObjectDialog = deleteObjectDialog;
        vm.addTerminationDialog = addTerminationDialog;
        vm.changeProcessStatus=changeProcessStatus;
        vm.gotoFormUsers=gotoFormUsers;
        vm.saveProcess = saveProcess;
        
        //firebase
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var db=firebase.database();
        ///

        var designFormKey=statePrm.designFormKey;
        var companyKey=statePrm.companyKey;

        var chart;
        var nodeCounter=0;
        vm.formUsers=[];
        var dataObj={};
        $scope.dataObj=dataObj;
        var chartData;

        loadUsers().then(function (n) {
            vm.isUserExist=true;
            vm.isProcessAllowed=false;
            checkProcessExist();
            //load google charts
            google.charts.load('current', { packages: ["orgchart"] });
            google.charts.setOnLoadCallback(drawChart);
        }, function (err) {
            vm.isUserExist=false;
            vm.isProcessAllowed=false;
        });

        function checkProcessExist() {
            db.ref('/Process/'+companyKey+'/'+designFormKey).once('value', function(snap){
                if(snap.val()) {
                    var data=snap.val();
                    nodeCounter=data.NodeCounter;

                    $timeout(function () {
                        vm.processActive=data.Active;
                        vm.isProcessAllowed=true;
                        vm.isProcessExist=true;
                        if (vm.processActive) {
                            vm.processStatusMsg='online';
                        } else {
                            vm.processStatusMsg='offline';
                        }
                    });
                } else {
                    $timeout(function () {
                        vm.processStatusMsg='offline';
                        vm.isProcessAllowed=false;
                        vm.isProcessExist=false;
                    });
                }
            });
        };

        function startFirstProcess() {
            $timeout(function () {
                vm.isProcessExist=true;
                vm.isProcessAllowed=true;
                vm.processActive=false;
            });
            chartData = new google.visualization.DataTable();
            chartData.addColumn('string', 'Name');
            chartData.addColumn('string', 'Manager');

            dataObj['0'] = { 'Type': 'Submission', 'UserEmail': 'New Form'};
            chartData.addRows([
                [{ v: '0', f: 'New Form' },
                    '']
            ]);

            chart = new google.visualization.OrgChart(document.getElementById('chart_div'));
            chart.draw(chartData, { allowHtml: true });
            google.visualization.events.addListener(chart, 'select', selectHandler);

            function selectHandler() {
                var selectedItem = chart.getSelection()[0];
                if (selectedItem) {
                    var value = chartData.getValue(selectedItem.row, 0);
                    var row = selectedItem.row;
                    var type = dataObj[value].Type;
                    $timeout(function () {
                        vm.selectedNode =
                            {
                                'row'   : row,
                                'value' : value,
                                'type'  : type         
                            };
                    });
                } else {
                    $timeout(function () {
                        vm.selectedNode = null;
                    });
                }
            };
        };

        function loadUsers() {
            return new Promise(function(resolve, reject) {
                db.ref('/DesignForm/'+companyKey+'/'+designFormKey+'/Users').once('value', function(snap){
                    var n=snap.numChildren();
                    if (n>0) {
                        var counter=0;
                        snap.forEach(function (userSnap) {
                            var key = userSnap.val().UID;
                            var email = userSnap.val().Email;
                            db.ref('/Users/'+key+'/Photo/PhotoURL').once('value', function(photoSnap){
                                var photoURL = photoSnap.val();
                                if (!photoURL) {
                                    photoURL="assets/images/etc/blank-profile-picture.jpg"
                                }
                                vm.formUsers.push({"Key":key, "Email":email, "PhotoURL":photoURL});
                                counter++;
                                if (counter>=n) {resolve(n);}
                            });
                        });
                    } else {
                        reject(Error("AN ERROR"));
                    }
                });
            });
        };

        function loadProcess() {
            return new Promise(function(resolve, reject) {
                db.ref('/Process/'+companyKey+'/'+designFormKey+'/Nodes').once('value', function(snap){
                    var n=snap.numChildren();
                    var counter=0;                    
                    snap.forEach(function (processNode) {
                        var key = processNode.key;
                        var data = processNode.val();
                        var type = data.Type;

                        if (type=='Submission') {
                            dataObj[key]={'Type':'Submission', 'UserEmail': 'New Form'};
                            chartData.addRows([
                                [{v:key, f:'New Form'},
                                '']
                            ]);
                            counter++;
                            if (counter>=n) {resolve();}
                        }

                        if (type=='Approval') {
                            var photoURL=vm.formUsers.getByEmail(data.UserEmail).PhotoURL;
                            dataObj[key]={'Type':'Approval','ParentName':data.ParentName.toString(),'ParentAction':data.ParentAction,'UserEmail':data.UserEmail, 'UserKey': data.UserKey};
                            chartData.addRows([
                                [{v:key, f:''+
                                    '<div class="approval-option">'+data.ParentAction+'</div>'+
                                        '<div class="approval-node"> #'+key+
                                            '<div class="user-container">'+
                                                '<img src="'+photoURL+'"></img>'+
                                            '<div class="user-email">'+data.UserEmail+'</div>'+
                                        '</div>'+
                                    '</div>'},
                                ''+data.ParentName+'']
                            ]);
                            counter++;
                            if (counter>=n) {resolve();}                            
                        }

                        if (type=='Termination') {
                            var imgURL="assets/images/etc/finish-flag.png";
                            dataObj[key]={'Type':'Termination','ParentName':data.ParentName.toString(),'ParentAction':data.ParentAction,'UserEmail':'Termination'};
                            chartData.addRows([
                                [{v:key, f:''+
                                '<div class="approval-option">' + data.ParentAction + '</div>' +
                                    '<div class="approval-node"> #' + key +
                                        '<div class="user-container">' +
                                            '<img src="' + imgURL + '"></img>' +
                                        '<div class="user-email">Termination</div>' +
                                    '</div>' +
                                '</div>'},
                                ''+data.ParentName+'']
                            ]);
                            counter++;
                            if (counter>=n) {resolve();}                            
                        }

                    });
                });
            });
        };

        function drawChart() {
            chartData = new google.visualization.DataTable();
            chartData.addColumn('string', 'Name');
            chartData.addColumn('string', 'Manager');

            loadProcess().then(function() {
                chart = new google.visualization.OrgChart(document.getElementById('chart_div'));
                chart.draw(chartData, { allowHtml: true });
                google.visualization.events.addListener(chart, 'select', selectHandler);

                function selectHandler() {
                    var selectedItem = chart.getSelection()[0];
                    if (selectedItem) {
                        var value = chartData.getValue(selectedItem.row, 0);
                        var row = selectedItem.row;
                        var type = dataObj[value].Type;
                        $timeout(function () {
                            vm.selectedNode =
                                {
                                    'row'   : row,
                                    'value' : value,
                                    'type'  : type         
                                };
                        });
                    } else {
                        $timeout(function () {
                            vm.selectedNode = null;
                        });
                    }
                };
            });
        };

        function updateChart() {
            var rc=chartData.getNumberOfRows();
            chartData.removeRows(0, rc);
            for (var index in dataObj) { 
                if (dataObj.hasOwnProperty(index)) {
                    var item = dataObj[index];
                    var x=index.toString();
                    if (item.Type == 'Submission') {
                        chartData.addRows([
                            [{ v: x, f: 'New Form' },
                                '']
                        ]);
                    } else if (item.Type == 'Approval') {
                        var photoURL = vm.formUsers.getByEmail(item.UserEmail).PhotoURL;
                        chartData.addRows([
                            [{
                                v: x, f: '' +
                                    '<div class="approval-option">' + item.ParentAction + '</div>' +
                                        '<div class="approval-node">' + index +
                                            '<div class="user-container">' +
                                                '<img src="' + photoURL + '"></img>' +
                                            '<div class="user-email">' + item.UserEmail + '</div>' +
                                        '</div>' +
                                    '</div>'
                            },
                            '' + item.ParentName + '']
                        ]);
                    } else if (item.Type == 'Termination') {
                        var imgURL="assets/images/etc/finish-flag.png";
                        chartData.addRows([
                            [{
                                v: x, f: '' +
                                '<div class="approval-option">' + item.ParentAction + '</div>' +
                                    '<div class="approval-node">' + index +
                                        '<div class="user-container">' +
                                            '<img src="' + imgURL + '"></img>' +
                                        '<div class="user-email">Termination</div>' +
                                    '</div>' +
                                '</div>'
                            },
                            '' + item.ParentName + '']
                        ]);
                    }
                }
            };

            chart.draw(chartData, { allowHtml: true });
            chart.setSelection(null);
            vm.selectedNode = null;
        };

        function changeProcessStatus(status) {
            if (status==true) {
                vm.processStatusMsg='online';
            } else {
                vm.processStatusMsg='offline';
            }
        };

        function gotoFormUsers() {
            $state.go('app.my-company_my-forms.detail.main', {id: designFormKey});
        };


       /**
         * Array prototype
         *
         * Get by email
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getByEmail = function (value)
        {
            return this.filter(function (x)
            {
                return x.Email === value;
            })[0];
        }

        /**
         * Array prototype
         *
         * Get by name
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getByName = function (value)
        {
            return this.filter(function (x)
            {
                return x.Name === value;
            })[0];
        }

        /**
         * Open new approval node dialog
         *
         * @param ev
         */
        function addApprovalDialog(ev) {
            if (!vm.selectedNode) {
                return;
            }

            var len=Object.keys(dataObj).length;

            $mdDialog.show({
                controller         : 'AddApprovalDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/add-approval/add-approval-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    designFormKey   : designFormKey,
                    formUsers       : vm.formUsers,
                    parentName      : vm.selectedNode.value,
                    parentUserEmail : dataObj[vm.selectedNode.value].UserEmail
                }
            })
            .then(function(newNode) {
                var counter=0;
                var duplicate=false;
                for (var index in dataObj) {
                    if (dataObj.hasOwnProperty(index)) {
                        counter++;
                        if (dataObj[index].ParentName==vm.selectedNode.value && dataObj[index].ParentAction==newNode.parentAction) {
                            duplicate=true;
                        }
                        if (counter==len) {
                            if (duplicate==true) {
                                duplicateProcessDialog(ev, newNode, 'Approval', true);
                            } else {
                                addApprovalObject(newNode, false);
                            }
                        } 
                    }
                };

            }, function() {

            });
        };

        function addApprovalObject(newNode, duplicate) {

            if (duplicate==true) {
                var parentAction=newNode.parentAction;
                check(newNode.parentName, parentAction)

                function check(itemName, action) {
                    for (var index in dataObj) {
                        if (dataObj.hasOwnProperty(index)) {
                            if (dataObj[index].ParentName==itemName) {
                                if (dataObj[index].ParentAction==action) {
                                    delete dataObj[index];
                                    check(index, null);
                                } else {
                                    if (action==null) {
                                        delete dataObj[index];
                                        check(index, null);
                                    }
                                }
                            } 
                        }
                    };  
                }
            }

            nodeCounter++;
            var key=nodeCounter.toString();
            dataObj[key] =
                {
                    'Type': 'Approval',
                    'ParentName': vm.selectedNode.value,
                    'ParentAction': newNode.parentAction,
                    'UserEmail': newNode.selectedUser.Email,
                    'UserKey': newNode.selectedUser.Key
                }
            vm.selectedNode = null;
            updateChart(); 
        };

        function duplicateProcessDialog(ev, newNode, objType, isNew) {
            $mdDialog.show({
                controller         : 'DuplicateProcessDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/duplicate-process/duplicate-process-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    newNode   : newNode
                }
            })
            .then(function(result) {
                if (isNew==true) {
                    if (objType=='Approval') {
                        addApprovalObject(newNode, true);
                    } else if (objType=='Termination') {
                        addTerminationObject(newNode, true);
                    }
                } else {
                    if (objType=='Approval') {
                        editApprovalObject(newNode, true);
                    } else if (objType=='Termination') {
                        editTerminationObject(newNode, true);
                    }                   
                }

            }, function() {

            });
        };

        function deleteObjectDialog(ev) {
            if (!vm.selectedNode) {
                return;
            };

            var childObjects={};

            checkParent(vm.selectedNode.value);

            function checkParent(prname) {
                for (var index in dataObj) {
                    if (dataObj.hasOwnProperty(index)) {
                        var item = dataObj[index];
                        if (item.ParentName == prname) {
                            childObjects[index]=dataObj[index];
                            checkParent(index);
                        }
                    }
                };
            };

            $mdDialog.show({
                controller         : 'DeleteObjectDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/delete-object/delete-object-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    selectedObj : dataObj[vm.selectedNode.value],
                    selectedKey : vm.selectedNode.value,
                    childObjects: childObjects
                }
            })
            .then(function(result) {

                delete dataObj[vm.selectedNode.value];

                if (result=='all') {
                    for (var index in childObjects) {
                        if (childObjects.hasOwnProperty(index)) {
                            delete dataObj[index];
                        }
                    };
                } else {
                    for (var index in childObjects) {
                        if (childObjects.hasOwnProperty(index)) {
                            dataObj[index].ParentName='';
                            dataObj[index].ParentAction='';
                        }
                    };                    
                }

                chartData.og.forEach(function (item) {
                    if (item.c[1].v == vm.selectedNode.value) {
                        item.c[1].v = '';
                    }
                });

                updateChart();

                //chartData.removeRow(vm.selectedNode.row);

                //chart.draw(chartData, { allowHtml: true });
                //chart.setSelection(null);
                vm.selectedNode = null;

            }, function() {
                
            });
        };

        /**
         * Open edit approval dialog
         *
         * @param ev
         */
        function editApprovalDialog(ev) {
            if (!vm.selectedNode) {
                return;
            }

            var parentName=dataObj[vm.selectedNode.value].ParentName;
            var parentAction=dataObj[vm.selectedNode.value].ParentAction;
            var userEmail=dataObj[vm.selectedNode.value].UserEmail;
            var allowedObjects=angular.copy(dataObj);
            var type= vm.selectedNode.type;
            delete allowedObjects[vm.selectedNode.value];

            //if (vm.selectedNode.type=='Termination') {
                //delete allowedObjects[0];
            //}

            checkParent(vm.selectedNode.value);

            function checkParent(prname) {
                for (var index in dataObj) { 
                    if (dataObj.hasOwnProperty(index)) {
                        var item = dataObj[index];
                        if (item.Type=='Termination') {
                            delete allowedObjects[index];
                        } else if (item.ParentName==prname) {
                            delete allowedObjects[index];
                            checkParent(index);
                        }
                    }
                };
            };

            $mdDialog.show({
                controller         : 'EditApprovalDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/edit-approval/edit-approval-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    parentName     : parentName,
                    parentAction   : parentAction,
                    userEmail      : userEmail,
                    allowedObjects : allowedObjects,
                    formUsers      : vm.formUsers,
                    type           : type
                }
            })
            .then(function(newNode) {
                var len=Object.keys(dataObj).length;
                var counter=0;
                var duplicate=false;
                for (var index in dataObj) {
                    if (dataObj.hasOwnProperty(index)) {
                        counter++;
                        if (dataObj[index].ParentName==newNode.parentName && dataObj[index].ParentAction==newNode.parentAction && index!=vm.selectedNode.value) {
                            duplicate=true;
                        }
                        if (counter==len) {
                            if (duplicate==true) {
                                duplicateProcessDialog(ev, newNode, 'Approval', false);
                            } else {
                                if (type == 'Approval') {
                                    editApprovalObject(newNode, false);
                                } else if (type == 'Termination') {
                                    editTerminationObject(newNode, false);
                                }
                            }
                        } 
                    }
                };

            }, function() {

            });
        };

        function editApprovalObject(newNode, duplicate) {

            if (duplicate==true) {
                var parentAction=newNode.parentAction;
                check(newNode.parentName, parentAction)

                function check(itemName, action) {
                    for (var index in dataObj) {
                        if (dataObj.hasOwnProperty(index)) {
                            if (dataObj[index].ParentName==itemName && index!=vm.selectedNode.value) {
                                if (dataObj[index].ParentAction==action) {
                                    delete dataObj[index];
                                    check(index, null);
                                } else {
                                    if (action==null) {
                                        delete dataObj[index];
                                        check(index, null);
                                    }
                                }
                            } 
                        }
                    };  
                };
            }

            var parentName=dataObj[vm.selectedNode.value].ParentName;
            var parentAction=dataObj[vm.selectedNode.value].ParentAction;
            var userEmail=dataObj[vm.selectedNode.value].UserEmail;

            if (newNode.parentName!=parentName) {
                dataObj[vm.selectedNode.value].ParentName=newNode.parentName;
            }

            if (newNode.parentAction!=parentAction) {
                dataObj[vm.selectedNode.value].ParentAction=newNode.parentAction;
            }

            if (newNode.userEmail!=userEmail) {
                dataObj[vm.selectedNode.value].UserEmail=newNode.userEmail;
                dataObj[vm.selectedNode.value].UserKey=vm.formUsers.getByEmail(newNode.userEmail).Key;
            }

            updateChart();
        };

        function editTerminationObject(newNode, duplicate) {

            if (duplicate==true) {
                var parentAction=newNode.parentAction;
                check(newNode.parentName, parentAction)

                function check(itemName, action) {
                    for (var index in dataObj) {
                        if (dataObj.hasOwnProperty(index) && index!=vm.selectedNode.value) {
                            if (dataObj[index].ParentName==itemName) {
                                if (dataObj[index].ParentAction==action) {
                                    delete dataObj[index];
                                    check(index, null);
                                } else {
                                    if (action==null) {
                                        delete dataObj[index];
                                        check(index, null);
                                    }
                                }
                            } 
                        }
                    };  
                }
            }

            var parentName=dataObj[vm.selectedNode.value].ParentName;
            var parentAction=dataObj[vm.selectedNode.value].ParentAction;
            var userEmail=dataObj[vm.selectedNode.value].UserEmail;


            if (newNode.parentName != parentName) {
                dataObj[vm.selectedNode.value].ParentName = newNode.parentName;
            }

            if (newNode.parentAction != parentAction) {
                dataObj[vm.selectedNode.value].ParentAction = newNode.parentAction;
            }

            updateChart();
        };

        /**
         * Open add Termination dialog
         *
         * @param ev
         */
        function addTerminationDialog(ev) {
            if (!vm.selectedNode) {
                return;
            }

            var len=Object.keys(dataObj).length;

            $mdDialog.show({
                controller         : 'AddTerminationDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/add-termination/add-termination-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    parentName      : vm.selectedNode.value,
                    parentUserEmail  : dataObj[vm.selectedNode.value].UserEmail
                }
            })
            .then(function(newNode) {
                var counter = 0;
                var duplicate = false;
                for (var index in dataObj) {
                    if (dataObj.hasOwnProperty(index)) {
                        counter++;
                        if (dataObj[index].ParentName == vm.selectedNode.value && dataObj[index].ParentAction == newNode.parentAction) {
                            duplicate = true;
                        }
                        if (counter == len) {
                            if (duplicate == true) {
                                duplicateProcessDialog(ev, newNode, 'Termination', true);
                            } else {
                                addTerminationObject(newNode, false);
                            }
                        }
                    }
                };

            }, function() {

            });
        };

        function addTerminationObject(newNode, duplicate) {

            if (duplicate == true) {
                var parentAction = newNode.parentAction;
                check(newNode.parentName, parentAction)

                function check(itemName, action) {
                    for (var index in dataObj) {
                        if (dataObj.hasOwnProperty(index)) {
                            if (dataObj[index].ParentName == itemName) {
                                if (dataObj[index].ParentAction == action) {
                                    delete dataObj[index];
                                    check(index, null);
                                } else {
                                    if (action == null) {
                                        delete dataObj[index];
                                        check(index, null);
                                    }
                                }
                            }
                        }
                    };
                }
            }

            nodeCounter++;
            var key = nodeCounter.toString();
            dataObj[key] =
                {
                    'Type': 'Termination',
                    'ParentName': vm.selectedNode.value,
                    'ParentAction': newNode.parentAction,
                    'UserEmail': 'Termination'
                }
            vm.selectedNode = null;
            updateChart();
        };

        function verifyProcess() {
            return new Promise(function(resolve, reject) {
                var unverified=angular.copy(dataObj);
                var len=Object.keys(dataObj).length;
                var counter=0;

                for (var index in dataObj) {
                    if (dataObj.hasOwnProperty(index)) {
                        checkObject(index);
                    }
                };

                function checkObject(index) {
                    var type=dataObj[index].Type;
                    var parent=dataObj[index].ParentName;
                    if (type=='Approval') {
                        if (dataObj[parent]) {
                            if (dataObj[parent].ParentName) {
                                delete unverified[parent];
                            } else if (dataObj[parent].Type=='Submission') {
                                delete unverified[parent];
                            } 
                        } else {
                            unverified[index].Error='No Parent';
                        }

                    } else if (type=='Termination') {
                        if (dataObj[parent]) {
                            if (dataObj[parent].ParentName) {
                                delete unverified[parent];
                            } else if (dataObj[parent].Type=='Submission') {
                                delete unverified[parent];
                            }
                            delete unverified[index];
                        } else {
                            unverified[index].Error='No Parent';
                        }
                    }
                    counter++;
                    if (counter==len) {
                        resolve(unverified);
                    }
                };
            });
        };

        function saveProcess(ev) {
            verifyProcess().then(function (result) {
                if (Object.keys(result).length == 0) {

                    var title = $translate.instant('MF.PROCESS_SAVE_CONFIRM');
                    var textContent = $translate.instant('MF.PROCESS_SAVE_CONFIRM_MSG');
                    var updateText = $translate.instant('MF.UPDATE');
        
                    var confirm = $mdDialog.confirm()
                        .title(title)
                        .htmlContent(textContent)
                        .ariaLabel('save process')
                        .targetEvent(ev)
                        .ok(updateText)
                        .cancel('CANCEL');
        
                    $mdDialog.show(confirm).then(function ()
                    {
                        processDbUpdate();
                    }, function ()
                    {
        
                    });

                } else {
                    $mdDialog.show({
                        controller         : 'VerificationWarningDialogController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/process/verification-warning/verification-warning-dialog.html',
                        parent             : angular.element(document.body),
                        targetEvent        : ev,
                        clickOutsideToClose: true,
                        locals             : {
                            unverifiedList   : result
                        }
                    })
                    .then(function(newNode) {
                        processDbUpdate();
                    }, function() {
        
                    });
                }
            }, function () {

            });

        };

        function processDbUpdate() {
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var updates = { 'NodeCounter': nodeCounter, 'Active': vm.processActive, 'LastUpdate': dateNow, 'Nodes': dataObj }
            var ref = db.ref('/Process/' + companyKey + '/' + designFormKey);
            ref.update(updates)
                .then(function () {
                    var textContent = $translate.instant('MF.PROCESS_SAVED');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(textContent)
                            .hideDelay(1000)
                            .position('top right')
                    );
                })
                .catch(function (error) {
                    var textContent = $translate.instant('MF.ERROR');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(textContent + ': ' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                });
        };

    }



})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        
        .directive('nftextValue', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container md-no-float class="md-block">'+
                    '<label translate="MF.TEXT">Text</label>'+
                    '<input ng-model="vm.settingsItem.Value" type="text" name="text" required>'+
                    '<div ng-messages="settingsForm.text.$error">'+
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                    '</div>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfalignItem', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container md-no-float class="md-block">'+
                    '<label translate="MF.ALIGN">Align</label>'+
                    '<md-select ng-model="vm.settingsItem.Align">'+
                        '<md-option value="start center" translate="MF.LEFT">Left</md-option>'+
                        '<md-option value="center center" translate="MF.CENTER">Center</md-option>'+
                        '<md-option value="end center" translate="MF.RIGHT">Right</md-option>'+
                    '</md-select>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfcolorPicker', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div>'+
                    '<label>Background</label>'+
                    '<ms-material-color-picker ms-model-type="obj" ng-model="settingsItem.BackgroundColor">'+
                        '<md-button class="{{$selectedColor}}">Select a Color</md-button>'+
                        //'<div md-colors="{background: \'{{$selectedColor}}\'}" style="height:20px;width:100%;"></div>'+
                    '</ms-material-color-picker>'+
                '</div>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nflabelText', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container md-no-float class="md-block">'+
                    '<label translate="MF.LABEL_TEXT">Label Text</label>'+
                    '<input ng-model="vm.settingsItem.LabelText" type="text" name="label" required>'+
                    '<div ng-messages="settingsForm.label.$error">'+
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                    '</div>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfrequiredField', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div class="md-block" layout="column">'+
                    '<label translate="MF.REQUIRED" style="color: rgba(0,0,0,0.54); font-size: 13px;">Required</label>'+
                    '<md-switch aria-label="Switch" ng-model="vm.settingsItem.Required"></md-switch>'+
                '</div>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfallowAdddeleterows', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div class="md-block" layout="column">'+
                    '<label translate="MF.ALLOW_ADDDELETEROWS" style="color: rgba(0,0,0,0.54); font-size: 13px;">Allow Add/Delete Rows</label>'+
                    '<md-switch aria-label="Switch" ng-model="vm.settingsItem.AllowAddDeleteRows"></md-switch>'+
                '</div>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfmaxChar', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                    '<md-input-container class="md-block">'+
                        '<label translate="MF.MAX_CHARACTER_LIMIT">Max Character Limit</label>'+
                        '<input name="maxchar" required ng-model="vm.settingsItem.MaxLength" type="number" step="1" min="1" max="999">'+
                        '<div class="hint" ng-if="!settingsForm.maxchar.$invalid">(Min:1 - Max:999)</div>'+
                        '<div ng-messages="settingsForm.maxchar.$error">'+
                            '<div ng-message="required" translate="MF.REQUIRED">Required.</div>'+
                            '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>'+
                            '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>'+
                        '</div>'+
                    '</md-input-container>',  
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfminmaxValue', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div layout="row" layout-align="space-between center">'+                
                    '<md-input-container class="md-block">'+
                        '<label translate="MF.MINIMUM">Minimum</label>'+
                        '<input name="minval" ng-model="vm.settingsItem.MinValue" type="number" step="1">'+
                    '</md-input-container>'+
                    '<md-input-container class="md-block">'+
                        '<label translate="MF.MAXIMUM">Maximum</label>'+
                        '<input name="maxval" ng-model="vm.settingsItem.MaxValue" type="number" step="1">'+
                    '</md-input-container>'+
                '</div>',                      
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfselectOptions', ['$translate', '$timeout', function($translate, $timeout) {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div class="option-panel">'+
                    '<div layout="row">'+
                        '<h3 flex="100" translate="MF.OPTIONS">Options</h3>'+
                    '</div>'+
 
                    '<div class="option-list" ng-if="prmrefresh">'+
                        '<div ng-repeat="opt in vm.settingsItem.Options | orderBy:\'Seq\'" layout="row" layout-align="center center" class="option-list-item">'+
                            '<div flex="90" layout="column">'+
                                '<div layout="row">'+
                                    '<input ng-required="true" ng-change="optionChange($index)" class="option-input" ng-model="opt.Value" name="input_{{$index}}" flex="100"></input>'+
                                    '<div layout="row" flex="25" ng-show="settingsForm.input_{{$index}}.$dirty">'+
                                        '<md-button class="md-icon-button" aria-label="Apply" ng-click="optionUpdate(opt.Seq,$index)" ng-show="settingsForm.input_{{$index}}.$viewValue!=\'\'">'+
                                            '<md-icon md-font-icon="icon-check" class="s18"></md-icon>'+
                                        '</md-button>'+
                                        '<md-button class="md-icon-button" aria-label="Cancel" ng-click="optionCancel(opt.Seq,$index)">'+
                                            '<md-icon md-font-icon="icon-close" class="s18"></md-icon>'+
                                        '</md-button>'+                                            
                                    '</div>'+
                                '</div>'+
                                '<p class="option-error" ng-if="inputError[$index]" translate="MF.DUPLICATE_WARNING"></p>'+
                            '</div>'+
                            //'<div flex="10">'+
                                '<md-menu>'+
                                    '<md-button aria-label="Open input actions menu" class="md-icon-button" ng-click="openMenu($mdMenu, $event)">'+
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>'+
                                    '</md-button>'+
                                    '<md-menu-content width="2">'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="optionUp(opt.Seq)" ng-disabled="settingsForm.input_{{$index}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-chevron-up" md-menu-align-target></md-icon>'+
                                                'Up'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="optionDown(opt.Seq)" ng-disabled="settingsForm.input_{{$index}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-chevron-down"></md-icon>'+
                                                'Down'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="optionDelete(opt.Seq)" ng-disabled="settingsForm.input_{{$index}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-delete"></md-icon>'+
                                                'Remove'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                    '</md-menu-content>'+
                                '</md-menu>'+
                            //'</div>'+
                        '</div>'+
                        '<div layout="row" layout-align="end-center">'+
                            '<md-button ng-click="optionAdd($event)" translate="MF.ADD_NEW">Add New</md-button>'+
                        '</div>'+
                    '</div>'+

                '</div>',

                link: function(scope, elem, attrs) {
                    scope.prmrefresh=true;

                    if (typeof scope.vm.settingsItem.Options=='undefined'){
                        scope.settingsItem.Options=[];
                    };

                    var lastSavedOptions=angular.copy(scope.vm.settingsItem.Options);

                    var checkOption = function(index) {
                        var check=scope.vm.settingsItem.Options;
                        var len=check.length;
                        var val=check[index].Value;
                        for (var x=0;x<len;x++) {
                            if(x!=index && check[x].Value==val) {
                                return false;
                                break
                            }
                        }
                        return true;
                    }; 

                    var originatorEv;
                    scope.openMenu = function($mdMenu, ev) {
                        originatorEv = ev;
                        $mdMenu.open(ev);
                    };

                    scope.optionAdd=function() {
                        scope.vm.settingsItem.OptCounter++;
                        var i=scope.vm.settingsItem.OptCounter;
                        var newIndex=scope.vm.settingsItem.Options.length;
                        scope.vm.settingsItem.Options.push({Key:'opt_'+i, Value:'', Seq:newIndex});
                        var newOpt=scope.vm.settingsItem.Options[newIndex];
                        lastSavedOptions.push({Key:newOpt.Key, Value:newOpt.Value, Seq:newIndex});
                    };

                    scope.optionDelete=function(seq) {
                        var check=angular.copy(scope.vm.settingsItem.Options);
                        var len=check.length;
                        var removei=null;
                        for (var i=0;i<len;i++) {
                            if (check[i].Seq==seq) {
                                removei=i;
                            } else {
                                if (check[i].Seq>seq) {
                                    scope.vm.settingsItem.Options[i].Seq--;
                                    lastSavedOptions[i].Seq--;
                                }
                            }
                        }
                        scope.vm.settingsItem.Options.splice(removei, 1)
                        lastSavedOptions.splice(removei, 1)
                        scope.prmrefresh=false;
                        $timeout(function(){
                            scope.prmrefresh=true;
                        })
                    };

                    scope.optionChange=function(index) {
                        scope.settingsForm["input_"+index].$setValidity("duplicateOpt", false);
                    };


                    //yeni eklenen option x ile cancellanırsa her koşulda yazdığın ekranda kalıyor.

                    scope.inputError=[];

                    scope.optionUpdate=function(seq,formIndex) {
                        var check=scope.vm.settingsItem.Options;
                        var len=check.length;
                        var index=null;
                        for (i=0;i<len;i++) {
                            if (seq==check[i].Seq) {
                                index=i;
                                break;
                            }   
                        }

                        if (checkOption(index)==true) {
                            lastSavedOptions[index].Value=scope.vm.settingsItem.Options[index].Value;
                            scope.settingsForm["input_"+formIndex].$setPristine();
                            scope.inputError[formIndex]=false;
                            scope.settingsForm["input_"+formIndex].$setValidity("duplicateOpt", true);
                        } else {
                            scope.inputError[formIndex]=true;
                        }
                    };

                    scope.optionUp=function(seq) {
                        if (seq!=0 && scope.settingsForm["input_"+seq].$dirty==false && scope.settingsForm["input_"+(seq-1)].$dirty==false) {
                            scope.vm.settingsItem.Options.forEach (function(itemOpt) {
                                switch (itemOpt.Seq) {
                                    case seq:
                                        itemOpt.Seq--;
                                        break;
                                    case seq-1:
                                        itemOpt.Seq++;
                                        break;
                                }
                            })
                            lastSavedOptions=angular.copy(scope.vm.settingsItem.Options);
                            scope.prmrefresh=false;
                            $timeout(function(){
                                scope.prmrefresh=true;
                            })
                        }	
                    };

                    scope.optionDown=function(seq) {
                        var len = scope.vm.settingsItem.Options.length;
                        if (seq<len-1 && scope.settingsForm["input_"+seq].$dirty==false && scope.settingsForm["input_"+(seq+1)].$dirty==false) {
                            scope.vm.settingsItem.Options.forEach (function(itemOpt) {
                                switch (itemOpt.Seq) {
                                    case seq:
                                        itemOpt.Seq++;
                                        break;
                                    case seq+1:
                                        itemOpt.Seq--;
                                        break;
                                }
                            })
                            lastSavedOptions=angular.copy(scope.vm.settingsItem.Options);
                            scope.prmrefresh=false;
                            $timeout(function(){
                                scope.prmrefresh=true;
                            })                            
                        }	
                    };

                    scope.optionCancel = function(seq,formIndex) {
                        var index=null;
                        scope.vm.settingsItem.Options.forEach (function(item,xindex) {
                            if (seq==item.Seq) {
                                index=xindex;
                            } 
                        })
                        scope.vm.settingsItem.Options[index].Value=lastSavedOptions[index].Value;
                        scope.settingsForm["input_"+formIndex].$setPristine();
                        scope.inputError[formIndex]=false;
                        scope.settingsForm["input_"+formIndex].$setValidity("duplicateOpt", true);
                    };
                }
            };
        }])

        .directive('nfselectOptionorder', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container md-no-float class="md-block">'+
                    '<label translate="MF.OPTION_ORDER">Option Order</label>'+
                    '<md-select ng-model="vm.settingsItem.OptionOrder">'+
                        '<md-option value="row" translate="MF.HORIZONTAL">Horizontal</md-option>'+
                        '<md-option value="column" translate="MF.VERTICAL">Vertical</md-option>'+
                    '</md-select>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfimageFile', ['$mdDialog', function($mdDialog) {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                    '<div class="image-upload-container md-background-bg">'+
                        '<div id="image-uploader">'+
                            //'<div class="upload-button" layout="column" layout-align="center center">'+
                            //    '<input type="file" ng-model-instant onchange="angular.element(this).scope().imageUpload(this)"/>'+
                            //'</div>'+

                            '<div flow-init="{singleFile:true}" flow-file-added="!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]; validate( $flow, $file )" class="ng-scope">'+
                                '<div>'+
                                    '<md-button class="md-icon-button ng-cloak" aria-label="add image" flow-btn="" ng-show="checkfilePath()">'+
                                        '<md-icon md-font-icon="icon-plus-circle-outline" class="icon s24"></md-icon>'+
                                        '<input type="file" style="visibility: hidden; position: absolute;">'+
                                    '</md-button>'+

                                    '<md-button class="md-icon-button ng-cloak" aria-label="change image" flow-btn="" ng-show="!checkfilePath() || $flow.files.length">'+
                                        '<md-icon md-font-icon="icon-pencil-box-outline" class="icon s24"></md-icon>'+
                                        '<input type="file" style="visibility: hidden; position: absolute;">'+
                                    '</md-button>'+

                                    '<md-button class="md-icon-button md-primary md-warn ng-cloak" aria-label="remove" ng-show="!checkfilePath() || $flow.files.length" ng-click="$flow.cancel(); cancelFile($flow)">'+
                                        '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                    '</md-button>'+
                                '</div>'+
                                '<div layout="row" layout-align="center center" ng-show="!$flow.files.length">'+
                                    '<img ng-src="{{vm.settingsItem.ImageURL}}">'+
                                '</div>'+
                                '<div layout="row" layout-align="center center" ng-show="$flow.files.length">'+
                                    '<img flow-img="$flow.files[0]">'+
                                '</div>'+
                                '<div ng-show="errors">'+
                                    '<div ng-repeat="error in errors" style="font-size:10px;color:red;">{{error.msg}}'+
                                    '</div>'+
                                '</div>'+
                                '<p style="font-size:10px;color:gray;">Max 3 mb and only PNG,GIF,JPG,JEPG files allowed.</p>'+
                            '</div>'+

                            //'<div layout="row" layout-align="center center">'+
                            //    '<img style="width:100px" ng-src="{{vm.settingsItem.ImageURL}}">'+
                            //'</div>'+
                        '</div>'+
                        '<md-slider-container>'+
                            '<span>%</span>'+
                            '<md-slider flex min="0" max="100" ng-change="dimUpdate()" ng-model="vm.settingsItem.Scale" aria-label="scale" id="scale-slider">'+
                            '</md-slider>'+
                            '<md-input-container>'+
                                '<input flex required name="width" type="number" min="0" max="100" ng-change="dimUpdate()" ng-model="vm.settingsItem.Scale" aria-label="scale" aria-controls="scale-slider">'+
                                '<div ng-messages="settingsForm.width.$error">'+
                                    '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Max Value Limit</div>'+
                                    '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Min Value Limit</div>'+
                                    '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                '</div>'+                                  
                            '</md-input-container>'+
                        '</md-slider-container>'+
                        '<div layout="row" layout-align="center center">'+
                            '<md-input-container md-no-float>'+
                                '<label translate="MF.WIDTH">Width</label>'+
                                '<input ng-value="vm.settingsItem.Width" type="text" disabled>'+                         
                            '</md-input-container>'+                
                            '<md-input-container md-no-float>'+
                                '<label translate="MF.HEIGHT">Height</label>'+
                                '<input ng-value="vm.settingsItem.Height" type="text" disabled>'+
                            '</md-input-container>'+
                        '</div>'+                         
                    '</div>',
                link: function(scope, elem, attrs) {

                    //console.log(scope.vm.settingsItem.ImageURL);

                    scope.validate = function ($flow, flowFile) {
                        scope.errors = [];
                        if (flowFile.size > 3 * 1024 * 1024) {
                            scope.errors.push({ msg: "Error: File is bigger than 3 mb" });
                            return false;
                        } else {
                            var fileReader = new FileReader();
                            fileReader.readAsDataURL(flowFile.file);
                            fileReader.onload = function (event) {
                                var img = new Image();
                                img.src = event.target.result;
                                img.onload = function () {
                                    flowFile.file.dimensions = {
                                        width: this.width,
                                        height: this.height
                                    };
                                    scope.vm.settingsItem.ImageURL = event.target.result
                                    scope.$apply(function () {
                                        scope.vm.settingsItem.Width = img.width;
                                        scope.vm.settingsItem.Height = img.height;
                                        scope.vm.settingsItem.WidthOrg = img.width;
                                        scope.vm.settingsItem.HeightOrg = img.height;
                                        scope.vm.settingsItem.Scale = 100;
                                    });
                                    return true;
                                }
                            };
                        }
                    };

                    scope.cancelFile = function($flow) {
                        $flow.cancel();
                        scope.vm.settingsItem.ImageURL = 'assets/images/etc/image-placeholder.png';
                        scope.vm.settingsItem.Width = 210;
                        scope.vm.settingsItem.Height = 210;
                        scope.vm.settingsItem.WidthOrg = 210;
                        scope.vm.settingsItem.HeightOrg = 210;
                        scope.vm.settingsItem.Scale = 100;
                    };

                    scope.checkfilePath = function() {
                        if (scope.vm.settingsItem.ImageURL == 'assets/images/etc/image-placeholder.png') {
                            return true;
                        }
                        return false;
                    };

                    scope.dimUpdate = function() {
                        scope.vm.settingsItem.Width=Math.round(scope.vm.settingsItem.WidthOrg*scope.vm.settingsItem.Scale/100);
                        scope.vm.settingsItem.Height=Math.round(scope.vm.settingsItem.HeightOrg*scope.vm.settingsItem.Scale/100)
                    }
                }
            };
        }])

        .directive('nfminmaxDate', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                    '<div layout="row" layout-align="space-between center">'+
                        '<md-input-container>'+
                            '<label translate="MF.MIN_DATE">Min Date</label>'+
                            '<md-datepicker ng-model="vm.settingsItem.MinDate" name="datemin" md-hide-icons="calendar"></md-datepicker>'+
                            '<div ng-messages="settingsForm.datemin.$error">'+
                                '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>'+
                            '</div>'+
                        '</md-input-container>'+
                        '<md-input-container>'+
                            '<label translate="MF.MAX_DATE">Max Date</label>'+
                            '<md-datepicker ng-model="vm.settingsItem.MaxDate" name="datemax" md-hide-icons="calendar"></md-datepicker>'+
                            '<div ng-messages="settingsForm.datemax.$error">'+
                                '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>'+
                            '</div>'+
                        '</md-input-container>'+
                    '</div>',                
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfdateHideicons', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container md-no-float class="md-block">'+
                    '<label translate="MF.HIDE_ICONS">Hide Icons</label>'+
                    '<md-select ng-model="vm.settingsItem.HideIcons">'+
                        '<md-option value="" translate="MF.NONE">None</md-option>'+
                        '<md-option value="calendar" translate="MF.CALENDAR">Calendar</md-option>'+
                        '<md-option value="triangle" translate="MF.TRIANGLE">Triangle</md-option>'+
                        '<md-option value="all" translate="MF.ALL">All</md-option>'+
                    '</md-select>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfphonenumberMask', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div layout="row">'+
                    '<md-input-container md-no-float class="md-block" flex="50">'+
                        '<label translate="MF.MASK">Mask</label>'+
                        '<input ng-model="vm.settingsItem.Mask" type="text" name="mask">'+
                        '<div class="hint">e.g. (999) 999-9999</div>'+
                        '<div ng-messages="settingsForm.mask.$error">'+
                            //'<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                        '</div>'+
                    '</md-input-container>'+
                    '<md-input-container md-no-float class="md-block" flex="50">'+
                        '<label translate="MF.MASK_CHAR">Mask Char</label>'+
                        '<md-select ng-model="vm.settingsItem.MaskChar">'+
                            '<md-option value="_">_</md-option>'+
                            '<md-option value="x">x</md-option>'+
                        '</md-select>'+
                    '</md-input-container>'+
                '</div>',          
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nfrowNumber', function() {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<md-input-container class="md-block">'+
                    '<label translate="MF.ROW_NUMBER">Row Number</label>'+
                    '<input name="rownumber" ng-model="vm.settingsItem.RowNumber" required type="number" step="1" min="1" max="100">'+
                    '<div class="hint" ng-if="!settingsForm.rownumber.$invalid">(Min:1 - Max:100)</div>'+
                    '<div ng-messages="settingsForm.rownumber.$error">'+
                        '<div ng-message="required" translate="MF.REQUIRED">Required.</div>'+
                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>'+
                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>'+
                    '</div>'+
                '</md-input-container>',
                link: function(scope, elem, attrs) {

                }
            };
        })

        .directive('nftableColumns', ['$translate', '$timeout', function($translate, $timeout) {
            return {
                restrict: 'E',
                replace: true,
                template: ''+
                '<div class="option-panel">'+
                    '<div layout="row">'+
                        '<h3 flex="100" translate="MF.COLUMNS">Columns</h3>'+
                    '</div>'+
 
                    '<div class="option-list" ng-if="prmrefresh">'+
                        '<div ng-repeat="col in vm.settingsItem.Columns | orderBy:\'Seq\'" layout="row" layout-align="center center" class="option-list-item">'+
                            '<div flex="90" layout="column">'+
                                '<div layout="row">'+
                                    '<input ng-required="true" ng-change="columnChange(col.Key)" class="option-input" ng-model="col.Value" name="input_{{col.Key}}" flex="100"></input>'+
                                    '<div layout="row" flex="25" ng-show="settingsForm.input_{{col.Key}}.$dirty">'+
                                        '<md-button class="md-icon-button" aria-label="Apply" ng-click="columnUpdate(col.Key, col.Seq)" ng-show="settingsForm.input_{{col.Key}}.$viewValue!=\'\'">'+
                                            '<md-icon md-font-icon="icon-check" class="s18"></md-icon>'+
                                        '</md-button>'+
                                        '<md-button class="md-icon-button" aria-label="Cancel" ng-click="columnCancel(col.Key, col.Seq)">'+
                                            '<md-icon md-font-icon="icon-close" class="s18"></md-icon>'+
                                        '</md-button>'+                                            
                                    '</div>'+
                                '</div>'+
                                '<p class="option-error" ng-if="inputError[col.Key]" translate="MF.DUPLICATE_WARNING"></p>'+
                            '</div>'+
                            //'<div flex="10">'+
                                '<md-menu>'+
                                    '<md-button aria-label="Open input actions menu" class="md-icon-button" ng-click="openMenu($mdMenu, $event)">'+
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>'+
                                    '</md-button>'+
                                    '<md-menu-content width="2">'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="columnUp(col.Key, col.Seq)" ng-disabled="settingsForm.input_{{col.Key}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-chevron-up" md-menu-align-target></md-icon>'+
                                                'Up'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="columnDown(col.Key, col.Seq)" ng-disabled="settingsForm.input_{{col.Key}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-chevron-down"></md-icon>'+
                                                'Down'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                        '<md-menu-item>'+
                                            '<md-button ng-click="columnDelete(col.Key, col.Seq)" ng-disabled="settingsForm.input_{{col.Key}}.$dirty">'+
                                                '<md-icon md-font-icon="icon-delete"></md-icon>'+
                                                'Remove'+
                                            '</md-button>'+
                                        '</md-menu-item>'+
                                    '</md-menu-content>'+
                                '</md-menu>'+
                            //'</div>'+
                        '</div>'+
                        '<div layout="row" layout-align="end-center">'+
                            '<md-button ng-click="columnAdd($event)" translate="MF.ADD_NEW">Add New</md-button>'+
                        '</div>'+
                    '</div>'+

                '</div>',

                link: function(scope, elem, attrs) {
                    scope.prmrefresh=true;

                    if (typeof scope.vm.settingsItem.Columns=='undefined'){
                        scope.settingsItem.Columns=[];
                    };

                    var lastSavedColumns=angular.copy(scope.vm.settingsItem.Columns);

                    var checkColumn = function (key, seq) {
                        var result = false;
                        var check = scope.vm.settingsItem.Columns;
                        var val = check.getBySeq(seq).Value;
                        angular.forEach(check, function (item, itemKey) {
                            if (item.Value == val && item.Key != key) {
                                result = true;
                            }
                        })
                        return result;
                    }; 

                    var originatorEv;
                    scope.openMenu = function ($mdMenu, ev) {
                        originatorEv = ev;
                        $mdMenu.open(ev);
                    };

                    scope.columnAdd = function () {
                        scope.vm.settingsItem.ColCounter++;
                        var i = scope.vm.settingsItem.ColCounter;
                        var newSeq = scope.vm.settingsItem.Columns.length;
                        scope.vm.settingsItem.Columns.push({ Key: 'col_' + i, Value: '', Seq: newSeq });
                        lastSavedColumns = angular.copy(scope.vm.settingsItem.Columns);
                        //var newCol=scope.vm.settingsItem.Columns[newIndex];scope.vm.settingsItem.Columns
                        //scope.vm.settingsItem.Rows[0].Cols.push({Key:newCol.Key, Value:""});
                    };

                    scope.columnDelete = function (key, seq) {
                        var item = scope.vm.settingsItem.Columns.getBySeq(seq);
                        var index = scope.vm.settingsItem.Columns.indexOf(item);
                        scope.vm.settingsItem.Columns.splice(index, 1);
                        angular.forEach(scope.vm.settingsItem.Columns, function (item, itemKey) {
                            if (item.Seq > seq) {
                                item.Seq--;
                            }
                        })
                        lastSavedColumns = angular.copy(scope.vm.settingsItem.Columns);
                    };

                    scope.columnChange=function(key) {
                        scope.settingsForm["input_"+key].$setValidity("duplicateCol", false);
                    };

                    scope.inputError=[];

                    scope.columnUpdate=function(key, seq) {
                        if (!checkColumn(key, seq)) {
                            scope.settingsForm["input_"+key].$setPristine();
                            scope.inputError[key]=false;
                            scope.settingsForm["input_"+key].$setValidity("duplicateCol", true);
                            lastSavedColumns=angular.copy(scope.vm.settingsItem.Columns);
                        } else {
                            scope.inputError[key]=true;
                        }
                    };

                    scope.columnUp=function(key, seq) {
                        if (seq>0) {
                            var x = scope.vm.settingsItem.Columns.getBySeq(seq);
                            var y = scope.vm.settingsItem.Columns.getBySeq(seq-1);
                            x.Seq--;
                            y.Seq++;
                            lastSavedColumns=angular.copy(scope.vm.settingsItem.Columns);
                        }	
                    };

                    scope.columnDown=function(key, seq) {
                        var len = scope.vm.settingsItem.Columns.length;
                        if (seq<len-1) {
                            var x = scope.vm.settingsItem.Columns.getBySeq(seq);
                            var y = scope.vm.settingsItem.Columns.getBySeq(seq+1);
                            x.Seq++;
                            y.Seq--;
                            lastSavedColumns=angular.copy(scope.vm.settingsItem.Columns);
                        }	
                    };

                    scope.columnCancel = function (key, seq) {
                        scope.vm.settingsItem.Columns.getBySeq(seq).Value = lastSavedColumns.getBySeq(seq).Value;
                        scope.settingsForm["input_" + key].$setPristine();
                        scope.inputError[key] = false;
                        scope.settingsForm["input_" + key].$setValidity("duplicateCol", true);
                    };

                    Array.prototype.getBySeq = function (value)
                    {
                        return this.filter(function (x)
                        {
                            return x.Seq === value;
                        })[0];
                    }

                }
            };
        }])

})();
(function () {
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormDesignController', MyFormDesignController);

    /** @ngInject */
    function MyFormDesignController($scope, $rootScope, $state, $timeout, $mdDialog, $document, $mdToast, $translate, $mdSidenav, $compile, $filter, statePrm, formatTimeStamp) {
        var vm = this;
        // Methods
        vm.toolbarClick = toolbarClick;
        vm.divSelection = divSelection;
        vm.btnElementSettings = btnElementSettings;
        vm.btnElementUp = btnElementUp;
        vm.btnElementDown = btnElementDown;
        vm.btnElementDelete = btnElementDelete;
        vm.btnElementClone = btnElementClone;
        vm.settingsPanelSave = settingsPanelSave;
        vm.btnDesignFormDbSave = btnDesignFormDbSave;
        vm.showMyFormDesign = showMyFormDesign;
        vm.btnPreviewForm = btnPreviewForm;
        vm.btnUploadTemplateDialog = btnUploadTemplateDialog;
        vm.btnSearchTemplate = btnSearchTemplate;
        vm.btnPreviewTemplate = btnPreviewTemplate;
        vm.getRows = getRows;
        vm.openTableRowMenu = openTableRowMenu;
        vm.addRow = addRow;
        vm.deleteRow = deleteRow;
        
        //
        vm.showForm = true;
        //firebase
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var db = firebase.database();
        ///        
        var designFormKey = statePrm.designFormKey;
        var companyKey = statePrm.companyKey;
        var lastFormDivId = 0;

        var formItems = [];
        //vm.formItems = formItems;

        var refreshItem = [];
        vm.refreshItem = refreshItem;

        var formUsers = {};

        $scope.$watch('downloadTemplateKey', function (newValue, oldValue) {
            //downloadTemplateKey is being created in myformcontroller
            if (newValue) {
                downloadTemplateConfirmDialog(newValue);
            }
        });

        $scope.$watch('saveFormItem', function (newValue, oldValue) {
            //saveFormItem is being created in myformcontroller
            if (newValue) {
                settingsPanelSave();
            }
        });

        //$rootScope.showLoadingPanel = true;

        showMyFormDesign('myform')
            .then(function() {
                $timeout(function () {
                    //$rootScope.showLoadingPanel = false;
                    vm.formItems = formItems;
                },1000);
            });

        function toolbarClick(elementType) {
            var Id = calculateId();
            var formdivId = "formdivId_" + Id;
            vm.selectedDivId = formdivId;
            vm.selectedElementType = elementType;
            vm.showBtnGrpElementActions = true;
            addItem(elementType, formdivId);
        };

        function calculateId() {
            lastFormDivId = lastFormDivId + 1;
            return lastFormDivId;
        };

        function divSelection(div, elm, index) {
            vm.selectedDiv = div;
            vm.selectedElementType = elm;
            vm.selectedDivIndex = index
            vm.showBtnGrpElementActions = true;
        };

        function refreshItem(formdivId) {
            vm.selectedDiv = div;
            vm.selectedElementType = elm;
            vm.selectedDivIndex = index
            vm.showBtnGrpElementActions = true;
        };

        function getRows(id) {
            return formItems.getById(id).Rows;
        };

        var originatorEv;

        function openTableRowMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function addRow(formdivId) {
            var item = formItems.getById(formdivId);
            var rowsObj = item["Rows"];
            var cols = rowsObj[Object.keys(rowsObj)[0]]["Cols"];
            item["RowNumber"]++;
            item["RowCounter"]++;
            item["Rows"]["row_" + item.RowCounter] = { "RowKey": "row_" + item.RowCounter, "Cols": cols };
        };

        function deleteRow(formdivId, rowKey) {
            var item = formItems.getById(formdivId);
            if (Object.keys(item.Rows).length>1) {
                item.RowNumber--;
                delete item["Rows"][rowKey];
            }
        };

        function addItem(elementType, formdivId) {
            var label = '<label flex="20" ng-if="item.LabelType!=\'no-show\'" class="itemLabel control-label">{{item.LabelText}}</label>';
            var divx = '<div layout="{{item.LabelType}}">';
            var divy = '<div flex="auto">';
            var divz = '<div class="inputData"></div>';
            var htmlTemp = '' +
                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

            switch (elementType) {
                case "Header":
                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: 'Header', BackgroundColor: '#', Align: 'center center' });
                    break;
                case "Label":
                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: 'Label', BackgroundColor: '#', Align: 'start center' });
                    break;
                case "Text Box":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', MaxLength: 100, Required: false });
                    break;
                case "Text Area":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', MaxLength: 800, Required: false });
                    break;
                case "Dropdown":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="temp.Value">' +
                        '<md-option ng-repeat="opt in item.Options" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                        '</md-select>' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>'
                    formItems.push({
                        id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false, OptCounter: 3,
                        Options: [
                            { Key: 'opt_1', Value: 'Option 1', Seq: 0 },
                            { Key: 'opt_2', Value: 'Option 2', Seq: 1 },
                            { Key: 'opt_3', Value: 'Option 3', Seq: 2 }
                        ]
                    });
                    break;
                case "Radio Button":
                    var element = '' +
                        '<p>{{item.LabelText}}</p>' +
                        '<md-input-container class="md-block">' +
                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="temp.Value">' +
                        '<md-radio-button ng-repeat="opt in item.Options" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                        '</md-radio-group>' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                    formItems.push({
                        id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', OptionOrder: 'row', Required: false, OptCounter: 3,
                        Options: [
                            { Key: 'opt_1', Value: 'Option 1', Seq: 0 },
                            { Key: 'opt_2', Value: 'Option 2', Seq: 1 },
                            { Key: 'opt_3', Value: 'Option 3', Seq: 2 }
                        ]
                    });
                    break;
                case "Checkbox":
                    var element = '' +
                        '<p>{{item.LabelText}}</p>' +
                        '<div layout="{{item.OptionOrder}}">' +
                        '<md-checkbox ng-repeat="opt in item.Options" aria-label="opt.Value">{{opt.Value}}</md-checkbox>' +
                        '</div>';
                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                    formItems.push({
                        id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', OptionOrder: 'row', OptCounter: 3,
                        Options: [
                            { Key: 'opt_1', Value: 'Option 1', Seq: 0 },
                            { Key: 'opt_2', Value: 'Option 2', Seq: 1 },
                            { Key: 'opt_3', Value: 'Option 3', Seq: 2 }
                        ]
                    });
                    break;
                case "Image":
                    var src = "assets/images/etc/image-placeholder.png";
                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, ImageURL: src, Align: 'center center', Scale: 100, Width: 210, Height: 210, WidthOrg: 210, HeightOrg: 210 });
                    break;
                case "Line":
                    var element = '<hr>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType });
                    break;
                case "File Upload":
                    var element = ''+
                        '<div flow-init="{singleFile:true, flowTotalSize:1024, target:\'upload\'}" flow-files-submitted="$flow.upload()" flow-file-success="$file.msg = $message">'+
                        '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                            '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                            '<input type="file" name="' + formdivId + '" style="visibility: hidden; position: absolute;">'+
                        '</md-button>'+
                        '<md-input-container>'+
                            '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                            '<input type="text" disabled>'+
                            '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                            '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                        '</md-input-container>'+
                        '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                            '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                        '</md-button>'+
                        '</div>';
                    htmlTemp = htmlTemp + element + '</div></div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType });
                    break;
                case "Date":
                    var element = '' +
                        '<md-input-container>' +
                        '<label>{{item.LabelText}}</label>' +
                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false, MinDate: null, MaxDate: null, HideIcons: 'calendar' });
                    break;
                case "Time":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false });
                    break;
                case "Numeric":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false });
                    break;
                case "Email":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                        'translate ng-pattern="/^.+@.+\..+$/">' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                        '<div ng-message="required">' +
                        '<span translate="MF.REQUIRED">Required</span>' +
                        '</div>' +
                        '<div ng-message="pattern">' +
                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                        '</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false });
                    break;
                case "Phone Number":
                    var element = '' +
                        '<md-input-container class="md-block">' +
                        '<label>{{item.LabelText}}</label>' +
                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                        '</div>' +
                        '</md-input-container>';
                    htmlTemp = htmlTemp + element + '</div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: 'Label', Required: false, Mask: '(999) 999-9999', MaskChar: '_' });
                    break;
                case "Table":
                    var rowNumber = 1;
                    var columns = [];
                    for (var i=0; i<=2; i++) {
                        columns.push({ Key: 'col_'+i, Value: 'Column '+i, Seq: i });
                    }

                    var rows = {
                        "row_1": {
                            "RowKey": "row_1",
                            "Cols": {
                                "col_0": {
                                    "Value": ""
                                },
                                "col_1": {
                                    "Value": ""
                                },
                                "col_2": {
                                    "Value": ""
                                }
                            }
                        }
                    }

                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                    var table = '<table class="simple" ms-responsive-table>';
                    var thead = '<thead>' +
                        '<tr>' +
                        '<th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th>' +
                        '<th class="actions" ng-if="item.AllowAddDeleteRows">' +
                        '<md-button class="md-icon-button md-accent"' +
                        'aria-label="Add row" translate' +
                        'translate-attr-aria-label="SW.ADD_ROW"' +
                        'ng-click="vm.addRow(\'' + formdivId + '\')">' +
                        '<md-icon md-font-icon="icon-table-row-plus-after"></md-icon>' +
                        '</md-button>' +
                        '</th>' +
                        '</tr>' +
                        '</thead>';
                    var tbody = '<tbody>' +
                        '<tr ng-repeat="row in vm.getRows(item.id) track by row.RowKey">' +
                        '<td ng-repeat="col in row.Cols track by $index">' +
                        '<input>' +
                        '</td>' +
                        '<td class="actions" ng-if="item.AllowAddDeleteRows">' +
                        '<md-menu>' +
                        '<md-button aria-label="Open actions menu" class="md-icon-button" ng-click="vm.openTableRowMenu($mdMenu, $event)">' +
                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>' +
                        '</md-button>' +
                        '<md-menu-content width="2">' +
                        '<md-menu-item>' +
                        '<md-button ng-click="vm.deleteRow(\'' + formdivId + '\',row.RowKey)" ng-disabled="" translate="SW.DELETE">' +
                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                        'Delete' +
                        '</md-button>' +
                        '</md-menu-item>' +
                        '</md-menu-content>' +
                        '</md-menu>' +
                        '</td>' +
                        '</tr>' +
                        '</tbody>';

                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, RowNumber: 1, Rows: rows, Columns: columns, RowCounter: 1, ColCounter: 2, AllowAddDeleteRows:false });
                    break;
            }
            itemSeqOrder();
            divSelection(formdivId, elementType, formItems.length - 1);
            scrollToItem(formdivId);
        };

        function btnElementUp() {
            var i = vm.selectedDivIndex;
            if (i != 0 && i != null) {
                var temp = formItems[i];
                formItems[i] = formItems[i - 1];
                formItems[i - 1] = temp;
                itemSeqOrder();
                vm.selectedDivIndex--;

                vm.showForm = false;
                $timeout(function () {
                    vm.showForm = true;
                });
            };
        };

        function btnElementDown() {
            var i = vm.selectedDivIndex;
            var len = formItems.length;
            if (i < len - 1 && i != null) {
                var temp = formItems[i];
                formItems[i] = formItems[i + 1];
                formItems[i + 1] = temp;
                itemSeqOrder();
                vm.selectedDivIndex++;

                vm.showForm = false;
                $timeout(function () {
                    vm.showForm = true;
                });
            };
        };

        function btnElementDelete() {
            var i = vm.selectedDivIndex;
            if (i != null) {
                formItems.splice(i, 1);
                if (formItems.length == 0) {
                    lastFormDivId = 0;
                } else {
                    itemSeqOrder();
                }
                vm.selectedDivIndex = null;
                vm.showForm = false;
                $timeout(function () {
                    vm.showForm = true;
                });
            };
        };

        function btnElementClone() {
            var i = vm.selectedDivIndex;
            if (i != null) {
                var maxSeq = Math.max.apply(Math, formItems.map(function (x) { return x.Seq; }));
                var newId = calculateId();
                var newformdivId = "formdivId_" + newId;
                var oldformdivId = formItems[i].id;
                var temp = angular.copy(formItems[i]);
                temp.Seq = maxSeq + 1;
                temp.id = newformdivId;
                temp.html = temp.html.replace(RegExp(oldformdivId, "g"), newformdivId);
                formItems.push(temp);
                divSelection(newformdivId, temp.Type, temp.Seq);
                scrollToItem(newformdivId);
            }
        };

        function btnPreviewForm(ev) {
            $mdDialog.show({
                controller: 'PreviewFormDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-forms/dialogs/design/preview-form/preview-form-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    formItems: formItems,
                    designFormName: $scope.$parent.vm.form.Name
                }
            })
        };

        function btnUploadTemplateDialog(ev) {
            if (!vm.selectedNode) {
                //return;
            }

            //var len=Object.keys(dataObj).length;

            $mdDialog.show({
                controller: 'UploadTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-forms/dialogs/design/upload-template/upload-template-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    designFormKey: designFormKey,
                    companyKey: companyKey
                }
            })
                .then(function (newForm) {

                    var refSource = db.ref('/DesignFormItems/' + companyKey + '/' + designFormKey);
                    var newTargetKey = db.ref('CloudDesignForm').push().key;
                    var updates = {};
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    updates['/CloudDesignForm/' + newTargetKey] =
                        {
                            'Name': newForm.name,
                            'Description': newForm.description,
                            'DateCreated': dateNow,
                            'CompanyKey': companyKey,
                            'DesignFormKey': designFormKey,
                            'UID': UID
                        };

                    refSource.once('value')
                        .then(function (snap) {
                            var newFormItems = snap.val();
                            updates['/CloudDesignFormItems/' + newTargetKey] = newFormItems;

                            db.ref().update(updates)
                                .then(function () {
                                    var textContent = $translate.instant('MF.FORM_UPLOADED');
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent(textContent)
                                            .hideDelay(1000)
                                            .position('top right')
                                    );
                                })
                                .catch(function (error) {
                                    var textContent = $translate.instant('MF.ERROR');
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent(textContent + ': ' + error)
                                            .hideDelay(1000)
                                            .position('top right')
                                    );
                                });

                        }).catch(function (err) {
                            console.log(err)
                        });

                }, function () {

                });
        };

        function btnSearchTemplate() {
            $mdSidenav('search-template').toggle()
                .then(function () {
                    if (!$scope.$parent.vm.templates.length) {
                        firebase.database().ref('/CloudDesignForm').once('value')
                            .then(function (snap) {
                                snap.forEach(function (snapTemplate) {
                                    var key = snapTemplate.key;
                                    var data = snapTemplate.val();
                                    getUser(data.UID).then(function (formUser) {
                                        data.Key = key;
                                        data.UserDisplayName = formUser.displayName;
                                        data.UserPhotoURL = formUser.photoURL;
                                        $timeout(function () {
                                            $scope.$parent.vm.templates.push(data);
                                        });
                                    });
                                })
                            });
                    }
                });
        };

        function btnPreviewTemplate(ev, templateKey, templateName) {
            $mdDialog.show({
                controller: 'PreviewTemplateialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-forms/dialogs/design/preview-template/preview-template-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    templateKey: templateKey,
                    templateName: templateName
                }
            })
        };

        function downloadTemplateConfirmDialog(templateKey) {
			var title = $translate.instant('MF.DOWNLOAD_TEMPLATE_CONFIRM');
            var textContent = $translate.instant('MF.DOWNLOAD_TEMPLATE_CONFIRM_MSG');
            var text_ok = $translate.instant('MF.OK');
            var text_cancel = $translate.instant('MF.CANCEL');

            var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent(textContent)
                .ariaLabel('confirm download template')
                //.targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function ()
            {
                $rootScope.showLoadingPanel = true;
                showMyFormDesign(templateKey)
                    .then(function() {
                        $scope.$parent.downloadTemplateKey = null;
                        $mdSidenav('search-template').close();
                        $timeout(function () {
                            $rootScope.showLoadingPanel = false;
                            var textContent = $translate.instant('MF.FORM_IMPORTED');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(textContent)
                                    .hideDelay(2000)
                                    .position('top right')
                            );
                        }, 1000);
                    });
            }, function ()
            {
                //md dialog cancelled
                $scope.$parent.downloadTemplateKey = null;
            });
        };

        function getUser(userKey) {
            return new Promise(function (resolve, reject) {
                if (!formUsers[userKey]) {
                    db.ref('/Users/').child(userKey)
                        .once('value', function (userSnap) {
                            var data = userSnap.val();
                            formUsers[userKey] = { "displayName": data.DisplayName, "photoURL": data.Photo.PhotoURL };
                            resolve(formUsers[userKey]);
                        });
                } else {
                    resolve(formUsers[userKey]);
                }
            });
        };

        function itemSeqOrder() {
            formItems.forEach(function (item, index) {
                item.Seq = index;
            })
        };

        function guidGenerator() {

            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        };

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };

        function settingsPanelSave() {
            var index = vm.selectedDivIndex;

            if (vm.settingsItem.Type == 'Table') {
                var cols = {};
                angular.forEach(vm.settingsItem.Columns, function (item, key) {
                    cols[item.Key] = {"Value": ""};
                });
                vm.settingsItem['Rows'] = {};
                for (var i = 1; i <= vm.settingsItem.RowNumber; i++) {
                    vm.settingsItem['Rows']['row_' + i] = {'RowKey':'row_'+i, 'Cols':cols};
                    vm.settingsItem.RowCounter = i;
                }
            }

            formItems[index] = vm.settingsItem;
            
            refreshItem[vm.selectedDiv] = false;
            $timeout(function () {
                refreshItem[vm.selectedDiv] = true;
            });
            $mdSidenav('design-form-settings').close()
                .then(function() {

                })
            
        };

        function btnDesignFormDbSave() {
            var tempArr = angular.copy(formItems);
            var count = tempArr.length;
            var itemsObj = {};
            var obj = { 'DivCounter': lastFormDivId, 'Items': itemsObj };
            var imageArr = [];
            for (var i = 0; i < count; i++) {
                itemsObj[tempArr[i].id] = {};
                for (var property in tempArr[i]) {
                    if (tempArr[i].hasOwnProperty(property)) {
                        if (property != 'html' && property != 'id') {
                            itemsObj[tempArr[i].id][property] = tempArr[i][property];

                            if (property == 'Options') {
                                var optObj = {};
                                tempArr[i][property].forEach(function (opt) {
                                    optObj[opt.Key] = {};
                                    optObj[opt.Key]['Seq'] = opt.Seq;
                                    optObj[opt.Key]['Value'] = opt.Value;
                                    optObj[opt.Key]['Selected'] = false;
                                });
                                itemsObj[tempArr[i].id]['Options'] = optObj
                            }
                            if (property == 'Columns') {
                                var colObj = {};
                                tempArr[i][property].forEach(function (col) {
                                    colObj[col.Key] = {};
                                    colObj[col.Key]['Seq'] = col.Seq;
                                    colObj[col.Key]['Value'] = col.Value;
                                });
                                itemsObj[tempArr[i].id]['Columns'] = colObj
                            }

                            if (property == 'ImageURL') {
                                var imgData = tempArr[i][property];
                                if (imgData.startsWith("data") == true) {
                                    var imgKey = tempArr[i].id;
                                    imageArr.push({ "id": imgKey, "img": imgData, "formitemKey": i });
                                    itemsObj[tempArr[i].id][property] = null;
                                }
                            }
                        }
                    }
                }
            }

            if (imageArr.length > 0) {
                executeImgSave(imageArr)
                    .then(function () {
                        executeSave(obj);
                    }).catch(function (error) {
                        var textContent = $translate.instant('MF.ERROR');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent + ': ' + error)
                                .hideDelay(1000)
                                .position('top right')
                        );
                    });
            } else {
                executeSave(obj);
            }

            function executeImgSave(imgArr) {
                return new Promise(function (resolve, reject) {
                    var storageRef = firebase.storage().ref('designform-images/' + companyKey + '/' + designFormKey);
                    var len = imgArr.length;
                    var counter = 1;
                    imgArr.forEach(function (item) {
                        var storageKey = guidGenerator();
                        var imgData = item.img;
                        storageRef.child(storageKey).putString(imgData, 'data_url')
                            .then(function (snapshot) {
                                var downloadURL = snapshot.downloadURL;
                                itemsObj[item.id]['ImageURL'] = downloadURL;
                                counter++;
                                if (counter > len) {
                                    resolve ();
                                }
                            }).catch(function (err) {
                                reject(err);
                            });
                    });
                });
            };

        };

        function executeSave(saveobj) {
            var ref = firebase.database().ref('/DesignFormItems/' + companyKey + '/' + designFormKey);
            ref.update(saveobj)
                .then(function () {
                    var textContent = $translate.instant('MF.FORM_SAVED');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(textContent)
                            .hideDelay(1000)
                            .position('top right')
                    );
                })
                .catch(function (error) {
                    var textContent = $translate.instant('MF.ERROR');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(textContent + ': ' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                });
        };

        function showMyFormDesign(prm) {
            return new Promise(function (resolve, reject) {
                var dbRefCounter;
                var dbRefFormItems;

                if (prm == 'myform') {
                    dbRefCounter = firebase.database().ref('/DesignFormItems/' + companyKey + '/' + designFormKey).child('DivCounter');
                    dbRefFormItems = firebase.database().ref('/DesignFormItems/' + companyKey + '/' + designFormKey + '/Items').orderByChild('Seq');
                } else {
                    vm.formItems = formItems = [];
                    dbRefCounter = firebase.database().ref('/CloudDesignFormItems/' + prm).child('DivCounter');
                    dbRefFormItems = firebase.database().ref('/CloudDesignFormItems/' + prm + '/Items').orderByChild('Seq');                
                }

                dbRefCounter
                    .once('value', function (snapshot) {
                        lastFormDivId = snapshot.val();
                    });

                dbRefFormItems
                    .once('value', function (snapshot) {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="temp.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="temp.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" aria-label="opt.Value">{{opt.Value}}</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var element = ''+
                                        '<div flow-init="{singleFile:true, target:\'upload\'}" flow-file-added="fileAdded( $flow, $file )" flow-file-success="$file.msg = $message">'+
                                        '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                                            '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '<input type="file" style="visibility: hidden; position: absolute;">'+
                                        '</md-button>'+
                                        '<md-input-container>'+
                                            '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                                            '<input type="text" disabled>'+
                                            '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                                            '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                        '</md-input-container>'+
                                        '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                                            '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                        '</md-button>'+
                                        '</div>';

                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    refreshItem[formdivId] = true;
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>{{item.Value}}' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required">' +
                                        '<span translate="MF.REQUIRED">Required</span>' +
                                        '</div>' +
                                        '<div ng-message="pattern">' +
                                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead>' +
                                        '<tr>' +
                                        '<th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th>' +
                                        '<th class="actions" ng-if="item.AllowAddDeleteRows">' +
                                        '<md-button class="md-icon-button md-accent"' +
                                        'aria-label="Add row" translate' +
                                        'translate-attr-aria-label="SW.ADD_ROW"' +
                                        'ng-click="vm.addRow(\'' + formdivId + '\')">' +
                                        '<md-icon md-font-icon="icon-table-row-plus-after"></md-icon>' +
                                        '</md-button>' +
                                        '</th>' +
                                        '</tr>' +
                                        '</thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in vm.getRows(item.id) track by row.RowKey">' +
                                        '<td ng-repeat="col in row.Cols track by $index">' +
                                        '<input>' +
                                        '</td>' +
                                        '<td ng-if="item.AllowAddDeleteRows" class="actions">' +
                                        '<md-menu >' +
                                        '<md-button aria-label="Open actions menu" class="md-icon-button" ng-click="vm.openTableRowMenu($mdMenu, $event)">' +
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>' +
                                        '</md-button>' +
                                        '<md-menu-content width="2">' +
                                        '<md-menu-item>' +
                                        '<md-button ng-click="vm.deleteRow(\'' + formdivId + '\',row.RowKey)" ng-disabled="" translate="SW.DELETE"' +
                                        'ng-if="item.AllowAddDeleteRows">'+
                                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                                        'Delete' +
                                        '</md-button>' +
                                        '</md-menu-item>' +
                                        '</md-menu-content>' +
                                        '</md-menu>' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Seq: seq, Type: elementType, RowNumber: rowNumber, RowCounter: rowCounter, Rows: rows, Columns: columns, ColCounter: colCounter, AllowAddDeleteRows: allowAddDeleteRows });
                                    break;
                            }
                        });
                    });

                resolve(formItems);
            });
        };

        function btnElementSettings() {
            if (vm.selectedDivIndex != null) {
                vm.settingsItem = angular.copy(formItems[vm.selectedDivIndex]);
                $scope.$parent.vm.settingsItem = vm.settingsItem;

                $mdSidenav('design-form-settings').open()
                    .then(function () {

                    });
            };
        };

        function scrollToItem(formdivId) {
            $timeout(function() {
                var elmnt = document.getElementById(formdivId);
                elmnt.scrollIntoView();
            }, 500);
        };

        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }

        $timeout(function() {
            //on page load, mdSidenav isn't registered yet, so used within the timeout block 
            $mdSidenav('design-form-settings').onClose(function () {
                $scope.$parent.saveFormItem = null;
                $scope.$parent.vm.settingsItem = null;
            });
        });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('VerificationWarningDialogController', VerificationWarningDialogController);

    /** @ngInject */
    function VerificationWarningDialogController($mdDialog, unverifiedList, $translate)
    {
        var vm = this;

        vm.unverifiedList=unverifiedList;

        // Data
        var db=firebase.database();

		vm.title = $translate.instant('MF.PROCESS_VERIFICATION_WARNING');

		// Methods
        vm.closeDialog = closeDialog;
        vm.submit = submit;
        //
    

        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function submit() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('EditApprovalDialogController', EditApprovalDialogController);

    /** @ngInject */
    function EditApprovalDialogController($mdDialog, parentName, parentAction, userEmail, allowedObjects, formUsers, type, $translate)
    {
        var vm = this;

        vm.form={};

        // Data
        var db=firebase.database();

        vm.title = $translate.instant('MF.EDIT');

        vm.form.parentName=parentName;
        vm.form.parentAction=parentAction;
        vm.form.userEmail=userEmail;
        vm.allowedObjects=allowedObjects;
        vm.formUsers=formUsers;
        vm.type=type;

        if (parentName) {
            vm.parentType=allowedObjects[parentName].Type;
        }
        

        // Methods
        vm.onParentChanged=onParentChanged;
		vm.submitForm=submitForm;
		vm.closeDialog = closeDialog;
        //
        
        if (parentName=='Submission') {
            vm.form.approvalOption='Submission';
        }

        function onParentChanged(prName) {
            vm.parentType=allowedObjects[prName].Type;
        };

		function submitForm() {
			$mdDialog.hide(vm.form);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('DuplicateProcessDialogController', DuplicateProcessDialogController);

    /** @ngInject */
    function DuplicateProcessDialogController($mdDialog, newNode, $translate)
    {
        var vm = this;

        // Data
        var db=firebase.database();

		vm.title = $translate.instant('MF.DUPLICATE_PROCESS_WARNING');

        // Methods
        vm.submitForm = submitForm;
		vm.closeDialog = closeDialog;
        //

        vm.newNode=newNode;

        vm.warningMsg = $translate.instant('MF.DUPLICATE_PROCESS_WARNING_ADD_MSG')+' ('+newNode.parentAction+') '+
                        $translate.instant('MF.DUPLICATE_PROCESS_WARNING_MSG')+' '+
                        $translate.instant('MF.DO_YOU_WANT_TO_CONTINUE');

        function submitForm() {
            $mdDialog.hide();
        };


        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('DeleteObjectDialogController', DeleteObjectDialogController);

    /** @ngInject */
    function DeleteObjectDialogController($mdDialog, selectedObj, selectedKey, childObjects, $translate)
    {
        var vm = this;

        vm.form={'selection':'self'};

        // Data
        var db=firebase.database();

        vm.title = $translate.instant('MF.DELETE_PROCESS_OBJECT');
        var childDeleteMsg='';

        vm.childNumber=Object.keys(childObjects).length;

        vm.selectedObj=selectedObj;
        vm.selectedKey=selectedKey;

        // Methods
        vm.onSelectionChanged=onSelectionChanged;
		vm.submitForm=submitForm;
		vm.closeDialog = closeDialog;
        //

        proceedTextMsg();

        function proceedTextMsg() {
            vm.textContent = $translate.instant('MF.OBJECT') +': ('+selectedKey +' - '+selectedObj.UserEmail+')'+childDeleteMsg+$translate.instant('MF.PROCESS_DELETE_CONFIRM_MSG');
        };

        function onSelectionChanged(opt) {
            if (opt=='self') {
                childDeleteMsg='';
            } else {
                childDeleteMsg= ' ' + $translate.instant('MF.AND_FOLLOWING') + vm.childNumber + ' ' + $translate.instant('MF.OBJECT(S)');
            }

            proceedTextMsg();
        };

		function submitForm() {
			$mdDialog.hide(vm.form.selection);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('AddTerminationDialogController', AddTerminationDialogController);

    /** @ngInject */
    function AddTerminationDialogController($mdDialog, parentName, parentUserEmail, $translate)
    {
        var vm = this;

        vm.form={};

        // Data

		vm.title = $translate.instant('MF.ADD_TERMINATION_OBJECT');
        vm.form.parentName=parentName;
        vm.form.parentUserEmail=parentUserEmail;

		// Methods
		vm.submitForm=submitForm;
		vm.closeDialog = closeDialog;
        //
        
        if (parentName=='Submission') {
            vm.form.parentAction='Submission';
        }

		function submitForm() {
			$mdDialog.hide(vm.form);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('AddApprovalDialogController', AddApprovalDialogController);

    /** @ngInject */
    function AddApprovalDialogController($mdDialog, designFormKey, formUsers, parentName, parentUserEmail, $translate)
    {
        var vm = this;

        vm.form={};

        // Data
        var db=firebase.database();

		vm.title = $translate.instant('MF.NEW_APPROVAL');
        vm.formUsers=formUsers;
        vm.form.parentName=parentName;
        vm.form.parentUserEmail=parentUserEmail;

		// Methods
		vm.addNewApproval=addNewApproval;
		vm.closeDialog = closeDialog;
        //
        
        if (parentName=='Submission') {
            vm.form.parentAction='Submission';
        }

		function addNewApproval() {
			$mdDialog.hide(vm.form);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('UploadTemplateDialogController', UploadTemplateDialogController);

    /** @ngInject */
    function UploadTemplateDialogController($mdDialog, $translate, designFormKey, companyKey)
    {
        var vm = this;

        vm.form={};

        // Data

		vm.title = $translate.instant('MF.UPLOAD_AS_CLOUD_TEMPLATE');


		// Methods
		vm.submitForm=submitForm;
		vm.closeDialog = closeDialog;
        //

		function submitForm() {
			$mdDialog.hide(vm.form);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('PreviewTemplateialogController', PreviewTemplateialogController);

    /** @ngInject */
    function PreviewTemplateialogController($mdDialog, $timeout, templateKey, templateName) {
        var vm = this;
        // Data
        var formItems = [];
        vm.title = templateName;
        vm.formItems = formItems;
        var db=firebase.database();

        // Methods
        vm.addRow = addRow;
        vm.deleteRow = deleteRow;
        vm.openTableRowMenu = openTableRowMenu;
        vm.cancelDialog = cancelDialog;
        //

        var originatorEv;

        showForm();

        function openTableRowMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function addRow(formdivId, i) {
            var columns = formItems[i]["Columns"];
            var len = columns.length;
            var cols = [];
            for (var x = 0; x < len; x++) {
                cols.push({ "Key": columns[x].Key, "Value": "" })
            }
            var newKey = formItems[i].RowCounter = formItems[i].RowCounter + 1;
            formItems[i]["Rows"].push({ "Key": "row_" + newKey, "Cols": cols });
        };

        function deleteRow(formdivId, itemindex, rowindex) {
            var len = formItems[itemindex]["Rows"].length;
            if (len > 1) {
                formItems[itemindex]["Rows"].splice(rowindex, 1);
            }
        };

        function showForm() {
            db.ref('/CloudDesignFormItems/' + templateKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';


                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" ' +
                                        'md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: labelText, Seq: seq, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq, Selected: false });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" ' +
                                        'aria-label="opt.Value" ' +
                                        'ng-model="opt.Selected">{{opt.Value}}' +
                                        '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, LabelText: labelText, Seq: seq, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var element = ''+
                                        '<div flow-init="{singleFile:true, target:\'upload\'}" flow-files-submitted="$flow.upload()" flow-file-success="$file.msg = $message">'+
                                        '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                                            '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '<input type="file" style="visibility: hidden; position: absolute;">'+
                                        '</md-button>'+
                                        '<md-input-container>'+
                                            '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                                            '<input type="text" disabled>'+
                                            '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                                            '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                        '</md-input-container>'+
                                        '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                                            '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                        '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="pattern" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = [];
                                    for (var rowKey in data.Rows) {
                                        var rowcolArr = [];
                                        for (var colKey in data.Rows[rowKey]) {
                                            rowcolArr.push({ "Key": colKey, "Value": data.Rows[rowKey][colKey] });
                                        }
                                        rows.push({ "Key": rowKey, "Cols": rowcolArr });
                                    }

                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead>' +
                                        '<tr>' +
                                        '<th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th>' +
                                        '<th>' +
                                        '<md-button class="md-icon-button md-accent"' +
                                        'aria-label="Add row" translate' +
                                        'translate-attr-aria-label="SW.ADD_ROW"' +
                                        'ng-click="vm.addRow(\'' + formdivId + '\',$index)">' +
                                        '<md-icon md-font-icon="icon-table-row-plus-after"></md-icon>' +
                                        '</md-button>' +
                                        '</th>' +
                                        '</tr>' +
                                        '</thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in item.Rows track by $index">' +
                                        '<td ng-repeat="col in row.Cols">' +
                                        '<input ng-model="col.Value">' +
                                        '</td>' +
                                        '<td>' +
                                        '<md-menu>' +
                                        '<md-button aria-label="Open actions menu" class="md-icon-button" ng-click="vm.openTableRowMenu($mdMenu, $event)">' +
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>' +
                                        '</md-button>' +
                                        '<md-menu-content width="2">' +
                                        '<md-menu-item>' +
                                        '<md-button ng-click="vm.deleteRow(\'' + formdivId + '\',parentIndex,$index)" ng-disabled="" translate="SW.DELETE">' +
                                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                                        'Delete' +
                                        '</md-button>' +
                                        '</md-menu-item>' +
                                        '</md-menu-content>' +
                                        '</md-menu>' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, RowCounter: rowCounter, Columns: columns, Rows: rows, ColCounter: colCounter });
                                    break;
                            }

                        });
                    });
                });

        };

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('PreviewFormDialogController', PreviewFormDialogController);

    /** @ngInject */
    function PreviewFormDialogController($mdDialog, formItems, designFormName)
    {
        var vm = this;
        // Data

        vm.title = designFormName;
        var previewFormItems = angular.copy(formItems);
        vm.previewFormItems = previewFormItems;

        // Methods
        vm.addRow=addRow;
        vm.getRows = getRows;
        vm.deleteRow=deleteRow;
        vm.openTableRowMenu=openTableRowMenu;
        vm.cancelDialog = cancelDialog;
        //

        var originatorEv;

        function openTableRowMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function getRows(id) {
            return previewFormItems.getById(id).Rows;
        };

        function addRow(formdivId) {
            var item = previewFormItems.getById(formdivId);
            var rowsObj = item["Rows"];
            var cols = angular.copy(rowsObj[Object.keys(rowsObj)[0]]["Cols"]);
            angular.forEach(cols, function(colItem, colKey) {
                colItem.Value = "";
            });
            item["RowNumber"]++;
            item["RowCounter"]++;
            item["Rows"]["row_" + item.RowCounter] = { "RowKey": "row_" + item.RowCounter, "Cols": cols };
        };

        function deleteRow(formdivId, rowKey) {
            var item = previewFormItems.getById(formdivId);
            if (Object.keys(item.Rows).length>1) {
                item.RowNumber--;
                delete item["Rows"][rowKey];
            }
        };

        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }

        function cancelDialog()
        {
            $mdDialog.cancel();
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.shared-withme',
            []
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_shared-withme', {
                url      : '/pages/shared-withme',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/shared-withme/shared-withme.html',
                        controller : 'SharedWithmeController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]               
                },
                bodyClass: 'shared-withme'
            })
            .state('app.pages_shared-withme.viewformlist', {
                url      : '/viewformlist',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/shared-withme/views/view-formlist/view-formlist.html',
                        controller : 'ViewFormListController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]          
                },
                bodyClass: 'view-formlist'
            });            

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/shared-withme');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.shared-withme', {
            title : 'Shared With Me',
            icon  : 'icon-note-outline',
            state : 'app.pages_shared-withme',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.shared-withme')
        .controller('ViewFormDialogController', ViewFormDialogController);

    /** @ngInject */
    function ViewFormDialogController($mdDialog, $mdToast, $timeout, formInfo, nfviewForm)
    {
        var vm = this;
        // Data

        showForm();
        
        function showForm() {
            firebase.database().ref('/FormItems/' + formInfo.FormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                            '<label>{{item.LabelText}}</label>' +
                                            '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                            '<div ng-messages="viewForm.' + formdivId + '.$error">' +
                                                '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                                '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                            '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: value, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Value: value, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        var optSelected = data.Options[key].Selected;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq, Selected: optSelected});
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                            '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" '+
                                                'aria-label="opt.Value" '+
                                                'ng-checked="opt.Selected">{{opt.Value}}'+
                                            '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var fileName = data.FileName;
                                    var fileURL = data.FileURL;
                                    var element = ''+
                                        '<div>'+
                                            '<md-button class="md-icon-button" aria-label="attach file" ng-disabled>'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label>{{item.FileName}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="item.FileURL" class="md-icon-button md-primary" aria-label="remove" ng-href="{{item.FileURL}}" target="_blank">'+
                                                '<md-icon md-font-icon="icon-download"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, FileName: fileName, FileURL: fileURL });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate==null) {
                                        var maxDate=null;
                                    } else {
                                        var maxDate=data.MaxDate;
                                    }
                                    if (data.minDate==null) {
                                        var minDate=null;
                                    } else {
                                        var minDate=data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var timeValue= new Date(value);
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: timeValue, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required">' +
                                        '<span translate="MF.REQUIRED">Required</span>' +
                                        '</div>' +
                                        '<div ng-message="pattern">' +
                                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead><tr><th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th></tr></thead>';
                                    var tbody = '<tbody>'+
                                                    '<tr ng-repeat="row in item.Rows track by $index">'+
                                                        '<td ng-repeat="col in row.Cols">' +
                                                            '<input ng-value="col.Value">' +
                                                        '</td>'+
                                                    '</tr>'+
                                                '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, RowCounter: rowCounter, Columns: columns, Rows:rows, ColCounter: colCounter });
                                    break;
                            }

                        });
                    });
                });
        };

        vm.title = formInfo.DesignFormName+' ('+formInfo.FormKey+')';
        var formItems=[];
        vm.formItems=formItems;


        // Methods
        vm.closeDialog = closeDialog;

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormController', MyFormController);

    /** @ngInject */
    function MyFormController($state, $scope, $timeout, $mdDialog, $mdSidenav, $document, $mdToast, statePrm, formatTimeStamp)
    {
        var vm = this;
        // Methods
        vm.gotoForms=gotoForms;
        vm.showMyFormMain=showMyFormMain;
        vm.saveMyFormMain=saveMyFormMain;
        vm.formatDate=formatDate;
        vm.toggleSidenav=toggleSidenav;
        vm.upload=upload;
        vm.imageSuccess=imageSuccess;
        vm.deleteImage=deleteImage;
        vm.btnPreviewTemplate = btnPreviewTemplate;
        vm.btnDownloadTemplate = btnDownloadTemplate;
        vm.closeSearchTemplateDialog = closeSearchTemplateDialog;
        vm.checkSettingsItem = checkSettingsItem;
        vm.btnSettingsPanelSave = btnSettingsPanelSave;
        //////////

        vm.templates = [];

        var designFormKey=statePrm.designFormKey;
        var companyKey=statePrm.companyKey;

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Go to forms page
         */
        function gotoForms()
        {
            $state.go('app.my-company_my-forms');
        }

        //format date
        function formatDate(date) {
            return formatTimeStamp.format(date);
        };

        // firebase//
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var db=firebase.database();

        showMyFormMain()

        function showMyFormMain() {
            db.ref('/DesignForm/'+companyKey+'/'+designFormKey).once('value', function(snapshot){
                $timeout(function() {
                    vm.form=snapshot.val();
                });
            });   
        };

        function saveMyFormMain(ev) {
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var ref = db.ref('/DesignForm/' + companyKey + '/' + designFormKey);
            var updates = {
                "DateEdited": dateNow,
                "Name": vm.form.Name,
                "Type": vm.form.Type,
                "WidgetColor": vm.form.WidgetColor,
                //"FontColor": vm.form.FontColor,
                "Description": vm.form.Description
            }

            if (vm.form.WidgetImageURL) {
                if (vm.form.WidgetImageURL.startsWith("data") == true) {
                    executeImgSave(vm.form.WidgetImageURL)
                        .then(function (downloadURL) {
                            updates["WidgetImageURL"] = downloadURL;
                            doUpdate();
                        });
                } else {
                    doUpdate();
                }
            } else {
                updates["WidgetImageURL"] = '';
                doUpdate();
            }

            function doUpdate() {
                ref.update(updates)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Form Saved!')
                            .hideDelay(1000)
                            .position('top right')
                    );
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                }); 
            };
        };

        function executeImgSave(imgData) {
            return new Promise(function(resolve, reject) {
                var ref=db.ref('/DesignForm/'+companyKey+'/'+designFormKey);                     
                var storageRef = firebase.storage().ref('designform-images/'+UID+'/'+designFormKey);
                storageRef.putString(imgData, 'data_url').then(function(snapshot) {
                    resolve(snapshot.downloadURL);
                });
            });
        };


        function btnPreviewTemplate(ev, templateKey, templateName) {
            $mdDialog.show({
                controller: 'PreviewTemplateialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-forms/dialogs/design/preview-template/preview-template-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    templateKey: templateKey,
                    templateName: templateName
                }
            })
        };

        function btnDownloadTemplate(ev, templateKey, templateName) {
            // it is being watched in myformdesigncontroller
            $scope.downloadTemplateKey = templateKey;
        };

        function btnSettingsPanelSave () {
            // it is being watched in myformdesigncontroller
            $scope.saveFormItem = true;
        };

        function closeSearchTemplateDialog() {
            $mdSidenav('search-template').toggle();
        };


        vm.ngFlowOptions = {
            singleFile: true,
            allowDuplicateUploads    : true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };

        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            vm.form.WidgetImageURL = '';
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };
            vm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file.file);
            fileReader.onload = function (event)
            {
                file.url = event.target.result;
                $scope.$evalAsync(function ()
                {
                    vm.form.WidgetImageURL = file.url;
                });
            };
            file.type = 'image';
        }

        vm.settingsObjects = {
            'Header': {'text-value':1,'align-item':1},
            'Label': {'text-value':1,'align-item':1},
            'Text Box': {'label-text':1,'max-char':1,'required-field':1},
            'Text Area': {'label-text':1,'max-char':1,'required-field':1},
            'Dropdown': {'label-text':1,'required-field':1,'select-options':1},
            'Radio Button': {'label-text':1,'option-order':1,'required-field':1,'select-options':1},
            'Checkbox': {'label-text':1,'option-order':1,'required-field':1,'select-options':1},
            'Image': {'image-file':1,'align-item':1},
            'Line': {},
            'File Upload': {},
            'Date': {'label-text':1,'minmax-date':1,'date-hideicons':1,'required-field':1},
            'Time': {'label-text':1,'required-field':1},
            'Numeric': {'label-text':1,'minmax-value':1,'required-field':1},
            'Email': {'label-text':1,'required-field':1},
            'Phone Number': {'label-text':1,'phonenumber-mask':1,'required-field':1},
            'Table': {'row-number':1, 'allow-adddeleterows':1, 'table-columns':1}
        };

        function checkSettingsItem (item, obj) {
            if (item && obj) {
                return (vm.settingsObjects[item][obj]);
            }
            return false;
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormDialogController', MyFormDialogController);

    /** @ngInject */
    function MyFormDialogController($mdDialog, $mdToast, UID, companyKey)
    {
        var vm = this;
        // Data
        vm.myForm = {
            'id'      : '',
            'Type'    : '',
            'Name': ''
        };

        vm.title = 'New Form';
        vm.newForm = true

        // Methods
        vm.addNewForm = addNewForm;
        vm.closeDialog = closeDialog;

        /**
         * Add new form
         */
        function addNewForm()
        {
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var postData = {
                DateCreated: dateNow,
                DateEdited: dateNow,
                Name: vm.myForm.Name,
                Type: vm.myForm.Type,
                WidgetColor: '',
                Description: '',
                UID: UID
            };

			var newPostKey = firebase.database().ref().child('DesignForm').push().key;
			var updates = {};
            updates['DesignForm/' +companyKey+'/'+ newPostKey] = postData;
			firebase.database().ref().update(updates)
		    .then(function() {
	            $mdToast.show(
	                $mdToast.simple()
	                .textContent('Form Created!')                       
	                .hideDelay(1000)
	                .position('top right')
	            );
		    })
		    .catch(function(error) {
	            $mdToast.show(
	                $mdToast.simple()
	                .textContent('Error:'+error)                       
	                .hideDelay(1000)
	                .position('top right')
	            );
		    });

            closeDialog();
        }


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('AddUserDialogController', AddUserDialogController);

    /** @ngInject */
    function AddUserDialogController($mdDialog)
    {
        var vm = this;

        // Methods
		vm.closeDialog = closeDialog;
		vm.submitForm = submitForm;

		function submitForm(ev, email) {
			$mdDialog.hide(email);
		};


        function closeDialog() {
            $mdDialog.cancel();
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-page',
            []
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-page')
        .controller('UploadCompanyPictureDialogController', UploadCompanyPictureDialogController);

    /** @ngInject */
    function UploadCompanyPictureDialogController($scope, $mdDialog, $mdToast, $translate, companyKey, UID)
    {
        var vm = this;
        // Data
        var db=firebase.database();
		vm.myImage='';
        vm.myCroppedImage='';
        vm.showSaveButton=false;

        // Methods
        vm.cancelDialog = cancelDialog;
        vm.executeImgSave=executeImgSave;

        function cancelDialog() {
            $mdDialog.cancel();
		};

        $scope.imageUpload=function(element) {
            var reader = new FileReader();
            reader.onload = imageIsLoaded;
            reader.readAsDataURL(element.files[0]);
		};
		
        function imageIsLoaded(ev) {
            var img = new Image();
            img.src=ev.target.result;
            img.onload = function(){
                $scope.$apply(function() {
                    $scope.myImage=ev.target.result;
                    vm.showSaveButton=true;
                });
            }       
        };

        function executeImgSave(imgData) {
            vm.showSaveButton = false;
            var ref = firebase.database().ref('/CompanyPages/' + companyKey);
            var storageRef = firebase.storage().ref('company-images/' + companyKey);
            storageRef.child(companyKey).putString(imgData, 'data_url')
                .then(function (snapshot) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    var downloadURL = snapshot.downloadURL;
                    ref.child("Photo").update({ "PhotoURL": downloadURL, "LastUpdate": dateNow })
                        .then(function() {
                            var msg = $translate.instant('MCP.COMPANY_PICTURE_SAVED');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(msg)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                            $mdDialog.hide(downloadURL);
                        })
                        .catch(function (error) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Error:' + error)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                        });
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(3000)
                            .position('top right')
                    );
                });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-page')
        .controller('UploadBgDialogController', UploadBgDialogController);

    /** @ngInject */
    function UploadBgDialogController($scope, $mdDialog, $mdToast, $translate, UID)
    {
        var vm = this;
        // Data
        var db=firebase.database();
		vm.myImage='';
        vm.myCroppedImage='';
        vm.showSaveButton=false;

        // Methods
        vm.cancelDialog = cancelDialog;
        vm.executeImgSave=executeImgSave;

        function cancelDialog() {
            $mdDialog.cancel();
		};

        $scope.imageUpload=function(element) {
            var reader = new FileReader();
            reader.onload = imageIsLoaded;
            reader.readAsDataURL(element.files[0]);
		};
		
        function imageIsLoaded(ev) {
            var img = new Image();
            img.src=ev.target.result;
            img.onload = function(){
                $scope.$apply(function() {
                    $scope.myImage=ev.target.result;
                    vm.showSaveButton=true;
                });
            }       
        };

        function executeImgSave(imgData) {
            var ref=firebase.database().ref('/Users/'+UID);                     
            var storageRef = firebase.storage().ref('profile-images/'+UID);
            storageRef.child(UID).putString(imgData, 'data_url').then(function(snapshot) {
                var downloadURL=snapshot.downloadURL;
                ref.update({"PhotoURL":downloadURL})
                $mdDialog.hide(downloadURL);
            });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.waiting-forme',
            [
                // 3rd Party Dependencies
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_waiting-forme', {
                abstract: true,
                url     : '/pages/waiting-forme'
            })        
            .state('app.pages_waiting-forme.pending-forms', {
                url      : '/pending-forms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/waiting-forme/pending-forms/pending-forms.html',
                        controller : 'WaitingForMePendingFormsController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]                   
                },
                bodyClass: 'waiting-forme'
            })
            .state('app.pages_waiting-forme.archive', {
                url      : '/archive',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/waiting-forme/archive/archive.html',
                        controller : 'WaitingForMeArchiveController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]          
                },
                bodyClass: 'waiting-forme'
            });            

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/waiting-forme');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.waiting-forme', {
            title : 'Waiting For Me',
            icon  : 'icon-account-check',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.waiting-forme.pending-forms', {
            title: 'Pending Forms',
            state: 'app.pages_waiting-forme.pending-forms'
        });

        msNavigationServiceProvider.saveItem('pages.waiting-forme.archive', {
            title: 'Archive',
            state: 'app.pages_waiting-forme.archive'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.waiting-forme')
        .controller('ViewFormDialogController', ViewFormDialogController);

    /** @ngInject */
    function ViewFormDialogController($mdDialog, $mdToast, $timeout, formInfo, nfviewForm)
    {
        var vm = this;
        // Data

        showForm();
        
        function showForm() {
            firebase.database().ref('/FormItems/' + formInfo.FormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="viewForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: value, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Value: value, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        var optSelected = data.Options[key].Selected;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq, Selected: optSelected });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" ' +
                                        'aria-label="opt.Value" ' +
                                        'ng-checked="opt.Selected">{{opt.Value}}' +
                                        '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var fileName = data.FileName;
                                    var fileURL = data.FileURL;
                                    var element = ''+
                                        '<div>'+
                                            '<md-button class="md-icon-button" aria-label="attach file" ng-disabled>'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label>{{item.FileName}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="item.FileURL" class="md-icon-button md-primary" aria-label="remove" ng-href="{{item.FileURL}}" target="_blank">'+
                                                '<md-icon md-font-icon="icon-download"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, FileName: fileName, FileURL: fileURL });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var timeValue = new Date(value);
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: timeValue, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required">' +
                                        '<span translate="MF.REQUIRED">Required</span>' +
                                        '</div>' +
                                        '<div ng-message="pattern">' +
                                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead><tr><th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th></tr></thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in item.Rows track by $index">' +
                                        '<td ng-repeat="col in row.Cols">' +
                                        '<input ng-value="col.Value">' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, RowCounter: rowCounter, Columns: columns, Rows: rows, ColCounter: colCounter });
                                    break;
                            }

                        });
                    });
                });
        };

        vm.title = formInfo.DesignFormName+' ('+formInfo.FormKey+')';
        var formItems=[];
        vm.formItems=formItems;


        // Methods
        vm.closeDialog = closeDialog;

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.shared-withme')
        .controller('ViewFormListController', ViewFormListController);

    /** @ngInject */
    function ViewFormListController($state, $timeout, $mdSidenav, $mdDialog, $document, nfdesignForm, formatTimeStamp)
    {
        var vm = this;

        // Data
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;

        //Methods
        vm.goSharedWithMe=goSharedWithMe;
        vm.toggleDetails=toggleDetails;
        vm.openViewFormDialog=openViewFormDialog;
        vm.select=select;
        
        var designFormKey=nfdesignForm.getKey();
        var designFormName=nfdesignForm.getName();
        vm.designFormName=designFormName;
        vm.forms=[];
        var formUsers={};
        vm.formTransactions=[];      

        loadForms();

        function loadForms() {
            var formRef = db.ref('/UserFormSubmissions/' + UID).orderByChild('DesignFormKey').equalTo(designFormKey);
            formRef.once('value', function(snap){
                snap.forEach(function(snapForm) {
                    var key=snapForm.key;
                    var data=snapForm.val();
                    var dateCreated=data.DateCreated;
                    var status=data.Status;

                    $timeout(function(){
                        vm.forms.push({
                            "FormKey":key,
                            "DesignFormKey": designFormKey,
                            "DesignFormName":designFormName, 
                            "Status":status, 
                            "DateCreated":dateCreated
                        });
                    });
                })
            });
        };

        function goSharedWithMe()
        {
            $state.go('app.pages_shared-withme');
        };

        function select(item) {
            vm.selected=item;
            if (!vm.formTransactions[item.FormKey]) {
                loadFormTransaction(item.DesignFormKey, item.FormKey);
            }            
        };

        function loadFormTransaction(designFormKey, formKey) {
            db.ref('/FormTransactions/' + designFormKey + '/' + formKey).once('value', function (snap) {
                snap.forEach(function(snapTransaction){
                    var data=snapTransaction.val();
                    var dateTime=data.DateTime,
                        action=data.Action,
                        formUserUID=data.UID;
                        vm.formTransactions[formKey] = [];

                    if (!formUsers.formUserUID) {
                        loadFormUser(formUserUID)
                            .then(function (response) {
                                var userName = response.DisplayName;
                                var photoURL = response.PhotoURL;
                                $timeout(function () {
                                    vm.formTransactions[formKey].push({'DateTime': dateTime, 'Action': action, 'UserName': userName, 'PhotoURL': photoURL});
                                });
                            });
                    } else {
                        var userName = formUsers.formUserUID.DisplayName;
                        $timeout(function () {
                            vm.formTransactions[formKey].push({'DateTime':dateTime, 'Action':action, 'UID':uid, 'UserName': userName, 'PhotoURL': photoURL});
                        });
                    }
                })
            })
        };

        function loadFormUser(formUserUID) {
            return new Promise(function(resolve, reject) {
                db.ref('/Users/').child(formUserUID)
                .once('value', function (userSnap) {
                    var displayName = userSnap.val().DisplayName;
                    var photoURL = userSnap.val().Photo.PhotoURL;
                    formUsers[formUserUID]={};
                    formUsers[formUserUID]["DisplayName"]=displayName;
                    formUsers[formUserUID]["PhotoURL"]=photoURL;
                    resolve(formUsers[formUserUID]);
                });
            });
        };


        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('form-detail-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


        /**
         * Open new form dialog
         *
         * @param ev
         */
        function openViewFormDialog(item,ev)
        {
            vm.selected = item;
            $mdDialog.show({
                controller         : 'ViewFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pages/shared-withme/views/view-formlist/dialog/viewform-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    formInfo :   vm.selected
                }
            });
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search', ['ngMeta'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, ngMetaProvider)
    {
        // State
        $stateProvider
            .state('app.pages_search', {
                abstract: true,
                url     : '/pages/search',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/search/search.html',
                        controller : 'SearchController as vm'
                    }
                },
                bodyClass: 'search'
            })
            .state('app.pages_search.company', {
                url: '/company/:searchKey',
                views: {
                    'company': {
                        templateUrl: 'app/main/pages/search/tabs/company/search-company.html',
                        controller: 'SearchCompanyController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$waitForSignIn();
                    }]
                },
                bodyClass: 'search',
                data: {
                    'meta': {
                        'title': 'Search Company',
                        'og:title': 'Search Company',
                        'description': 'Search company pages and view public forms',
                        'og:description': 'Search company pages and view public forms',
                    }
                }
            })
            .state('app.pages_search.person', {
                url: '/person/:searchKey',
                views: {
                    'person': {
                        templateUrl: 'app/main/pages/search/tabs/person/search-person.html',
                        controller: 'SearchPersonController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$waitForSignIn();
                    }]
                },
                bodyClass: 'search',
                data: {
                    'meta': {
                        'title': 'Search People',
                        'og:title': 'Search People',
                        'description': 'Search people',
                        'og:description': 'Search people',
                    }
                }
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchPersonController', SearchPersonController)
        .directive('scrollToBottom', scrollToBottomDirective);

    /** @ngInject */
    function SearchPersonController($state, $timeout)
    {
        var vm = this;

        //firebase
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;

        // Methods
        vm.followPersonPage = followPersonPage;
        vm.unFollowPersonPage = unFollowPersonPage;
        vm.showMore = showMore;
        vm.search = search;
        //////////
        vm.countryCodes = [];
        vm.personPages = [];
        vm.searchKeys = {};
        vm.noResultsFound = false;
        vm.loadingProgress = false;
        var lastStackKey;

        vm.searchKeys.displayName = $state.params.searchKey;

        var personPagesRef = db.ref('/Users/').orderByKey().limitToFirst(11);

        loadCountryCodes();

        if ($state.params.searchKey) {
            search();
        } else {
            loadPersonPages();
        }
        
        function loadCountryCodes() {
            db.ref('Definitions/Countries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    vm.countryCodes.push({'key':item.key, 'name':item.val()});
                })
            })
        };

        function search() {
            vm.loadingProgress = true;

            if (vm.searchKeys.countryCode && !vm.searchKeys.displayName) {
                var searchKey = vm.searchKeys.countryCode;
                personPagesRef = db.ref('/Users/').orderByChild('CountryCode').equalTo(searchKey).limitToFirst(11);

            } else if (!vm.searchKeys.countryCode && vm.searchKeys.displayName) {
                var searchKey = vm.searchKeys.displayName.toLowerCase();
                personPagesRef = db.ref('/Users/').orderByChild('DisplayNameLower').startAt(searchKey).endAt(searchKey + '\uf8ff').limitToFirst(11);

            } else if (vm.searchKeys.countryCode && vm.searchKeys.displayName) {
                var searchKey = vm.searchKeys.countryCode + '_' + vm.searchKeys.displayName.toLowerCase();
                personPagesRef = db.ref('/Users/').orderByChild('Search_cc_dn').startAt(searchKey).endAt(searchKey + '\uf8ff').limitToFirst(11);

            } else {
                personPagesRef = db.ref('/Users/').orderByKey().limitToFirst(11);
            }

            vm.personPages = [];
            loadPersonPages();
        };

        function loadPersonPages(reload) {
            var counter = 0;
            personPagesRef.once('value', function (snap) {
                var children = snap.numChildren();

                if (children == 0) {
                    $timeout(function () {
                        vm.noResultsFound = true;
                    });
                } else {
                    $timeout(function () {
                        vm.noResultsFound = false;
                    });                    
                }

                if (children < 11) {
                    vm.showMoreBtnVisible = false;
                } else {
                    vm.showMoreBtnVisible = true;
                }
                snap.forEach(function (snapPersonPage) {
                    var data = snapPersonPage.val();
                    var key = snapPersonPage.key;
                    lastStackKey = key;

                    var countryName;

                    if (data.CountryCode) {
                        countryName = vm.countryCodes.getByKey(data.CountryCode).name;
                    }

                    counter++;

                    if(counter <= 10) {
                        isFollow(key).then(function (resp) {
                            var isFollowing = resp;
                            $timeout(function () {
                                vm.personPages.push({
                                    'key': key,
                                    'displayName': data.DisplayName,
                                    'countryName': countryName,
                                    'photoURL': data.Photo.PhotoURL,
                                    'isFollowing': isFollowing
                                });
                            });
                        })
                    }
                })

                vm.loadingProgress = false;
            });
        };

        function showMore() {
            personPagesRef = db.ref('/Users/').orderByKey().startAt(lastStackKey).limitToFirst(11);
            loadPersonPages();
        };

        function isFollow(personPageKey) {
            return new Promise(function(resolve, reject) {
                if (vm.user) {
                    db.ref('/UserFollows/' + vm.user.uid + '/Person/' + personPageKey).once('value', function (snap) {
                        if (snap.val()) {
                            resolve (true);
                        } else {
                            resolve (false);
                        }
                    })
                } else {
                    resolve (false);
                }
            });
        };

        function followPersonPage(personPageKey) {
            if (vm.user) {
                var ref = db.ref('UserFollows/' + vm.user.uid + '/Person/' + personPageKey);
                ref.set(true)
                    .then(function () {
                        $timeout(function () {
                            vm.personPages.getByKey(personPageKey).isFollowing = true;
                        });
                    }), function (err) {
                        console.log(err);
                    }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function unFollowPersonPage(personPageKey) {
            var ref = db.ref('UserFollows/' + vm.user.uid + '/Person/' + personPageKey);
            ref.set(null)
                .then(function () {
                    $timeout(function () {
                        vm.personPages.getByKey(personPageKey).isFollowing = false;
                    });
                }), function (err) {
                    console.log(err);
                }
        };

        Array.prototype.getByKey = function (value)
        {
            return this.filter(function (x)
            {
                return x.key === value;
            })[0];
        }


    }

    /** @ngInject */
    function scrollToBottomDirective($document) {
        var unbind;
        return {
            restrict: 'A',
            scope: { scrollToBottom: "=" },
            link: function (scope, element) {
                if (unbind) { unbind(); }
                unbind = scope.$watchCollection('scrollToBottom', function () {
                    // assumes we have jQuery, which handles the pretty animation
                    // otherwise, just use this code instead:
                    // element[0].scrollTop = element[0].scrollHeight;
                    $(element).animate({ scrollTop: element[0].scrollHeight });
                });
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchCompanyController', SearchCompanyController)
        .directive('scrollToBottom', scrollToBottomDirective);

    /** @ngInject */
    function SearchCompanyController($state, $timeout)
    {
        var vm = this;

        //firebase
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;

        // Methods
        vm.followCompanyPage = followCompanyPage;
        vm.unFollowCompanyPage = unFollowCompanyPage;
        vm.showMore = showMore;
        vm.search = search;
        //////////
        vm.countryCodes = [];
        vm.industryCodes = [];
        vm.companyPages = [];
        vm.searchKeys = {};
        vm.noResultsFound = false;
        var lastStackKey;
        
        vm.searchKeys.companyName = $state.params.searchKey;

        var companyPagesRef = db.ref('/CompanyPages/').orderByKey().limitToFirst(11);

        loadCountryCodes();

        loadIndustryCodes();

        if ($state.params.searchKey) {
            search();
        } else {
            loadCompanyPages();
        }

        function loadCountryCodes() {
            db.ref('Definitions/Countries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    vm.countryCodes.push({'key':item.key, 'name':item.val()});
                })
            })
        };

        function loadIndustryCodes() {
            db.ref('/Definitions/Industries').once('value', function (snap) {
                snap.forEach(function (item) {
                    vm.industryCodes.push({'key': item.key, 'name': item.val()});
                })
            });
        };

        function search() {

            if (vm.searchKeys.countryCode && !vm.searchKeys.industryCode && !vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.countryCode;
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('CountryCode').equalTo(searchKey).limitToFirst(11);

            } else if (!vm.searchKeys.countryCode && vm.searchKeys.industryCode && !vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.industryCode;
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('IndustryCode').equalTo(searchKey).limitToFirst(11);

            } else if (!vm.searchKeys.countryCode && !vm.searchKeys.industryCode && vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.companyName.toLowerCase();
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('CompanyNameLower').startAt(searchKey).endAt(searchKey+'\uf8ff').limitToFirst(11);

            } else if (vm.searchKeys.countryCode && vm.searchKeys.industryCode && !vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.countryCode + '_' + vm.searchKeys.industryCode;
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('Search_cc_ic').equalTo(searchKey).limitToFirst(11);

            } else if (vm.searchKeys.countryCode && !vm.searchKeys.industryCode && vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.countryCode + '_' + vm.searchKeys.companyName.toLowerCase();
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('Search_cc_cn').startAt(searchKey).endAt(searchKey+'\uf8ff').limitToFirst(11);

            } else if (!vm.searchKeys.countryCode && vm.searchKeys.industryCode && vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.industryCode + '_' + vm.searchKeys.companyName.toLowerCase();
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('Search_ic_cn').startAt(searchKey).endAt(searchKey+'\uf8ff').limitToFirst(11);

            } else if (vm.searchKeys.countryCode && vm.searchKeys.industryCode && vm.searchKeys.companyName) {
                var searchKey = vm.searchKeys.countryCode + '_' + vm.searchKeys.industryCode + '_' + vm.searchKeys.companyName.toLowerCase();
                companyPagesRef = db.ref('/CompanyPages/').orderByChild('Search_cc_ic_cn').startAt(searchKey).endAt(searchKey+'\uf8ff').limitToFirst(11);

            } else {
                companyPagesRef = db.ref('/CompanyPages/').orderByKey().limitToFirst(11);
            }
            vm.companyPages = [];
            loadCompanyPages();
        };

        function loadCompanyPages() {
            var counter = 0;
            companyPagesRef.once('value', function (snap) {
                var children = snap.numChildren();
                if (children == 0) {
                    $timeout(function () {
                        vm.noResultsFound = true;
                    });
                } else {
                    $timeout(function () {
                        vm.noResultsFound = false;
                    });                    
                }

                if (children < 11) {
                    vm.showMoreBtnVisible = false;
                } else {
                    vm.showMoreBtnVisible = true;
                }
                snap.forEach(function (snapCompanyPage) {
                    var data = snapCompanyPage.val();
                    var key = snapCompanyPage.key;
                    lastStackKey = key;
                    var industryName;

                    if (data.IndustryCode) {
                        industryName = vm.industryCodes.getByKey(data.IndustryCode).name;
                    }

                    counter++;

                    if(counter <= 10) {
                        isFollow(key).then(function (resp) {
                            var isFollowing = resp;
                            $timeout(function () {
                                vm.companyPages.push({
                                    'key': key,
                                    'companyName': data.CompanyName,
                                    'companyURL': data.CompanyURL,
                                    'photoURL': data.Photo.PhotoURL,
                                    'industryName': industryName,
                                    'isFollowing': isFollowing
                                });
                            });
                        })
                    }
                })
            });
        };

        function showMore() {
            companyPagesRef = db.ref('/CompanyPages/').orderByKey().startAt(lastStackKey).limitToFirst(11);
            loadCompanyPages();
        };

        function isFollow(companyPageKey) {
            return new Promise(function(resolve, reject) {
                if (vm.user) {
                    db.ref('/UserFollows/' + vm.user.uid + '/Company/' + companyPageKey).once('value', function (snap) {
                        if (snap.val()) {
                            resolve (true);
                        } else {
                            resolve (false);
                        }
                    })
                } else {
                    resolve (false);
                }
            });
        };

        function followCompanyPage(companyPageKey) {
            if (vm.user) {
                var ref = db.ref('UserFollows/' + vm.user.uid + '/Company/' + companyPageKey);
                ref.set(true)
                    .then(function () {
                        $timeout(function () {
                            vm.companyPages.getByKey(companyPageKey).isFollowing = true;
                        });
                    }), function (err) {
                        console.log(err);
                    }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function unFollowCompanyPage(companyPageKey) {
            var ref = db.ref('UserFollows/' + vm.user.uid + '/Company/' + companyPageKey);
            ref.set(null)
                .then(function () {
                    $timeout(function () {
                        vm.companyPages.getByKey(companyPageKey).isFollowing = false;
                    });
                }), function (err) {
                    console.log(err);
                }
        };

        Array.prototype.getByKey = function (value)
        {
            return this.filter(function (x)
            {
                return x.key === value;
            })[0];
        }


    }

    /** @ngInject */
    function scrollToBottomDirective($document) {
        var unbind;
        return {
            restrict: 'A',
            scope: { scrollToBottom: "=" },
            link: function (scope, element) {
                if (unbind) { unbind(); }
                unbind = scope.$watchCollection('scrollToBottom', function () {
                    // assumes we have jQuery, which handles the pretty animation
                    // otherwise, just use this code instead:
                    // element[0].scrollTop = element[0].scrollHeight;
                    $(element).animate({ scrollTop: element[0].scrollHeight });
                });
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-person', ['ngTextTruncate', 'flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.public-person', {
                url      : '/person/:profileId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/public-person/public-person.html',
                        controller : 'PublicPersonController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$waitForSignIn();
                    }]
                },
                bodyClass: 'public-person'
            });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/public-person');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-person')
        .controller('ShowLikesDialogController', ShowLikesDialogController);

    /** @ngInject */
    function ShowLikesDialogController($mdDialog, $state, $timeout, likes)
    {
        var vm = this;
        var db=firebase.database();
        vm.users = [];

        vm.likeCount = Object.keys(likes).length;

        // Methods
        vm.gotoUserPage = gotoUserPage;
        vm.closeDialog = closeDialog;
        //

        angular.forEach(likes, function (data, userKey) {
            db.ref('/Users/').child(userKey)
            .once('value', function (userSnap) {
                var displayName = userSnap.val().DisplayName;
                var photoURL = userSnap.val().Photo.PhotoURL;
                $timeout(function () {
                    vm.users.push({'key': userKey, 'displayName': displayName, 'photoURL': photoURL});
                });
            });
        });


        function gotoUserPage(userKey) {
            $mdDialog.hide();
            $state.go('app.public-person',{'profileId':userKey});
        };


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('SharePersonPostDialogController', SharePersonPostDialogController);

    /** @ngInject */
    function SharePersonPostDialogController($mdDialog, $translate, $timeout, sharedPost, personPage, user)
    {
        var vm = this;

        vm.newSharedPost={commentsEnabled:true};

        // Data

        vm.title = $translate.instant('PUBLIC_PERSON.SHARE');
        vm.sharedPost = sharedPost;
        vm.personPage = personPage;
        vm.user = user;

		// Methods
        vm.submitSharedPost = submitSharedPost;
        vm.closeDialog = closeDialog;
        vm.enableComments = enableComments;
        vm.disableComments = disableComments;
        //
        
        function enableComments() {
            $timeout(function() {
                vm.newSharedPost.commentsEnabled = true;
            }, 500)
        };

        function disableComments() {
            $timeout(function() {
                vm.newSharedPost.commentsEnabled = false;
            }, 500)
        };

		function submitSharedPost() {
			$mdDialog.hide(vm.newSharedPost);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-company', ['ngTextTruncate', 'flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.public-company', {
                url: '/company/:companyURL',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/public-company/public-company.html',
                        controller: 'PublicCompanyController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$waitForSignIn();
                    }],
                    companyURL: function ($stateParams) {
                        return ($stateParams.companyURL);
                    }
                },
                bodyClass: 'public-company'
            });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/public-company');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-company')
        .controller('msProfileFormnoteController', msProfileFormnoteController)
        .directive('msProfileFormnote', msProfileFormnoteDirective);

    /** @ngInject */
    function msProfileFormnoteController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.Description || vm.note.Description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.Description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.Description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msProfileFormnoteDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msProfileFormnoteController as MsProfileFormnote',
            templateUrl     : 'app/main/pages/public-company/directives/ms-profile-formnote/ms-profile-formnote.html',
            require         : ['msProfileFormnote', '^msMasonry'],
            bindToController: {
                msProfileFormnote: '='
            },
            link            : function (scope, element, attributes, controllers)
            {
                var MsProfileFormnote = controllers[0];
                var msMasonry = controllers[1];

                MsProfileFormnote.element = element;
                MsProfileFormnote.note = MsProfileFormnote.msProfileFormnote;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsProfileFormnote.noFontResize = true;
                }

                scope.$watch('MsProfileFormnote.msProfileFormnote', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsProfileFormnote.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsProfileFormnote.noFontResize || MsProfileFormnote.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsProfileFormnote.columnWidth = msMasonry.columnWidth;

                    MsProfileFormnote.updateDescriptionFontSize();
                });
            }
        };
    }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-company')
        .controller('ShowLikesDialogController', ShowLikesDialogController);

    /** @ngInject */
    function ShowLikesDialogController($mdDialog, $state, $timeout, likes)
    {
        var vm = this;
        var db=firebase.database();
        vm.users = [];

        vm.likeCount = Object.keys(likes).length;

        // Methods
        vm.gotoUserPage = gotoUserPage;
        vm.closeDialog = closeDialog;
        //

        angular.forEach(likes, function (data, userKey) {
            db.ref('/Users/').child(userKey)
            .once('value', function (userSnap) {
                var displayName = userSnap.val().DisplayName;
                var photoURL = userSnap.val().Photo.PhotoURL;
                $timeout(function () {
                    vm.users.push({'key': userKey, 'displayName': displayName, 'photoURL': photoURL});
                });
            });
        });


        function gotoUserPage(userKey) {
            $mdDialog.hide();
            $state.go('app.public-person',{'profileId':userKey});
        };


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('ShareCompanyPostDialogController', ShareCompanyPostDialogController);

    /** @ngInject */
    function ShareCompanyPostDialogController($mdDialog, $translate, $timeout, sharedPost, companyPage, user)
    {
        var vm = this;

        vm.newSharedPost={commentsEnabled:true};

        // Data

        vm.title = $translate.instant('PUBLIC_COMPANY.SHARE');
        vm.sharedPost = sharedPost;
        vm.companyPage = companyPage;
        vm.user = user;

		// Methods
        vm.submitSharedPost = submitSharedPost;
        vm.closeDialog = closeDialog;
        vm.enableComments = enableComments;
        vm.disableComments = disableComments;
        //
        
        function enableComments() {
            $timeout(function() {
                vm.newSharedPost.commentsEnabled = true;
            }, 500)
        };

        function disableComments() {
            $timeout(function() {
                vm.newSharedPost.commentsEnabled = false;
            }, 500)
        };

		function submitSharedPost() {
			$mdDialog.hide(vm.newSharedPost);
		};

        function closeDialog()
        {
            $mdDialog.cancel();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-company')
        .controller('FillFormDialogController', FillFormDialogController);

    /** @ngInject */
    function FillFormDialogController($mdDialog, $mdToast, $timeout, $translate, $rootScope, designFormKey, designFormName, UID, companyKey)
    {
        var vm = this;
        // Data
        var db=firebase.database();

        vm.title = designFormName;

        var formItems = [];
        vm.formItems = formItems;

        // Methods
        vm.addRow = addRow;
        vm.deleteRow = deleteRow;
        vm.openTableRowMenu = openTableRowMenu;
        vm.submitForm = submitForm;
        vm.cancelDialog = cancelDialog;
        vm.getRows = getRows;
        vm.fileAdded = fileAdded;

        showForm();

        var originatorEv;
        function openTableRowMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function getRows(id) {
            return formItems.getById(id).Rows;
        };

        function addRow(formdivId, i) {
            var item = formItems.getById(formdivId);
            var rowsObj = item["Rows"];
            var cols = angular.copy(rowsObj[Object.keys(rowsObj)[0]]["Cols"]);
            angular.forEach(cols, function(colItem, colKey) {
                colItem.Value = "";
            });
            item["RowNumber"]++;
            item["RowCounter"]++;
            item["Rows"]["row_" + item.RowCounter] = { "RowKey": "row_" + item.RowCounter, "Cols": cols };
        };

        function deleteRow(formdivId, rowKey) {
            var item = formItems.getById(formdivId);
            if (Object.keys(item.Rows).length>1) {
                item.RowNumber--;
                delete item["Rows"][rowKey];
            }
        };

        function fileAdded(item, $flow, flowFile, formdivId) {
            var item = formItems.getById(formdivId);
            var fileReader = new FileReader();
            fileReader.readAsDataURL(flowFile.file);
            fileReader.onload = function (event) {
                item.FileURL = event.target.result;
                item.FileName = flowFile.file.name;
            };
        };

        function showForm() {
            db.ref('/DesignFormItems/' + companyKey + '/' + designFormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" ' +
                                        'md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq, Selected: false });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" ' +
                                        'aria-label="opt.Value" ' +
                                        'ng-model="opt.Selected">{{opt.Value}}' +
                                        '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var element = ''+
                                        '<div flow-init="{singleFile:true, target:\'upload\'}" flow-file-added="vm.fileAdded( item, $flow, $file, \'' + formdivId + '\')" flow-file-success="$file.msg = $message">'+
                                            '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                                '<input type="file" name="' + formdivId + '"  style="visibility: hidden; position: absolute;">'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                                                '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="pattern" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead>' +
                                        '<tr>' +
                                        '<th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th>' +
                                        '<th class="actions" ng-if="item.AllowAddDeleteRows">' +
                                        '<md-button class="md-icon-button md-accent"' +
                                        'aria-label="Add row" translate' +
                                        'translate-attr-aria-label="SW.ADD_ROW"' +
                                        'ng-click="vm.addRow(\'' + formdivId + '\',$index)">' +
                                        '<md-icon md-font-icon="icon-table-row-plus-after"></md-icon>' +
                                        '</md-button>' +
                                        '</th>' +
                                        '</tr>' +
                                        '</thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in vm.getRows(item.id) track by row.RowKey">' +
                                        '<td ng-repeat="col in row.Cols track by $index">' +
                                        '<input ng-model="col.Value">' +
                                        '</td>' +
                                        '<td ng-if="item.AllowAddDeleteRows" class="actions">' +
                                        '<md-menu >' +
                                        '<md-button aria-label="Open actions menu" class="md-icon-button" ng-click="vm.openTableRowMenu($mdMenu, $event)">' +
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>' +
                                        '</md-button>' +
                                        '<md-menu-content width="2">' +
                                        '<md-menu-item>' +
                                        '<md-button ng-click="vm.deleteRow(\'' + formdivId + '\',row.RowKey)" ng-disabled="" translate="SW.DELETE"' +
                                        'ng-if="item.AllowAddDeleteRows">'+
                                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                                        'Delete' +
                                        '</md-button>' +
                                        '</md-menu-item>' +
                                        '</md-menu-content>' +
                                        '</md-menu>' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Seq: seq, Type: elementType, RowNumber: rowNumber, RowCounter: rowCounter, Rows: rows, Columns: columns, ColCounter: colCounter, AllowAddDeleteRows: allowAddDeleteRows });
                                    break;
                            }
                        });
                    });
                });
        };

        function submitForm() {
            var tempArr=angular.copy(formItems);
            var count=tempArr.length;
            var newFormKey = db.ref().child('Form').child(designFormKey).push().key;
            var dateNow=firebase.database['ServerValue']['TIMESTAMP'];
            var updates={};
            var obj={'CompanyKey': companyKey, 'DesignFormKey':designFormKey, 'DesignFormName':designFormName, 'DateCreated':dateNow, 'UID':UID};
            var itemsObj={};
            var fileArr = [];

            function createItemsObj() {
                return new Promise(function(resolve, reject) {
                    for (var i=0; i<=count; i++) {
                        if (i==count) {
                            resolve(itemsObj);
                        }
                        itemsObj[tempArr[i].id]={};
                        for (var property in tempArr[i]) {
                            if (tempArr[i].hasOwnProperty(property)) {
                                if (property!='html' && property!='id' ) {
                                    itemsObj[tempArr[i].id][property]=tempArr[i][property];
                                } 
                                if (property=='Options') {
                                    var optObj={};
                                    tempArr[i][property].forEach(function(opt){
                                        optObj[opt.Key]={};
                                        optObj[opt.Key]['Seq']=opt.Seq;
                                        optObj[opt.Key]['Value']=opt.Value;
                                        if (tempArr[i]["Type"]=="Checkbox") {
                                            optObj[opt.Key]['Selected']=opt.Selected;
                                        };
                                    });
                                    itemsObj[tempArr[i].id]['Options']=optObj
                                }
                                if (property=='Columns') {
                                    var colObj={};
                                    tempArr[i][property].forEach(function(col){
                                        colObj[col.Key]={};
                                        colObj[col.Key]['Seq']=col.Seq;
                                        colObj[col.Key]['Value']=col.Value;
                                    });
                                    itemsObj[tempArr[i].id]['Columns']=colObj
                                }
                                if (property == 'FileURL') {
                                    var fileData = tempArr[i][property];
                                    var fileKey = tempArr[i].id;
                                    fileArr.push({ "id": fileKey, "file": fileData, "formitemKey": i, "fileName": tempArr[i].FileName });
                                    itemsObj[tempArr[i].id][property] = null;
                                }
        
                            }
                        }
        
                    }
                });
            };

            function executeFileSave(fileArr) {
                return new Promise(function (resolve, reject) {
                    var storageRef = firebase.storage().ref('form-files/' + designFormKey);
                    var len = fileArr.length;
                    var counter = 1;
                    fileArr.forEach(function (item) {
                        var storageKey = guidGenerator();
                        var fileType = getFileExtension(item.fileName);
                        var fileData = item.file;
                        var newKey = storageKey + '.' + fileType;
                        storageRef.child(newKey).putString(fileData, 'data_url')
                            .then(function (snapshot) {
                                var downloadURL = snapshot.downloadURL;
                                itemsObj[item.id]['FileURL'] = downloadURL;
                                itemsObj[item.id]['FileType'] = fileType;
                                counter++;
                                if (counter > len) {
                                    resolve();
                                }
                            }).catch(function (err) {
                                reject(err);
                            });
                    });
                });
            };

            createItemsObj().then(function (itemsObj) {
                $rootScope.showLoadingPanel = true;
                updates['/Form/' + companyKey + '/' + designFormKey + '/' + newFormKey] = obj;
                updates['/FormItems/' + newFormKey] = { 'CompanyKey': companyKey, 'DesignFormKey': designFormKey, 'Items': itemsObj };

                if (fileArr.length > 0) {
                    executeFileSave(fileArr)
                        .then(function () {
                            executeSave(updates);
                        }).catch(function (error) {
                            $rootScope.showLoadingPanel = false;
                            var textContent = $translate.instant('MF.ERROR');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(textContent + ': ' + error)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                        });
                } else {
                    executeSave(updates);
                }
            });
        };

        function executeSave(saveobj) {
            db.ref().update(saveobj)
                .then(function () {
                    closeDialog();
                })
                .catch(function (error) {
                    $rootScope.showLoadingPanel = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(3000)
                            .position('top right')
                    );
                });
        };

        function getFileExtension(filename) {
            return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
        };

        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        };

        function cancelDialog()
        {
            $mdDialog.cancel();
        }


        function closeDialog()
        {
            $mdDialog.hide();
        }

        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', ['ngImgCrop'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.pages_profile', {
                
                url      : '/pages/profile',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile/profile.html',
                        controller : 'ProfileController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]               
                },
                bodyClass: 'profile'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('UploadPictureDialogController', UploadPictureDialogController);

    /** @ngInject */
    function UploadPictureDialogController($scope, $mdDialog, $mdToast, $translate, UID)
    {
        var vm = this;
        // Data
        var db = firebase.database();
        vm.myImage = '';
        vm.myCroppedImage = '';
        vm.showSaveButton = false;

        // Methods
        vm.cancelDialog = cancelDialog;
        vm.executeImgSave = executeImgSave;

        function cancelDialog() {
            $mdDialog.cancel();
        };

        $scope.imageUpload = function (element) {
            var reader = new FileReader();
            reader.onload = imageIsLoaded;
            reader.readAsDataURL(element.files[0]);
        };

        function imageIsLoaded(ev) {
            var img = new Image();
            img.src = ev.target.result;
            img.onload = function () {
                $scope.$apply(function () {
                    $scope.myImage = ev.target.result;
                    vm.showSaveButton = true;
                });
            }
        };

        function executeImgSave(imgData) {
            vm.showSaveButton = false;
            var ref = firebase.database().ref('/Users/' + UID);
            var storageRef = firebase.storage().ref('profile-images/' + UID);

            storageRef.child(UID).putString(imgData, 'data_url')
                .then(function (snapshot) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    var downloadURL = snapshot.downloadURL;
                    ref.child("Photo").update({ "PhotoURL": downloadURL, "LastUpdate": dateNow })
                        .then(function () {
                            var msg = $translate.instant('PROFILE.PROFILE_PICTURE_SAVED');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(msg)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                            $mdDialog.hide(downloadURL);
                        })
                        .catch(function (error) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent('Error:' + error)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                        });
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(3000)
                            .position('top right')
                    );
                });

        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('UploadBgDialogController', UploadBgDialogController);

    /** @ngInject */
    function UploadBgDialogController($scope, $mdDialog, $mdToast, $translate, UID)
    {
        var vm = this;
        // Data
        var db=firebase.database();
		vm.myImage='';
        vm.myCroppedImage='';
        vm.showSaveButton=false;

        // Methods
        vm.cancelDialog = cancelDialog;
        vm.executeImgSave=executeImgSave;

        function cancelDialog() {
            $mdDialog.cancel();
		};

        $scope.imageUpload=function(element) {
            var reader = new FileReader();
            reader.onload = imageIsLoaded;
            reader.readAsDataURL(element.files[0]);
		};
		
        function imageIsLoaded(ev) {
            var img = new Image();
            img.src=ev.target.result;
            img.onload = function(){
                $scope.$apply(function() {
                    $scope.myImage=ev.target.result;
                    vm.showSaveButton=true;
                });
            }       
        };

        function executeImgSave(imgData) {
            var ref=firebase.database().ref('/Users/'+UID);                     
            var storageRef = firebase.storage().ref('profile-images/'+UID);
            storageRef.child(UID).putString(imgData, 'data_url').then(function(snapshot) {
                var downloadURL=snapshot.downloadURL;
                ref.update({"PhotoURL":downloadURL})
                $mdDialog.hide(downloadURL);
            });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.waiting-forme')
        .controller('ViewFormDialogController', ViewFormDialogController);

    /** @ngInject */
    function ViewFormDialogController($mdDialog, $mdToast, $timeout, formInfo, nfviewForm)
    {
        var vm = this;
        vm.title = formInfo.DesignFormName+' ('+formInfo.FormKey+')';
        var formItems=[];
        vm.formItems=formItems;

        // Methods
        vm.closeDialog = closeDialog;
        //
        showForm();
        
        function showForm() {
            firebase.database().ref('/FormItems/' + formInfo.FormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';

                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="viewForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: value, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Value: value, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var optValue = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        var optSelected = data.Options[key].Selected;
                                        options.push({ Key: optId, Value: optValue, Seq: optSeq, Selected: optSelected });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" ' +
                                        'aria-label="opt.Value" ' +
                                        'ng-checked="opt.Selected">{{opt.Value}}' +
                                        '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var fileName = data.FileName;
                                    var fileURL = data.FileURL;
                                    var element = ''+
                                        '<div>'+
                                            '<md-button class="md-icon-button" aria-label="attach file" ng-disabled>'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label>{{item.FileName}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="item.FileURL" class="md-icon-button md-primary" aria-label="remove" ng-href="{{item.FileURL}}" target="_blank">'+
                                                '<md-icon md-font-icon="icon-download"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, FileName: fileName, FileURL: fileURL });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var timeValue = new Date(value);
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Value: timeValue, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required">' +
                                        '<span translate="MF.REQUIRED">Required</span>' +
                                        '</div>' +
                                        '<div ng-message="pattern">' +
                                        '<span translate="MF.VALID_WARNING">The entered value is not valid</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="formDiv.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead><tr><th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th></tr></thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in item.Rows track by $index">' +
                                        '<td ng-repeat="col in row.Cols">' +
                                        '<input ng-value="col.Value">' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, RowCounter: rowCounter, Columns: columns, Rows: rows, ColCounter: colCounter });
                                    break;
                            }

                        });
                    });
                });
        };



        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.waiting-forme')
        .controller('WaitingForMePendingFormsController', WaitingForMePendingFormsController);

    /** @ngInject */
    function WaitingForMePendingFormsController($scope, $state, $timeout, $mdSidenav, $mdDialog, $document, $translate, $mdToast, $http, formatTimeStamp)
    {
        var vm = this;

        // Data
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;

        //Methods 
        vm.toggleDetails = toggleDetails;
        vm.openViewFormDialog = openViewFormDialog;
        vm.openActionFormDialog = openActionFormDialog;
        vm.select = select;

        vm.forms = [];
        var companyPages = {};
        var formUsers = {};
        vm.formTransactions = [];
        var sharedForms = [];

        var formRef = db.ref('/UserFormWaitingForMe/' + UID);

        vm.showLoadingPanel = false;

        loadForms();

        function loadForms() {
            formRef.on('child_added', function (item) {
                var formData = item.val(),
                    formKey = item.key,
                    dateCreated = formData.DateCreated,
                    designFormKey = formData.DesignFormKey,
                    designFormName = formData.DesignFormName,
                    currentProcessNode = formData.CurrentProcessNode,
                    formUserUID = formData.UID,
                    companyKey = formData.CompanyKey,
                    currentProcessUID = formData.CurrentProcessUID,
                    status = formData.Status,
                    userName = '',
                    companyName = '';

                if (!formUsers[formUserUID]) {
                    loadFormUser(formUserUID).then(function (response) {
                        userName = response.DisplayName;
                    });
                } else {
                    userName = formUsers[formUserUID].DisplayName;
                }

                if (!companyPages[companyKey]) {
                    loadCompanyPage(companyKey).then(function (response) {
                        companyName = response.CompanyName;
                        pushData();
                    });
                } else {
                    companyName = companyPages[companyKey].CompanyName;
                    pushData();
                }

                function pushData() {
                    $timeout(function () {
                        vm.forms.push({
                            "FormKey": formKey,
                            "DateCreated": dateCreated,
                            "DesignFormKey": designFormKey,
                            "DesignFormName": designFormName,
                            "UserName": userName,
                            "UserUID": formUserUID,
                            "CurrentProcessNode": currentProcessNode,
                            "Status": status,
                            "CompanyKey": companyKey,
                            "CompanyName": companyName
                        });
                    });
                }
            }, function (err) {
                console.log(err);
            });

            var formRefChildRemovedCallback = formRef.on('child_removed', function (item) {
                var formKey = item.key;
                var i = findIndexByFormKey(formKey);
                vm.forms.splice(i,1);
            });
        };

        function loadCompanyPage(companyKey) {
            return new Promise(function (resolve, reject) {
                db.ref('/CompanyPages/').child(companyKey)
                    .once('value', function (snap) {
                        var companyName = snap.val().CompanyName;
                        var photoURL = snap.val().Photo.PhotoURL;
                        companyPages[companyKey] = {};
                        companyPages[companyKey]["CompanyName"] = companyName;
                        companyPages[companyKey]["PhotoURL"] = photoURL;
                        resolve(companyPages[companyKey]);
                    });
            });
        };

        function loadFormUser(formUserUID) {
            return new Promise(function(resolve, reject) {
                db.ref('/Users/').child(formUserUID)
                .once('value', function (userSnap) {
                    var displayName = userSnap.val().DisplayName;
                    var photoURL = userSnap.val().Photo.PhotoURL;
                    formUsers[formUserUID]={};
                    formUsers[formUserUID]["DisplayName"]=displayName;
                    formUsers[formUserUID]["PhotoURL"]=photoURL;
                    resolve(formUsers[formUserUID]);
                });
            });
        };

        function select(item) {
            vm.selected=item;
            if (!vm.formTransactions[item.FormKey]) {
                loadFormTransactions(item.DesignFormKey, item.FormKey);
            }            
        };

        function findIndexByFormKey(formKey){
            for (var i=0; i < vm.forms.length; i++) {
                if (vm.forms[i].FormKey === formKey) {
                    return i;
                }
            }
        };
        

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('form-detail-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


        /**
         * Open view form dialog
         *
         * @param ev
         */
        function openViewFormDialog(item, ev)
        {
            $mdDialog.show({
                controller         : 'ViewFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pages/waiting-forme/dialogs/view-form/view-form-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    formInfo :   item
                }
            });
        };


        /**
         * Open action form dialog
         */
        function openActionFormDialog(form, action, ev) {
            if (action=='Approve') {
                var title = $translate.instant('WFM.APPROVE_FORM');
                var textContent = $translate.instant('WFM.PROCESS_APPROVE_MSG');
            } else if (action=='Reject') {
                var title = $translate.instant('WFM.REJECT_FORM');
                var textContent = $translate.instant('WFM.PROCESS_REJECT_MSG');   
            }
			
            var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent(textContent)
                .ariaLabel('Confirm process')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm)
                .then(function () {
                    vm.showLoadingPanel = true;
                    
                    var formActionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/formAction';

                    firebase.auth().currentUser.getToken()
                        .then(function (token) {

                            var req = {
                                method: 'POST',
                                url: formActionURL,
                                headers: {
                                    'Authorization': 'Bearer ' + token
                                },
                                data: {
                                    'action': action,
                                    'formKey': form.FormKey,
                                    'designFormKey': form.DesignFormKey,
                                    'companyKey': form.CompanyKey,
                                    'currentProcessNode': form.CurrentProcessNode,
                                }
                            }

                            $http(req)
                                .then(function (resp) {
                                    vm.selected=null;
                                    var textContent = $translate.instant('MF.FORM_SAVED');
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent(textContent)
                                            .hideDelay(1000)
                                            .position('top right')
                                    );
                                    $timeout(function () {
                                        vm.showLoadingPanel = false;
                                    },1000);
                                }, function (err) {
                                    var textContent = $translate.instant('MF.ERROR');
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent(textContent + ': ' + err)
                                            .hideDelay(1000)
                                            .position('top right')
                                    );
                                    $timeout(function () {
                                        vm.showLoadingPanel = false;
                                    },1000);
                                });

                        }, function () {

                        });
                }, function() {
                    //cancelled dialog
                    
                });

        };

        function loadFormTransactions(designFormKey, formKey) {
            db.ref('/FormTransactions/' + designFormKey + '/' + formKey).once('value', function (snap) {
                snap.forEach(function(snapTransaction){
                    var data=snapTransaction.val();
                    var dateTime=data.DateTime,
                        action=data.Action,
                        formUserUID=data.UID;
                        vm.formTransactions[formKey] = [];

                    if (!formUsers.formUserUID) {
                        loadFormUser(formUserUID)
                            .then(function (response) {
                                var userName = response.DisplayName;
                                var photoURL = response.PhotoURL;
                                $timeout(function () {
                                    vm.formTransactions[formKey].push({'DateTime': dateTime, 'Action': action, 'UserName': userName, 'PhotoURL': photoURL});
                                });
                            });
                    } else {
                        var userName = formUsers.formUserUID.DisplayName;
                        $timeout(function () {
                            vm.formTransactions[formKey].push({'DateTime':dateTime, 'Action':action, 'UserName': userName, 'PhotoURL': photoURL});
                        });
                    }
                })
            })
        };

        $scope.$on("$destroy", function() {
            formRef.off();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.waiting-forme')
        .controller('WaitingForMeArchiveController', WaitingForMeArchiveController);

    /** @ngInject */
    function WaitingForMeArchiveController($state, $timeout, $mdSidenav, $mdDialog, $document, $translate, $mdToast, formatTimeStamp)
    {
        var vm = this;
        
                // Data
                var db = firebase.database();
                var user = firebase.auth().currentUser;
                var UID = user.uid;
        
                //Methods 
                vm.toggleDetails=toggleDetails;
                vm.openViewFormDialog=openViewFormDialog;
                vm.select=select;      
        
                vm.forms=[];
                var companyPages = {};
                var formUsers={};
                vm.formTransactions=[];
                var sharedForms=[];
        
                loadArchiveRef();
        
                function loadArchiveRef() {
                    var archiveRef=db.ref('/UserFormArchiveRef/'+UID);
                    archiveRef.once('value', function(snap) {
                        snap.forEach(function(item){
                            var formKey=item.key;
                            var designFormKey=item.val().DesignFormKey;
                            var companyKey=item.val().CompanyKey;
                            loadForm(formKey, designFormKey, companyKey);
                        })
                    });
                };
        
                function loadForm(formKey, designFormKey, companyKey) {
                    var formRef=db.ref('/Form/'+companyKey+'/'+designFormKey+'/'+formKey);
                    formRef.once('value', function (snap) {
                        var formData = snap.val(),
                            dateCreated = formData.DateCreated,
                            designFormName = formData.DesignFormName,
                            currentProcessNode = formData.CurrentProcessNode,
                            formUserUID = formData.UID,
                            currentProcessUID = formData.CurrentProcessUID,
                            status = formData.Status,
                            userName = '',
                            companyName = '';

                        if (!formUsers[formUserUID]) {
                            loadFormUser(formUserUID).then(function (response) {
                                userName = response.DisplayName;
                            });
                        } else {
                            userName = formUsers[UID].DisplayName;
                        }

                        if (!companyPages[companyKey]) {
                            loadCompanyPage(companyKey).then(function (response) {
                                companyName = response.CompanyName;
                                pushData();
                            });
                        } else {
                            companyName = companyPages[companyKey].CompanyName;
                            pushData();
                        }

                        function pushData() {
                            $timeout(function () {
                                vm.forms.push({
                                    "FormKey": formKey,
                                    "DateCreated": dateCreated,
                                    "DesignFormKey": designFormKey,
                                    "DesignFormName": designFormName,
                                    "UserName": userName,
                                    "UserUID": formUserUID,
                                    "CurrentProcessNode": currentProcessNode,
                                    "Status": status,
                                    "CompanyKey": companyKey,
                                    "CompanyName": companyName
                                });
                            });
                        }
                    });
                };

                function loadCompanyPage(companyKey) {
                    return new Promise(function (resolve, reject) {
                        db.ref('/CompanyPages/').child(companyKey)
                            .once('value', function (snap) {
                                var companyName = snap.val().CompanyName;
                                var photoURL = snap.val().Photo.PhotoURL;
                                companyPages[companyKey] = {};
                                companyPages[companyKey]["CompanyName"] = companyName;
                                companyPages[companyKey]["PhotoURL"] = photoURL;
                                resolve(companyPages[companyKey]);
                            });
                    });
                };
        
                function loadFormUser(formUserUID) {
                    return new Promise(function(resolve, reject) {
                        db.ref('/Users/').child(formUserUID)
                        .once('value', function (userSnap) {
                            var displayName = userSnap.val().DisplayName;
                            var photoURL = userSnap.val().Photo.PhotoURL;
                            formUsers[formUserUID]={};
                            formUsers[formUserUID]["DisplayName"]=displayName;
                            formUsers[formUserUID]["PhotoURL"]=photoURL;
                            resolve(formUsers[formUserUID]);
                        });
                    });
                };
        
                function select(item) {
                    vm.selected=item;
                    if (!vm.formTransactions[item.FormKey]) {
                        loadFormTransactions(item.DesignFormKey, item.FormKey);
                    }            
                };
        
                //format date 
                function formatDate(date){
                    return formatTimeStamp.format(date);
                };
        
                /**
                 * Toggle details
                 *
                 * @param item
                 */
                function toggleDetails(item)
                {
                    vm.selected = item;
                    toggleSidenav('form-detail-sidenav');
                }
        
                /**
                 * Toggle sidenav
                 *
                 * @param sidenavId
                 */
                function toggleSidenav(sidenavId)
                {
                    $mdSidenav(sidenavId).toggle();
                }
        
        
                /**
                 * Open view form dialog
                 *
                 * @param ev
                 */
                function openViewFormDialog(item, ev)
                {
                    $mdDialog.show({
                        controller         : 'ViewFormDialogController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/pages/waiting-forme/dialogs/view-form/view-form-dialog.html',
                        parent             : angular.element($document.find('#content-container')),
                        targetEvent        : ev,
                        clickOutsideToClose: true,
                        locals             : {
                            formInfo :   item
                        }
                    });
                };
        
                function loadFormTransactions(designFormKey, formKey) {
                    db.ref('/FormTransactions/' + designFormKey + '/' + formKey).once('value', function (snap) {
                        snap.forEach(function(snapTransaction){
                            var data=snapTransaction.val();
                            var dateTime=data.DateTime,
                                action=data.Action,
                                formUserUID=data.UID;
                                vm.formTransactions[formKey] = [];
        
                            if (!formUsers.formUserUID) {
                                loadFormUser(formUserUID)
                                    .then(function (response) {
                                        var userName = response.DisplayName;
                                        var photoURL = response.PhotoURL;
                                        $timeout(function () {
                                            vm.formTransactions[formKey].push({'DateTime': dateTime, 'Action': action, 'UserName': userName, 'PhotoURL': photoURL});
                                        });
                                    });
                            } else {
                                var userName = formUsers.formUserUID.DisplayName;
                                $timeout(function () {
                                    vm.formTransactions[formKey].push({'DateTime':dateTime, 'Action':action, 'UserName': userName, 'PhotoURL': photoURL});
                                });
                            }
                        })
                    })
                };
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('FillFormDialogController', FillFormDialogController);

    /** @ngInject */
    function FillFormDialogController($mdDialog, $mdToast, $timeout, $rootScope, designFormKey, designFormName, UID, companyKey)
    {
        var vm = this;
        // Data
        var db = firebase.database();

        vm.title = designFormName;

        var formItems = [];
        vm.formItems = formItems;

        // Methods
        vm.addRow = addRow;
        vm.deleteRow = deleteRow;
        vm.openTableRowMenu = openTableRowMenu;
        vm.submitForm = submitForm;
        vm.cancelDialog = cancelDialog;
        vm.getRows = getRows;
        vm.fileAdded = fileAdded;

        showForm();

        var originatorEv;
        function openTableRowMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function getRows(id) {
            return formItems.getById(id).Rows;
        };

        function addRow(formdivId, i) {
            var item = formItems.getById(formdivId);
            var rowsObj = item["Rows"];
            var cols = angular.copy(rowsObj[Object.keys(rowsObj)[0]]["Cols"]);
            angular.forEach(cols, function(colItem, colKey) {
                colItem.Value = "";
            });
            item["RowNumber"]++;
            item["RowCounter"]++;
            item["Rows"]["row_" + item.RowCounter] = { "RowKey": "row_" + item.RowCounter, "Cols": cols };
        };

        function deleteRow(formdivId, rowKey) {
            var item = formItems.getById(formdivId);
            if (Object.keys(item.Rows).length>1) {
                item.RowNumber--;
                delete item["Rows"][rowKey];
            }
        };

        function fileAdded(item, $flow, flowFile, formdivId) {
            var item = formItems.getById(formdivId);
            var fileReader = new FileReader();
            fileReader.readAsDataURL(flowFile.file);
            fileReader.onload = function (event) {
                item.FileURL = event.target.result;
                item.FileName = flowFile.file.name;
            };
        };

        function showForm() {
            db.ref('/DesignFormItems/' + companyKey + '/' + designFormKey + '/Items').orderByChild('Seq')
                .once('value', function (snapshot) {
                    $timeout(function () {
                        snapshot.forEach(function (childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText = data.LabelText;
                            var seq = data.Seq;
                            var Id = data.Id;
                            var elementType = data.Type;
                            var value = data.Value;
                            var backgroundColor = data.BackgroundColor;
                            var align = data.Align;
                            var required = data.Required;

                            var divx = '<div layout="{{item.LabelType}}">';
                            var divy = '<div flex="auto">';
                            var divz = '<div class="inputData"></div>';
                            var htmlTemp = '' +
                                '<div class="formDesignDiv" Id=' + formdivId + ' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" ' +
                                'ng-class="{selectedDiv:vm.selectedDiv==\'' + formdivId + '\'}" ng-click="vm.divSelection(\'' + formdivId + '\',\'' + elementType + '\',$index)">';


                            switch (elementType) {
                                case "Header":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Label":
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, Value: value, BackgroundColor: backgroundColor, Align: align });
                                    break;
                                case "Text Box":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Text Area":
                                    var maxLength = data.MaxLength;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<textarea name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" ' +
                                        'md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, MaxLength: maxLength, Required: required });
                                    break;
                                case "Dropdown":
                                    var optCounter = data.OptCounter;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-select name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>' +
                                        '</md-select>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divx + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptCounter: optCounter, Options: options });
                                    break;
                                case "Radio Button":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">' +
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>' +
                                        '</md-radio-group>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Checkbox":
                                    var optCounter = data.OptCounter;
                                    var optionOrder = data.OptionOrder;
                                    var options = [];
                                    for (var key in data.Options) {
                                        var optId = key;
                                        var value = data.Options[key].Value;
                                        var optSeq = data.Options[key].Seq;
                                        options.push({ Key: optId, Value: value, Seq: optSeq, Selected: false });
                                    }
                                    var element = '' +
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">' +
                                        '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" ' +
                                        'aria-label="opt.Value" ' +
                                        'ng-model="opt.Selected">{{opt.Value}}' +
                                        '</md-checkbox>' +
                                        '</div>';
                                    htmlTemp = htmlTemp + divy + element + '</div></div>'
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, OptionOrder: optionOrder, OptCounter: optCounter, Options: options });
                                    break;
                                case "Image":
                                    var imageURL = data.ImageURL;
                                    var scale = data.Scale;
                                    var width = data.Width;
                                    var height = data.Height;
                                    var widthOrg = data.WidthOrg;
                                    var heightOrg = data.HeightOrg;
                                    var element = '<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, ImageURL: imageURL, Align: align, Scale: scale, Width: width, Height: height, WidthOrg: widthOrg, HeightOrg: heightOrg });
                                    break;
                                case "Line":
                                    var element = '<hr class="inputData">';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "File Upload":
                                    var element = ''+
                                        '<div flow-init="{singleFile:true, target:\'upload\'}" flow-file-added="vm.fileAdded( item, $flow, $file, \'' + formdivId + '\')" flow-file-success="$file.msg = $message">'+
                                            '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                                                '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                                '<input type="file" style="visibility: hidden; position: absolute;">'+
                                            '</md-button>'+
                                            '<md-input-container>'+
                                                '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                                                '<input type="text" disabled>'+
                                                '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                                                '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                            '</md-input-container>'+
                                            '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                                                '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                            '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq });
                                    break;
                                case "Date":
                                    var hideIcons = data.HideIcons;
                                    if (data.maxDate == null) {
                                        var maxDate = null;
                                    } else {
                                        var maxDate = data.MaxDate;
                                    }
                                    if (data.minDate == null) {
                                        var minDate = null;
                                    } else {
                                        var minDate = data.MinDate;
                                    }
                                    var element = '' +
                                        '<md-input-container>' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<md-datepicker ng-model="item.Value" name="' + formdivId + '" ng-required="item.Required" md-hide-icons="item.HideIcons" ' +
                                        'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>' +
                                        '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, HideIcons: hideIcons, MaxDate: maxDate, MinDate: minDate });
                                    break;
                                case "Time":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="time" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Numeric":
                                    if (data.MinValue) { var minValue = data.MinValue; } else { var minValue = null; }
                                    if (data.MaxValue) { var maxValue = data.MaxValue; } else { var maxValue = null; }
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="number" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>' +
                                        '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, MinValue: minValue, MaxValue: maxValue });
                                    break;
                                case "Email":
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="email" name="' + formdivId + '" ng-required="item.Required" ng-model="item.Value"' +
                                        'translate ng-pattern="/^.+@.+\..+$/">' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error" role="alert" multiple>' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="pattern" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required });
                                    break;
                                case "Phone Number":
                                    var mask = data.Mask;
                                    var maskChar = data.MaskChar;
                                    var element = '' +
                                        '<md-input-container class="md-block">' +
                                        '<label>{{item.LabelText}}</label>' +
                                        '<input type="text" aria-label="Phone Number" name="' + formdivId + '" ng-required="item.Required" ' +
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>' +
                                        '<div ng-messages="fillForm.' + formdivId + '.$error">' +
                                        '<div ng-message="required" translate="MF.REQUIRED">Required</div>' +
                                        '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>' +
                                        '</div>' +
                                        '</md-input-container>';
                                    htmlTemp = htmlTemp + element + '</div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Type: elementType, Seq: seq, LabelText: labelText, Required: required, Mask: mask, MaskChar: maskChar });
                                    break;
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element = '<div class="simple-table-container md-whiteframe-4dp">';
                                    var table = '<table class="simple" ms-responsive-table>';
                                    var thead = '<thead>' +
                                        '<tr>' +
                                        '<th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th>' +
                                        '<th class="actions" ng-if="item.AllowAddDeleteRows">' +
                                        '<md-button class="md-icon-button md-accent"' +
                                        'aria-label="Add row" translate' +
                                        'translate-attr-aria-label="SW.ADD_ROW"' +
                                        'ng-click="vm.addRow(\'' + formdivId + '\',$index)">' +
                                        '<md-icon md-font-icon="icon-table-row-plus-after"></md-icon>' +
                                        '</md-button>' +
                                        '</th>' +
                                        '</tr>' +
                                        '</thead>';
                                    var tbody = '<tbody>' +
                                        '<tr ng-repeat="row in vm.getRows(item.id) track by row.RowKey">' +
                                        '<td ng-repeat="col in row.Cols track by $index">' +
                                        '<input ng-model="col.Value">' +
                                        '</td>' +
                                        '<td ng-if="item.AllowAddDeleteRows" class="actions">' +
                                        '<md-menu >' +
                                        '<md-button aria-label="Open actions menu" class="md-icon-button" ng-click="vm.openTableRowMenu($mdMenu, $event)">' +
                                        '<md-icon md-menu-origin md-font-icon="icon-dots-vertical" class="s18"></md-icon>' +
                                        '</md-button>' +
                                        '<md-menu-content width="2">' +
                                        '<md-menu-item>' +
                                        '<md-button ng-click="vm.deleteRow(\'' + formdivId + '\',row.RowKey)" ng-disabled="" translate="SW.DELETE"' +
                                        'ng-if="item.AllowAddDeleteRows">'+
                                        '<md-icon md-font-icon="icon-delete"></md-icon>' +
                                        'Delete' +
                                        '</md-button>' +
                                        '</md-menu-item>' +
                                        '</md-menu-content>' +
                                        '</md-menu>' +
                                        '</td>' +
                                        '</tr>' +
                                        '</tbody>';
                
                                    htmlTemp = htmlTemp + element + table + thead + tbody + '</table></div>';
                                    formItems.push({ id: formdivId, html: htmlTemp, Seq: seq, Type: elementType, RowNumber: rowNumber, RowCounter: rowCounter, Rows: rows, Columns: columns, ColCounter: colCounter, AllowAddDeleteRows: allowAddDeleteRows });
                                    break;
                            }

                        });
                    });
                });

        };

        function submitForm() {
            var tempArr=angular.copy(formItems);
            var count=tempArr.length;
            var newFormKey = db.ref().child('Form').child(designFormKey).push().key;
            var dateNow=firebase.database['ServerValue']['TIMESTAMP'];
            var updates={};
            var obj={'CompanyKey': companyKey, 'DesignFormKey':designFormKey, 'DesignFormName':designFormName, 'DateCreated':dateNow, 'UID':UID};
            var itemsObj={};
            var fileArr = [];

            function createItemsObj() {
                return new Promise(function(resolve, reject) {
                    for (var i=0; i<=count; i++) {
                        if (i==count) {
                            resolve(itemsObj);
                        }
                        itemsObj[tempArr[i].id]={};
                        for (var property in tempArr[i]) {
                            if (tempArr[i].hasOwnProperty(property)) {
                                if (property!='html' && property!='id' ) {
                                    itemsObj[tempArr[i].id][property]=tempArr[i][property];
                                } 
                                if (property=='Options') {
                                    var optObj={};
                                    tempArr[i][property].forEach(function(opt){
                                        optObj[opt.Key]={};
                                        optObj[opt.Key]['Seq']=opt.Seq;
                                        optObj[opt.Key]['Value']=opt.Value;
                                        if (tempArr[i]["Type"]=="Checkbox") {
                                            optObj[opt.Key]['Selected']=opt.Selected;
                                        };
                                    });
                                    itemsObj[tempArr[i].id]['Options']=optObj
                                }
                                if (property=='Columns') {
                                    var colObj={};
                                    tempArr[i][property].forEach(function(col){
                                        colObj[col.Key]={};
                                        colObj[col.Key]['Seq']=col.Seq;
                                        colObj[col.Key]['Value']=col.Value;
                                    });
                                    itemsObj[tempArr[i].id]['Columns']=colObj
                                }
                                if (property == 'FileURL') {
                                    var fileData = tempArr[i][property];
                                    var fileKey = tempArr[i].id;
                                    fileArr.push({ "id": fileKey, "file": fileData, "formitemKey": i, "fileName": tempArr[i].FileName });
                                    itemsObj[tempArr[i].id][property] = null;
                                }
                            }
                        }
        
                    }
                });
            };

            function executeFileSave(fileArr) {
                return new Promise(function (resolve, reject) {
                    var storageRef = firebase.storage().ref('form-files/' + designFormKey);
                    var len = fileArr.length;
                    var counter = 1;
                    fileArr.forEach(function (item) {
                        var storageKey = guidGenerator();
                        var fileType = getFileExtension(item.fileName);
                        var fileData = item.file;
                        var newKey = storageKey + '.' + fileType;
                        storageRef.child(newKey).putString(fileData, 'data_url')
                            .then(function (snapshot) {
                                var downloadURL = snapshot.downloadURL;
                                itemsObj[item.id]['FileURL'] = downloadURL;
                                itemsObj[item.id]['FileType'] = fileType;
                                counter++;
                                if (counter > len) {
                                    resolve();
                                }
                            }).catch(function (err) {
                                reject(err);
                            });
                    });
                });
            };

            createItemsObj().then(function (itemsObj) {
                $rootScope.showLoadingPanel = true;
                updates['/Form/' + companyKey + '/' + designFormKey + '/' + newFormKey] = obj;
                updates['/FormItems/' + newFormKey] = { 'CompanyKey': companyKey, 'DesignFormKey': designFormKey, 'Items': itemsObj };

                if (fileArr.length > 0) {
                    executeFileSave(fileArr)
                        .then(function () {
                            executeSave(updates);
                        }).catch(function (error) {
                            var textContent = $translate.instant('MF.ERROR');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(textContent + ': ' + error)
                                    .hideDelay(1000)
                                    .position('top right')
                            );
                        });
                } else {
                    executeSave(updates);
                }
            });             
        };

        function executeSave(saveobj) {
            db.ref().update(saveobj)
                .then(function () {
                    closeDialog();
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                });
        };

        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        };

        function cancelDialog()
        {
            $mdDialog.cancel();
        }


        function closeDialog()
        {
            $mdDialog.hide();
        }

        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.verification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_verification', {
            url      : '/pages/auth/verification',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_verification': {
                    templateUrl: 'app/main/pages/auth/verification/verification.html',
                    controller : 'VerificationController as vm'
                }
            },
            resolve: {
                "currentAuth": ["Auth", function (Auth) {
                    return Auth.$requireSignIn();
                }]
            },            
            bodyClass: 'verification'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/verification');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.verification')
        .controller('VerificationController', VerificationController);

    /** @ngInject */
    function VerificationController($mdDialog, $translate, $state) {
        var vm = this;

        // Data

        // Methods
        vm.resendVerificationEmail = resendVerificationEmail;
        //////////


        //get currentuser data
        var user = firebase.auth().currentUser;
        //redirect user if verification already done
        if (user.emailVerified == true) {
            $state.go('app.pages_auth_login');
        } else {
            vm.email=user.email;
        }

        function resendVerificationEmail() {
            //resend verification email
            user.sendEmailVerification().then(function () {
                // Email sent, display info dialog
                showEmailSentDialog()
            }, function (error) {
                console.log(error);
            });
        }

        function showEmailSentDialog() {
            var title = $translate.instant('VERIFICATION.EMAIL_SENT');
            var desc = $translate.instant('VERIFICATION.EMAIL_SENT_MESSAGE');

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(title)
                    .textContent(desc)
                    .ariaLabel(title)
                    .ok('OK')
            );
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.user-actions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_user-actions', {
            url      : '/pages/auth/user-actions',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_user-actions': {
                    templateUrl: 'app/main/pages/auth/user-actions/user-actions.html',
                    controller : 'UserActionsController as vm'
                }
            },
            resolve: {
                "currentAuth": ["Auth", function (Auth) {
                    return Auth.$waitForSignIn();
                }]
            },            
            bodyClass: 'user-actions'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/user-actions');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.user-actions')
        .controller('UserActionsController', UserActionsController);

    /** @ngInject */
    function UserActionsController($timeout, $state, $translate, $mdDialog, $http) {
        var vm = this;


        var auth = firebase.auth();

        // Methods
        vm.saveResetPassword = saveResetPassword;
        vm.resendVerificationEmail = resendVerificationEmail;
        //

        var mode = getParameterByName('mode');
        var actionCode = getParameterByName('oobCode');
        var apiKey = getParameterByName('apiKey');
        var continueUrl = getParameterByName('continueUrl');

        switch (mode) {
            case 'resetPassword':
                handleResetPassword(auth, actionCode);
                break;
            case 'recoverEmail':
                handleRecoverEmail(auth, actionCode);
                break;
            case 'verifyEmail':
                handleVerifyEmail(auth, actionCode);
                break;
            default:
            // Error: invalid mode.
                var user = firebase.auth().currentUser;
                if (user && !user.emailVerified) {
                    vm.email=user.email;
                    //handleVerifyEmail();
                    handleUnverifiedEmail();
                } else {
                    handleError();
                }   
        }
        //}, false);

        function getParameterByName(name) {
            var url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        function handleVerifyEmail(auth, actionCode) {
            auth.applyActionCode(actionCode).then(function () {
                $timeout(function () {
                    vm.action_verifyEmail = true;
                    vm.verifyEmailIsSuccess = true;
                });
            }).catch(function (error) {
                // TODO: Code is invalid or expired. Ask the user to verify their email address again
                $timeout(function () {
                    vm.action_verifyEmail = true;
                    vm.verifyEmailIsError = true;
                    vm.verifyEmailErrorMsg = error.message;
                });
            });
        };


        function handleResetPassword(auth, actionCode) {
            vm.action_resetEmail = true;
            // Verify the password reset code is valid.
            auth.verifyPasswordResetCode(actionCode).then(function (email) {
                $timeout(function () {
                    vm.action_resetEmailCodeValid = true;
                    vm.email = email;
                });
            }).catch(function (error) {
                // TODO: Invalid or expired action code. Ask user to try to reset the password again.
                $timeout(function () {
                    vm.action_resetEmailCodeInvalid = true;
                });
            });
        };

        function handleUnverifiedEmail() {
            vm.action_emailUnverified = true;
            
        };

        function handleError() {
            vm.action_error = true;
        };

        function saveResetPassword() {
            // Save the new password.
            auth.confirmPasswordReset(actionCode, vm.form.password).then(function (resp) {
                // Password reset has been confirmed and new password updated.
                //auto sign in user
                auth.signInWithEmailAndPassword(vm.email, vm.form.password).catch(function (error) {
                    // Handle Errors here.
                    console.log(error.code);
                });

                firebase.auth().onAuthStateChanged(function (user) {
                    if (user) {
                        // User is signed in. check if user email not verified and set true
                        user.updateProfile({ emailVerified: true})
                            .then(function () {
                                //
                            }).catch(function (error) {
                                console.log(error);
                            });

                    } else {
                        // User is signed out.
                    }
                });

                $timeout(function () {
                    vm.resetPasswordIsSuccess = true;
                });

            }).catch(function (error) {
                // Error occurred during confirmation. The code might have expired or the password is too weak.
                console.log(error);
            });
        }

        function resendVerificationEmail() {
            //resend verification email
            user.sendEmailVerification().then(function () {
                // Email sent, display info dialog
                showEmailSentDialog()
            }, function (error) {
                console.log(error);
            });
        }

        function showEmailSentDialog() {
            var title = $translate.instant('VERIFICATION.EMAIL_SENT');
            var desc = $translate.instant('VERIFICATION.EMAIL_SENT_MESSAGE');

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .title(title)
                    .textContent(desc)
                    .ariaLabel(title)
                    .ok('OK')
            );
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.signup', ['ngMeta'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, ngMetaProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_signup', {
            url      : '/pages/auth/signup',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_signup': {
                    templateUrl: 'app/main/pages/auth/signup/signup.html',
                    controller : 'SignupController as vm'
                }
            },
            bodyClass: 'signup',
            data: {
                'meta': {
                    'title': 'Join Notefield now for free',
                    'og:title': 'Join Notefield now for free',
                    'description': 'Signup now and start to use online forms, create new forms and submit shared forms',
                    'og:description': 'Signup now and start to use online forms, create new forms and submit shared forms',
                }
            },
            resolve: {
                "currentAuth": ["Auth", function(Auth) {
                    return Auth.$waitForSignIn();
                }]
            }            
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/signup');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.signup')
        .controller('SignupController', SignupController);

    /** @ngInject */
    function SignupController($timeout, $translate, $state) {
        var vm = this;

        // Data
        var db = firebase.database();

        // Methods
        vm.signup = signup;
        //

        function signup() {
            vm.error = null;
            vm.signupErrorMsg = null;

            firebase.auth().createUserWithEmailAndPassword(vm.form.email, vm.form.password)
                .then(function (authData) {
                    //Get auth data from firebase
                    var uid = authData.uid;
                    var email = authData.email;
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    //update db
                    db.ref('/Users/' + uid).update({
                        "Email": email,
                        "UID": uid,
                        "FirstName": vm.form.firstname,
                        "LastName": vm.form.lastname,
                        "DisplayName": vm.form.firstname+" "+vm.form.lastname,
                        "DisplayNameLower": vm.form.firstname.toLowerCase()+" "+vm.form.lastname.toLowerCase(),
                        "Phone": "",
                        "Photo": {"PhotoURL": "assets/images/etc/blank-profile-picture.jpg", "LastUpdate":dateNow},
                        "DateCreated": dateNow
                    });
                    //get currentuser data
                    var user = firebase.auth().currentUser;
                    //update user displayname
                    user.updateProfile({
                        displayName: vm.form.firstname,
                        photoURL: "assets/images/etc/blank-profile-picture.jpg"
                    }).then(function () {
                        // Update successful. send verification email
                        sendVerificationEmail(user);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(function (error) {
                    $timeout(function () {
                        // Handle Errors here.
                        var errorCode = error.code;
                        var errorMessage = error.message;

                        switch (errorCode) {
                            case 'auth/weak-password':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.PASSWORD_WEAK');
                                break;
                            case 'auth/invalid-email':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.EMAIL_MUST_VALID');
                                break;
                            case 'auth/email-already-in-use':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.EMAIL_ALREADY_IN_USE');
                        }
                    })
                });
        };

        function sendVerificationEmail(user) {
            //send verification email
            user.sendEmailVerification().then(function () {
                // Email sent, redirect to verification info page
                $state.go('app.pages_auth_user-actions');
            }, function (error) {
                console.log(error);
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', ['ngMeta'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, ngMetaProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            data: {
                'meta': {
                    'title': 'Login to Notefield',
                    'og:title': 'Login to Notefield',
                    'description': 'Login to Notefield now',
                    'og:description': 'Login to Notefield now',
                }
            },
            resolve: {
                "currentAuth": ["Auth", function(Auth) {
                    return Auth.$waitForSignIn();
                }]
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, $mdDialog, $translate, $timeout, Auth) {
        var vm = this;
        // Data
        var db = firebase.database();
        // Methods
        vm.login = login;
        vm.loginWithGoogle = loginWithGoogle;
        vm.loginWithFacebook = loginWithFacebook;
        //////////


        function login() {
            vm.error = null;
            vm.signinErrorMsg = null;

            Auth.$signInWithEmailAndPassword(vm.form.email, vm.form.password)
                .then(function (authData) {
                    // Logged in, redirect to correct room
                    $state.go('app.pages_app-console');
                })
                .catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;

                    switch (errorCode) {
                        case 'auth/wrong-password':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.WRONG_PASSWORD');
                            break;
                        case 'auth/user-not-found':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.USER_NOT_FOUND');
                            break;
                        case 'auth/user-disabled':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.USER_DISABLED');
                            break;
                        case 'auth/invalid-email':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.EMAIL_MUST_VALID');
                    }
                });
        };

        function loginWithGoogle(ev) {
            var provider = new firebase.auth.GoogleAuthProvider();
            //provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
            //firebase.auth().useDeviceLanguage();

            firebase.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;

                var firstName = user.displayName.split(' ').slice(0, -1).join(' ');
                var lastName = user.displayName.split(' ').slice(-1).join(' ');

                //update user table
                db.ref('/Users/' + user.uid).once('value', function (snap) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    if (!snap.val()) {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL},
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    } else {
                        db.ref('/Users/' + user.uid).update({
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL}
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    }
                });

            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });
        };

        function loginWithFacebook(ev) {
            var provider = new firebase.auth.FacebookAuthProvider();

            //firebase.auth().useDeviceLanguage();

            firebase.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;
                var user = result.user;

                var firstName = user.displayName.split(' ').slice(0, -1).join(' ');
                var lastName = user.displayName.split(' ').slice(-1).join(' ');
                //update user table
                db.ref('/Users/' + user.uid).once('value', function (snap) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    if (!snap.val()) {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL},
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    } else {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL},
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    }
                });


            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });
        };

        function needVerificationDialog(ev) {
            var title = $translate.instant('LOGIN.EMAIL_VERIFICATION_ERR_TITLE');
            var desc = $translate.instant('LOGIN.EMAIL_VERIFICATION_ERR_MSG');
            var confirmMsg = $translate.instant('LOGIN.SEND_EMAIL_AGAIN');
            var cancelMsg = $translate.instant('LOGIN.OK');

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel(title)
                .targetEvent(ev)
                .ok(confirmMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {
                var user = firebase.auth().currentUser;
                user.sendEmailVerification(vm.form.email).then(function () {
                    // Email sent.
                }).catch(function (error) {
                    // An error happened.
                    console.log(error);
                });
            }, function () {
                // cancelled
            });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', ['ngMeta'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, ngMetaProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            data: {
                'meta': {
                    'title': 'Forgot password',
                    'og:title': 'Forgot password',
                    'description': 'Forgot password',
                    'og:description': 'Forgot password',
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($mdDialog, $timeout, $translate) {
        var vm = this;
        // Data
        var db = firebase.database();

        // Methods
        vm.checkEmail = checkEmail;
        //////////

        function checkEmail(ev) {
            firebase.auth().fetchProvidersForEmail(vm.form.email)
                .then(function (result) {
                    if (result[0]) {
                        foundAccountDialog(ev);
                    } else {
                        noAccountDialog(ev);
                    }
                });
        }

        function noAccountDialog(ev) {
            var title = $translate.instant('FORGOTPASSWORD.MESSAGES.EMAIL_NOT_FOUND_TITLE');
            var desc = $translate.instant('FORGOTPASSWORD.MESSAGES.EMAIL_NOT_FOUND_MSG');

            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#forgot-password')))
                    .clickOutsideToClose(false)
                    .title(title)
                    .textContent(desc)
                    .ariaLabel(title)
                    .ok('ok')
                    .targetEvent(ev)
            );
        }

        function foundAccountDialog(ev) {
            var title = $translate.instant('FORGOTPASSWORD.MESSAGES.EMAIL_FOUND_TITLE');
            var desc = $translate.instant('FORGOTPASSWORD.MESSAGES.EMAIL_FOUND_MSG');
            var confirmMsg = $translate.instant('FORGOTPASSWORD.SEND_ME_EMAIL');
            var cancelMsg = $translate.instant('FORGOTPASSWORD.CANCEL');

            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel(title)
                .targetEvent(ev)
                .ok(confirmMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {

                var auth = firebase.auth();

                auth.sendPasswordResetEmail(vm.form.email).then(function () {
                    // Email sent.
                    $timeout(function () {
                        vm.finalPanel = true;
                    })
                }).catch(function (error) {
                    // An error happened.
                    console.log(error);
                });
            }, function () {
                // cancelled
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-forms')
        .controller('MyFormsController', MyFormsController);

    /** @ngInject */
    function MyFormsController($mdSidenav, $state, $timeout, $mdDialog, $document, $mdToast, $translate, formatTimeStamp, $http, $rootScope, companyKey)
    {
        var vm = this;

        //firebase
        var db=firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;

        var myForms=[];
        var myFormsRef= db.ref('/DesignForm/'+companyKey).orderByChild('UID').equalTo(UID);
        myFormsRef.on('child_added', function(snap){
            var key=snap.key;
            var data=snap.val();
            var name=data.Name;
            var type=data.Type;
            var widgetColor=data.WidgetColor;
            var dateEdited=data.DateEdited;
            var dateCreated=data.DateCreated;
            db.ref('/Form/'+companyKey+'/'+key)
            .once('value', function(formsnap){
                var count=formsnap.numChildren();
                $timeout(function(){
                    myForms.push({"Key":key, "Name":name, "Type":type, "WidgetColor":widgetColor, "DateCreated":dateCreated, "DateEdited":dateEdited, "FormTotal":count});
                });
            });
        });


        // Data
        vm.currentView = 'list';
        vm.showDetails = true;

        //vm.path = Documents.data.path;
        vm.myForms = myForms;
        vm.selected = vm.myForms[0];


        // Methods

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;
        vm.openAddFormDialog=openAddFormDialog;
        vm.deleteFormConfirm=deleteFormConfirm;
        vm.gotoFormDetail=gotoFormDetail;
        vm.gotoFormSubmissions=gotoFormSubmissions;
        vm.loadSubmittedFormsWidget=loadSubmittedFormsWidget;

        //////////


        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;

            vm.widget_SubmittedForms.currentRange = "TD";
            vm.widget_SubmittedForms.data.count = {
                "TD": 0,
                "TM": 0,
                "TY": 0
            };

            loadSharedUsersWidget(item);
            loadSubmittedFormsWidget();
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        /**
         * Open new form dialog
         *
         * @param ev
         */
        function openAddFormDialog(ev)
        {
            $mdDialog.show({
                controller         : 'MyFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/my-company/my-forms/dialogs/myform/myform-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    UID : UID,
                    companyKey : companyKey
                }
            });
        };

        /**
         * Delete Form Confirm Dialog
         */
        function deleteFormConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the form?')
                .htmlContent('<b>' + vm.selected.Name + '</b>' + ' will be deleted.')
                .ariaLabel('delete form')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function () {

                var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/deleteForm';

                firebase.auth().currentUser.getToken()
                    .then(function (token) {
                        $rootScope.showLoadingPanel = true;
                        var req = {
                            method: 'POST',
                            url: functionURL,
                            headers: {
                                'Authorization': 'Bearer ' + token
                            },
                            data: {
                                'companyKey': companyKey,
                                'designFormKey': vm.selected.Key
                            }
                        }

                        $http(req)
                            .then(function (resp) {
                                $rootScope.showLoadingPanel = false;
                                vm.myForms.splice(vm.myForms.indexOf(vm.selected), 1);
                                var textContent = $translate.instant('MF.FORM_DELETE_SUCCESS_MSG');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            }, function (err) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('MF.ERROR');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent + ': ' + err)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            });

                    }, function () {
                        $rootScope.showLoadingPanel = false;
                    });

            });
        }


        /**
         * @param id
         */
        function gotoFormDetail(id)
        {
            $state.go('app.my-company_my-forms.detail.main', {'designFormKey': id, 'companyKey': companyKey});
        }


        /**
         * @param id
         */
        function gotoFormSubmissions(id)
        {
            $state.go('app.my-company_my-forms.detail.submissions', {'designFormKey': id, 'companyKey': companyKey});
        }


        //Widget Submitted Forms/////

        var widget_submitted_forms_label= $translate.instant('MF.SUBMITTED_FORMS');
        var TD= $translate.instant('MF.TODAY');
        var TM= $translate.instant('MF.THIS_MONTH');
        var TY= $translate.instant('MF.THIS_YEAR');

        vm.widget_SubmittedForms= {
            "ranges": {
                "TD": TD,
                "TM": TM,
                "TY": TY   
            },
            "currentRange": "TD",
            "data": {
                "label": widget_submitted_forms_label,
                "count": {
                    "TD": 0,
                    "TM": 0,
                    "TY": 0
                },
                "extra": {
                    "label": "Completed",
                    "count": {
                        "TD": "0",
                        "TM": "0",
                        "TY": "0"
                    }
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        function loadSubmittedFormsWidget() {
            var range=vm.widget_SubmittedForms.currentRange;
            var startDate;
            switch (range) {
                case 'TD':
                    startDate = moment().startOf('day').unix() * 1000;
                    break;
                case 'TM':
                    startDate = moment().startOf('month').unix() * 1000;
                    break;
                case 'TY':
                    startDate = moment().startOf('year').unix() * 1000;
                    break;
                default:
                // Error: invalid mode.
            }

            db.ref('/Form/'+companyKey+'/'+vm.selected.Key).orderByChild("DateCreated").startAt(startDate).once('value', function (snap) {
                var formNumber = snap.numChildren();
                var completedNumber = 0;
                var data = snap.val();

                angular.forEach(data, function(value, key) {
                    if (value.Status == 'Completed') {
                        completedNumber++;
                    }
                })

                $timeout(function () {
                    vm.widget_SubmittedForms.data.count[range] = formNumber;
                    vm.widget_SubmittedForms.data.extra.count[range] = completedNumber;
                });
            });
        }



        

        function loadSharedUsersWidget(form) {
            var title = $translate.instant('MF.SHARED_USERS');
            var label= $translate.instant('MF.USERS');
            
            db.ref('/DesignForm/'+companyKey +'/' + form.Key + '/Users').once('value', function (snap) {
                var count=snap.numChildren();
                $timeout(function(){
                    vm.widget_SharedUsers= {
                        "title": title,
                        "data": {
                            "label": label,
                            "count": count
                        }
                    };
                });
            }); 
        }






    }

})();
(function () {
    'use strict';

    angular
        .module('app.my-company.my-company-page')
        .controller('MyCompanyPageController', MyCompanyPageController);

    /** @ngInject */
    function MyCompanyPageController($mdSidenav, $state, $timeout, $mdDialog, $document, $mdToast, $translate, companyKey, formatTimeStamp) {

        var vm = this;

        //firebase
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var companyRef = db.ref('/CompanyPages/' + companyKey);
        vm.industryCodes = [];
        vm.countryCodes = [];

        // Methods
        vm.openMenu = openMenu;
        vm.saveCompany = saveCompany;
        vm.changeCompanyPicture = changeCompanyPicture;
        vm.changeCompanyBg = changeCompanyBg;
        vm.removeCompanyPicture = removeCompanyPicture;
        vm.removeCompanyBg = removeCompanyBg;
        //////////

        vm.company = {};

        loadIndustryCodes();

        loadCountryCodes();

        loadCompany();

        function loadIndustryCodes() {
            db.ref('Definitions/Industries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    vm.industryCodes.push({'code':item.key, 'name':item.val()});
                })
            })
        };

        function loadCountryCodes() {
            db.ref('Definitions/Countries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    vm.countryCodes.push({'code':item.key, 'name':item.val()});
                })
            })
        };

        function loadCompany() {
            companyRef.once('value', function (snap) {
                var data = snap.val();

                $timeout(function () {
                    vm.company = data;

                    if (vm.company.Photo.PhotoURL == "assets/images/etc/blank-company-picture.png") {
                        vm.showRemoveCompanyPictureMenu = false;
                    } else {
                        vm.showRemoveCompanyPictureMenu = true;
                    }
                });
            });
        };

        function saveCompany(ev) {
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            vm.company.DateEdited = dateNow;
            vm.company.CompanyNameLower = vm.company.CompanyName.toLowerCase();
            var industryCode = vm.company.IndustryCode;
            var countryCode = vm.company.CountryCode;
            if (!industryCode) {
                industryCode = "~";
            }
            if (!countryCode) {
                countryCode = "~";
            }
            vm.company.Search_cc_ic = countryCode + '_' + industryCode;
            vm.company.Search_cc_cn = countryCode + '_' + vm.company.CompanyNameLower;
            vm.company.Search_ic_cn = industryCode + '_' + vm.company.CompanyNameLower;
            vm.company.Search_cc_ic_cn = countryCode + '_' + industryCode + '_' + vm.company.CompanyNameLower;
            companyRef.update(vm.company)
                .then(function () {
                    var msg = $translate.instant('MCP.SAVED');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msg)
                            .hideDelay(1000)
                            .position('top right')
                    );
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                });
        };

        var originatorEv;
        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        /**
         * Open changePicture dialog
         *
         * @param ev
         */
        function changeCompanyPicture(ev) {
            $mdDialog.show({
                controller: 'UploadCompanyPictureDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-company-page/dialogs/upload-picture/uploadpicture-dialog.html',
                parent: angular.element($document.find('#my-company-page')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    companyKey: companyKey,
                    UID: UID
                }
            }).then(function (downloadURL) {
                if (downloadURL) {
                    //update user
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    companyRef.child('Photo').update({ 'PhotoURL': downloadURL, 'LastUpdate': dateNow})
                    .then(function() {
                        $timeout(function () {
                            vm.company.Photo.PhotoURL = downloadURL;
                            vm.company.Photo.LastUpdate = dateNow;
                            vm.showRemoveCompanyPictureMenu = true;
                        });
                    })
                }
            }, function () {

            });
        };


        /**
         * Open changeBG dialog
         *
         * @param ev
         */
        function changeCompanyBg(ev) {
            $mdDialog.show({
                controller: 'UploadBgDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/my-company/my-company-page/dialogs/upload-bg/uploadbg-dialog.html',
                parent: angular.element($document.find('#my-company')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    companyKey: companyKey
                }
            }).then(function (downloadURL) {
                if (downloadURL) {
                    companyRef.child('BgPhoto').update({ 'PhotoURL': downloadURL })
                    .then(function() {
                        $timeout(function () {
                            vm.company.BgPhoto.PhotoURL = downloadURL;
                            vm.showRemoveCompanyBgPictureMenu = true;
                        });
                    })
                }
            }, function () {

            });
        };


        function removeCompanyPicture(ev) {
            var title = $translate.instant('MCP.CONFIRM_REMOVE_COMPANY_PIC');
            var cancelMsg = $translate.instant('MCP.CANCEL');
            var removeMsg = $translate.instant('MCP.REMOVE');

            var confirm = $mdDialog.confirm()
                .title(title)
                //.textContent('')
                .ariaLabel('Remove company picture')
                .targetEvent(ev)
                .ok(removeMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {
                var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                //update user db
                companyRef.child("Photo").update({ "PhotoURL": "assets/images/etc/blank-company-picture.png", "LastUpdate": dateNow })
                    .then(function () {
                        $timeout(function () {
                            vm.company.Photo.PhotoURL = "assets/images/etc/blank-company-picture.png";
                            vm.showRemoveCompanyPictureMenu = false;
                        });

                        var msg = $translate.instant('MCP.COMPANY_PICTURE_REMOVED');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(msg)
                                .hideDelay(3000)
                                .position('top right')
                        );

                    })
            }, function () {

            });
        };


        function removeCompanyBg(ev) {
            var title = $translate.instant('MCP.CONFIRM_REMOVE_COMPANY_BG_PIC');
            var cancelMsg = $translate.instant('MCP.CANCEL');
            var removeMsg = $translate.instant('MCP.REMOVE');

            var confirm = $mdDialog.confirm()
                .title(title)
                //.textContent('')
                .ariaLabel('Remove company background picture')
                .targetEvent(ev)
                .ok(removeMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {
                //update user db
                companyRef.child('BgPhoto').update({ "PhotoURL": null }).
                    then(function () {
                        $timeout(function () {
                            vm.company.BgPhoto.PhotoURL = "assets/images/etc/blank-company-picture.jpg";
                            vm.showRemoveCompanyBgPictureMenu = false;
                        });
                    })
            }, function () {

            });
        };




    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-page')
        .controller('MyCompanyMessagesController', MyCompanyMessagesController);

    /** @ngInject */
    function MyCompanyMessagesController($scope, $mdSidenav, $state, $timeout, $document, $mdMedia, $mdDialog, $translate, companyKey, formatTimeStamp, $rootScope)
    {
        var vm = this;

        //Firebase
        var db=firebase.database();
        
        
        // Data
        vm.companyPage = {};
        vm.contacts = [];
        vm.chat = undefined;
        vm.user = firebase.auth().currentUser;
        var UID = vm.user.uid;
        var newMsgTotalRef = db.ref('/CompanyMessages/' + companyKey + '/NewMessageTotal');
        var messagingRef = db.ref('/CompanyMessages/' + companyKey + '/Contacts/User');
        var chatRef;

        // Methods
        vm.chatFilterByGroup = chatFilterByGroup;
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.markUnread = markUnread;
        vm.markRead = markRead;
        vm.sendtoArchive = sendtoArchive;
        vm.restore = restore;
        vm.setChatGroupFilter = setChatGroupFilter;
        vm.deleteChatConfirm = deleteChatConfirm;
        vm.gotoContactPublicProfile = gotoContactPublicProfile;
        //

        // Paramaters
        vm.chatFilterGroupName=='ALL';

        //get companypage url
        db.ref('/CompanyPages/' + companyKey + '/Photo/PhotoURL').once('value')
            .then(function(snap) {
                vm.companyPage.photoURL = snap.val();
            });

        loadThreadsByUser();


        //set new messagetotal=0 while opening the page
        if ($rootScope.companyPages[companyKey].newMsg) {
            newMsgTotalRef.set(0);
        }

        function onContactNewMsg(userKey) {
            messagingRef.child(userKey).child('IsNew').set(false);
        };


        //listen messaging contacts for last message changes
        var pref = db.ref('/CompanyMessages/' + companyKey + '/Contacts/User').orderByChild("LastDate");
        pref.on('child_changed', function (snap) {
            var data=snap.val();
            var key=snap.key;
            var p= vm.contacts.getById(key);

            $timeout(function () {
                p.LastDate=data.LastDate;
                p.LastMessage=data.LastMessage;
                p.IsRead=data.IsRead;
                p.IsArchived=data.IsArchived;
            });
        });
        ///

        function loadThreadsByUser() {
            messagingRef.orderByChild("LastDate").on('child_added', function (msgsnap) {
                var key = msgsnap.key;
                var usersRef = db.ref('/Users').child(key);

                usersRef.once('value', function (usersnap) {
                    var userData = usersnap.val();
                    var displayName = userData.DisplayName;
                    var photoURL = userData.Photo.PhotoURL;

                    var msgData = msgsnap.val();
                    var lastDate = msgData.LastDate;
                    var lastMessage = msgData.LastMessage;
                    var isRead = msgData.IsRead;
                    var isArchived = msgData.IsArchived;

                    $timeout(function () {
                        vm.contacts.push
                            ({
                                "MsgUID": key,
                                "DisplayName": displayName,
                                "PhotoURL": photoURL,
                                "LastDate": lastDate,
                                "LastMessage": lastMessage,
                                "IsRead": isRead,
                                "IsArchived": isArchived
                            });

                            if (msgData.IsNew) {
                                onContactNewMsg(key);
                            }
                    });

                });
            });
        };

        function getChat(contactId)
        {
            vm.chat = [];
            vm.chatContactId = contactId;
            chatRef = db.ref('/CompanyMessages/'+companyKey+'/Messages/User/'+contactId).orderByChild('Date');

            chatRef.on('child_added', function(msgsnap) {
                var key=msgsnap.key;
                var msgData=msgsnap.val();
                var date=msgData.Date;
                var text=msgData.Text;
                var type=msgData.Type;

                $timeout(function() {
                    vm.chat.push({"Key":key, "Date":date, "Text":text, "Type":type});
                    scrollToBottomOfChat();
                });
                
            });

            // Reset the reply textarea
            resetReplyTextarea();

            if (!$mdMedia('gt-md')) {
                $mdSidenav('left-sidenav').close();
            }
            
            // Reset Left Sidenav View
            vm.toggleLeftSidenavView(false);
        };

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

			var updates = {};
            var dateNow=firebase.database['ServerValue']['TIMESTAMP'];
            
            var dbRef = db.ref('/CompanyMessages/' + companyKey + '/Messages/User/' + vm.chatContactId);
            var newPostKey = dbRef.push().key;
            var postData = {
                Date: dateNow,
                Text: vm.replyMessage,
                Type: "O"
            };

            dbRef.child(newPostKey).update(postData)
                .then(function () {
                    $timeout(function () {
                        //reset text area
                        resetReplyTextarea();
                    });
                }).catch(function (err) {
                    console.log(err);
                });
        };

        function gotoContactPublicProfile() {
            var data = vm.contacts.getById(vm.chatContactId);
            $state.go("app.public-person", { 'profileId': vm.chatContactId });
        };


        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.MsgUID === value;
            })[0];
        }


        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        //set chatFilterGroupName
        function setChatGroupFilter(prm){
            vm.chatFilterGroupName=prm;
        };

        // chat filter by group
        function chatFilterByGroup(item) {
            if (!vm.chatFilterGroupName) {
                vm.chatFilterGroupName='ALL';
            }

            if (vm.chatFilterGroupName=='ALL') {
                if (item.IsArchived==false) {
                    return true;
                }
            } else if (vm.chatFilterGroupName=='UNREAD') {
                if (item.IsArchived==false && item.IsRead==false) {
                    return true;
                }
            } else if (vm.chatFilterGroupName=='ARCHIVED') {
                if (item.IsArchived==true) {
                    return true;
                }
            } else {
                return false;
            }
        };

        function getChatIndexById(element) {
            return element.MsgUID === vm.chatContactId;
        };

        function markUnread() {
            var index = vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsRead == true) {
                var ref = firebase.database().ref('/CompanyMessages/' + companyKey + '/Contacts/User/' + vm.chatContactId + '/IsRead');
                ref.set(true).then(function () {
                    $timeout(function () {
                        vm.contacts[index].IsRead = false;
                    })
                })
            }
        };

        function markRead() {
            var index = vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsRead == false) {
                var ref = firebase.database().ref('/CompanyMessages/' + companyKey + '/Contacts/User/' + vm.chatContactId + '/IsRead');
                ref.set(true).then(function () {
                    $timeout(function () {
                        vm.contacts[index].IsRead = true;
                    })
                })
            }
        };

        function sendtoArchive() {
            var index=vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsArchived==false) {
                var ref=firebase.database().ref('/CompanyMessages/'+companyKey+'/Contacts/User/'+vm.chatContactId+'/IsArchived');
                ref.set(true).then(function(){
                    $timeout(function() {
                        vm.contacts[index].IsArchived=true;
                    })
                })
            }
        };

        function restore() {
            var index=vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsArchived==true) {
                var ref=firebase.database().ref('/CompanyMessages/'+companyKey+'/Contacts/User/'+vm.chatContactId+'/IsArchived');
                ref.set(false).then(function(){
                    $timeout(function() {
                        vm.contacts[index].IsArchived=false;
                    })
                })
            }
        };

        /**
         * Delete chat Confirm Dialog
         */
        function deleteChatConfirm(ev)
        {
			var title = $translate.instant('MESSAGING.CHAT_DELETE_CONFIRM');
			var textContent = $translate.instant('MESSAGING.CHAT_DELETE_CONFIRM_MSG');

            var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent(textContent + '<b>' + vm.contacts.getById(vm.chatContactId).DisplayName + '</b>')
                .ariaLabel('delete chat')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                deleteChat();

            }, function ()
            {

            });
        };

        function deleteChat() {
            var index = vm.contacts.findIndex(getChatIndexById);
            var ref = firebase.database().ref('/CompanyMessages/' + companyKey);

            var updates = {};
            updates['/Contacts/User/' + vm.chatContactId] = null;
            updates['/Messages/User/' + vm.chatContactId] = null;

            ref.update(updates).then(function () {
                $timeout(function () {
                    vm.contacts.splice(index, 1);
                    vm.chatContactId = null;
                    vm.chat = null;
                });
            })
        };

        $scope.$on("$destroy", function() {
            pref.off();
            messagingRef.off();

            if (chatRef) {
                chatRef.off();
            }
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-dashboard')
        .controller('MyCompanyDashboardController', MyCompanyDashboardController);

    /** @ngInject */
    function MyCompanyDashboardController($scope, $interval, $timeout, $mdSidenav, $translate, companyKey)
    {
        var vm = this;

        // Data
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;
        var UID=vm.user.uid;

        // Methods
        vm.selectForm = selectForm;
        vm.loadSubmittedFormsWidget = loadSubmittedFormsWidget;
        //

        vm.forms=[];
        vm.selectedForm = {};
        vm.selectedForm.Name = $translate.instant('MCD.SELECT_A_FORM');

        loadForms();

        function loadForms() {
            var designFormsRef = db.ref('/DesignForm/' + companyKey);
            designFormsRef.once('value', function (snap) {
                snap.forEach(function (designFormSnap) {
                    var key = designFormSnap.key;
                    var data = designFormSnap.val();
                    var name = data.Name;
                    var type = data.Type;
                    db.ref('/Form/' + companyKey + '/DesignFormKey')
                        .once('value', function (formSnap) {
                            var count = formSnap.numChildren();
                            $timeout(function () {
                                vm.forms.push({ "Key": key, "Name": name, "Type": type, "FormTotal": count });
                            });
                        });
                });
            });
        }

        //vm.selectedForm = vm.forms[0];


        function selectForm(form) {
            vm.selectedForm = form;
            loadSubmittedFormsWidget();
            loadSharedUsersWidget();
            loadApprovalsWaitingWidget();
            loadResponseDistributionWidget();
        }

        //////////
        

        // Widget Submitted Forms //

        var text_submitted_forms = $translate.instant('MCD.SUBMITTED_FORMS');
        var text_completed = $translate.instant('MCD.COMPLETED');
        var text_td = $translate.instant('MCD.TODAY');
        var text_tm = $translate.instant('MCD.THIS_MONTH');
        var text_ty = $translate.instant('MCD.THIS_YEAR');

        vm.widget_SubmittedForms= {
            "ranges": {
                "TD": text_td,
                "TM": text_tm,
                "TY": text_ty   
            },
            "currentRange": "TD",
            "data": {
                "label": text_submitted_forms,
                "count": {
                    "TD": 0,
                    "TM": 0,
                    "TY": 0
                },
                "extra": {
                    "label": text_completed,
                    "count": {
                        "TD": "0",
                        "TM": "0",
                        "TY": "0"
                    }
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        // Widget Shared Users //

        var text_shared_users= $translate.instant('MCD.SHARED_USERS');
        var text_users = $translate.instant('MCD.USERS');

        vm.widget_SharedUsers= {
            "title": text_shared_users,
            "data": {
                "label": text_users,
                "count": 0
            }
        };

        // Widget Approvals Waiting //
        var text_approvals= $translate.instant('MCD.APPROVALS');
        var text_waiting = $translate.instant('MCD.WAITING');

        vm.widget_ApprovalsWaiting= {
            "title": text_approvals,
            "data": {
                "label": text_waiting,
                "count": 0
            }
        };

        // Widget Response Distribution //
        var text_response_distribution = $translate.instant('MCD.RESPONSE_DISTRIBUTION');
        var text_select = $translate.instant('MCD.SELECT');
        var text_submitted_forms = $translate.instant('MCD.SUBMITTED_FORMS');
        var text_number_of_responses = $translate.instant('MCD.NUMBER_OF_RESPONSES');

        vm.widget_ResponseDistribution = {
            title       : text_response_distribution,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft: {
                "title": text_submitted_forms,
                "count": 0
            },
            footerRight: {
                "title": text_number_of_responses,
                "count": 0
            },
            questions      : {},
            currentQuestion: text_select,
            changeQuestion : function (question)
            {
                //vm.widget_ResponseDistribution.currentQuestion = question;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                db.ref('/Form/' + companyKey + '/' + vm.selectedForm.Key).once('value', function (snap) {
                    if (snap.val()) {
                        var formNumber = snap.numChildren();
                        var responseNumber = 0;
                        var x = 0;
                        snap.forEach(function (formSnap) {
                            getResponses(formSnap.key).then(function (hasResponse) {
                                x++;
                                if (hasResponse) {
                                    responseNumber++;
                                }
                                if (x >= formNumber) {
                                    loadResponseData(formNumber, responseNumber);
                                }
                            });
                        })
                    }
                });

                var responses = {};

                function getResponses(formKey) {
                    return new Promise(function (resolve, reject) {
                        db.ref('/FormItems/' + formKey + '/Items/' + question + '/Value').once('value', function (snap) {
                            var hasResponse = false;
                            if (snap.val()) {
                                hasResponse = true;
                                var response = snap.val();
                                if (responses[response]) {
                                    responses[response].value++;
                                } else {
                                    responses[response] = {"value":1};
                                }
                            }
                            resolve(hasResponse);
                        });
                    });
                };

                function loadResponseData(formNumber, responseNumber) {
                    angular.forEach(responses, function (data, index)
                    {
                        vm.widget_ResponseDistribution.mainChart.data.push({
                            "label": index,
                            "value": data.value
                        });
                    });

                    $timeout(function() {
                        vm.widget_ResponseDistribution.footerLeft.count = formNumber;
                        vm.widget_ResponseDistribution.footerRight.count = responseNumber;
                    });
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget_ResponseDistribution.changeQuestion('TW');
            }
        };



        function loadSubmittedFormsWidget() {
            var range = vm.widget_SubmittedForms.currentRange;
            var startDate;
            switch (range) {
                case 'TD':
                    startDate = moment().startOf('day').unix() * 1000;
                    break;
                case 'TM':
                    startDate = moment().startOf('month').unix() * 1000;
                    break;
                case 'TY':
                    startDate = moment().startOf('year').unix() * 1000;
                    break;
                default:
                // Error: invalid mode.
            }

            db.ref('/Form/' + companyKey + '/' + vm.selectedForm.Key).orderByChild("DateCreated").startAt(startDate).once('value', function (snap) {
                var formNumber = snap.numChildren();
                var completedNumber = 0;
                var data = snap.val();

                angular.forEach(data, function (value, key) {
                    if (value.Status == 'Completed') {
                        completedNumber++;
                    }
                })

                $timeout(function () {
                    vm.widget_SubmittedForms.data.count[range] = formNumber;
                    vm.widget_SubmittedForms.data.extra.count[range] = completedNumber;
                });
            });
        };

        function loadSharedUsersWidget() {
            db.ref('/DesignForm/' + companyKey + '/' + vm.selectedForm.Key + '/Users').once('value', function (snap) {
                var count = snap.numChildren();
                $timeout(function () {
                    vm.widget_SharedUsers.data.count = count;
                });
            });
        };

        function loadApprovalsWaitingWidget() {
            db.ref('/Form/' + companyKey + '/' + vm.selectedForm.Key).orderByChild("Status").equalTo("Pending").once('value', function (snap) {
                var count = snap.numChildren();

                $timeout(function () {
                    vm.widget_ApprovalsWaiting.data.count = count;
                });
            });
        };

                ///////////

                
        function loadResponseDistributionWidget() {
            vm.widget_ResponseDistribution.questions = {};
            db.ref('/DesignFormItems/' + companyKey + '/' + vm.selectedForm.Key + '/Items').once('value', function (snap) {
                if (snap.val()) {
                    snap.forEach(function(itemSnap) {
                        if (itemSnap.val().Type == ('Radio Button' || 'Checkbox' || 'Dropdown')) {
                            vm.widget_ResponseDistribution.questions[itemSnap.key] = itemSnap.val().LabelText;
                        }
                    })
                }
            });            
        };

        //function loadResponseDistributionWidget2() {
            vm.dashboardData={};
            vm.dashboardData.widget_ResponseDistribution= {
                "title": "Task Distribution",
                "questions": {
                    "TW": "11This Week",
                    "LW": "Last Week",
                    "2W": "2 Weeks Ago"
                },
                "mainChart": [
                    {
                        "label": "Frontend",
                        "values": {
                            "2W": 18,
                            "LW": 19,
                            "TW": 15
                        }
                    },
                    {
                        "label": "Backend",
                        "values": {
                            "2W": 17,
                            "LW": 16,
                            "TW": 20
                        }
                    },
                    {
                        "label": "API",
                        "values": {
                            "2W": 40,
                            "LW": 42,
                            "TW": 38
                        }
                    },
                    {
                        "label": "Issues",
                        "values": {
                            "2W": 25,
                            "LW": 23,
                            "TW": 27
                        }
                    }
                ],
                "footerLeft": {
                    "title": text_submitted_forms,
                    "count": {
                        "2W": 487,
                        "LW": 526,
                        "TW": 594
                    }
                },
                "footerRight": {
                    "title": text_number_of_responses,
                    "count": {
                        "2W": 193,
                        "LW": 260,
                        "TW": 287
                    }
                }
            };
        //};



        vm.dashboardData.widget5= {
            "title": "Weekly Report",
            "ranges": {
                "TW": "This Week",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
            },
            "mainChart": [
                {
                    "key": "Closed Issues",
                    "values": {
                        "2W": [
                            {"x": "Mon", "y": 9},
                            {"x": "Tue", "y": 12},
                            {"x": "Wed", "y": 9},
                            {"x": "Thu", "y": 12},
                            {"x": "Fri", "y": 7},
                            {"x": "Sat", "y": 8},
                            {"x": "Sun", "y": 16}
                        ],
                        "LW": [
                            {"x": "Mon", "y": 12},
                            {"x": "Tue", "y": 8},
                            {"x": "Wed", "y": 7},
                            {"x": "Thu", "y": 13},
                            {"x": "Fri", "y": 7},
                            {"x": "Sat", "y": 6},
                            {"x": "Sun", "y": 10}
                        ],
                        "TW": [
                            {"x": "Mon", "y": 2},
                            {"x": "Tue", "y": 2},
                            {"x": "Wed", "y": 1},
                            {"x": "Thu", "y": 2},
                            {"x": "Fri", "y": 1},
                            {"x": "Sat", "y": 1},
                            {"x": "Sun", "y": 2}
                        ]
                    }
                },
                {
                    "key": "Issues",
                    "values": {
                        "2W": [
                            {"x": "Mon", "y": 37},
                            {"x": "Tue", "y": 32},
                            {"x": "Wed", "y": 39},
                            {"x": "Thu", "y": 27},
                            {"x": "Fri", "y": 18},
                            {"x": "Sat", "y": 24},
                            {"x": "Sun", "y": 20}
                        ],
                        "LW": [
                            {"x": "Mon", "y": 37},
                            {"x": "Tue", "y": 24},
                            {"x": "Wed", "y": 51},
                            {"x": "Thu", "y": 31},
                            {"x": "Fri", "y": 29},
                            {"x": "Sat", "y": 17},
                            {"x": "Sun", "y": 31}
                        ],
                        "TW": [
                            {"x": "Mon", "y": 3},
                            {"x": "Tue", "y": 2},
                            {"x": "Wed", "y": 1},
                            {"x": "Thu", "y": 2},
                            {"x": "Fri", "y": 1},
                            {"x": "Sat", "y": 1},
                            {"x": "Sun", "y": 2}
                        ]
                    }
                }
            ],
            "supporting": {
                "created": {
                    "label": "SUBMITTED",
                    "count": {
                        "2W": 48,
                        "LW": 46,
                        "TW": 12
                    },
                    "chart": {
                        "key": "Created",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 8},
                                {"x": 2, "y": 5},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 2},
                                {"x": 4, "y": 1},
                                {"x": 5, "y": 1},
                                {"x": 6, "y": 2}
                            ]
                        }
                    }
                },
                "closed": {
                    "label": "COMPLETED",
                    "count": {
                        "2W": 27,
                        "LW": 31,
                        "TW": 11
                    },
                    "chart": {
                        "key": "Closed",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 2},
                                {"x": 4, "y": 2},
                                {"x": 5, "y": 0},
                                {"x": 6, "y": 1}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 2},
                                {"x": 4, "y": 2},
                                {"x": 5, "y": 0},
                                {"x": 6, "y": 1}
                            ]
                        }
                    }
                },
                "reOpened": {
                    "label": "PENDING",
                    "count": {
                        "2W": 4,
                        "LW": 5,
                        "TW": 1
                    },
                    "chart": {
                        "key": "Re-Opened",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "TW": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 4},
                                {"x": 4, "y": 8},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 4}
                            ]
                        }
                    }
                },
                "wontFix": {
                    "label": "CANCELLED",
                    "count": {
                        "2W": 6,
                        "LW": 3,
                        "TW": 0
                    },
                    "chart": {
                        "key": "Won't Fix",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 3},
                                {"x": 6, "y": 2}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 0},
                                {"x": 1, "y": 0},
                                {"x": 2, "y": 0},
                                {"x": 3, "y": 0},
                                {"x": 4, "y": 0},
                                {"x": 5, "y": 0},
                                {"x": 6, "y": 0}
                            ]
                        }
                    }
                },
                "needsTest": {
                    "label": "NEEDS TEST",
                    "count": {
                        "2W": 10,
                        "LW": 7,
                        "TW": 8
                    },
                    "chart": {
                        "key": "Needs Test",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "TW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ]
                        }
                    }
                },
                "fixed": {
                    "label": "FIXED",
                    "count": {
                        "2W": 21,
                        "LW": 17,
                        "TW": 14
                    },
                    "chart": {
                        "key": "Fixed",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 3},
                                {"x": 6, "y": 2}
                            ]
                        }
                    }
                }
            }
        };



        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };




        // Initialize Widget 5
        vm.widget5.init();


    }

})();
(function () {
    'use strict';

    angular
        .module('app.my-company.create-company-page',
        []
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.create-company-page')
        .controller('CreateCompanyPageController', CreateCompanyPageController);

    /** @ngInject */
    function CreateCompanyPageController($state, $timeout, $mdDialog, $document, $mdToast, $translate, $http, $rootScope)
    {
        var vm = this;
        // Methods
        vm.submitForm=submitForm;

        // firebase//
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var db=firebase.database();

        function submitForm(ev, form) {
            form.$invalid = true;
            checkCompanyURL(ev, vm.form.companyURL);
        };

        function checkCompanyURL(ev, url) {
            var ref = db.ref('/CompanyPages').orderByChild('CompanyURL').equalTo(url);
            ref.once('value')
                .then(function (snap) {
                    if (snap.val()) {
                        var title = $translate.instant('CCP.THIS_URL_ALREADY_EXISTS');
                        var textContent = $translate.instant('CCP.CREATE_COMPANY_URL_EXISTS_WARNING');

                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#create-company-page')))
                                .clickOutsideToClose(true)
                                .title(title)
                                .textContent(textContent)
                                .ariaLabel('URL exists')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                    } else {
                        createCompany();
                    }
                })
        };

        function createCompany() {
            var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/createCompanyPage';

            firebase.auth().currentUser.getToken()
                .then(function (token) {
                    $rootScope.showLoadingPanel = true;
                    var req = {
                        method: 'POST',
                        url: functionURL,
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                        data: {
                            'companyURL': vm.form.companyURL,
                            'companyName': vm.form.companyName
                        }
                    }

                    $http(req)
                        .then(function (resp) {
                            $rootScope.showLoadingPanel = false;
                            var textContent = $translate.instant('CCP.COMPANY_PAGE_CREATED');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(textContent)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                            //force token refresh
                            firebase.auth().currentUser.getToken(true)
                                .then(function () {
                                    $state.go('app.my-company_my-company-page', {'companyKey':resp.data.companyKey});
                                })
                        }, function (err) {
                            $rootScope.showLoadingPanel = false;
                            var textContent = $translate.instant('CCP.ERROR');
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(textContent + ': ' + err)
                                    .hideDelay(3000)
                                    .position('top right')
                            );
                        });

                }, function () {
                    $rootScope.showLoadingPanel = false;
                });
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.main',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_main', {
            url      : '/dashboard-main',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/main/dashboard-main.html',
                    controller : 'DashboardMainController as vm'
                }
            },
            resolve  : {
                "currentAuth": ["Auth", function(Auth) {
                return Auth.$requireSignIn();
                }]               
            },            
            bodyClass: 'dashboard-main'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.main')
        .controller('DashboardMainController', DashboardMainController);

    /** @ngInject */
    function DashboardMainController($scope, $interval, $timeout, $mdSidenav, $translate)
    {
        var vm = this;

        // Data
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;
        var UID=vm.user.uid;

        // Methods
        vm.selectForm = selectForm;
        vm.loadSubmittedFormsWidget=loadSubmittedFormsWidget;
        //

        vm.forms=[];

        loadForms();

        function loadForms() {
            var formsRef= db.ref('/DesignForm').orderByChild('UID').equalTo(UID);
            formsRef.on('child_added', function(snap){
                var key=snap.key;
                var data=snap.val();
                var name=data.Name;
                var type=data.Type;
                db.ref('/Form').orderByChild('DesignFormKey').equalTo(key)
                .once('value', function(formsnap){
                    var count=formsnap.numChildren();
                    $timeout(function(){
                        vm.forms.push({"Key":key, "Name":name, "Type":type, "FormTotal":count});
                    });
                });
            });
        }

        //vm.selectedForm = vm.forms[0];


        function selectForm(form) {
            vm.selectedForm = form;
            loadSubmittedFormsWidget();
            
        }

        //////////
        






        //Widget Submitted Forms/////

        var widget_submitted_forms_label= $translate.instant('MF.SUBMITTED_FORMS');
        var TD= $translate.instant('MF.TODAY');
        var TM= $translate.instant('MF.THIS_MONTH');
        var TY= $translate.instant('MF.THIS_YEAR');

        vm.widget_SubmittedForms= {
            "ranges": {
                "TD": TD,
                "TM": TM,
                "TY": TY   
            },
            "currentRange": "TD",
            "data": {
                "label": widget_submitted_forms_label,
                "count": {
                    "TD": 0,
                    "TM": 0,
                    "TY": 0
                },
                "extra": {
                    "label": "Completed",
                    "count": {
                        "TD": "?",
                        "TM": "?",
                        "TY": "?"
                    }
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        function loadSubmittedFormsWidget() {
            var range=vm.widget_SubmittedForms.currentRange;
            var startDate;
            switch (range) {
                case 'TD':
                    startDate = moment().startOf('day').unix() * 1000;
                    break;
                case 'TM':
                    startDate = moment().startOf('month').unix() * 1000;
                    break;
                case 'TY':
                    startDate = moment().startOf('year').unix() * 1000;
                    break;
                default:
                // Error: invalid mode.
            }
            console.log(range);
            db.ref('/Form/' + vm.selectedForm.Key).orderByChild("DateCreated").startAt(startDate).once('value', function (snap) {
                var count = snap.numChildren();
                $timeout(function () {
                    vm.widget_SubmittedForms.data.count[range] = count;
                });
            });
        }










        ///////////

        vm.dashboardData={};






        vm.dashboardData.widget5= {
            "title": "Github Issues",
            "ranges": {
                "TW": "This Week",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
            },
            "mainChart": [
                {
                    "key": "Closed Issues",
                    "values": {
                        "2W": [
                            {"x": "Mon", "y": 9},
                            {"x": "Tue", "y": 12},
                            {"x": "Wed", "y": 9},
                            {"x": "Thu", "y": 12},
                            {"x": "Fri", "y": 7},
                            {"x": "Sat", "y": 8},
                            {"x": "Sun", "y": 16}
                        ],
                        "LW": [
                            {"x": "Mon", "y": 12},
                            {"x": "Tue", "y": 8},
                            {"x": "Wed", "y": 7},
                            {"x": "Thu", "y": 13},
                            {"x": "Fri", "y": 7},
                            {"x": "Sat", "y": 6},
                            {"x": "Sun", "y": 10}
                        ],
                        "TW": [
                            {"x": "Mon", "y": 11},
                            {"x": "Tue", "y": 10},
                            {"x": "Wed", "y": 8},
                            {"x": "Thu", "y": 11},
                            {"x": "Fri", "y": 8},
                            {"x": "Sat", "y": 10},
                            {"x": "Sun", "y": 17}
                        ]
                    }
                },
                {
                    "key": "Issues",
                    "values": {
                        "2W": [
                            {"x": "Mon", "y": 37},
                            {"x": "Tue", "y": 32},
                            {"x": "Wed", "y": 39},
                            {"x": "Thu", "y": 27},
                            {"x": "Fri", "y": 18},
                            {"x": "Sat", "y": 24},
                            {"x": "Sun", "y": 20}
                        ],
                        "LW": [
                            {"x": "Mon", "y": 37},
                            {"x": "Tue", "y": 24},
                            {"x": "Wed", "y": 51},
                            {"x": "Thu", "y": 31},
                            {"x": "Fri", "y": 29},
                            {"x": "Sat", "y": 17},
                            {"x": "Sun", "y": 31}
                        ],
                        "TW": [
                            {"x": "Mon", "y": 42},
                            {"x": "Tue", "y": 28},
                            {"x": "Wed", "y": 43},
                            {"x": "Thu", "y": 34},
                            {"x": "Fri", "y": 20},
                            {"x": "Sat", "y": 25},
                            {"x": "Sun", "y": 22}
                        ]
                    }
                }
            ],
            "supporting": {
                "created": {
                    "label": "CREATED",
                    "count": {
                        "2W": 48,
                        "LW": 46,
                        "TW": 54
                    },
                    "chart": {
                        "key": "Created",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 8},
                                {"x": 2, "y": 5},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 4},
                                {"x": 4, "y": 8},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 4}
                            ]
                        }
                    }
                },
                "closed": {
                    "label": "CLOSED",
                    "count": {
                        "2W": 27,
                        "LW": 31,
                        "TW": 26
                    },
                    "chart": {
                        "key": "Closed",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 4},
                                {"x": 4, "y": 8},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 4}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ]
                        }
                    }
                },
                "reOpened": {
                    "label": "RE-OPENED",
                    "count": {
                        "2W": 4,
                        "LW": 5,
                        "TW": 2
                    },
                    "chart": {
                        "key": "Re-Opened",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "TW": [
                                {"x": 0, "y": 3},
                                {"x": 1, "y": 2},
                                {"x": 2, "y": 1},
                                {"x": 3, "y": 4},
                                {"x": 4, "y": 8},
                                {"x": 5, "y": 8},
                                {"x": 6, "y": 4}
                            ]
                        }
                    }
                },
                "wontFix": {
                    "label": "WON'T FIX",
                    "count": {
                        "2W": 6,
                        "LW": 3,
                        "TW": 4
                    },
                    "chart": {
                        "key": "Won't Fix",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 3},
                                {"x": 6, "y": 2}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ]
                        }
                    }
                },
                "needsTest": {
                    "label": "NEEDS TEST",
                    "count": {
                        "2W": 10,
                        "LW": 7,
                        "TW": 8
                    },
                    "chart": {
                        "key": "Needs Test",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "LW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "TW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 3},
                                {"x": 2, "y": 7},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ]
                        }
                    }
                },
                "fixed": {
                    "label": "FIXED",
                    "count": {
                        "2W": 21,
                        "LW": 17,
                        "TW": 14
                    },
                    "chart": {
                        "key": "Fixed",
                        "values": {
                            "2W": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 8},
                                {"x": 3, "y": 8},
                                {"x": 4, "y": 6},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 1}
                            ],
                            "LW": [
                                {"x": 0, "y": 6},
                                {"x": 1, "y": 5},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 5},
                                {"x": 4, "y": 7},
                                {"x": 5, "y": 4},
                                {"x": 6, "y": 7}
                            ],
                            "TW": [
                                {"x": 0, "y": 5},
                                {"x": 1, "y": 7},
                                {"x": 2, "y": 4},
                                {"x": 3, "y": 6},
                                {"x": 4, "y": 5},
                                {"x": 5, "y": 3},
                                {"x": 6, "y": 2}
                            ]
                        }
                    }
                }
            }
        };

        vm.dashboardData.widget6= {
            "title": "Task Distribution",
            "ranges": {
                "TW": "This Week",
                "LW": "Last Week",
                "2W": "2 Weeks Ago"
            },
            "mainChart": [
                {
                    "label": "Frontend",
                    "values": {
                        "2W": 18,
                        "LW": 19,
                        "TW": 15
                    }
                },
                {
                    "label": "Backend",
                    "values": {
                        "2W": 17,
                        "LW": 16,
                        "TW": 20
                    }
                },
                {
                    "label": "API",
                    "values": {
                        "2W": 40,
                        "LW": 42,
                        "TW": 38
                    }
                },
                {
                    "label": "Issues",
                    "values": {
                        "2W": 25,
                        "LW": 23,
                        "TW": 27
                    }
                }
            ],
            "footerLeft": {
                "title": "Tasks Added",
                "count": {
                    "2W": 487,
                    "LW": 526,
                    "TW": 594
                }
            },
            "footerRight": {
                "title": "Tasks Completed",
                "count": {
                    "2W": 193,
                    "LW": 260,
                    "TW": 287
                }
            }
        };

        vm.dashboardData.widget7= {
            "title": "Schedule",
            "ranges": {
                "T": "Today",
                "TM": "Tomorrow"
            },
            "schedule": {
                "T": [
                    {
                        "title": "Group Meeting",
                        "time": "In 32 minutes",
                        "location": "Room 1B"
                    },
                    {
                        "title": "Coffee Break",
                        "time": "10:30 AM"
                    },
                    {
                        "title": "Public Beta Release",
                        "time": "11:00 AM"
                    },
                    {
                        "title": "Lunch",
                        "time": "12:10 PM"
                    },
                    {
                        "title": "Dinner with David",
                        "time": "17:30 PM"
                    },
                    {
                        "title": "Jane's Birthday Party",
                        "time": "19:30 PM"
                    },
                    {
                        "title": "Overseer's Retirement Party",
                        "time": "21:30 PM"
                    }
                ],
                "TM": [
                    {
                        "title": "Marketing Meeting",
                        "time": "09:00 AM"
                    },
                    {
                        "title": "Public Announcement",
                        "time": "11:00 AM"
                    },
                    {
                        "title": "Lunch",
                        "time": "12:10 PM"
                    },
                    {
                        "title": "Meeting with Beta Testers",
                        "time": "15:00 AM"
                    },
                    {
                        "title": "Live Stream",
                        "time": "17:30 PM"
                    },
                    {
                        "title": "Release Party",
                        "time": "19:30 PM"
                    },
                    {
                        "title": "CEO's Party",
                        "time": "22:30 PM"
                    }
                ]
            }
        };



        vm.widget2= {
            "title": "Overdue",
            "data": {
                "label": "TASKS",
                "count": 4,
                "extra": {
                    "label": "Yesterday's overdue",
                    "count": 2
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        vm.widget3= {
            "title": "Issues",
            "data": {
                "label": "OPEN",
                "count": 32,
                "extra": {
                    "label": "Closed today",
                    "count": 0
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        vm.widget4= {
            "title": "Features",
            "data": {
                "label": "PROPOSALS",
                "count": 42,
                "extra": {
                    "label": "Implemented",
                    "count": 8
                }
            },
            "detail": "You can show some detailed information about this widget in here."
        };

        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.shared-withme')
        .controller('SharedWithmeController', SharedWithmeController);

    /** @ngInject */
    function SharedWithmeController($mdSidenav, $state, $timeout, $translate, $rootScope, $mdDialog, $document, $mdToast, nfdesignForm, formatTimeStamp)
    {
        var vm = this;

        //firebase
        var db=firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var sharedForms=[];
        var sharedFormsRef = db.ref('/UserSharedForms/'+UID);
        sharedFormsRef.once('value', function(snap) {
            snap.forEach(function(child){
                var key=child.key;
                var data=child.val();
                var companyKey=data.CompanyKey;
                var count=0;
                db.ref('/UserFormSubmissions/'+UID).orderByChild("DesignFormKey").equalTo(key)
                .once('value', function(formsnap){
                    count=formsnap.numChildren();

                    db.ref('/DesignForm/'+companyKey+'/'+key)
                    .once('value', function(snap) {
                        var data=snap.val();
                        var name=data.Name;
                        var type=data.Type;

                        db.ref('/CompanyPages/'+companyKey)
                        .once('value', function(userSnap) {
                            var companyName=userSnap.val().CompanyName;
                            var companyURL=userSnap.val().CompanyURL;
                            $timeout(function () {
                                sharedForms.push({
                                    "Key": key,
                                    "Name": name,
                                    "Type": type,
                                    "FormTotal": count,
                                    "CompanyName": companyName,
                                    "CompanyURL": companyURL,
                                    "CompanyKey": companyKey
                                });
                            });
                        });
                    });
                });
            });
        });


        // Data
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.sharedForms = sharedForms;
        vm.selected = vm.sharedForms[0];

        // Methods

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;
        vm.viewFormList=viewFormList;
        vm.openFillFormDialog=openFillFormDialog;

        //////////


        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        /**
         * @param id
         */
        function viewFormList(id)
        {
            nfdesignForm.setKey(id.Key);
            nfdesignForm.setName(id.Name);
            $state.go('app.pages_shared-withme.viewformlist');
        }

        /**
         * Array prototype
         *
         * Get by key
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getByKey = function (value)
        {
            return this.filter(function (x)
            {
                return x.Key === value;
            })[0];
        }

        /**
         * Open fill form dialog
         *
         * @param ev
         */
        function openFillFormDialog(ev, formKey, formName, companyKey) {
            $mdDialog.show({
                controller: 'FillFormDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pages/shared-withme/dialogs/fillform-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    UID: UID,
                    designFormKey: formKey,
                    designFormName: formName,
                    companyKey : companyKey
                }
            }).then(function () {
                vm.sharedForms.getByKey(formKey).FormTotal++;
                $rootScope.showLoadingPanel = false;

                var title = $translate.instant('PUBLIC_COMPANY.FORM_SUBMITTED');
                var textContent = $translate.instant('PUBLIC_COMPANY.FORM_SUBMITTED_MSG');
                var okText = $translate.instant('OK');

                $timeout(function () {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#content-container')))
                            .clickOutsideToClose(true)
                            .title(title)
                            .textContent(textContent)
                            .ariaLabel('form submission process')
                            .ok(okText)
                            .targetEvent(ev)
                    );
                    
                },1000);

            }, function () {
                //cancel
            });
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController($state)
    {
        var vm = this;
        
        // Methods
        
        if ($state.current.name == 'app.pages_search.person') {
            vm.activeTab = 1;
        } else {
            vm.activeTab = 0;
        }
        

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.public-person')
        .controller('PublicPersonController', PublicPersonController);

    /** @ngInject */
    function PublicPersonController($scope, $state, $timeout, $document, $mdDialog, $mdToast, $translate, $rootScope, $http, formatTimeStamp, ngMeta)
    {
        var vm = this;
        
        //firebase
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;

        //
        vm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.gotoMessaging = gotoMessaging;
        vm.followPersonPage = followPersonPage;
        vm.unFollowPersonPage = unFollowPersonPage;
        vm.followingOnMouseOver = followingOnMouseOver;
        vm.followingOnMouseLeave = followingOnMouseLeave;
        vm.submitPost = submitPost;
        vm.showPostComments = showPostComments;
        vm.showPostLikes = showPostLikes;
        vm.showCommentLikes = showCommentLikes;
        vm.showReplyLikes = showReplyLikes;
        vm.submitPostComment = submitPostComment;
        vm.togglePostLike = togglePostLike;
        vm.toggleCommentLike = toggleCommentLike;
        vm.showCommentReplyPanel = showCommentReplyPanel;
        vm.submitCommentReply = submitCommentReply;
        vm.showCommentReplies = showCommentReplies;
        vm.toggleReplyLike = toggleReplyLike;
        vm.showPreviousPosts = showPreviousPosts;
        vm.showPreviousComments = showPreviousComments;
        vm.showPreviousReplies = showPreviousReplies;
        vm.imageUpload = imageUpload;
        vm.enableComments = enableComments;
        vm.disableComments = disableComments;
        vm.cancelFile = cancelFile;
        vm.deletePost = deletePost;
        vm.deleteReply = deleteReply;
        vm.deleteComment = deleteComment;
        vm.sharePost = sharePost;

        //////////

        var profileUID = $state.params.profileId;

        var loadPostsRef;
        var formUsers = {};

        vm.personPage = {};
        vm.posts = [];
        vm.newPost = {commentsEnabled:true};
        vm.postDisplayLimit = 5;

        loadPersonData();

        function isFollow() {
            if (vm.user) {
                db.ref('/UserFollows/' + vm.user.uid + '/Person/' + profileUID).once('value', function (snap) {
                    if (snap.val()) {
                        vm.isFollow = true;
                    } else {
                        vm.isFollow = false;
                    }
                })
            } else {
                vm.isFollow = false;
            }
        };

        function loadPersonData() {
            db.ref('/Users/' + profileUID).once('value', function (snap) {
                var data = snap.val();
                //meta
                ngMeta.setTitle(data.DisplayName);
                ngMeta.setTag('description', data.DisplayName);
                //
                isFollow();
                $timeout(function () {
                    vm.personPage.email = data.Email;
                    vm.personPage.displayName = data.DisplayName;
                    vm.personPage.phone = data.Phone;
                    vm.personPage.key = profileUID;
                    vm.personPage.photoURL = data.Photo.PhotoURL;
                    vm.personPage.postCount = data.PostCount;
                    vm.personPage.followerCount = data.FollowerCount;
                    if (vm.user) {
                        if (vm.user.uid == vm.personPage.key) {
                            vm.isOwner = true;
                        }
                    }
                    loadPosts();
                });
            });
        };

        function loadPosts() {
            loadPostsRef = db.ref('/PostsPerson/' + profileUID + '/Posts').orderByChild('Date');
            loadPostsRef.on('child_added', function (snap) {
                var key = snap.key;
                var data = snap.val();
                var personKey = data.PersonKey;
                var date = data.Date;
                var type = data.Type;
                var message = data.Message;
                var media = data.Media;
                var comments = [];
                var commentCount = 0;
                var postLikeCount = 0;
                var cm_displayLimit = 2;
                var likes = data.Likes;
                var commentsEnabled = data.CommentsEnabled;
                var sharedPost;
                var isLikePost = false;

                var checkSharedPost = new Promise(function (resolve, reject) {
                    if (data.SharedPost) {
                        if (data.SharedPost.Group == "p") {
                            getUser(data.SharedPost.PersonKey).then(function (resp) {
                                sharedPost = {};
                                sharedPost.key = data.SharedPost.Key;
                                sharedPost.date = data.SharedPost.Date;
                                sharedPost.message = data.SharedPost.Message;
                                sharedPost.media = data.SharedPost.Media;
                                sharedPost.personKey = data.SharedPost.PersonKey;
                                sharedPost.displayName = resp.displayName;
                                sharedPost.photoURL = resp.photoURL;
                                sharedPost.group = "p";
                                resolve();
                            });
                        } else if (data.SharedPost.Group == "c") {
                            getCompany(data.SharedPost.CompanyKey).then(function (resp) {
                                sharedPost = {};
                                sharedPost.key = data.SharedPost.Key;
                                sharedPost.date = data.SharedPost.Date;
                                sharedPost.message = data.SharedPost.Message;
                                sharedPost.media = data.SharedPost.Media;
                                sharedPost.companyKey = data.SharedPost.CompanyKey;
                                sharedPost.companyName = resp.companyName;
                                sharedPost.photoURL = resp.photoURL;
                                sharedPost.companyURL = resp.companyURL;
                                sharedPost.group = "c";
                                resolve();
                            });
                        }

                        function getUser(sharedPersonKey) {
                            return new Promise(function (resolve, reject) {
                                //get user data
                                if (!formUsers[sharedPersonKey]) {
                                    loadFormUser(sharedPersonKey).then(function (response) {
                                        resolve({ displayName: response.DisplayName, photoURL: response.PhotoURL });
                                    });
                                } else {
                                    resolve({ displayName: formUsers[sharedPersonKey].DisplayName, photoURL: formUsers[sharedPersonKey].PhotoURL });
                                }
                            });
                        };

                        function getCompany(sharedCompanyKey) {
                            return new Promise(function (resolve, reject) {
                                //get company data
                                db.ref('/CompanyPages/' + sharedCompanyKey).once('value', function (snap) {
                                    var data = snap.val();
                                    resolve({ companyName: data.CompanyName, photoURL: data.Photo.PhotoURL, companyURL: data.CompanyURL});
                                });
                            });
                        };

                    } else {
                        resolve();
                    }
                });

                var checkComments = new Promise(function (resolve, reject) {
                    if (data.Comments) {
                        commentCount = Object.keys(data.Comments).length;
                        angular.forEach(data.Comments, function (commentData, commentKey) {
                            var cm_replies = [];
                            var cm_key, cm_date, cm_message, cm_showReplies, cm_userKey, cm_displayName, cm_photoURL, cm_isLike, cm_likes, cm_likeCount, cm_replyCount;
                            cm_key = commentKey;
                            cm_date = commentData.Date;
                            cm_message = commentData.Message;
                            cm_likes = commentData.Likes;
                            cm_showReplies = false;
                            cm_userKey = commentData.UID;

                            function getUser() {
                                return new Promise(function (resolve, reject) {
                                    //get user data
                                    if (!formUsers[commentData.UID]) {
                                        loadFormUser(commentData.UID).then(function (response) {
                                            cm_displayName = response.DisplayName;
                                            cm_photoURL = response.PhotoURL;
                                            resolve();
                                        });
                                    } else {
                                        cm_displayName = formUsers[commentData.UID].DisplayName;
                                        cm_photoURL = formUsers[commentData.UID].PhotoURL;
                                        resolve();
                                    }
                                });
                            };
                            //get comment likes
                            if (cm_likes) {
                                cm_likeCount = Object.keys(cm_likes).length;
                                if (vm.user && cm_likes[vm.user.uid]) {
                                    cm_isLike = true;
                                }
                            } else {
                                cm_likeCount = 0;
                            }

                            var rp_displayLimit = 2;

                            function getReplies() {
                                return new Promise(function (resolve, reject) {
                                    //get comment replies
                                    if (commentData.Replies) {
                                        cm_replyCount = Object.keys(commentData.Replies).length;
                                        var x = 0;
                                        angular.forEach(commentData.Replies, function (replyData, replyKey) {
                                            var rp_key, rp_date, rp_message, rp_userKey, rp_displayName, rp_photoURL, rp_likes, rp_isLike, rp_likeCount;
                                            rp_key = replyKey;
                                            rp_date = replyData.Date;
                                            rp_message = replyData.Message;
                                            rp_likes = replyData.Likes;
                                            rp_userKey = replyData.UID;

                                            //get reply likes
                                            if (rp_likes) {
                                                rp_likeCount = Object.keys(rp_likes).length;
                                                if (vm.user && rp_likes[vm.user.uid]) {
                                                    rp_isLike = true;
                                                }
                                            } else {
                                                rp_likeCount = 0;
                                            }

                                            function getUser() {
                                                return new Promise(function (resolve, reject) {
                                                    //get user data
                                                    if (!formUsers[replyData.UID]) {
                                                        loadFormUser(replyData.UID).then(function (response) {
                                                            rp_displayName = response.DisplayName;
                                                            rp_photoURL = response.PhotoURL;
                                                            resolve();
                                                        });
                                                    } else {
                                                        rp_displayName = formUsers[replyData.UID].DisplayName;
                                                        rp_photoURL = formUsers[replyData.UID].PhotoURL;
                                                        resolve();
                                                    }
                                                });
                                            };

                                            getUser().then(function () {
                                                cm_replies.push({
                                                    'key': rp_key,
                                                    'date': rp_date,
                                                    'message': rp_message,
                                                    'displayName': rp_displayName,
                                                    'photoURL': rp_photoURL,
                                                    'isLike': rp_isLike,
                                                    'likeCount': rp_likeCount,
                                                    'likes': rp_likes,
                                                    'userKey': rp_userKey
                                                });
                                                x++;
                                                if (x == cm_replyCount) { resolve(); }
                                            });

                                        });
                                    } else {
                                        cm_replyCount = 0;
                                        resolve();
                                    }
                                });
                            };

                            getUser().then(function () {
                                getReplies().then(function () {
                                    comments.push({
                                        'key': cm_key,
                                        'date': cm_date,
                                        'message': cm_message,
                                        'showReplies': cm_showReplies,
                                        'displayName': cm_displayName,
                                        'photoURL': cm_photoURL,
                                        'isLike': cm_isLike,
                                        'likeCount': cm_likeCount,
                                        'likes': cm_likes,
                                        'replyCount': cm_replyCount,
                                        'replies': cm_replies,
                                        'replyDisplayLimit': rp_displayLimit,
                                        'userKey': cm_userKey
                                    });
                                    resolve();
                                });
                            });

                        });
                    } else {
                        resolve();
                    }
                });

                var checkPostLikes = new Promise(function (resolve, reject) {
                    if (likes) {
                        postLikeCount = Object.keys(likes).length;
                        if (vm.user && likes[vm.user.uid]) {
                            isLikePost = true;
                            resolve();
                        }
                    } else {
                        resolve();
                    }
                });

                Promise.all([checkSharedPost, checkComments, checkPostLikes]).then(function(values) {
                    $timeout(function () {
                        vm.posts.push({
                            'key': key, 
                            'personKey': vm.personPage.key,
                            'photoURL': vm.personPage.photoURL,
                            'displayName': vm.personPage.displayName,
                            'type': type, 
                            'date': date, 
                            'message': message,
                            'commentsEnabled': commentsEnabled,
                            'showComments': false, 
                            'commentCount': commentCount, 
                            'comments': comments,
                            'likeCount': postLikeCount,
                            'isLike': isLikePost,
                            'likes': likes,
                            'commentDisplayLimit': cm_displayLimit,
                            'media': media,
                            'sharedPost': sharedPost
                        });
                    });
                });               

            });
        };

        function enableComments() {
            $timeout(function() {
                vm.newPost.commentsEnabled = true;
            }, 500)
        };

        function disableComments() {
            $timeout(function() {
                vm.newPost.commentsEnabled = false;
            }, 500)
        };

        function showPostComments(ev, postKey) {
            if (vm.user) {
                vm.posts.getByKey(postKey).showComments = true;
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showCommentReplies(commentKey, postKey) {
            if (vm.user) {
                vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplies = true;
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showPostLikes(ev, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller         : 'ShowLikesDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/pages/public-person/dialogs/showlikes/showlikes-dialog.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        likes : vm.posts.getByKey(postKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }               
        };

        function showCommentLikes(ev, commentKey, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller         : 'ShowLikesDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/pages/public-person/dialogs/showlikes/showlikes-dialog.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        likes : vm.posts.getByKey(postKey).comments.getByKey(commentKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showReplyLikes(ev, replyKey, commentKey, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller         : 'ShowLikesDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/pages/public-person/dialogs/showlikes/showlikes-dialog.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true,
                    locals             : {
                        likes : vm.posts.getByKey(postKey).comments.getByKey(commentKey).replies.getByKey(replyKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showPreviousPosts() {
            vm.postDisplayLimit += 10;
        };

        function showPreviousComments(postKey) {
            vm.posts.getByKey(postKey).commentDisplayLimit += 10;
        };

        function showPreviousReplies(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).replyDisplayLimit += 10;
        };

        function showCommentReplyPanel(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplies = true;
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplyPanel = true;
        };

        function hideCommentReplyPanel(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplyPanel = false;
        };

        function imageUpload(flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                vm.newPost.image = event.target.result;
            };
            fileReader.readAsDataURL(flowFile.file);
        };

        function submitPostComment(form, postKey, message) {
            form.$invalid = true;
            vm.commentForm[postKey].message = '';
            var postCommentRef = db.ref('/PostsPerson/' + profileUID + '/Posts/' + postKey + '/Comments/');
            var postCommentKey = postCommentRef.push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var updates = { UID: vm.user.uid, Message: message, Date: dateNow };

            var post = vm.posts.getByKey(postKey);
            var newCommentCount = post.commentCount + 1;
            
            postCommentRef.child(postCommentKey).update(updates)
                .then(function () {
                    const timestamp = Date.now();
                    $timeout(function () {
                        post.commentCount = newCommentCount;
                        if (!post.comments) {
                            post.comments = [];
                        }
                        post.comments.push({
                            'key': postCommentKey,
                            'displayName': vm.user.displayName,
                            'photoURL': vm.user.photoURL,
                            'message': message,
                            'date': timestamp,
                            'showComments': false,
                            'isLike': false,
                            'likeCount': 0,
                            'commentCount': 0,
                            //'comments': '',
                            'commentDisplayLimit': 2,
                            'userKey': vm.user.uid
                        });
                        post.commentDisplayLimit++;
                    });
                })
        };

        function submitCommentReply(form, postKey, commentKey, message) {
            form.$invalid = true;
            vm.replyForm[commentKey].message = '';
            var replyRef = db.ref('/PostsPerson/' + profileUID + '/Posts/' + postKey + '/Comments/' + commentKey + '/Replies/');
            var replyKey = replyRef.push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var updates = { UID: vm.user.uid, Message: message, Date: dateNow };

            var comment = vm.posts.getByKey(postKey).comments.getByKey(commentKey);
            var newReplyCount = comment.replyCount + 1;

            replyRef.child(replyKey).update(updates)
                .then(function () {
                    const timestamp = Date.now();
                    $timeout(function () {
                        comment.replyCount = newReplyCount;
                        if (!comment.replies) {
                            comment.replies = [];
                        }
                        comment.replies.push({
                            'key': replyKey,
                            'displayName': vm.user.displayName,
                            'photoURL': vm.user.photoURL,
                            'message': message,
                            'date': timestamp,
                            'isLike': false,
                            'likeCount': 0,
                            'userKey': vm.user.uid
                        });
                        comment.replyDisplayLimit++;
                        hideCommentReplyPanel(commentKey, postKey);
                    });
                })
        };

        function loadFormUser(formUserUID) {
            return new Promise(function(resolve, reject) {
                db.ref('/Users/').child(formUserUID)
                .once('value', function (userSnap) {
                    var displayName = userSnap.val().DisplayName;
                    var photoURL = userSnap.val().Photo.PhotoURL;
                    formUsers[formUserUID]={};
                    formUsers[formUserUID]["DisplayName"]=displayName;
                    formUsers[formUserUID]["PhotoURL"]=photoURL;
                    resolve(formUsers[formUserUID]);
                });
            });
        };

        function followPersonPage() {
            if (vm.user) {
                var ref = db.ref('UserFollows/' + vm.user.uid + '/Person/' + profileUID);
                ref.set(true)
                    .then(function () {
                        $timeout(function () {
                            vm.isFollow = true;
                        });
                    }), function (err) {
                        console.log(err);
                    }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function unFollowPersonPage() {
            var ref = db.ref('UserFollows/' + vm.user.uid + '/Person/' + profileUID);
            ref.set(null)
                .then(function () {
                    $timeout(function () {
                        vm.isFollow = false;
                    });
                }), function (err) {
                    console.log(err);
                }
        };

        function followingOnMouseOver() {
            vm.isFollowingMouseOver = true;
        };

        function followingOnMouseLeave() {
            vm.isFollowingMouseOver = false;
        };

        function togglePostLike(postKey) {
            if (vm.user) {
                var post = vm.posts.getByKey(postKey);
                var ref = db.ref('PostsPerson/' + profileUID + '/Posts/' + postKey + '/Likes/' + vm.user.uid);
                if (post.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                post.isLike = false;
                                post.likeCount -= 1;
                                post.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                post.isLike = true;
                                post.likeCount += 1;
                                if (!post.likes) {
                                    post.likes = {};
                                }
                                post.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login'); 
            }
        };

        function toggleCommentLike(commentKey, postKey) {
            if (vm.user) {
                var comment = vm.posts.getByKey(postKey).comments.getByKey(commentKey);
                var ref = db.ref('PostsPerson/' + profileUID + '/Posts/' + postKey + '/Comments/' + commentKey + '/Likes/' + vm.user.uid);
                if (comment.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                comment.isLike = false;
                                comment.likeCount -= 1;
                                comment.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                comment.isLike = true;
                                comment.likeCount += 1;
                                if (!comment.likes) {
                                    comment.likes = {};
                                }
                                comment.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function toggleReplyLike(replyKey, commentKey, postKey) {
            if (vm.user) {
                var reply = vm.posts.getByKey(postKey).comments.getByKey(commentKey).replies.getByKey(replyKey);
                var ref = db.ref('PostsPerson/' + profileUID + '/Posts/' + postKey + '/Comments/' + commentKey + '/Replies/' + replyKey + '/Likes/' + vm.user.uid);
                if (reply.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                reply.isLike = false;
                                reply.likeCount -= 1;
                                reply.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                reply.isLike = true;
                                reply.likeCount += 1;
                                if (!reply.likes) {
                                    reply.likes = {};
                                }
                                reply.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function deletePost(ev, post) {
            var title = $translate.instant('PUBLIC_PERSON.DELETE_POST_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_PERSON.DELETE_POST_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_PERSON.DELETE');
            var text_cancel = $translate.instant('PUBLIC_PERSON.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {

                var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/deletePostPerson';

                firebase.auth().currentUser.getToken()
                    .then(function (token) {
                        $rootScope.showLoadingPanel = true;
                        var req = {
                            method: 'POST',
                            url: functionURL,
                            headers: {
                                'Authorization': 'Bearer ' + token
                            },
                            data: {
                                'postKey': post.key, 
                            }
                        }

                        $http(req)
                            .then(function (resp) {
                                vm.personPage.postCount--;
                                var index = vm.posts.indexOf(vm.posts.getByKey(post.key));
                                vm.posts.splice(index, 1);

                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_PERSON.DELETE_POST_SUCCESS_MSG');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            }, function (err) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_PERSON.ERROR');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent + ': ' + err)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            });

                    }, function () {
                        $rootScope.showLoadingPanel = false;
                    });

            }, function () {
                //
            });
        };

        function deleteComment(ev, comment, post) {
            var title = $translate.instant('PUBLIC_PERSON.DELETE_COMMENT_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_PERSON.DELETE_COMMENT_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_PERSON.DELETE');
            var text_cancel = $translate.instant('PUBLIC_PERSON.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {
                var ref = db.ref('PostsPerson/' + vm.personPage.key + '/Posts/' + post.key + '/Comments/' + comment.key);
                ref.remove()
                    .then(function () {
                        post.commentCount = post.commentCount - 1;
                        var postIndex = vm.posts.indexOf(post);
                        var commentIndex = vm.posts[postIndex].comments.indexOf(comment);
                        vm.posts[postIndex].comments.splice(commentIndex, 1);
                        var textContent = $translate.instant('PUBLIC_PERSON.DELETE_COMMENT_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                    }).catch(function (err) {
                        console.log(err)
                    });
            }, function () {
                //
            });
        };

        function deleteReply(ev, reply, comment, post) {
            var title = $translate.instant('PUBLIC_PERSON.DELETE_REPLY_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_PERSON.DELETE_REPLY_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_PERSON.DELETE');
            var text_cancel = $translate.instant('PUBLIC_PERSON.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {
                var ref = db.ref('PostsPerson/' + vm.personPage.key + '/Posts/' + post.key + '/Comments/' + comment.key + '/Replies/' + reply.key);
                ref.remove()
                    .then(function () {
                        comment.replyCount = comment.replyCount - 1;
                        var postIndex = vm.posts.indexOf(post);
                        var commentIndex = vm.posts[postIndex].comments.indexOf(comment);
                        var replyIndex = vm.posts[postIndex].comments[commentIndex].replies.indexOf(reply);
                        vm.posts[postIndex].comments[commentIndex].replies.splice(replyIndex, 1);
                        var textContent = $translate.instant('PUBLIC_PERSON.DELETE_REPLY_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                    }).catch(function (err) {
                        console.log(err)
                    });
            }, function () {
                //
            });
        };

        function submitPost(form) {
            form.$invalid = true;
            var postRef = db.ref('PostsPerson/' + vm.user.uid);
            var postKey = postRef.child('Posts').push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var postObj = { 
                Type: 'Post', 
                Message: vm.newPost.message, 
                PersonKey: vm.personPage.key, 
                Date: dateNow,
                CommentsEnabled: vm.newPost.commentsEnabled
            };
            var imgFile = vm.ngFlow.flow.files[0];

            if (imgFile) {
                var storageRef = firebase.storage().ref('posts-person/' + vm.user.uid + '/' + postKey);
                storageRef.putString(vm.newPost.image, 'data_url').then(function (snapshot) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    var downloadURL = snapshot.downloadURL;
                    postObj.Media = { Type: 'Image', Preview: downloadURL };
                    execUpdate();
                });
            } else {
                execUpdate();
            }

            function execUpdate() {
                postRef.child("Posts").child(postKey).update(postObj)
                    .then(function () {
                        vm.personPage.postCount++;
                        var textContent = $translate.instant('PUBLIC_PERSON.POST_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                        $timeout(function () {
                            vm.ngFlow.flow.files = [];
                            vm.newPost.message = '';
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
            };


        };

        function cancelFile($flow) {
            $flow.cancel();
            vm.newPost.image = null;
        };

        function sharePost(ev, post) {
            var postToShare = post;
            if (post.sharedPost) {
                postToShare = post.sharedPost;
            }

            $mdDialog.show({
                controller         : 'SharePersonPostDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pages/public-person/dialogs/sharepost/share-person-post-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    sharedPost      : postToShare,
                    personPage      : vm.personPage,
                    user            : vm.user
                }
            })
            .then(function(newPost) {

                var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/sharePostPerson';

                firebase.auth().currentUser.getToken()
                    .then(function (token) {
                        $rootScope.showLoadingPanel = true;
                        var req = {
                            method: 'POST',
                            url: functionURL,
                            headers: {
                                'Authorization': 'Bearer ' + token
                            },
                            data: {
                                'sharedPersonKey': postToShare.personKey,
                                'sharedPostKey': postToShare.key,
                                'commentsEnabled': newPost.commentsEnabled,
                                'message': newPost.message
                            }
                        }

                        $http(req)
                            .then(function (resp) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_PERSON.POST_SUCCESS_MSG');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            }, function (err) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_PERSON.ERROR');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent + ': ' + err.data)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            });

                    }, function () {
                        $rootScope.showLoadingPanel = false;
                    });


            }, function() {

            });           
        };



        /**
         * @param id
         */
        function gotoMessaging()
        {
            $state.go('app.messaging', {id: vm.personPage.key, type: 'u'});
        }

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        Array.prototype.getByKey = function (value)
        {
            return this.filter(function (x)
            {
                return x.key === value;
            })[0];
        }

        $scope.$on("$destroy", function() {
            if (vm.user) {
                loadPostsRef.off();
            }
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.public-company')
        .controller('PublicCompanyController', PublicCompanyController);

    /** @ngInject */
    function PublicCompanyController($scope, $state, $timeout, $document, $mdDialog, $mdToast, $translate, $rootScope, $http, Auth, formatTimeStamp, companyURL, ngMeta) {
        var vm = this;

        //firebase
        var db = firebase.database();
        vm.user = firebase.auth().currentUser;
        //
        vm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.gotoMessaging = gotoMessaging;
        vm.followCompanyPage = followCompanyPage;
        vm.unFollowCompanyPage = unFollowCompanyPage;
        vm.followingOnMouseOver = followingOnMouseOver;
        vm.followingOnMouseLeave = followingOnMouseLeave;
        vm.submitPost = submitPost;
        vm.showPostComments = showPostComments;
        vm.showPostLikes = showPostLikes;
        vm.showCommentLikes = showCommentLikes;
        vm.showReplyLikes = showReplyLikes;
        vm.submitPostComment = submitPostComment;
        vm.togglePostLike = togglePostLike;
        vm.toggleCommentLike = toggleCommentLike;
        vm.showCommentReplyPanel = showCommentReplyPanel;
        vm.submitCommentReply = submitCommentReply;
        vm.showCommentReplies = showCommentReplies;
        vm.toggleReplyLike = toggleReplyLike;
        vm.showPreviousPosts = showPreviousPosts;
        vm.showPreviousComments = showPreviousComments;
        vm.showPreviousReplies = showPreviousReplies;
        vm.imageUpload = imageUpload;
        vm.enableComments = enableComments;
        vm.disableComments = disableComments;
        vm.openFillFormDialog = openFillFormDialog;
        vm.login = login;
        vm.loginWithGoogle = loginWithGoogle;
        vm.loginWithFacebook = loginWithFacebook;
        vm.toggleAboutMoreLess = toggleAboutMoreLess;
        vm.cancelFile = cancelFile;
        vm.deletePost = deletePost;
        vm.scrollToPost = scrollToPost;
        vm.getLastPostLikeCount = getLastPostLikeCount;
        vm.getLastPostCommentCount = getLastPostCommentCount;
        vm.deleteReply = deleteReply;
        vm.deleteComment = deleteComment;
        vm.sharePost = sharePost;

        //////////

        var loadPostsRef, lastPostRef;
        var formUsers = {};

        vm.companyPage = {};
        vm.publicForms = [];
        vm.posts = [];
        vm.newPost = { commentsEnabled: true };
        vm.postDisplayLimit = 5;

        loadCompanyData();


        function isFollow(companyPageKey) {
            if (vm.user) {
                db.ref('/UserFollows/' + vm.user.uid + '/Company/' + companyPageKey).once('value', function (snap) {
                    if (snap.val()) {
                        vm.isFollow = true;
                    } else {
                        vm.isFollow = false;
                    }
                })
            } else {
                vm.isFollow = false;
            }
        };

        function loadCompanyData() {
            db.ref('/CompanyPages/').orderByChild('CompanyURL').equalTo(companyURL).once('value', function (snap) {
                snap.forEach(function (snapCompanyPage) {
                    var data = snapCompanyPage.val();
                    var key = snapCompanyPage.key;
                    //meta
                    ngMeta.setTitle(data.CompanyName);
                    //                    //
                    isFollow(key);
                    $timeout(function () {
                        vm.companyPage.key = key;
                        vm.companyPage.companyName = data.CompanyName;

                        if (data.AboutUs) {
                            vm.companyPage.aboutUs = data.AboutUs.replace(/(?:\r\n|\r|\n)/g, '<br />');
                            //meta
                            ngMeta.setTag('description', data.CompanyName + '. ' + data.AboutUs.replace(/(?:\r\n|\r|\n)/g, ' ').substring(0,150));
                            //
                        }
                        vm.companyPage.photoURL = data.Photo.PhotoURL;
                        vm.companyPage.address = data.Address;
                        vm.companyPage.phone = data.Phone;
                        vm.companyPage.website = data.Website;
                        vm.companyPage.email = data.Email;
                        vm.companyPage.UID = data.OwnerUID;
                        vm.companyPage.url = data.CompanyURL;
                        vm.companyPage.postCount = data.PostCount;
                        vm.companyPage.followerCount = data.FollowerCount;
                        if (vm.user) {
                            if (vm.user.uid == vm.companyPage.UID) {
                                vm.isOwner = true;
                            }
                            loadPosts();
                        }
                        loadPublicForms();
                    });
                })
            });
        };

        function loadPosts() {
            lastPostRef = db.ref('/PostsCompany/' + vm.companyPage.key + '/LastPost');
            lastPostRef.on('value', function (snap) {
                $timeout(function () {
                    vm.lastPost = snap.val();
                });
            });

            loadPostsRef = db.ref('/PostsCompany/' + vm.companyPage.key + '/Posts').orderByChild('Date');
            loadPostsRef.on('child_added', function (snap) {
                var key = snap.key;
                var data = snap.val();
                var date = data.Date;
                var type = data.Type;
                var message = data.Message;
                var media = data.Media;
                var comments = [];
                var commentCount = 0;
                var postLikeCount = 0;
                var cm_displayLimit = 2;
                var likes = data.Likes;
                var commentsEnabled = data.CommentsEnabled;
                if (data.Comments) {
                    commentCount = Object.keys(data.Comments).length;
                    angular.forEach(data.Comments, function (commentData, commentKey) {
                        var cm_replies = [];
                        var cm_key, cm_date, cm_message, cm_showReplies, cm_userKey, cm_displayName, cm_photoURL, cm_isLike, cm_likes, cm_likeCount, cm_replyCount;
                        cm_key = commentKey;
                        cm_date = commentData.Date;
                        cm_message = commentData.Message;
                        cm_likes = commentData.Likes;
                        cm_showReplies = false;
                        cm_userKey = commentData.UID;

                        function getUser() {
                            return new Promise(function (resolve, reject) {
                                //get user data
                                if (!formUsers[commentData.UID]) {
                                    loadFormUser(commentData.UID).then(function (response) {
                                        cm_displayName = response.DisplayName;
                                        cm_photoURL = response.PhotoURL;
                                        resolve();
                                    });
                                } else {
                                    cm_displayName = formUsers[commentData.UID].DisplayName;
                                    cm_photoURL = formUsers[commentData.UID].PhotoURL;
                                    resolve();
                                }
                            });
                        };
                        //get comment likes
                        if (cm_likes) {
                            cm_likeCount = Object.keys(cm_likes).length;
                            if (vm.user && cm_likes[vm.user.uid]) {
                                cm_isLike = true;
                            }
                        } else {
                            cm_likeCount = 0;
                        }

                        var rp_displayLimit = 2;

                        function getReplies() {
                            return new Promise(function (resolve, reject) {
                                //get comment replies
                                if (commentData.Replies) {
                                    cm_replyCount = Object.keys(commentData.Replies).length;
                                    var x = 0;
                                    angular.forEach(commentData.Replies, function (replyData, replyKey) {
                                        var rp_key, rp_date, rp_message, rp_userKey, rp_displayName, rp_photoURL, rp_likes, rp_isLike, rp_likeCount;
                                        rp_key = replyKey;
                                        rp_date = replyData.Date;
                                        rp_message = replyData.Message;
                                        rp_likes = replyData.Likes;
                                        rp_userKey = replyData.UID;

                                        //get reply likes
                                        if (vm.user && rp_likes) {
                                            rp_likeCount = Object.keys(rp_likes).length;
                                            if (rp_likes[vm.user.uid]) {
                                                rp_isLike = true;
                                            }
                                        } else {
                                            rp_likeCount = 0;
                                        }

                                        function getUser() {
                                            return new Promise(function (resolve, reject) {
                                                //get user data
                                                if (!formUsers[replyData.UID]) {
                                                    loadFormUser(replyData.UID).then(function (response) {
                                                        rp_displayName = response.DisplayName;
                                                        rp_photoURL = response.PhotoURL;
                                                        resolve();
                                                    });
                                                } else {
                                                    rp_displayName = formUsers[replyData.UID].DisplayName;
                                                    rp_photoURL = formUsers[replyData.UID].PhotoURL;
                                                    resolve();
                                                }
                                            });
                                        };

                                        getUser().then(function () {
                                            cm_replies.push({
                                                'key': rp_key,
                                                'date': rp_date,
                                                'message': rp_message,
                                                'displayName': rp_displayName,
                                                'photoURL': rp_photoURL,
                                                'isLike': rp_isLike,
                                                'likeCount': rp_likeCount,
                                                'likes': rp_likes,
                                                'userKey': rp_userKey
                                            });
                                            x++;
                                            if (x == cm_replyCount) { resolve(); }
                                        });

                                    });
                                } else {
                                    cm_replyCount = 0;
                                    resolve();
                                }
                            });
                        };

                        getUser().then(function () {
                            getReplies().then(function () {
                                comments.push({
                                    'key': cm_key,
                                    'date': cm_date,
                                    'message': cm_message,
                                    'showReplies': cm_showReplies,
                                    'displayName': cm_displayName,
                                    'photoURL': cm_photoURL,
                                    'isLike': cm_isLike,
                                    'likeCount': cm_likeCount,
                                    'likes': cm_likes,
                                    'replyCount': cm_replyCount,
                                    'replies': cm_replies,
                                    'replyDisplayLimit': rp_displayLimit,
                                    'userKey': cm_userKey
                                });
                            });
                        });

                    });
                }
                var isLikePost = false;
                if (likes) {
                    postLikeCount = Object.keys(likes).length;
                    if (vm.user && likes[vm.user.uid]) {
                        isLikePost = true;
                    }
                }

                pushData();

                function pushData() {
                    $timeout(function () {
                        vm.posts.push({
                            'key': key,
                            'type': type,
                            'date': date,
                            'message': message,
                            'commentsEnabled': commentsEnabled,
                            'showComments': false,
                            'commentCount': commentCount,
                            'comments': comments,
                            'likeCount': postLikeCount,
                            'isLike': isLikePost,
                            'likes': likes,
                            'commentDisplayLimit': cm_displayLimit,
                            'media': media
                        });
                    });
                };
            });
        };

        function enableComments() {
            vm.newPost.commentsEnabled = true;
        };

        function disableComments() {
            vm.newPost.commentsEnabled = false;
        };

        function showPostComments(ev, postKey) {
            if (vm.user) {
                vm.posts.getByKey(postKey).showComments = true;
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showCommentReplies(commentKey, postKey) {
            if (vm.user) {
                vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplies = true;
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showPostLikes(ev, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller: 'ShowLikesDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/pages/public-company/dialogs/showlikes/showlikes-dialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        likes: vm.posts.getByKey(postKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showCommentLikes(ev, commentKey, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller: 'ShowLikesDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/pages/public-company/dialogs/showlikes/showlikes-dialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        likes: vm.posts.getByKey(postKey).comments.getByKey(commentKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showReplyLikes(ev, replyKey, commentKey, postKey) {
            if (vm.user) {
                $mdDialog.show({
                    controller: 'ShowLikesDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/pages/public-company/dialogs/showlikes/showlikes-dialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        likes: vm.posts.getByKey(postKey).comments.getByKey(commentKey).replies.getByKey(replyKey).likes
                    }
                });
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function showPreviousPosts() {
            vm.postDisplayLimit += 10;
        };

        function showPreviousComments(postKey) {
            vm.posts.getByKey(postKey).commentDisplayLimit += 10;
        };

        function showPreviousReplies(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).replyDisplayLimit += 10;
        };

        function showCommentReplyPanel(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplies = true;
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplyPanel = true;
        };

        function hideCommentReplyPanel(commentKey, postKey) {
            vm.posts.getByKey(postKey).comments.getByKey(commentKey).showReplyPanel = false;
        };

        function imageUpload(flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                vm.newPost.image = event.target.result;
            };
            fileReader.readAsDataURL(flowFile.file);
        };

        function submitPostComment(form, postKey, message) {
            form.$invalid = true;
            vm.commentForm[postKey].message = '';
            var postCommentRef = db.ref('/PostsCompany/' + vm.companyPage.key + '/Posts/' + postKey + '/Comments/');
            var postCommentKey = postCommentRef.push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var updates = { UID: vm.user.uid, Message: message, Date: dateNow };

            var post = vm.posts.getByKey(postKey);
            var newCommentCount = post.commentCount + 1;

            postCommentRef.child(postCommentKey).update(updates)
                .then(function () {
                    const timestamp = Date.now();
                    $timeout(function () {
                        post.commentCount = newCommentCount;
                        if (!post.comments) {
                            post.comments = [];
                        }
                        post.comments.push({
                            'key': postCommentKey,
                            'displayName': vm.user.displayName,
                            'photoURL': vm.user.photoURL,
                            'message': message,
                            'date': timestamp,
                            'showComments': false,
                            'isLike': false,
                            'likeCount': 0,
                            'commentCount': 0,
                            //'comments': '',
                            'commentDisplayLimit': 2,
                            'userKey': vm.user.uid
                        });
                        post.commentDisplayLimit++;
                    });
                })
        };

        function submitCommentReply(form, postKey, commentKey, message) {
            form.$invalid = true;
            vm.replyForm[commentKey].message = '';
            var replyRef = db.ref('/PostsCompany/' + vm.companyPage.key + '/Posts/' + postKey + '/Comments/' + commentKey + '/Replies/');
            var replyKey = replyRef.push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var updates = { UID: vm.user.uid, Message: message, Date: dateNow };

            var comment = vm.posts.getByKey(postKey).comments.getByKey(commentKey);
            var newReplyCount = comment.replyCount + 1;

            replyRef.child(replyKey).update(updates)
                .then(function () {
                    const timestamp = Date.now();
                    $timeout(function () {
                        comment.replyCount = newReplyCount;
                        if (!comment.replies) {
                            comment.replies = [];
                        }
                        comment.replies.push({
                            'key': replyKey,
                            'displayName': vm.user.displayName,
                            'photoURL': vm.user.photoURL,
                            'message': message,
                            'date': timestamp,
                            'isLike': false,
                            'likeCount': 0,
                            'userKey': vm.user.uid
                        });
                        comment.replyDisplayLimit++;
                        hideCommentReplyPanel(commentKey, postKey);
                    });
                })
        };

        function loadFormUser(formUserUID) {
            return new Promise(function (resolve, reject) {
                db.ref('/Users/').child(formUserUID)
                    .once('value', function (userSnap) {
                        var displayName = userSnap.val().DisplayName;
                        var photoURL = userSnap.val().Photo.PhotoURL;
                        formUsers[formUserUID] = {};
                        formUsers[formUserUID]["DisplayName"] = displayName;
                        formUsers[formUserUID]["PhotoURL"] = photoURL;
                        resolve(formUsers[formUserUID]);
                    });
            });
        };

        function loadPublicForms() {
            var publicFormsRef = db.ref('/DesignForm/' + vm.companyPage.key).orderByChild('Type').equalTo('Public')
            publicFormsRef.once('value', function (snap) {
                snap.forEach(function (snapDesignForm) {
                    var key = snapDesignForm.key;
                    var data = snapDesignForm.val();

                    var name = data.Name;
                    var type = data.Type;
                    var widgetColor = data.WidgetColor;
                    var widgetImageURL = data.WidgetImageURL;
                    if (data.Description) {
                        var desc = data.Description.replace(/(?:\r\n|\r|\n)/g, '<br />');
                    }

                    $timeout(function () {
                        vm.publicForms.push({ "Key": key, "Name": name, "Type": type, "WidgetColor": widgetColor, "WidgetImageURL": widgetImageURL, "Description": desc });
                    });
                });
            });
        };

        function followCompanyPage() {
            if (vm.user) {
                var ref = db.ref('UserFollows/' + vm.user.uid + '/Company/' + vm.companyPage.key);
                ref.set(true)
                    .then(function () {
                        $timeout(function () {
                            vm.companyPage.followerCount++;
                            vm.isFollow = true;
                        });
                    }), function (err) {
                        console.log(err);
                    }
            } else {
                $state.go('app.pages_auth_login');
            }

        };

        function unFollowCompanyPage(id) {
            var ref = db.ref('UserFollows/' + vm.user.uid + '/Company/' + vm.companyPage.key);
            ref.set(null)
                .then(function () {
                    $timeout(function () {
                        vm.companyPage.followerCount--;
                        vm.isFollow = false;
                    });
                }), function (err) {
                    console.log(err);
                }
        };

        function followingOnMouseOver() {
            vm.isFollowingMouseOver = true;
        };

        function followingOnMouseLeave() {
            vm.isFollowingMouseOver = false;
        };

        function togglePostLike(postKey) {
            if (vm.user) {
                var post = vm.posts.getByKey(postKey);
                var ref = db.ref('PostsCompany/' + vm.companyPage.key + '/Posts/' + postKey + '/Likes/' + vm.user.uid);
                if (post.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                post.isLike = false;
                                post.likeCount -= 1;
                                post.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                post.isLike = true;
                                post.likeCount += 1;
                                if (!post.likes) {
                                    post.likes = {};
                                }
                                post.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function toggleCommentLike(commentKey, postKey) {
            if (vm.user) {
                var comment = vm.posts.getByKey(postKey).comments.getByKey(commentKey);
                var ref = db.ref('PostsCompany/' + vm.companyPage.key + '/Posts/' + postKey + '/Comments/' + commentKey + '/Likes/' + vm.user.uid);
                if (comment.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                comment.isLike = false;
                                comment.likeCount -= 1;
                                comment.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                comment.isLike = true;
                                comment.likeCount += 1;
                                if (!comment.likes) {
                                    comment.likes = {};
                                }
                                comment.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function toggleReplyLike(replyKey, commentKey, postKey) {
            if (vm.user) {
                var reply = vm.posts.getByKey(postKey).comments.getByKey(commentKey).replies.getByKey(replyKey);
                var ref = db.ref('PostsCompany/' + vm.companyPage.key + '/Posts/' + postKey + '/Comments/' + commentKey + '/Replies/' + replyKey + '/Likes/' + vm.user.uid);
                if (reply.isLike) {
                    ref.set(null)
                        .then(function () {
                            $timeout(function () {
                                reply.isLike = false;
                                reply.likeCount -= 1;
                                reply.likes[vm.user.uid] = false;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                } else {
                    ref.set(true)
                        .then(function () {
                            $timeout(function () {
                                reply.isLike = true;
                                reply.likeCount += 1;
                                if (!reply.likes) {
                                    reply.likes = {};
                                }
                                reply.likes[vm.user.uid] = true;
                            });
                        }), function (err) {
                            console.log(err);
                        }
                }
            } else {
                $state.go('app.pages_auth_login');
            }
        };

        function deletePost(ev, post) {
            var title = $translate.instant('PUBLIC_COMPANY.DELETE_POST_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_COMPANY.DELETE_POST_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_COMPANY.DELETE');
            var text_cancel = $translate.instant('PUBLIC_COMPANY.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {

                var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/deletePostCompany';

                firebase.auth().currentUser.getToken()
                    .then(function (token) {
                        $rootScope.showLoadingPanel = true;
                        var req = {
                            method: 'POST',
                            url: functionURL,
                            headers: {
                                'Authorization': 'Bearer ' + token
                            },
                            data: {
                                'postKey': post.key,
                                'companyKey': vm.companyPage.key
                            }
                        }

                        $http(req)
                            .then(function (resp) {
                                vm.companyPage.postCount--;
                                var index = vm.posts.indexOf(vm.posts.getByKey(post.key));
                                vm.posts.splice(index, 1);

                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_COMPANY.DELETE_POST_SUCCESS_MSG');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            }, function (err) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_COMPANY.ERROR');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent + ': ' + err)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            });

                    }, function () {
                        $rootScope.showLoadingPanel = false;
                    });

            }, function () {
                //
            });
        };

        function deleteComment(ev, comment, post) {
            var title = $translate.instant('PUBLIC_COMPANY.DELETE_COMMENT_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_COMPANY.DELETE_COMMENT_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_COMPANY.DELETE');
            var text_cancel = $translate.instant('PUBLIC_COMPANY.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {
                var ref = db.ref('PostsCompany/' + vm.companyPage.key + '/Posts/' + post.key + '/Comments/' + comment.key);
                ref.remove()
                    .then(function () {
                        post.commentCount = post.commentCount - 1;
                        var postIndex = vm.posts.indexOf(post);
                        var commentIndex = vm.posts[postIndex].comments.indexOf(comment);
                        vm.posts[postIndex].comments.splice(commentIndex, 1);
                        var textContent = $translate.instant('PUBLIC_COMPANY.DELETE_COMMENT_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                    }).catch(function (err) {
                        console.log(err)
                    });
            }, function () {
                //
            });
        };

        function deleteReply(ev, reply, comment, post) {
            var title = $translate.instant('PUBLIC_COMPANY.DELETE_REPLY_CONFIRM_TITLE');
            var desc = $translate.instant('PUBLIC_COMPANY.DELETE_REPLY_CONFIRM_DESC');
            var text_ok = $translate.instant('PUBLIC_COMPANY.DELETE');
            var text_cancel = $translate.instant('PUBLIC_COMPANY.CANCEL');
            var confirm = $mdDialog.confirm()
                .title(title)
                .textContent(desc)
                .ariaLabel('Confirm')
                .targetEvent(ev)
                .ok(text_ok)
                .cancel(text_cancel);

            $mdDialog.show(confirm).then(function () {
                var ref = db.ref('PostsCompany/' + vm.companyPage.key + '/Posts/' + post.key + '/Comments/' + comment.key + '/Replies/' + reply.key);
                ref.remove()
                    .then(function () {
                        comment.replyCount = comment.replyCount - 1;
                        var postIndex = vm.posts.indexOf(post);
                        var commentIndex = vm.posts[postIndex].comments.indexOf(comment);
                        var replyIndex = vm.posts[postIndex].comments[commentIndex].replies.indexOf(reply);
                        vm.posts[postIndex].comments[commentIndex].replies.splice(replyIndex, 1);
                        var textContent = $translate.instant('PUBLIC_COMPANY.DELETE_REPLY_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                    }).catch(function (err) {
                        console.log(err)
                    });
            }, function () {
                //
            });
        };

        function scrollToPost(postKey) {
            var elmnt = document.getElementById(postKey);
            elmnt.scrollIntoView();
        };

        function getLastPostLikeCount() {
            if (vm.lastPost) {
                var x = vm.posts.getByKey(vm.lastPost.PostKey);
                if (x) {
                    return x.likeCount;
                }
            }
            return false;
        };

        function getLastPostCommentCount() {
            if (vm.lastPost) {
                var x = vm.posts.getByKey(vm.lastPost.PostKey);
                if (x) {
                    return x.commentCount;
                }
            }
            return false;
        };

        function submitPost(form) {
            form.$invalid = true;
            var postRef = db.ref('PostsCompany/' + vm.companyPage.key);
            var postKey = postRef.child('Posts').push().key;
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var postObj = {
                Type: 'Post',
                Message: vm.newPost.message,
                CompanyKey: vm.companyPage.key,
                Date: dateNow,
                CommentsEnabled: vm.newPost.commentsEnabled
            };
            var imgFile = vm.ngFlow.flow.files[0];

            if (imgFile) {
                var storageRef = firebase.storage().ref('posts-company/' + vm.companyPage.key + '/' + postKey);
                storageRef.putString(vm.newPost.image, 'data_url').then(function (snapshot) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    var downloadURL = snapshot.downloadURL;
                    postObj.Media = { Type: 'Image', Preview: downloadURL };
                    execUpdate();
                });
            } else {
                execUpdate();
            }

            function execUpdate() {
                postRef.child("Posts").child(postKey).update(postObj)
                    .then(function () {
                        vm.companyPage.postCount++;
                        var textContent = $translate.instant('PUBLIC_COMPANY.POST_SUCCESS_MSG');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(textContent)
                                .hideDelay(3000)
                                .position('top right')
                        );
                        $timeout(function () {
                            vm.ngFlow.flow.files = [];
                            vm.newPost.message = '';
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
            };

        };

        function cancelFile($flow) {
            $flow.cancel();
            vm.newPost.image = null;
        };

        function toggleAboutMoreLess() {
            if (vm.aboutSeeMore) {
                vm.aboutSeeMore = false;
            } else {
                vm.aboutSeeMore = true;
            }
        };

        function sharePost(ev, post) {
            var postToShare = post;

            $mdDialog.show({
                controller         : 'ShareCompanyPostDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pages/public-company/dialogs/sharepost/share-company-post-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    sharedPost      : postToShare,
                    companyPage     : vm.companyPage,
                    user            : vm.user
                }
            })
            .then(function(newPost) {

                var functionURL = 'https://us-central1-notefield-cf9cd.cloudfunctions.net/app/sharePostCompany';

                firebase.auth().currentUser.getToken()
                    .then(function (token) {
                        $rootScope.showLoadingPanel = true;
                        var req = {
                            method: 'POST',
                            url: functionURL,
                            headers: {
                                'Authorization': 'Bearer ' + token
                            },
                            data: {
                                'sharedCompanyKey': vm.companyPage.key,
                                'sharedPostKey': postToShare.key,
                                'commentsEnabled': newPost.commentsEnabled,
                                'message': newPost.message
                            }
                        }

                        $http(req)
                            .then(function (resp) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_COMPANY.POST_SUCCESS_MSG');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            }, function (err) {
                                $rootScope.showLoadingPanel = false;
                                var textContent = $translate.instant('PUBLIC_COMPANY.ERROR');
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(textContent + ': ' + err.data)
                                        .hideDelay(3000)
                                        .position('top right')
                                );
                            });

                    }, function () {
                        $rootScope.showLoadingPanel = false;
                    });


            }, function() {

            });           
        };

        /**
         * @param id
         */
        function gotoMessaging() {
            $state.go('app.messaging', { id: vm.companyPage.key, type: 'c' });
        };

        /**
         * Open fill form dialog
         *
         * @param ev
         */
        function openFillFormDialog(ev, formKey, formName) {
            if (vm.user) {
                $mdDialog.show({
                    controller: 'FillFormDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/pages/public-company/dialogs/fillform/fillform-dialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        UID: vm.user.uid,
                        designFormKey: formKey,
                        designFormName: formName,
                        companyKey: vm.companyPage.key
                    }
                }).then(function () {
                    $rootScope.showLoadingPanel = false;
                    
                    var title = $translate.instant('PUBLIC_COMPANY.FORM_SUBMITTED');
                    var textContent = $translate.instant('PUBLIC_COMPANY.FORM_SUBMITTED_MSG');
                    var okText = $translate.instant('OK');

                    $timeout(function () {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title(title)
                                .textContent(textContent)
                                .ariaLabel('form submission process')
                                .ok(okText)
                                .targetEvent(ev)
                        );

                    }, 1000);

                }, function () {
                    //cancel
                });
            } else {
                vm.loginprm = {};
                vm.loginprm.ev = ev;
                vm.loginprm.formKey = formKey;
                vm.loginprm.formName = formName;

                $mdDialog.show({
                    contentElement: '#loginDialog',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                });
            }
        };

        function login() {
            vm.error = null;
            vm.signinErrorMsg = null;

            Auth.$signInWithEmailAndPassword(vm.form.email, vm.form.password)
                .then(function (authData) {
                    vm.user = firebase.auth().currentUser;
                    // Logged in
                    $mdDialog.hide();
                    $timeout(function () {
                        openFillFormDialog(vm.loginprm.ev, vm.loginprm.formKey, vm.loginprm.formName);
                    },1000);
                })
                .catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;

                    switch (errorCode) {
                        case 'auth/wrong-password':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.WRONG_PASSWORD');
                            break;
                        case 'auth/user-not-found':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.USER_NOT_FOUND');
                            break;
                        case 'auth/user-disabled':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.USER_DISABLED');
                            break;
                        case 'auth/invalid-email':
                            vm.signinErrorMsg = $translate.instant('LOGIN.ERRORS.EMAIL_MUST_VALID');
                    }
                });
        };

        function loginWithGoogle(ev) {
            var provider = new firebase.auth.GoogleAuthProvider();
            //provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
            //firebase.auth().useDeviceLanguage();

            firebase.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;

                var firstName = user.displayName.split(' ').slice(0, -1).join(' ');
                var lastName = user.displayName.split(' ').slice(-1).join(' ');

                //update user table
                db.ref('/Users/' + user.uid).once('value', function (snap) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    if (!snap.val()) {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": { "LastUpdate": dateNow, "PhotoURL": user.photoURL },
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    } else {
                        db.ref('/Users/' + user.uid).update({
                            "Photo": { "LastUpdate": dateNow, "PhotoURL": user.photoURL }
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    }
                });

            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });
        };

        function loginWithFacebook(ev) {
            var provider = new firebase.auth.FacebookAuthProvider();

            //firebase.auth().useDeviceLanguage();

            firebase.auth().signInWithPopup(provider).then(function (result) {
                var token = result.credential.accessToken;
                var user = result.user;

                var firstName = user.displayName.split(' ').slice(0, -1).join(' ');
                var lastName = user.displayName.split(' ').slice(-1).join(' ');
                //update user table
                db.ref('/Users/' + user.uid).once('value', function (snap) {
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    if (!snap.val()) {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL},
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    } else {
                        db.ref('/Users/' + user.uid).update({
                            "Email": user.email,
                            "UID": user.uid,
                            "FirstName": firstName,
                            "LastName": lastName,
                            "Photo": {"LastUpdate": dateNow, "PhotoURL": user.photoURL},
                            "DateCreated": dateNow,
                            "Phone": "",
                            "DisplayName": user.displayName,
                            "DisplayNameLower": user.displayName.toLowerCase()
                        }).then(function () {
                            $state.go('app.pages_app-console');
                        })
                    }
                });


            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });
        };

        //format date 
        function formatDate(date) {
            return formatTimeStamp.format(date);
        };

        Array.prototype.getByKey = function (value) {
            return this.filter(function (x) {
                return x.key === value;
            })[0];
        }

        $scope.$on("$destroy", function () {
            if (vm.user) {
                loadPostsRef.off();
                lastPostRef.off();
            }
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($state, $timeout, $document, $mdDialog, $mdToast, $translate, formatTimeStamp) {
        var vm = this;

        //firebase
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;
        var userRef= db.ref('/Users/' + UID);

        // Methods
        vm.openMenu = openMenu;
        vm.saveProfileAbout = saveProfileAbout;
        vm.updatePassword = updatePassword;
        vm.changeProfilePicture = changeProfilePicture;
        vm.changeProfileBg = changeProfileBg;
        vm.removeProfilePicture = removeProfilePicture;
        vm.removeProfileBg = removeProfileBg;
        //////////

        vm.profile = {};
        vm.countryCodes = [];

        loadCountryCodes();

        loadUserData();

        function loadUserData() {
            userRef.once('value', function (snap) {
                var data = snap.val();
    
                $timeout(function () {
                    vm.profile = {
                        'email': data.Email,
                        'photoURL': data.Photo.PhotoURL,
                        'firstName': data.FirstName,
                        'lastName': data.LastName,
                        'phone': data.Phone,
                        'countryCode': data.CountryCode
                    };
                    if (user.photoURL=="assets/images/etc/blank-profile-picture.jpg") {
                        vm.showRemoveProfilePictureMenu = false;
                    } else {
                        vm.showRemoveProfilePictureMenu = true;
                    }
                });
            });
        };

        function loadCountryCodes() {
            db.ref('Definitions/Countries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    vm.countryCodes.push({'code':item.key, 'name':item.val()});
                })
            })
        };

        function saveProfileAbout(ev) {
            var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
            var ref = firebase.database().ref('/Users/' + UID);
            var displayName = vm.profile.firstName + " " + vm.profile.lastName;
            var displayNameLower = displayName.toLowerCase();

            var countryCode = vm.profile.countryCode;
            if (!countryCode) {
                countryCode = "~";
            }

            var search_cc_dn = countryCode + '_' + displayNameLower;

            var updates = {
                'FirstName': vm.profile.firstName,
                'LastName': vm.profile.lastName,
                'Phone': vm.profile.phone,
                'DisplayName': displayName,
                'DisplayNameLower': displayNameLower,
                "LastUpdate": dateNow,
                "Search_cc_dn": search_cc_dn
            };

            if (vm.profile.countryCode) {
                updates.CountryCode = vm.profile.countryCode;
            }

            ref.update(updates)
                .then(function () {
                    user.updateProfile({ "displayName": displayName });
                    var msg = $translate.instant('PROFILE.USER_SAVED');
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msg)
                            .hideDelay(1000)
                            .position('top right')
                    );
                })
                .catch(function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error:' + error)
                            .hideDelay(1000)
                            .position('top right')
                    );
                });
        };

        function clearPassChangeForm(form) {
            if (form) {
                vm.currentPass = undefined;
                vm.newPass = undefined;
                vm.newPassConfirm = undefined;
                form.$setValidity();
                form.$setPristine();
                form.$setUntouched();
            }
        };

        function updatePassword(ev, form) {
            if (vm.newPass != vm.newPassConfirm) {
                var msg = $translate.instant('PROFILE.PASSWORD_MATCH_ERROR');
                var title = $translate.instant('PROFILE.ERROR');
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#profile')))
                        .clickOutsideToClose(true)
                        .title(title)
                        .textContent(msg)
                        .ariaLabel('Password Change')
                        .ok('OK')
                        .targetEvent(ev)
                );

            } else {
                var user = firebase.auth().currentUser;
                var crd = firebase.auth.EmailAuthProvider.credential(user.email, vm.currentPass);
                user.reauthenticateWithCredential(crd)
                    .then(function () {
                        //update successful
                        user.updatePassword(vm.newPass).then(function () {
                            var title = $translate.instant('PROFILE.SUCCESS');
                            var msg = $translate.instant('PROFILE.PASSWORD_CHANGE_SUCCESS');
                            //clear the form fields
                            clearPassChangeForm(form);
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#profile')))
                                    .clickOutsideToClose(true)
                                    .title(title)
                                    .textContent(msg)
                                    .ariaLabel('Password Change')
                                    .ok('OK')
                                    .targetEvent(ev)
                            );
                        }, function (error) {
                            //update error
                            var title = $translate.instant('PROFILE.ERROR');
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#profile')))
                                    .clickOutsideToClose(true)
                                    .title(title)
                                    .textContent(error.message)
                                    .ariaLabel('Password Change')
                                    .ok('OK')
                                    .targetEvent(ev)
                            );
                        });
                    })
                    .catch(function (error) {
                        var msg = $translate.instant('PROFILE.CURRENT_PASSWORD_ERROR');
                        var title = $translate.instant('PROFILE.ERROR');
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#profile')))
                                .clickOutsideToClose(true)
                                .title(title)
                                .textContent(msg)
                                .ariaLabel('Password Change')
                                .ok('OK')
                                .targetEvent(ev)
                        );
                    });
            }
        };

        var originatorEv;
        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        /**
         * Open changePicture dialog
         *
         * @param ev
         */
        function changeProfilePicture(ev) {
            $mdDialog.show({
                controller: 'UploadPictureDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pages/profile/dialogs/upload-picture/uploadpicture-dialog.html',
                parent: angular.element($document.find('#profile')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    UID: UID
                }
            }).then(function (downloadURL) {
                if (downloadURL) {
                    //update user
                    user.updateProfile({ "photoURL": downloadURL })
                        .then(function () {
                            // Update successful.
                        }).catch(function (error) {
                            console.log(error);
                        });
                    $timeout(function () {
                        vm.profile.photoURL = downloadURL;
                        vm.showRemoveProfilePictureMenu = true;
                    });
                }
            }, function () {

            });
        };

        /**
         * Open changeBG dialog
         *
         * @param ev
         */
        function changeProfileBg(ev) {
            $mdDialog.show({
                controller: 'UploadBgDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pages/profile/dialogs/upload-bg/uploadbg-dialog.html',
                parent: angular.element($document.find('#profile')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    UID: UID
                }
            }).then(function (downloadURL) {
                if (downloadURL) {
                    vm.profile.BgPictureURL = downloadURL;
                    vm.showRemoveProfileBgPictureMenu = true;
                }
            }, function () {

            });
        };

        function removeProfilePicture(ev) {
            var title = $translate.instant('PROFILE.CONFIRM_REMOVE_PROFILE_PIC');
            var cancelMsg = $translate.instant('PROFILE.CANCEL');
            var removeMsg = $translate.instant('PROFILE.REMOVE');

            var confirm = $mdDialog.confirm()
                .title(title)
                //.textContent('')
                .ariaLabel('Remove profile picture')
                .targetEvent(ev)
                .ok(removeMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {
                var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                //update user db
                userRef.child("Photo").update({ "PhotoURL": "assets/images/etc/blank-profile-picture.jpg", "LastUpdate": dateNow })
                    .then(function () {
                        //update user
                        user.updateProfile({ "photoURL": "assets/images/etc/blank-profile-picture.jpg" });
                        $timeout(function () {
                            vm.profile.photoURL = "assets/images/etc/blank-profile-picture.jpg";
                            vm.showRemoveProfilePictureMenu = false;
                        });

                        var msg = $translate.instant('PROFILE.PROFILE_PICTURE_REMOVED');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(msg)
                                .hideDelay(3000)
                                .position('top right')
                        );
                        
                    })
            }, function () {

            });
        };

        function removeProfileBg(ev) {
            var title = $translate.instant('PROFILE.CONFIRM_REMOVE_PROFILE_PIC');
            var cancelMsg = $translate.instant('PROFILE.CANCEL');
            var removeMsg = $translate.instant('PROFILE.REMOVE');

            var confirm = $mdDialog.confirm()
                .title(title)
                //.textContent('')
                .ariaLabel('Remove profile picture')
                .targetEvent(ev)
                .ok(removeMsg)
                .cancel(cancelMsg);

            $mdDialog.show(confirm).then(function () {
                //update user db
                userRef.update({ "PhotoURL": null }).then(function () {
                    $timeout(function () {
                        vm.profile.Photo.PhotoURL = "assets/images/etc/blank-profile-picture.jpg";
                        vm.showRemoveProfileBgPictureMenu = false;
                    });
                })
            }, function () {

            });
        };

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.notifications', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.pages_notifications', {
                url      : '/notifications',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/notifications/notifications.html',
                        controller : 'NotificationsController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]                   
                },
                bodyClass: 'notifications'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/notifications');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.notifications')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController($state, $timeout, $mdSidenav, $mdDialog, $document, $translate, $mdToast, formatTimeStamp) {
        var vm = this;

        // Data
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;

        var formUsers = {};
        var formCompanies = {};
        vm.notifications = [];

        //Methods 
        vm.deleteNotification = deleteNotification;
        //

        loadNotifications();

        function loadNotifications() {
            db.ref('/Notifications/' + UID + '/NewNotificationTotal').set(0)
                .then(function () {
                    //
                }).catch(function (err) {
                    return console.log(err);
                });

            var notsRef = db.ref('/Notifications/' + UID + '/Messages').orderByChild("Date");
            notsRef.once('value', function (snapNots) {
                snapNots.forEach(function (item) {
                    var data = item.val();
                    if (data.UID) {
                        getUser(data.UID).then(function (formUser) {
                            $timeout(function () {
                                vm.notifications.push({
                                    "key": item.key,
                                    "data": data,
                                    "userDisplayName": formUser.displayName,
                                    "userPhotoURL": formUser.photoURL
                                });
                            });
                        })
                    } else if (data.CompanyKey){
                        getCompany(data.CompanyKey).then(function (formCompany) {
                            $timeout(function () {
                                vm.notifications.push({
                                    "key": item.key,
                                    "data": data,
                                    "companyName": formCompany.companyName,
                                    "companyPhotoURL": formCompany.photoURL,
                                    "companyURL": formCompany.companyURL
                                });
                            });
                        })
                    }
                })
            });
        };

        function getUser(userKey) {
            return new Promise(function (resolve, reject) {
                if (!formUsers[userKey]) {
                    db.ref('/Users/').child(userKey)
                        .once('value', function (userSnap) {
                            var data = userSnap.val();
                            formUsers[userKey] = { "displayName": data.DisplayName, "photoURL": data.Photo.PhotoURL };
                            resolve(formUsers[userKey]);
                        });
                } else {
                    resolve(formUsers[userKey]);
                }
            });
        };

        function getCompany(companyKey) {
            return new Promise(function (resolve, reject) {
                if (!formCompanies[companyKey]) {
                    db.ref('/CompanyPages/').child(companyKey)
                        .once('value', function (companySnap) {
                            var data = companySnap.val();
                            formCompanies[companyKey] = { "companyName": data.CompanyName, "photoURL": data.Photo.PhotoURL, "companyURL": data.CompanyURL };
                            resolve(formCompanies[companyKey]);
                        });
                } else {
                    resolve(formCompanies[companyKey]);
                }
            });
        };

        function deleteNotification(key) {
            db.ref('/Notifications/' + UID + '/Messages/' + key).remove()
                .then(function () {
                    var removeIndex = vm.notifications.map(function (item) { return item.key; }).indexOf(key);
                    vm.notifications.splice(removeIndex, 1);
                }).catch(function (err) {
                    return console.log(err);
                });
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.my-submissions',
            [
                // 3rd Party Dependencies
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider      
            .state('app.pages_my-submissions', {
                url      : '/pages/my-submissions',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/my-submissions/my-submissions.html',
                        controller : 'MySubmissionsController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]                   
                },
                bodyClass: 'my-submissions'
            })          

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/my-submissions');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.my-submissions', {
            title : 'My Submissions',
            icon  : 'icon-document',
            state : 'app.pages_my-submissions',
            weight: 2
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.my-submissions')
        .controller('MySubmissionsController', MySubmissionsController);

    /** @ngInject */
    function MySubmissionsController($state, $timeout, $mdSidenav, $mdDialog, $document, $translate, $mdToast, formatTimeStamp)
    {
        var vm = this;

        // Data
        var db = firebase.database();
        var user = firebase.auth().currentUser;
        var UID = user.uid;

        //Methods 
        vm.toggleDetails=toggleDetails;
        vm.openViewFormDialog=openViewFormDialog;
        vm.select=select;      

        vm.forms=[];
        var formUsers={};
        var companyPages={};
        vm.formTransactions=[];

        loadForms();

        function loadForms() {
            var formSubmissionsRef=db.ref('/UserFormSubmissions/'+UID).orderByChild("DateCreated");
            formSubmissionsRef.once('value', function(snapForm) {
                snapForm.forEach(function(item){
                    var formData = item.val(),
                        formKey = item.key,
                        dateCreated = formData.DateCreated,
                        designFormKey = formData.DesignFormKey,
                        designFormName = formData.DesignFormName,
                        currentProcessNode = formData.CurrentProcessNode,
                        formUserUID = formData.UID,
                        currentProcessUID = formData.CurrentProcessUID,
                        status = formData.Status,
                        companyKey = formData.CompanyKey,
                        companyName = '';

                    if (!companyPages[companyKey]) {
                        loadCompanyPage(companyKey).then(function(response){
                            companyName = response.CompanyName;
                            pushData();
                        });
                    } else {
                        companyName=companyPages[companyKey].CompanyName;
                        pushData();
                    }

                    function pushData() {
                        $timeout(function(){
                            vm.forms.push({
                                "FormKey"           : formKey,
                                "DateCreated"       : dateCreated,
                                "DesignFormKey"     : designFormKey,
                                "DesignFormName"    : designFormName,
                                "CurrentProcessNode": currentProcessNode,
                                "Status"            : status,
                                "CompanyName"       : companyName
                            });
                        });
                    }
                })
            });
        };

        function loadCompanyPage(companyKey) {
            return new Promise(function (resolve, reject) {
                db.ref('/CompanyPages/').child(companyKey)
                    .once('value', function (snap) {
                        var companyName = snap.val().CompanyName;
                        var photoURL = snap.val().Photo.PhotoURL;
                        companyPages[companyKey] = {};
                        companyPages[companyKey]["CompanyName"] = companyName;
                        companyPages[companyKey]["PhotoURL"] = photoURL;
                        resolve(companyPages[companyKey]);
                    });
            });
        };

        function loadFormUser(userKey) {
            return new Promise(function (resolve, reject) {
                db.ref('/Users/').child(userKey)
                    .once('value', function (snap) {
                        var displayName = snap.val().DisplayName;
                        var photoURL = snap.val().Photo.PhotoURL;
                        formUsers[userKey] = {};
                        formUsers[userKey]["DisplayName"] = displayName;
                        formUsers[userKey]["PhotoURL"] = photoURL;
                        resolve(formUsers[userKey]);
                    });
            });
        };

        function select(item) {
            vm.selected=item;
            if (!vm.formTransactions[item.FormKey]) {
                loadFormTransactions(item.DesignFormKey, item.FormKey);
            }            
        };

        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        };

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('form-detail-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


        /**
         * Open view form dialog
         *
         * @param ev
         */
        function openViewFormDialog(item, ev)
        {
            $mdDialog.show({
                controller         : 'ViewFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/pages/waiting-forme/dialogs/view-form/view-form-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    formInfo :   item
                }
            });
        };


        function loadFormTransactions(designFormKey, formKey) {
            db.ref('/FormTransactions/' + designFormKey + '/' + formKey).once('value', function (snap) {
                snap.forEach(function(snapTransaction){
                    var data=snapTransaction.val();
                    var dateTime=data.DateTime,
                        action=data.Action,
                        formUserUID=data.UID;
                        vm.formTransactions[formKey] = [];

                    if (!formUsers.formUserUID) {
                        loadFormUser(formUserUID)
                            .then(function (response) {
                                var userName = response.DisplayName;
                                var photoURL = response.PhotoURL;
                                $timeout(function () {
                                    vm.formTransactions[formKey].push({'DateTime': dateTime, 'Action': action, 'UserName': userName, 'PhotoURL': photoURL});
                                });
                            });
                    } else {
                        var userName = formUsers.formUserUID.DisplayName;
                        $timeout(function () {
                            vm.formTransactions[formKey].push({'DateTime':dateTime, 'Action':action, 'UserName': userName, 'PhotoURL': photoURL});
                        });
                    }
                })
            })
        };


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.app-console', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
            .state('app.pages_app-console', {
                
                url      : '/pages/app-console',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/app-console/app-console.html',
                        controller : 'AppConsoleController as vm'
                    }
                },
                resolve  : {
                    "currentAuth": ["Auth", function(Auth) {
                    return Auth.$requireSignIn();
                    }]               
                },
                bodyClass: 'app-console'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/app-console');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.app-console')
        .controller('AppConsoleController', AppConsoleController);

    /** @ngInject */
    function AppConsoleController($scope, $timeout, $translate)
    {
        var vm = this;

        // Data
        var db=firebase.database();
        vm.user = firebase.auth().currentUser;
        var UID=vm.user.uid;


        //////////


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.messaging', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.messaging', {
                url: '/messaging/thread/:type/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/messaging/messaging.html',
                        controller: 'MessagingController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$requireSignIn();
                    }],
                    threadId: function ($stateParams)
                    {
                        return ($stateParams.id);
                    },
                    threadType: function ($stateParams)
                    {
                        return ($stateParams.type);
                    }
                }             
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/messaging');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.messaging')
        .controller('MessagingController', MessagingController);

    /** @ngInject */
    function MessagingController($scope, $mdSidenav, $state, $timeout, $document, $mdMedia, $mdDialog, $translate, formatTimeStamp, threadId, threadType, $rootScope)
    {
        var vm = this;

        //Firebase
        var db=firebase.database();
        
        // Data
        vm.contacts = [];
        vm.chat = undefined;
        vm.user = firebase.auth().currentUser;
        var UID = vm.user.uid;
        var newMsgTotalRef = db.ref('/Messaging/' + UID + '/NewMessageTotal');
        var messagingRefUser;
        var messagingRefCompany;
        var chatRef;

        // Methods
        vm.chatFilterByGroup = chatFilterByGroup;
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.markUnread = markUnread;
        vm.markRead = markRead;
        vm.sendtoArchive = sendtoArchive;
        vm.restore = restore;
        vm.setChatGroupFilter = setChatGroupFilter;
        vm.deleteChatConfirm = deleteChatConfirm;
        vm.gotoContactPublicProfile = gotoContactPublicProfile;
        //

        // Paramaters
        vm.chatFilterGroupName=='ALL';
        var redirectHasMsg=false;

        //set new messagetotal=0 while opening the page
        if ($rootScope.newMsg) {
            newMsgTotalRef.set(0);
            //
            var isNewMsgRefUser = db.ref('/Messaging/' + UID + '/Contacts/User');
            isNewMsgRefUser.orderByChild('IsNew').equalTo(true).on('child_added',
                function (snap) {
                    isNewMsgRefUser.child(snap.key).child('IsNew').set(false);
                })
            //
            var isNewMsgRefCompany = db.ref('/Messaging/' + UID + '/Contacts/Company');
            isNewMsgRefCompany.orderByChild('IsNew').equalTo(true).on('child_added',
                function (snap) {
                    isNewMsgRefCompany.child(snap.key).child('IsNew').set(false);
                })
        }
        

        // check redirect for message
        if (threadId && threadType) {
            var redirectRef;
            if (threadType == 'u') {
                redirectRef = db.ref('/Messaging/' + UID + '/Contacts/User/' + threadId);
            } else if (threadType == 'c') {
                redirectRef = db.ref('/Messaging/' + UID + '/Contacts/Company/' + threadId);
            }

            redirectRef.once('value', function (snap) {
                if (snap.val() == null) {
                    loadRedirectThread(threadId);
                } else {
                    redirectHasMsg = true;
                }
            });
        };

        loadThreadsByUser();

        loadThreadsByCompany();

        //listen messaging contacts for last message changes
        var pref = db.ref('/Messaging/' + UID + '/Contacts/User').orderByChild("LastDate");
        pref.on('child_changed', function (snap) {
            var data=snap.val();
            var key=snap.key;
            var p= vm.contacts.getById(key);
            $timeout(function () {
                p.LastDate=data.LastDate;
                p.LastMessage=data.LastMessage;
                p.IsRead=data.IsRead;
                p.IsArchived=data.IsArchived;
            });

            //set new message total as 0
            newMsgTotalRef.set(0);
        });

        var cref = db.ref('/Messaging/' + UID + '/Contacts/Company').orderByChild("LastDate");
        cref.on('child_changed', function (snap) {
            var data=snap.val();
            var key=snap.key;
            var c= vm.contacts.getById(key);
            $timeout(function () {
                c.LastDate=data.LastDate;
                c.LastMessage=data.LastMessage;
                c.IsRead=data.IsRead;
                c.IsArchived=data.IsArchived;
            });

            //set new message total as 0
            newMsgTotalRef.set(0);
        });
        ///

        function loadThreadsByUser() {
            messagingRefUser = db.ref('/Messaging/' + UID + '/Contacts/User').orderByChild("LastDate");
            messagingRefUser.on('child_added', function (msgsnap) {
                var key = msgsnap.key;
                var usersRef = db.ref('/Users').child(key);

                usersRef.once('value', function (usersnap) {
                    var userData = usersnap.val();
                    var displayName = userData.DisplayName;
                    var photoURL = userData.Photo.PhotoURL;
                    
                    var msgData = msgsnap.val();
                    var lastDate = msgData.LastDate;
                    var lastMessage = msgData.LastMessage;
                    var isRead = msgData.IsRead;
                    var isArchived = msgData.IsArchived;
                    
                    if (key != threadId) {
                        $timeout(function () {
                            vm.contacts.push
                                ({
                                    "MsgUID": key,
                                    "DisplayName": displayName,
                                    "PhotoURL": photoURL,
                                    "LastDate": lastDate,
                                    "LastMessage": lastMessage,
                                    "IsRead": isRead,
                                    "IsArchived": isArchived,
                                    "Type": 'User'
                                });
                        });
                    } else {

                        var index = vm.contacts.findIndex(getChatIndexById);
                        vm.contacts.splice(index, 1);
                        $timeout(function () {
                            vm.contacts.push
                                ({
                                    "MsgUID": key,
                                    "DisplayName": displayName,
                                    "PhotoURL": photoURL,
                                    "LastDate": lastDate,
                                    "LastMessage": lastMessage,
                                    "IsRead": isRead,
                                    "IsArchived": isArchived,
                                    "Type": 'User'
                                });

                            //mark chat as read
                            if (vm.contacts.getById(threadId).IsRead == false) {
                                markRead();
                            }

                            if (redirectHasMsg == true) {
                                getChat(threadId);
                            }
                        });
                    }
                });
            });
        };

        function loadThreadsByCompany() {
            messagingRefCompany = db.ref('/Messaging/' + UID + '/Contacts/Company').orderByChild("LastDate");
            messagingRefCompany.on('child_added', function (msgsnap) {
                var key = msgsnap.key;
                var companyPagesRef = db.ref('/CompanyPages').child(key);

                companyPagesRef.once('value', function (companyPageSnap) {
                    var companyPageData = companyPageSnap.val();
                    var displayName = companyPageData.CompanyName;
                    var companyURL = companyPageData.CompanyURL;
                    var photoURL = companyPageData.Photo.PhotoURL;
                    
                    var msgData = msgsnap.val();
                    var lastDate = msgData.LastDate;
                    var lastMessage = msgData.LastMessage;
                    var isRead = msgData.IsRead;
                    var isArchived = msgData.IsArchived;
                    
                    if (key != threadId) {
                        $timeout(function () {
                            vm.contacts.push
                                ({
                                    "MsgUID": key,
                                    "DisplayName": displayName,
                                    "PhotoURL": photoURL,
                                    "LastDate": lastDate,
                                    "LastMessage": lastMessage,
                                    "IsRead": isRead,
                                    "IsArchived": isArchived,
                                    "Type": 'Company',
                                    "CompanyURL": companyURL
                                });
                        });
                    } else {

                        var index = vm.contacts.findIndex(getChatIndexById);
                        vm.contacts.splice(index, 1);

                        $timeout(function () {
                            vm.contacts.push
                                ({
                                    "MsgUID": key,
                                    "DisplayName": displayName,
                                    "PhotoURL": photoURL,
                                    "LastDate": lastDate,
                                    "LastMessage": lastMessage,
                                    "IsRead": isRead,
                                    "IsArchived": isArchived,
                                    "Type": 'Company',
                                    "CompanyURL": companyURL
                                });
                            
                            //mark chat as read
                            if (vm.contacts.getById(threadId).IsRead == false) {
                                markRead();
                            }

                            if (redirectHasMsg == true) {
                                getChat(threadId);
                            }
                        });
                    }
                });
            });
        };


        function loadRedirectThread(key) {
            if (threadType == 'u') {
                var usersRef = db.ref('/Users').child(key);
                usersRef.once('value', function (userSnap) {
                    var userData = userSnap.val();
                    var displayName = userData.DisplayName;
                    var photoURL = userData.Photo.PhotoURL;

                    $timeout(function () {
                        vm.contacts.push
                            ({
                                "MsgUID": key,
                                "DisplayName": displayName,
                                "PhotoURL": photoURL,
                                "Type": 'User'
                            });
                            getChat(key);
                    })
                });
            }

            if (threadType == 'c') {
                var companyPagesRef = db.ref('/CompanyPages').child(key);
                companyPagesRef.once('value', function (companyPageSnap) {
                    var companyPageData = companyPageSnap.val();
                    var displayName = companyPageData.CompanyName;
                    var companyURL = companyPageData.CompanyURL;
                    var photoURL = companyPageData.Photo.PhotoURL;

                    $timeout(function () {
                        vm.contacts.push
                            ({
                                "MsgUID": key,
                                "DisplayName": displayName,
                                "PhotoURL": photoURL,
                                "CompanyURL": companyURL,
                                "Type": 'Company'
                            });
                            getChat(key);
                    }) 
                });
            }
        };

        function getChat(contactId) {
            if (vm.chatContactId != contactId) {
                vm.chat = [];
                vm.chatContactId = contactId;
                var type = vm.contacts.getById(vm.chatContactId).Type;
                chatRef = db.ref('/Messaging/' + UID + '/Messages/');
                if (type == 'User') {
                    chatRef = chatRef.child('User').child(contactId).orderByChild('Date');
                } else if (type == 'Company') {
                    chatRef = chatRef.child('Company').child(contactId).orderByChild('Date');
                }
                chatRef.off();
                chatRef.on('child_added', function (msgsnap) {
                    var key = msgsnap.key;
                    var msgData = msgsnap.val();
                    var date = msgData.Date;
                    var text = msgData.Text;
                    var type = msgData.Type;

                    $timeout(function () {
                        vm.chat.push({ "Key": key, "Date": date, "Text": text, "Type": type });
                        // Scroll to the last message
                        scrollToBottomOfChat();
                    });
                });

                // Reset the reply textarea
                resetReplyTextarea();

                if (!$mdMedia('gt-md')) {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                vm.toggleLeftSidenavView(false);
            }
        };



        /**
         * Reply
         */
        function reply($event) {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

			var updates = {};
            var dateNow=firebase.database['ServerValue']['TIMESTAMP'];
            
            var type = vm.contacts.getById(vm.chatContactId).Type;

            if (type == 'User') {
                var dbRef=db.ref('/Messaging/'+UID+'/Messages/User/'+vm.chatContactId);
                var newPostKey = dbRef.push().key;
                var postData = {
                    Date: dateNow,
                    Text: vm.replyMessage,
                    Type: "O"
                };
                updates['/Messaging/' + UID + '/Messages/User/' + vm.chatContactId + '/' + newPostKey] = postData;

            } else if (type == 'Company') {
                var dbRef=db.ref('/Messaging/'+UID+'/Messages/Company/'+vm.chatContactId);
                var newPostKey = dbRef.push().key;
                var postData = {
                    Date: dateNow,
                    Text: vm.replyMessage,
                    Type: "O"
                };
                updates['/Messaging/' + UID + '/Messages/Company/' + vm.chatContactId + '/' + newPostKey] = postData;                
            }

            db.ref().update(updates)
                .then(function () {
                    $timeout(function () {
                        //reset text area
                        resetReplyTextarea();
                        // Scroll to the new message
                        scrollToBottomOfChat();
                    });
                }).catch(function (err) {
                    console.log(err);
                });
        };


        function gotoContactPublicProfile() {
            var data = vm.contacts.getById(vm.chatContactId);
            var type = data.Type;
            if (type == 'User') {
                $state.go("app.public-person", { 'profileId': vm.chatContactId });
            } else if (type == 'Company') {
                var companyURL = data.CompanyURL;
                $state.go("app.public-company", { 'companyURL': companyURL });
            }
        };


        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.MsgUID === value;
            })[0];
        }


        //format date 
        function formatDate(date){
            return formatTimeStamp.format(date);
        }

        //set chatFilterGroupName
        function setChatGroupFilter(prm){
            vm.chatFilterGroupName=prm;
        }

        // chat filter by group
        function chatFilterByGroup(item) {
            if (!vm.chatFilterGroupName) {
                vm.chatFilterGroupName='ALL';
            }

            if (vm.chatFilterGroupName=='ALL') {
                if (item.IsArchived==false) {
                    return true;
                }
            } else if (vm.chatFilterGroupName=='UNREAD') {
                if (item.IsArchived==false && item.IsRead==false) {
                    return true;
                }
            } else if (vm.chatFilterGroupName=='ARCHIVED') {
                if (item.IsArchived==true) {
                    return true;
                }
            } else {
                return false;
            }
        }

        function getChatIndexById(element) {
            return element.MsgUID === vm.chatContactId;
        }

        function markUnread() {
            var index = vm.contacts.findIndex(getChatIndexById);

            if (vm.contacts[index].IsRead == true) {
                var type = vm.contacts.getById(vm.chatContactId).Type;
                var ref;
                if (type == 'User') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/User/' + vm.chatContactId + '/IsRead');
                } else if (type = 'Company') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/Company/' + vm.chatContactId + '/IsRead');
                }

                ref.set(false);
            }
        };

        function markRead() {
            var index = vm.contacts.findIndex(getChatIndexById);

            if (vm.contacts[index].IsRead == false) {
                var type = vm.contacts.getById(vm.chatContactId).Type;
                var ref;
                if (type == 'User') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/User/' + vm.chatContactId + '/IsRead');
                } else if (type = 'Company') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/Company/' + vm.chatContactId + '/IsRead');
                }

                ref.set(true);
            }
        };

        function sendtoArchive() {
            var index=vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsArchived==false) {
                var type = vm.contacts.getById(vm.chatContactId).Type;
                var ref;
                if (type == 'User') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/User/' + vm.chatContactId + '/IsArchived');
                } else if (type = 'Company') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/Company/' + vm.chatContactId + '/IsArchived');
                }

                ref.set(true);
            }
        };

        function restore() {
            var index=vm.contacts.findIndex(getChatIndexById);
            if (vm.contacts[index].IsArchived==true) {
                var type = vm.contacts.getById(vm.chatContactId).Type;
                var ref;
                if (type == 'User') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/User/' + vm.chatContactId + '/IsArchived');
                } else if (type = 'Company') {
                    ref = firebase.database().ref('/Messaging/' + UID + '/Contacts/Company/' + vm.chatContactId + '/IsArchived');
                }

                ref.set(false);
            }
        };

        /**
         * Delete chat Confirm Dialog
         */
        function deleteChatConfirm(ev)
        {
			var title = $translate.instant('MESSAGING.CHAT_DELETE_CONFIRM');
			var textContent = $translate.instant('MESSAGING.CHAT_DELETE_CONFIRM_MSG');

            var confirm = $mdDialog.confirm()
                .title(title)
                .htmlContent(textContent + '<b>' + vm.contacts.getById(vm.chatContactId).DisplayName + '</b>')
                .ariaLabel('delete chat')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                deleteChat();

            }, function ()
            {

            });
        }

        function deleteChat() {
            var index = vm.contacts.findIndex(getChatIndexById);
            var type = vm.contacts.getById(vm.chatContactId).Type;
            var ref = firebase.database().ref('/Messaging/' + UID);
            var updates = {};

            if (type == 'User') {
                updates['/Contacts/User/' + vm.chatContactId] = null;
                updates['/Messages/User/' + vm.chatContactId] = null;
            } else if (type = 'Company') {
                updates['/Contacts/Company/' + vm.chatContactId] = null;
                updates['/Messages/Company/' + vm.chatContactId] = null;
            }

            ref.update(updates).then(function () {
                $timeout(function () {
                    vm.contacts.splice(index, 1);
                    vm.chatContactId = null;
                    vm.chat = null;
                });
            })
        };

        $scope.$on("$destroy", function() {
            pref.off();
            cref.off();
            messagingRefUser.off();
            messagingRefCompany.off();
            
            if (isNewMsgRefUser) {
                isNewMsgRefUser.off();
            }
            
            if (isNewMsgRefCompany) {
                isNewMsgRefCompany.off();
            }
            
            if (chatRef) {
                chatRef.off();
            }
        });


        

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, Auth)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        var db=firebase.database();

        vm.bodyEl = angular.element('body');
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.profileSearch = profileSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        // any time auth state changes, add the user data to scope
        Auth.$onAuthStateChanged(function(firebaseUser) {
            if(firebaseUser)
            {
                vm.uid = firebaseUser.uid;

                //listen profile photo changes
                var userRef = db.ref('/Users/' + vm.uid + '/Photo');
                userRef.on('value', function (snap) {
                    var userData = snap.val();
                    if (userData) {
                        $timeout(function () {
                            vm.user = {};
                            vm.user.PhotoURL = userData.PhotoURL;
                        });
                    }
                });
                //listen new message total changes
                var msgRef = db.ref('/Messaging/' + vm.uid + '/NewMessageTotal');
                msgRef.on('value', function (snap) {
                    var total = snap.val();
                    $timeout(function () {
                        vm.newMessageTotal = total;
                        if (total >0) {
                            $rootScope.newMsg = true;
                        }
                    });
                });

                //listen new notification total changes
                var notificationRef = db.ref('/Notifications/' + vm.uid + '/NewNotificationTotal');
                notificationRef.on('value', function (snap) {
                    var total = snap.val();
                    $timeout(function () {
                        vm.newNotificationTotal = total;
                    });
                });
            }
        });




        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout()
        {
            firebase.auth().signOut()
            .then(function() {      
                $state.go('app.pages_auth_login');
            }).catch(function(error) {
                console.log('Error signing out:', error);
            });
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }



        vm.search = {};
        vm.search.simulateQuery = false;
        vm.search.isDisabled = false;
        vm.users = [];
        vm.countryCodes = [];

        loadCountryCodes();

        //loadAll().then(function(resp) {
        //    vm.users = resp;
        //});

        function loadCountryCodes() {
            db.ref('Definitions/Countries/').once('value', function(snap) {
                snap.forEach(function(item) {
                    $timeout(function () {
                        vm.countryCodes.push({'key':item.key, 'name':item.val()});
                    });
                })
            })
        };

        function profileSearch(query) {
            return loadAll(query).then(function(resp) {
                var results = resp;
                var deferred;
                if (vm.search.simulateQuery) {
                    deferred = $q.defer();
                    $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                    return deferred.promise;
                } else {
                    return results;
                }
            }).catch(function(err) {
                var error = err;
            })
        };

        function loadAll(query) {
            return new Promise(function(resolve, reject) {
                var users = [];
                var personSearchRef,
                    companySearchRef;
                if (query) {
                    query = query.toLowerCase();
                    personSearchRef = db.ref('/Users/').orderByChild('DisplayNameLower').startAt(query).endAt(query + '\uf8ff').limitToFirst(5);
                    companySearchRef = db.ref('/CompanyPages/').orderByChild('CompanyNameLower').startAt(query).endAt(query + '\uf8ff').limitToFirst(5);
                } else {
                    personSearchRef = db.ref('/Users/').orderByChild('DisplayNameLower').limitToFirst(5);
                    companySearchRef = db.ref('/CompanyPages/').orderByChild('CompanyNameLower').limitToFirst(5);
                }

                getPeople();

                function getPeople() {
                    personSearchRef.once('value', function (snap) {
                        var len = snap.numChildren();
                        var counter = 0;
                        if (len > 0) {
                            snap.forEach(function (userSnap) {
                                var key = userSnap.key;
                                var data = userSnap.val();
                                var photoURL = data.Photo.PhotoURL;
                                var displayName = data.DisplayName;
                                var countryCode = data.CountryCode;
                                var countryName;

                                if (countryCode) {
                                    countryName = '';//vm.countryCodes.getByKey(countryCode).name;
                                }
    
                                users.push({
                                    'photoURL': photoURL,
                                    'displayName': displayName,
                                    'type': 'profile-person',
                                    'countryName': countryName,
                                    'key': key
                                });
    
                                counter++;
    
                                if (counter == len) {
                                    getCompanyPages();
                                }
                            })
                        } else {
                            getCompanyPages();
                        }
                    });
                };

                function getCompanyPages() {
                    companySearchRef.once('value', function (snap) {
                        var len = snap.numChildren();
                        var counter = 0;
                        if (len > 0) {
                            snap.forEach(function (userSnap) {
                                var key = userSnap.key;
                                var data = userSnap.val();
                                var photoURL = data.Photo.PhotoURL;
                                var displayName = data.CompanyName;
                                var url = data.CompanyURL;
    
                                users.push({
                                    'photoURL': photoURL,
                                    'displayName': displayName,
                                    'type': 'profile-company',
                                    'key': key,
                                    'url': url
                                });
    
                                counter++;
    
                                if (counter == len) {
                                    resolve(users);
                                }
                            })
                        } else {
                            resolve(users);
                        }
                    });
                };

                users.push({
                    'photoURL': '',
                    'displayName': 'Show all results',
                    'type': 'search-person',
                    'key': 'show-people'
                });

                users.push({
                    'photoURL': '',
                    'displayName': 'Show all results',
                    'type': 'search-company',
                    'key': 'show-companies'
                });
                

            });
        }

        function searchTextChange(text) {
            vm.prmText = text;
        };

        function selectedItemChange(item) {
            if (item) {
                vm.search.selectedItem = null;
                if (item.type == 'search-company') {
                    $state.go('app.pages_search.company', {'searchKey':vm.prmText});
                } else if (item.type == 'search-person') {
                    $state.go('app.pages_search.person', {'searchKey':vm.prmText});
                } else if (item.type == 'profile-person') {
                    $state.go('app.public-person', {'profileId':item.key}); 
                } else if (item.type == 'profile-company') {
                    $state.go('app.public-company', {'companyURL':item.url}); 
                }
            }
        };

        Array.prototype.getByKey = function (value)
        {
            return this.filter(function (x)
            {
                return x.key === value;
            })[0];
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, Auth)
    {
        var vm = this;
        vm.user = firebase.auth().currentUser;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        Auth.$onAuthStateChanged(function(firebaseUser) {
            if (firebaseUser) {
                vm.user = firebaseUser;
            }
        });


        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });


    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            
            'firebase',
            // Common 3rd Party Dependencies
            'textAngular',
            'xeditable',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Apps
            'app.dashboards',
            'app.messaging',
            'app.my-company',

            // Pages
            'app.pages',

            //home
            'app.home'
            //

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home', ['ngMeta','vAccordion','ngAnimate'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, ngMetaProvider)
    {
        $stateProvider
            .state('app.home', {
                url: '/',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.home': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController as vm'
                    }
                },
                bodyClass: 'home',
                data: {
                    'meta': {
                        'title': 'Notefield | Online Form Management - Approval Processes',
                        'og:title': 'Online Form Management',
                        'description': 'Notefield enable businesses to create online forms dynamically with approval process. Dynamic online form wizard and dashboard panels help you create and monitor web forms like contact form, survey form, registration form, customer complaint form and other online forms.',
                        'og:description': 'Notefield enable businesses to create online forms dynamically with approval process. Dynamic online form wizard and dashboard panels help you create and monitor web forms like contact form, survey form, registration form, customer complaint form and other online forms.'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$waitForSignIn();
                    }]
                }
            })
            .state('app.home.features_dynamic-form-design', {
                url: 'dynamic-form-design',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/dynamic-form-design/dynamic-form-design.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Dynamic Form Design',
                        'og:title': 'Dynamic Form Design',
                        'description': 'Create and design any form online. Use our powerful form design tools. Available form items; header, label, text area, text box, drop down, radio button, check box, image, line, page break, date, time, numeric, email, phone number, file upload, table.',
                        'og:description': 'Create and design any form online. Use our powerful form design tools. Available form items; header, label, text area, text box, drop down, radio button, check box, image, line, page break, date, time, numeric, email, phone number, file upload, table.',
                    }
                }
            })
            .state('app.home.features_form-templates', {
                url: 'form-templates',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/form-templates/form-templates.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Form Templates',
                        'og:title': 'Form Templates',
                        'description': 'When designing your forms, you can choose one from our form templates online and quickly create a form',
                        'og:description': 'When designing your forms, you can choose one from our form templates online and quickly create a form',
                    }
                }
            })
            .state('app.home.features_form-approval-process', {
                url: 'form-approval-process',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/form-approval-process/form-approval-process.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Form Approval Process',
                        'og:title': 'Form Approval Process',
                        'description': 'You can create an approval process for your forms online',
                        'og:description': 'You can create an approval process for your forms online',
                    }
                }
            })
            .state('app.home.features_document-workflow', {
                url: 'document-workflow',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/document-workflow/document-workflow.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Document Workflow',
                        'og:title': 'Document Workflow',
                        'description': 'You manage form workflow operations similar to approval process. Simply create your own custom processes using action buttons.',
                        'og:description': 'You manage form workflow operations similar to approval process. Simply create your own custom processes using action buttons.',
                    }
                }
            })
            .state('app.home.features_private-forms', {
                url: 'private-forms',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/private-forms/private-forms.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Private Forms',
                        'og:title': 'Private Forms',
                        'description': 'You can publish your form as private and restrict accessibility. Ensure that each user only gets access to the form that you have authorized and prevent users from reaching unauthorized forms.',
                        'og:description': 'You can publish your form as private and restrict accessibility. Ensure that each user only gets access to the form that you have authorized and prevent users from reaching unauthorized forms.',
                    }
                }
            })
            .state('app.home.features_public-forms', {
                url: 'public-forms',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/public-forms/public-forms.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Public Forms',
                        'og:title': 'Public Forms',
                        'description': 'Publish your forms as public and make them accessible to everyone. Customer complaint form, contact form, survey form and job application form are good examples for public forms as they need to be accessed by everyone.',
                        'og:description': 'Publish your forms as public and make them accessible to everyone. Customer complaint form, contact form, survey form and job application form are good examples for public forms as they need to be accessed by everyone.',
                    }
                }
            })
            .state('app.home.features_notification-messages', {
                url: 'notification-messages',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/notification-messages/notification-messages.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Notification Messages',
                        'og:title': 'Notification Messages',
                        'description': 'Notefield will help you to get notified when any action occurs regarding you or awaiting for your operation. When someone shared you a form, submitted a form which you shared or when any form is awaiting for your approval you will be notified.',
                        'og:description': 'Notefield will help you to get notified when any action occurs regarding you or awaiting for your operation. When someone shared you a form, submitted a form which you shared or when any form is awaiting for your approval you will be notified.',
                    }
                }
            })
            .state('app.home.features_share-forms', {
                url: 'share-forms',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/share-forms/share-forms.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Share Forms',
                        'og:title': 'Share Forms',
                        'description': 'Publish your form as private and share it to users just adding their emails. No problem if they are not already a Notefield member because Notefield will inform and generate shared forms for them after they accept.',
                        'og:description': 'Publish your form as private and share it to users just adding their emails. No problem if they are not already a Notefield member because Notefield will inform and generate shared forms for them after they accept.',
                    }
                }
            })
            .state('app.home.features_messaging', {
                url: 'messaging',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/messaging/messaging.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Messaging',
                        'og:title': 'Messaging',
                        'description': 'Notefield allows you to send and receive instant messages between other members. Send messages to other users or companies.',
                        'og:description': 'Notefield allows you to send and receive instant messages between other members. Send messages to other users or companies.',
                    }
                }
            })
            .state('app.home.features_track-process', {
                url: 'track-process',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/track-process/track-process.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Track Process',
                        'og:title': 'Track Process',
                        'description': 'Monitor the process transactions in a form. Display who performed the previous operations, adding and editing date or approvals. Follow the status of the form and who needs to act on the form now if you have defined a process for the form.',
                        'og:description': 'Monitor the process transactions in a form. Display who performed the previous operations, adding and editing date or approvals. Follow the status of the form and who needs to act on the form now if you have defined a process for the form.',
                    }
                }
            })
            .state('app.home.features_form-reports', {
                url: 'form-reports',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/form-reports/form-reports.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Form Reports',
                        'og:title': 'Form Reports',
                        'description': 'Notefield provides users detailed reports and access to important data required for various purposes. In Notefield, standard reports are provided in report pages, which can be either used as it is or customized as per your business requirements',
                        'og:description': 'Notefield provides users detailed reports and access to important data required for various purposes. In Notefield, standard reports are provided in report pages, which can be either used as it is or customized as per your business requirements',
                    }
                }
            })
            .state('app.home.features_company-dashboard', {
                url: 'company-dashboard',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/features/company-dashboard/company-dashboard.html'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Company Dashboard',
                        'og:title': 'Company Dashboard',
                        'description': 'See an overview of all your activity from all forms in one place. Select from the company form list and view the dashboard panel.',
                        'og:description': 'See an overview of all your activity from all forms in one place. Select from the company form list and view the dashboard panel.',
                    }
                }
            })
            .state('app.home.about_terms', {
                url: 'terms',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/about/terms/terms.html',
                        autoscroll:'true'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Terms & Conditions',
                        'og:title': 'Terms & Conditions',
                        'description': 'Terms and conditions',
                        'og:description': 'Terms and conditions',
                    }
                }
            })
            .state('app.home.privacy-policy', {
                url: 'privacy-policy',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/about/privacy-policy/privacy-policy.html',
                        autoscroll:'true'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Privacy Policy',
                        'og:title': 'Privacy Policy',
                        'description': 'Privacy policy',
                        'og:description': 'Privacy policy',
                    }
                }
            })
            .state('app.home.guides', {
                url: 'guides',
                views: {
                    'home-content': {
                        templateUrl: 'app/home/guides/guides.html',
                        autoscroll:'true'
                    }
                },
                data: {
                    'meta': {
                        'title': 'Guides',
                        'og:title': 'Guides',
                        'description': 'Learn about basic operations on Notefield. How to create a company page, design forms public or private, share with users, create approval process, form submissions, approve or reject forms and more',
                        'og:description': 'Learn about basic operations on Notefield. How to create a company page, design forms public or private, share with users, create approval process, form submissions, approve or reject forms and more',
                    }
                }
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/home');

        ngMetaProvider.useTitleSuffix(true);
        ngMetaProvider.setDefaultTitle('Online form management - approval process');
        //ngMetaProvider.setDefaultTitleSuffix(' | Notefield');
        //ngMetaProvider.setDefaultTag('description', 'bbNotefield enable businesses to create online forms dynamically with approval process. Dynamic online form wizard and dashboard panels help you create and monitor web forms like contact form, survey form, registration form, customer complaint form and other online forms.');

    }

})();
(function () {
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($state, $timeout, $translate, $mdDialog, Auth) {
        var vm = this;

        // Data

        // Methods
        vm.signup = signup;
        vm.logout = logout;
        vm.showVideo = showVideo;
        vm.closeVideo = closeVideo;
        //

        var db = firebase.database();

        function showVideo(ev) {
            $mdDialog.show({
                contentElement: '#videoDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        function closeVideo() {
            $mdDialog.hide();
        };

        Auth.$onAuthStateChanged(function(firebaseUser) {
            if (firebaseUser) {
                vm.user = firebaseUser;
            } else {
                vm.user = null;
            }
        });

        function logout() {
            firebase.auth().signOut()
            .then(function() {      
                $state.go('app.pages_auth_login');
            }).catch(function(error) {
                console.log('Error signing out:', error);
            });
        }

        function signup() {
            vm.error = null;
            vm.signupErrorMsg = null;

            firebase.auth().createUserWithEmailAndPassword(vm.form.email, vm.form.password)
                .then(function (authData) {
                    //Get auth data from firebase
                    var uid = authData.uid;
                    var email = authData.email;
                    var dateNow = firebase.database['ServerValue']['TIMESTAMP'];
                    //update db
                    db.ref('/Users/' + uid).update({
                        "Email": email,
                        "UID": uid,
                        "FirstName": vm.form.firstname,
                        "LastName": vm.form.lastname,
                        "DisplayName": vm.form.firstname+" "+vm.form.lastname,
                        "DisplayNameLower": vm.form.firstname.toLowerCase()+" "+vm.form.lastname.toLowerCase(),
                        "Phone": "",
                        "Photo": {"PhotoURL": "assets/images/etc/blank-profile-picture.jpg", "LastUpdate":dateNow},
                        "DateCreated": dateNow
                    });
                    //get currentuser data
                    var user = firebase.auth().currentUser;
                    //update user displayname
                    user.updateProfile({
                        displayName: vm.form.firstname,
                        photoURL: "assets/images/etc/blank-profile-picture.jpg"
                    }).then(function () {
                        // Update successful.
                    }).catch(function (error) {
                        // An error happened.
                        console.log(error);
                    });


                    //send verification email
                    user.sendEmailVerification().then(function () {
                        // Email sent.
                        console.log("email sent");
                        // redirect to verification info page
                        $state.go('app.pages_auth_user-actions');

                    }, function (error) {
                        // An error happened.
                        console.log(error);
                    });


                }).catch(function (error) {
                    $timeout(function () {
                        // Handle Errors here.
                        var errorCode = error.code;
                        var errorMessage = error.message;

                        switch (errorCode) {
                            case 'auth/weak-password':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.PASSWORD_WEAK');
                                break;
                            case 'auth/invalid-email':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.EMAIL_MUST_VALID');
                                break;
                            case 'auth/email-already-in-use':
                                vm.signupErrorMsg = $translate.instant('SIGNUP.ERRORS.EMAIL_ALREADY_IN_USE');
                        }
                    })
                });
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes, Auth, ngMeta)
    {
        //firebase Auth

        $rootScope
        .$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
            console.log(event);
            if (error === "AUTH_REQUIRED") {

                $state.go("app.pages_auth_login");
            }
        });

        //////////
        ngMeta.init();

        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams)
        {
            console.log(event);

            gtag('config', 'UA-113784120-1', {'page_path': toState.url});
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $locationProvider.hashPrefix('!');

        $urlRouterProvider.otherwise('/pages/errors/error-404');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('sitemap.xml', {
                url: '/sitemap.xml'
            })
            .state('robots.txt', {
                url: '/robots.txt'
            })
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .service('nfdesignForm', function () {
            var key,name;
            return {
                getKey: function () {
                    return key;
                },
                setKey: function (val) {
                    key=val;
                },
                getName: function () {
                    return name;
                },
                setName: function (val) {
                    name=val;
                }                 
            };
        })
        .service('formatTimeStamp', function() {
            this.format = function (timestamp) {
                var date=new Date(timestamp);
                var day=date.getDate();
                if (day<10){day='0'+day};
                var mnth=(date.getMonth()+1);
                if (mnth<10){mnth='0'+mnth};
                var year=date.getFullYear();
                var hour=(date.getHours());
                if (hour<10){hour='0'+hour};
                var minute=(date.getMinutes());
                if (minute<10){minute='0'+minute};
                var dateFormatted= day+'-'+mnth+'-'+year+' '+hour+':'+minute;
                return dateFormatted;
            }
        })
        .service('nfviewForm', function () {
            return {
                get: function (designFormKey) {

                    var formItems=[];
                    firebase.database().ref('/DesignFormItems/'+designFormKey+'/Items').orderByChild('Seq')
                    .once('value', function(snapshot) {
                        
                        var check1=snapshot.numChildren();
                        var x=0;
                        snapshot.forEach(function(childSnapshot) {
                            var formdivId = childSnapshot.key;
                            var data = childSnapshot.val();

                            var labelText=data.LabelText;
                            var seq=data.Seq;
                            var Id=data.Id;
                            var elementType=data.Type;
                            var value=data.Value;
                            var backgroundColor=data.BackgroundColor;
                            var align=data.Align;
                            var required=data.Required;

                            var divx='<div layout="{{item.LabelType}}">';
                            var divy='<div flex="auto">';
                            var divz='<div class="inputData"></div>';
                            var htmlTemp =''+
                            '<div class="formDesignDiv" Id='+formdivId+' tabindex="-1" ng-style="{\'background-color\': item.BackgroundColor}" '+
                            'ng-class="{selectedDiv:vm.selectedDiv==\''+formdivId+'\'}" ng-click="vm.divSelection(\''+formdivId+'\',\''+elementType+'\',$index)">';

                            switch (elementType) 
                            {
                                case "Header":
                                    var element='<div layout="row" layout-align="{{item.Align}}"><h2>{{item.Value}}</h2></div>';
                                    htmlTemp= htmlTemp+element+'</div>';	    		
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, Value:value, BackgroundColor:backgroundColor, Align:align});
                                    break;
                                case "Label":
                                    var element='<div layout="row" layout-align="{{item.Align}}"><p>{{item.Value}}</p></div>';
                                    htmlTemp= htmlTemp+element+'</div>';	    		
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, Value:value, BackgroundColor:backgroundColor, Align:align});
                                    break;
                                case "Text Box":
                                    var maxLength=data.MaxLength;
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<input name="'+formdivId+'" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}">'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>'+
                                        '</div>'+
                                    '</md-input-container>';
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, MaxLength:maxLength, Required:required});
                                    break;
                                case "Text Area":
                                    var maxLength=data.MaxLength;
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<textarea name="'+formdivId+'" ng-required="item.Required" ng-model="item.Value" md-maxlength="{{item.MaxLength}}" md-no-autogrow="true" rows="5" max-rows="7" md-select-on-focus></textarea>'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '<div ng-message="md-maxlength" translate="MF.MAX_LENGTH_WARNING">The description must be less than maximum limit.</div>'+
                                        '</div>'+
                                    '</md-input-container>';
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, MaxLength:maxLength, Required:required});	    
                                    break;
                                case "Dropdown":
                                    var optCounter=data.OptCounter;
                                    var options=[];
                                    for (var key in data.Options) {
                                        var optId=key;
                                        var value=data.Options[key].Value;
                                        var optSeq=data.Options[key].Seq;
                                        options.push({Key:optId, Value:value, Seq:optSeq});
                                    }
                                    var element=''+
                                        '<md-input-container class="md-block">'+
                                            '<label>{{item.LabelText}}</label>'+
                                            '<md-select name="'+formdivId+'" ng-required="item.Required" ng-model="temp.Value">'+
                                                '<md-option ng-repeat="opt in item.Options | orderBy:\'Seq\'" value="{{opt.Value}}">{{opt.Value}}</md-option>'+
                                            '</md-select>'+
                                            '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                                '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '</div>'+
                                        '</md-input-container>';   			
                                    htmlTemp= htmlTemp+divx+divy+element+'</div></div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required, OptCounter:optCounter, Options:options});
                                    break;
                                case "Radio Button":
                                    var optCounter=data.OptCounter;
                                    var optionOrder=data.OptionOrder;
                                    var options=[];
                                    for (var key in data.Options) {
                                        var optId=key;
                                        var value=data.Options[key].Value;
                                        var optSeq=data.Options[key].Seq;
                                        options.push({Key:optId, Value:value, Seq:optSeq});
                                    }
                                    var element=''+
                                        '<p>{{item.LabelText}}</p>' +
                                        '<md-input-container class="md-block">'+
                                        '<md-radio-group layout="{{item.OptionOrder}}" name="'+formdivId+'" ng-required="item.Required" ng-model="temp.Value">'+
                                            '<md-radio-button ng-repeat="opt in item.Options | orderBy:\'Seq\'" ng-value="opt.Value"> {{opt.Value}} </md-radio-button>'+
                                        '</md-radio-group>'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error" role="alert">'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                        '</div>'+
                                        '</md-input-container>'; 
                                    htmlTemp= htmlTemp+divy+element+'</div></div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText: labelText, Required:required, OptionOrder:optionOrder, OptCounter:optCounter, Options:options});
                                    break;
                                case "Checkbox":
                                    var optCounter=data.OptCounter;
                                    var optionOrder=data.OptionOrder;
                                    var options=[];
                                    for (var key in data.Options) {
                                        var optId=key;
                                        var value=data.Options[key].Value;
                                        var optSeq=data.Options[key].Seq;
                                        options.push({Key:optId, Value:value, Seq:optSeq});
                                    }
                                    var element=''+
                                        '<p>{{item.LabelText}}</p>' +
                                        '<div layout="{{item.OptionOrder}}">'+
                                            '<md-checkbox ng-repeat="opt in item.Options | orderBy:\'Seq\'" aria-label="opt.Value">{{opt.Value}}</md-checkbox>'+
                                        '</div>';
                                    htmlTemp= htmlTemp+divy+element+'</div></div>'
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText: labelText, OptionOrder:optionOrder, OptCounter:optCounter, Options:options});
                                    break;
                                case "Image":
                                    var imageURL=data.ImageURL;
                                    var scale=data.Scale;
                                    var width=data.Width;
                                    var height=data.Height;
                                    var widthOrg=data.WidthOrg;
                                    var heightOrg=data.HeightOrg;
                                    var element='<div layout="row" layout-align="{{item.Align}}"><img style="width:{{item.Width}}px; height:{{item.Height}}px;" src={{item.ImageURL}}></div>'
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, ImageURL:imageURL, Align:align, Scale:scale, Width:width, Height:height, WidthOrg:widthOrg, HeightOrg:heightOrg});
                                    break; 	
                                case "Line": 
                                    var element='<hr class="inputData">'; 
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq});
                                    break; 	
                                case "File Upload": 
                                    var element = ''+
                                        '<div flow-init="{singleFile:true, target:\'upload\'}" flow-files-submitted="$flow.upload()" flow-file-success="$file.msg = $message">'+
                                        '<md-button class="md-icon-button" aria-label="attach file" flow-btn="" ng-disabled="$flow.files[0]">'+
                                            '<md-icon md-font-icon="icon-paperclip" class="icon s24"></md-icon>'+
                                            '<input type="file" style="visibility: hidden; position: absolute;">'+
                                        '</md-button>'+
                                        '<md-input-container>'+
                                            '<label ng-show="$flow.files[0]">{{$flow.files[0].name}}</label>'+
                                            '<input type="text" disabled>'+
                                            '<div class="warning" ng-show="$flow.files[0].size>=3*1024*1024" style="font-size:10px; color:red; padding-left:2px;">file should be max 3 mb</div>'+
                                            '<div class="hint" style="font-size:10px; color:gray; padding-left:2px;">max 3 mb</div>'+
                                        '</md-input-container>'+
                                        '<md-button ng-show="$flow.files.length" class="md-icon-button md-primary md-warn" aria-label="remove" ng-click="$flow.files[0].cancel()">'+
                                            '<md-icon md-font-icon="icon-cancel"></md-icon>'+
                                        '</md-button>'+
                                        '</div>';
                                    htmlTemp = htmlTemp + element + '</div></div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq});
                                    break;
                                case "Date":
                                    var hideIcons=data.HideIcons;
                                    var maxDate=data.MaxDate;
                                    var minDate=data.MinDate;
                                    var element=''+
                                    '<md-input-container>'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<md-datepicker ng-model="item.Value" name="'+formdivId+'" ng-required="item.Required" md-hide-icons="item.HideIcons" '+
                                            'md-min-date="item.MinDate" md-max-date="item.MaxDate"></md-datepicker>'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '<div ng-message="mindate" translate="MF.MIN_DATE_WARNING">Date must be later than the min date</div>'+
                                            '<div ng-message="maxdate" translate="MF.MAX_DATE_WARNING">Date must be earlier than the max date</div>'+
                                        '</div>'+
                                    '</md-input-container>';
                                    refreshItem[formdivId]=true;
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required, HideIcons:hideIcons, MaxDate:maxDate, MinDate:minDate});
                                    break;
                                case "Time":
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<input type="time" name="'+formdivId+'" ng-required="item.Required" ng-model="item.Value">'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                        '</div>'+
                                    '</md-input-container>';
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required});
                                    break;	
                                case "Numeric":
                                    if(data.MinValue){var minValue=data.MinValue;} else {var minValue=null;}
                                    if(data.MaxValue){var maxValue=data.MaxValue;} else {var maxValue=null;}
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<input type="number" name="'+formdivId+'" ng-required="item.Required" ng-model="item.Value" step="any" min="{{item.MinValue}}" max="{{item.MaxValue}}">'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '<div ng-message="max" translate="MF.MAX_VALUE_WARNING">Maximum value limit error</div>'+
                                            '<div ng-message="min" translate="MF.MIN_VALUE_WARNING">Minimum value limit error</div>'+
                                        '</div>'+
                                    '</md-input-container>';                            
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required, MinValue:minValue, MaxValue:maxValue});  		
                                    break;	  
                                case "Email":
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<input type="email" name="'+formdivId+'" ng-required="item.Required" ng-model="item.Value"'+
                                            'translate ng-pattern="/^.+@.+\..+$/">'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error" role="alert" multiple>'+
                                            '<div ng-message="required">'+
                                                '<span translate="MF.REQUIRED">Required</span>'+
                                            '</div>'+
                                            '<div ng-message="pattern">'+
                                                '<span translate="MF.VALID_WARNING">The entered value is not valid</span>'+
                                            '</div>'+
                                        '</div>'+
                                    '</md-input-container>';
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required});     		
                                    break;	
                                case "Phone Number":
                                    var mask=data.Mask;
                                    var maskChar=data.MaskChar;
                                    var element=''+
                                    '<md-input-container class="md-block">'+
                                        '<label>{{item.LabelText}}</label>'+
                                        '<input type="text" aria-label="Phone Number" name="'+formdivId+'" ng-required="item.Required" '+
                                        'ui-mask-placeholder-char="{{item.MaskChar}}" ng-model="item.Value" ui-mask="{{item.Mask}}" ui-mask-placeholder ui-options={addDefaultPlaceholder:false}>'+
                                        '<div ng-messages="formDiv.'+formdivId+'.$error">'+
                                            '<div ng-message="required" translate="MF.REQUIRED">Required</div>'+
                                            '<div ng-message="valid" translate="MF.VALID_WARNING">The entered value is not valid</div>'+
                                        '</div>'+
                                    '</md-input-container>';                                             
                                    htmlTemp= htmlTemp+element+'</div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, LabelText:labelText, Required:required, Mask:mask, MaskChar:maskChar});  		
                                    break;	 
                                case "Table":
                                    var allowAddDeleteRows = data.AllowAddDeleteRows; 
                                    var rowNumber = data.RowNumber;
                                    var rowCounter = data.RowCounter;
                                    var colCounter = data.ColCounter;
                                    var columns = [];
                                    for (var key in data.Columns) {
                                        var colId = key;
                                        var value = data.Columns[key].Value;
                                        var colSeq = data.Columns[key].Seq;
                                        columns.push({ Key: colId, Value: value, Seq: colSeq });
                                    }
                                    var rows = data.Rows;
                                    var element='<div class="simple-table-container md-whiteframe-4dp">';
                                    var table='<table class="simple" ms-responsive-table>';
                                    var thead='<thead><tr><th ng-repeat="col in item.Columns | orderBy:\'Seq\'">{{col.Value}}</th></tr></thead>';
                                    var tbody='<tbody><tr ng-repeat="row in vm.rowCount(item.Rows) track by $index"><td ng-repeat="col in item.Columns">'+
                                                '<input ng-model="us">'+
                                                '</td></tr></tbody>';
                                                    //TODO: input ng-model in tbody
                                    //vm.rowCount=function(row)
                                   // {
                                            //TODO:performance. add and see console.log.
                                    //    return new Array(row);
                                  //  }
                                    htmlTemp= htmlTemp+element+table+thead+tbody+'</table></div>';
                                    formItems.push({id:formdivId, html:htmlTemp, Type:elementType, Seq:seq, Rows:rows, Columns:columns, ColCounter:colCounter});
                                    break;    
                            }
                            x++;
                            if (x>=check1) {
                                return formItems
                            }
                        });
                    });


                }              
            };
        })



})();











(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('Auth', ["$firebaseAuth",
            function($firebaseAuth) {
                return $firebaseAuth();
            }
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, Auth, $state, $rootScope, msNavigationService, $timeout)
    {
        var vm = this;
        $rootScope.showLoadingPanel = false;
        // Data
        vm.themes = fuseTheming.themes;

        //let callback = null;
        //let metadataRef = null;

        Auth.$onAuthStateChanged(function(user) {
            msNavigationService.deleteItem('companypages');
            if (user) {
                checkMyCompanies(user.uid);
                if (user.emailVerified==false) {
                    //$state.go ("app.pages_auth_user-actions");
                }

                // user.getToken().then(function (idToken) {
                //     var payload = JSON.parse(atob(idToken.split('.')[1]));
                // });
            }


        });
        //////////

        function checkMyCompanies(UID) {
            var myCompaniesRef= firebase.database().ref('/CompanyPages').orderByChild('OwnerUID').equalTo(UID);
            myCompaniesRef.once('value', function(snap){
                if (snap.val()) {
                    generateNavHeader();
                }
                snap.forEach(function(snapCompany){
                    var key=snapCompany.key;
                    var data=snapCompany.val();
                    generateNavMenu(key, data.CompanyName, data.CompanyURL);
                });
            });
    
            // Navigation
    
            function generateNavHeader() {
                msNavigationService.saveItem('companypages', {
                    title : 'Company Pages',
                    group : true,
                    weight: 2
                });
            };
    
            function generateNavMenu(key, companyName, companyURL) {
                msNavigationService.saveItem('companypages.'+companyName, {
                    title : companyName,
                    icon  : 'icon-web',
                    weight: 1
                });
        
                msNavigationService.saveItem('companypages.'+companyName+'.companypage', {
                    title       : 'Company Page',
                    state       : 'app.my-company_my-company-page',
                    stateParams : {'companyKey':key}
                });
        
                msNavigationService.saveItem('companypages.'+companyName+'.dashboard', {
                    title       : 'Dashboard',
                    state       : 'app.my-company_my-company-dashboard',
                    stateParams : {'companyKey':key}
                });
        
                msNavigationService.saveItem('companypages.'+companyName+'.myforms', {
                    title       : 'My Forms',
                    state       : 'app.my-company_my-forms',
                    stateParams : {'companyKey':key}
                });

                vm.msgtotal=0;
                $rootScope.companyPages = {};
                firebase.database().ref('/CompanyMessages/' + key + '/NewMessageTotal')
                    .on('value', function (snap) {
                        if (snap.val()) {
                            vm.msgtotal = snap.val();
                        } else {
                            vm.msgtotal = 0;
                        }
                        $rootScope.companyPages[key] = {newMsg: vm.msgtotal};

                        $timeout(function () {
                            msNavigationService.saveItem('companypages.' + companyName + '.messages', {
                                title: 'Messages',
                                state: 'app.my-company_my-company-messages',
                                stateParams: { 'companyKey': key },
                                badge: {
                                    content: vm.msgtotal,//nfCompanyMessageService.NewMsgTotal(),
                                    color: '#F44336'
                                },
                            });
                        })
                    });

            };
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');


})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $provide)
    {
        // Put your common app configurations here

        const config = {
            apiKey: "AIzaSyD7RObaT2F-JwforYiOtWuv-ia5U4O2Rqo",
            authDomain: "notefield-cf9cd.firebaseapp.com",
            databaseURL: "https://notefield-cf9cd.firebaseio.com",
            storageBucket: "notefield-cf9cd.appspot.com",
            messagingSenderId: "977579343969"
        };

        firebase.initializeApp(config);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.my-company.my-company-messages', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {

    }

})();
(function () {
    'use strict';

    angular
        .module('app.my-company',
        [
            'app.my-company.my-company-page',
            'app.my-company.create-company-page',
            'app.my-company.my-forms',
            'app.my-company.my-company-dashboard',
            'app.my-company.my-company-messages'
        ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider

            .state('app.my-company_create-company-page', {
                url: '/my-company/create',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/create-company-page/create-company-page.html',
                        controller: 'CreateCompanyPageController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$requireSignIn();
                    }]
                },
                bodyClass: 'create-company-page'
            })
            .state('app.my-company_my-company-page', {
                url: '/my-company/:companyKey/page',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/my-company-page/my-company-page.html',
                        controller: 'MyCompanyPageController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$requireSignIn();
                    }],
                    companyKey: function ($stateParams)
                    {
                        return ($stateParams.companyKey);
                    }
                },
                bodyClass: 'my-company-page'
            })
            .state('app.my-company_my-company-dashboard', {
                url: '/my-company/:companyKey/dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/my-company-dashboard/my-company-dashboard.html',
                        controller: 'MyCompanyDashboardController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$requireSignIn();
                    }],
                    companyKey: function ($stateParams)
                    {
                        return ($stateParams.companyKey);
                    }
                },
                bodyClass: 'my-company-dashboard'
            })
            .state('app.my-company_my-company-messages', {
                url: '/my-company/:companyKey/messages',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/my-company/my-company-messages/my-company-messages.html',
                        controller: 'MyCompanyMessagesController as vm'
                    }
                },
                resolve: {
                    "currentAuth": ["Auth", function (Auth) {
                        return Auth.$requireSignIn();
                    }],
                    companyKey: function ($stateParams)
                    {
                        return ($stateParams.companyKey);
                    }
                }             
            });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/my-company/my-company-page');
        $translatePartialLoaderProvider.addPart('app/main/apps/my-company/create-company-page');
        $translatePartialLoaderProvider.addPart('app/main/apps/my-company/my-forms');
        $translatePartialLoaderProvider.addPart('app/main/apps/my-company/my-company-dashboard');
        $translatePartialLoaderProvider.addPart('app/main/apps/my-company/my-company-messages');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards',
            [
                'app.dashboards.main'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/main');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.signup',
            'app.pages.auth.forgot-password',
            'app.pages.auth.verification',
            'app.pages.auth.user-actions',
            'app.pages.app-console',
            'app.pages.profile',
            'app.pages.public-person',
            'app.pages.public-company',
            'app.pages.shared-withme',
            'app.pages.search',
            'app.pages.waiting-forme',
            'app.pages.my-submissions',
            'app.pages.notifications',
            'app.pages.error-404',
            'app.pages.error-500'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 1
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div id=\"home\" class=\"flex-scrollable\" layout=\"column\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between-center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\" ui-sref=\"app.home\"><img \nsrc=\"assets/images/logos/notefield-logo.png\" alt=\"Notefield\"> <span hide-xs class=\"logo-title\">Notefield</span></div>\n<div ng-if=\"vm.user\" layout=\"row\" layout-align=\"start center\"><md-button md-no-ink ui-sref=\"app.pages_app-console\" \ntranslate=\"HOME.GOTO_CONSOLE\">Go To Console</md-button><md-menu-bar id=\"user-menu\" hide-xs><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.user.photoURL}}\"></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.MY_PROFILE\">My Profile</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n translate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div><div ng-if=\"!vm.user\" class=\"login-panel\"><md-button md-no-ink ui-sref=\"app.pages_auth_login\" \ntranslate=\"HOME.LOGIN\">Log in</md-button></div></div><div class=\"content md-background-bg\"><div layout=\"column\" \nui-view=\"home-content\"><div flex class=\"head-panel\" layout=\"column\" layout-align=\"center center\"><div class=\"\" \nflex=\"auto\" layout=\"row\"><div flex=\"10\" hide-sm hide-xs hide-md></div><div flex=\"auto\" class=\"sections-wrapper\"><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"head-section\"><h1 class=\"notesite-header\">\nNotefield helps you create and manage dynamic web forms online</h1><div class=\"md-whiteframe-4dp register-form-panel\" \nhide-xs><div class=\"form-title\" translate=\"HOME.GET_STARTED_TITLE\">Get started - it\'s free.</div><form \nng-submit=\"vm.signup()\" name=\"registerForm\" class=\"register-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.firstname\" \nplaceholder=\"First name\" translate translate-attr-placeholder=\"HOME.FIRST_NAME\" required><div \nng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HOME.ERRORS.REQUIRED\">Required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input name=\"lastname\" ng-model=\"vm.form.lastname\" placeholder=\"Last name\" translate \ntranslate-attr-placeholder=\"HOME.LAST_NAME\" required><div ng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"HOME.ERRORS.REQUIRED\">Required</span></div></div></md-input-container></div>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"HOME.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"HOME.ERRORS.REQUIRED\">Required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"HOME.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"HOME.PASSWORD\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HOME.ERRORS.REQUIRED\">Required</span></div></div></md-input-container><div class=\"terms\"><span \ntranslate=\"HOME.READ_ACCEPT\">By clicking Join now, you agree to the Notefield </span><a href=\"terms\" \nclass=\"md-accent-color\" translate=\"HOME.TERMS_COND\">terms and conditions</a></div><div class=\"error-msg\">\n{{vm.signupErrorMsg}}</div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"JOIN NOW\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"HOME.JOIN_NOW\" \ntranslate-attr-aria-label=\"HOME.JOIN_NOW\">JOIN NOW</md-button></form></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"info-section\"><div class=\"subinfo-section\"><h3>Easy to use and visual form design tool<p>\nCreate and design any kind of forms you want. Job application, guest feedback, customer survey, quality management and any other forms. Select from ready to use form items and make your own form in a few minutes.\n</p></h3></div><div class=\"subinfo-section\"><h3>Publish forms for public or specific users<p>\nYou can restrict access to your forms publishing as private. So only pre-defined users can access to your forms. When you publish a form public anybody can access and fill in the form (e.g. job application form or feedback form.)\n</p></h3></div><div class=\"subinfo-section\"><h3>Manage workflows and approval process<p>\nThe visual workflow editor is a visual tool for creating and managing process operations. Users quickly create workflow and approval process definitions, preview and publish.\n</p></h3></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"btn-section\"><md-button \nclass=\"md-raised join-button\" ui-sref=\"app.pages_auth_signup\" translate=\"HOME.GET_STARTED\">Get Started</md-button><a \nclass=\"md-raised watch-video-button\" ng-click=\"vm.showVideo($event)\"><i class=\"fa fa-play-circle\" aria-hidden=\"true\">\n</i> Watch The Video</a></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"videoDialog\">\n<md-dialog layout-padding class=\"video-dialog\"><h2>Explore Notefield in 60 seconds</h2><md-button \nclass=\"md-icon-button close-video\" aria-label=\"close\" ng-click=\"vm.closeVideo()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button><div class=\"\"><iframe class=\"video-frame\" data-autohide=\"1\" data-showinfo=\"0\" frameborder=\"0\" \nallowfullscreen=\"\" id=\"\" data-enablejsapi=\"1\" src=\"//www.youtube.com/embed/G9hw08X46R8?enablejsapi=1\" \norigin=\"https://www.notefield.com\"></iframe></div></md-dialog></div></div></div><div flex=\"10\" hide-sm hide-xs hide-md>\n</div></div></div><div flex class=\"app-info-panel\" layout=\"row\"><div flex=\"10\" hide-sm hide-xs></div><div flex=\"auto\">\n<div flex class=\"app-info-header\">Explore form management functions</div><div flex layout=\"column\" layout-gt-xs=\"row\">\n<div layout=\"column\" flex><div flex layout=\"row\" class=\"info-col\" ui-sref=\"app.home.features_dynamic-form-design\">\n<md-button class=\"md-fab md-mini\" aria-label=\"Dynamic Form Design\"><md-icon md-font-icon=\"icon-file-document\">\n</md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">Dynamic Form Design</div><div class=\"col-desc\">\nCreate and design any type of forms easily.</div></div></div><div flex layout=\"row\" class=\"info-col\" \nui-sref=\"app.home.features_form-templates\"><md-button class=\"md-fab md-mini\" aria-label=\"Form Templates\"><md-icon \nmd-font-icon=\"icon-file-multiple\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">\nForm Templates</div><div class=\"col-desc\">Select from form templates ready to use.</div></div></div><div flex \nlayout=\"row\" class=\"info-col\" ui-sref=\"app.home.features_form-approval-process\"><md-button class=\"md-fab md-mini\" \naria-label=\"Approval Process\"><md-icon md-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon></md-button><div \nlayout=\"column\" flex><div class=\"col-header\">Approval Process</div><div class=\"col-desc\">\nDefine approval process for users on forms.</div></div></div><div flex layout=\"row\" class=\"info-col\" \nui-sref=\"app.home.features_document-workflow\"><md-button class=\"md-fab md-mini\" aria-label=\"Document Workflow\"><md-icon\n md-font-icon=\"icon-source-fork\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">\nDocument Workflow</div><div class=\"col-desc\">Use visual workflow editor and define rules.</div></div></div></div><div \nlayout=\"column\" flex><div flex layout=\"row\" class=\"info-col\" ui-sref=\"app.home.features_public-forms\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Public Forms\"><md-icon md-font-icon=\"icon-earth\"></md-icon></md-button><div \nlayout=\"column\" flex><div class=\"col-header\">Public Forms</div><div class=\"col-desc\">\nPublish forms as public for general use.</div></div></div><div flex layout=\"row\" class=\"info-col\" \nui-sref=\"app.home.features_private-forms\"><md-button class=\"md-fab md-mini\" aria-label=\"Private Forms\"><md-icon \nmd-font-icon=\"icon-lock\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">Private Forms</div>\n<div class=\"col-desc\">Publish forms as private and assign to users.</div></div></div><div flex layout=\"row\" \nclass=\"info-col\" ui-sref=\"app.home.features_notification-messages\"><md-button class=\"md-fab md-mini\" \naria-label=\"Notification Messages\"><md-icon md-font-icon=\"icon-comment-alert-outline\"></md-icon></md-button><div \nlayout=\"column\" flex><div class=\"col-header\">Notification Messages</div><div class=\"col-desc\">\nDefine notification alerts and email messages depending on the rules.</div></div></div><div flex layout=\"row\" \nclass=\"info-col\" ui-sref=\"app.home.features_share-forms\"><md-button class=\"md-fab md-mini\" aria-label=\"Share Forms\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">\nShare Forms</div><div class=\"col-desc\">Assign and share forms to specific users.</div></div></div></div><div \nlayout=\"column\" flex><div flex layout=\"row\" class=\"info-col\" ui-sref=\"app.home.features_messaging\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Messaging\"><md-icon md-font-icon=\"icon-message-text-outline\"></md-icon></md-button>\n<div layout=\"column\" flex><div class=\"col-header\">Messaging</div><div class=\"col-desc\">\nSend and receive messages with users and companies.</div></div></div><div flex layout=\"row\" class=\"info-col\" \nui-sref=\"app.home.features_track-process\"><md-button class=\"md-fab md-mini\" aria-label=\"Track Process\"><md-icon \nmd-font-icon=\"icon-history\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">Track Process</div>\n<div class=\"col-desc\">View process and approval history on submitted forms.</div></div></div><div flex layout=\"row\" \nclass=\"info-col\" ui-sref=\"app.home.features_form-reports\"><md-button class=\"md-fab md-mini\" aria-label=\"Form Reports\">\n<md-icon md-font-icon=\"icon-chart-bar\"></md-icon></md-button><div layout=\"column\" flex><div class=\"col-header\">\nForm Reports</div><div class=\"col-desc\">View submitted form reports and statistics.</div></div></div><div flex \nlayout=\"row\" class=\"info-col\" ui-sref=\"app.home.features_company-dashboard\"><md-button class=\"md-fab md-mini\" \naria-label=\"Company Dashboard\"><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon></md-button><div layout=\"column\" \nflex><div class=\"col-header\">Company Dashboard</div><div class=\"col-desc\">\nMonitor key performance results quickly at a glance.</div></div></div></div></div></div><div flex=\"10\" hide-sm hide-xs>\n</div></div><div class=\"public-profiles-panel\" layout=\"column\"><div class=\"public-profiles-header\">\nPublish your forms on your company page</div><div class=\"description\">\nMake your forms accessible to your customers, business partners and other potential visitors directly.</div><div \nclass=\"bg-image\"><img src=\"assets/images/etc/notefield_public_profile.jpg\"></div></div></div></div><footer \nclass=\"footer\"><nav class=\"full-site-width\"><ul class=\"footer-linkbox-list\" layout=\"row\" layout-wrap><li \nclass=\"footer-linkbox\"><h3 class=\"footer-linkbox-header\">Notefield</h3><ul class=\"footer-link-list\"><li \nclass=\"footer-link\"><a href=\"pages/auth/signup\">Get Started</a></li><li class=\"footer-link\"><a href=\"pages/auth/login\">\nLog in</a></li><li class=\"footer-link\"><a href=\"pages/search/company/\">Search Company</a></li><li class=\"footer-link\">\n<a href=\"pages/search/person/\">Search People</a></li></ul></li><li class=\"footer-linkbox\"><h3 \nclass=\"footer-linkbox-header\">Support</h3><ul class=\"footer-link-list\"><li class=\"footer-link\"><a \nui-sref=\"app.public-company({companyURL:\'notefield\'})\">Contact Support</a></li><li class=\"footer-link\"><a \nhref=\"guides\">Guides</a></li><li class=\"footer-link\" hidden><a href=\"http://www.notefield.com\">Samples</a></li><li \nclass=\"footer-link\" hidden><a href=\"http://www.notefield.com\">Form Templates</a></li></ul></li><li \nclass=\"footer-linkbox\"><h3 class=\"footer-linkbox-header\">About</h3><ul class=\"footer-link-list\"><li \nclass=\"footer-link\"><a href=\"terms\">Terms & Conditions</a></li><li class=\"footer-link\"><a href=\"privacy-policy\">\nPrivacy Policy</a></li><li class=\"footer-link\" hidden><a href=\"http://www.notefield.com\">Security</a></li><li \nclass=\"footer-link\"><a ui-sref=\"app.public-company({companyURL:\'notefield\'})\">Contact</a></li></ul></li><li \nclass=\"footer-linkbox\"><h3 class=\"footer-linkbox-header\">Stay Connected</h3><ul class=\"footer-link-list\"><li \nclass=\"footer-link\"><a href=\"https://www.facebook.com/notefieldcom\">Facebook</a></li><li class=\"footer-link\"><a \nhref=\"https://twitter.com/notefield\">Twitter</a></li><li class=\"footer-link\"><a \nhref=\"https://www.youtube.com/channel/UC_MeG7f0zeyf2jzyMIUJHLA\">YouTube</a></li><li class=\"footer-link\"><a \nhref=\"https://www.linkedin.com/company/notefield\">Linkedin</a></li></ul></li></ul></nav></footer></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/home/guides/guides.html","<div id=\"guides\"><div layout=\"row\" class=\"header-panel\"><h1>Guides</h1></div><div class=\"guides-content\"><v-accordion \nclass=\"vAccordion--default\"><v-pane><v-pane-header><h2>Create company page</h2></v-pane-header><v-pane-content><p>\nCreate a company page for your company. Go to console and click on the profile picture on the top right to start and select \"Create Company Page\" button.\n</p><p><strong>Company name: </strong>Write your company name. You can change it later.</p><p><strong>Company url: \n</strong>\nDefine your company url. Notefield members and search engines will use this unique url to find your page as \"https://www.notefield.com/company/\n<strong>yourCompanyURL</strong>\" and you can not change it later.</p><img \nsrc=\"assets/images/etc/create_company_page.png\" alt=\"create_company_page\"><p>\nCompany page will be created when you click on the \"create\" button.</p><p>\nYour company page menu will appear on the left side.</p><img src=\"assets/images/etc/company_page_menu_collapsed.png\" \nalt=\"company_page_menu_collapsed\"></v-pane-content></v-pane><v-pane><v-pane-header><h2>Modify company page</h2>\n</v-pane-header><v-pane-content><p>\nSelect the company page you want to modify from the toolbar and click on the \"Company Page\" button. You can edit basic informations of your company page here.\n</p><img src=\"assets/images/etc/company_page_menu_expanded.png\" alt=\"company_page_menu_expanded\"><p>\nCompany information will be published on your company page as public.</p><p><strong>Company url: </strong>\nYou define this url when creating your company page and you can not change this url later.</p><p><strong>About Us: \n</strong>Write about your company in this section. This information will be published on your company page.</p><p>\n<strong>Industry: </strong>Choose the most appropriate industry code for your company.</p><p><strong>Phone: </strong>\nType in your company\'s phone number.</p><p><strong>Website: </strong>Type in your company\'s web address.</p><p><strong>\nEmail: </strong>Type in your company\'s email address.</p><p><strong>Address: </strong>Type in your company\'s address.\n</p><p><strong>Country: </strong>Choose the country code for your company.</p><img \nsrc=\"assets/images/etc/company_page_modify.png\" alt=\"company_page_modify\"></v-pane-content></v-pane><v-pane>\n<v-pane-header><h2>Manage company messages</h2></v-pane-header><v-pane-content><p>\nNotefield users can send messages to your company. You will see a counter icon displaying new message number.</p><img \nsrc=\"assets/images/etc/company_page_message_menu.png\" alt=\"company_page_message_menu\"><p>\nOnly the owner of the company page can display the company messages. You can reply, archive, mark as read or unread the messages.\n</p><img src=\"assets/images/etc/company_page_message_sample.png\" alt=\"company_page_message_sample\"></v-pane-content>\n</v-pane><v-pane><v-pane-header><h2>My forms</h2></v-pane-header><v-pane-content><p>\nNotefield helps you create and manage dynamic web forms online.</p><p>\nYou can view your existing forms and create, modify, design, share or manage approval process.</p><p>\nForms can be published as public or private. Public forms will be displayed on your company page and any notefield member can view and fill in the public forms. When you make a form as private it will not be displayed on your company page and only the notefield members you share will be able to view and fill in these type of forms.\n</p><p>Simply click on the <img src=\"assets/images/etc/create_form_button.png\" alt=\"my_forms_list\">\nbutton to create a new form.</p><p>\nWrite the name of the form and choose the form type as public or private. You can change these fields later. Clicking on the \"ADD FORM\" button will create the new form and it will forward you to the form panel where you will manage form settings, design or process screens.\n</p><img src=\"assets/images/etc/new_form_window.png\" alt=\"new_form_window\"><p>In the form list just click on the\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>button to edit an existing form.</p><p>\nIf you want to delete a form you can click<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon>\nbutton in the form list. Keep in mind that deleting a form will also remove all form submissions made by other users until now.\n</p><p>Clicking on the<md-icon md-font-icon=\"icon-file-find\" class=\"s16\"></md-icon>\nbutton you can view the list of all submissions of the form submitted by users.</p><img \nsrc=\"assets/images/etc/my_forms_list.png\" alt=\"my_forms_list\"><p>\nMain tab of the form lets you change some basic properties of the form.</p><p><strong>Name: </strong>\nUsers will see your form with this name.</p><p><strong>Type: </strong>\nChoose the form type as public or private. If you choose as \"Public\" then it will be displayed on your company page and any notefield member will be able to view and fill in the form. If you make the form as private it will not be displayed on your company page and only the notefield members you share will be able to view and fill in the form. You can change the type of the form anytime.\n</p><p><strong>Description: </strong>You can write a short description of the form.</p><p>\nUsers will see your public forms on your company page as shown in the preview panel on the right side.</p><p>\nYou can add an image by clicking on the<md-icon md-font-icon=\"icon-palette\" class=\"s16\"></md-icon>\nbutton and it will be displayed under the form name before the form description.</p><p>\nIf you want to change the color of the form panel just click on the<md-icon md-font-icon=\"icon-palette\" class=\"s16\">\n</md-icon>button and set a color you want.</p><img src=\"assets/images/etc/my_form_main.png\" alt=\"my_form_main\">\n</v-pane-content></v-pane><v-pane><v-pane-header><h2>Form design</h2></v-pane-header><v-pane-content><p>\nEasily create your form using the form elements in the toolbar. When you save the form any user will view the last saved form. You can add form elements into your form just clicking on the form elements in the toolbar which is on the left side.\n</p><p>\nOnce you add an item you can change its position up and down. Each form element has its own settings which you can modify.\n</p><h3>Toolbar</h3><p><strong>Header: </strong>\nAdds header element to form. You can modify the text and alignment of the header element.</p><p><strong>Label: \n</strong>\nAdds label element to the form. Labels are static text fields in the form that users can not change. You can modify the text and alignment of the label element.\n</p><p><strong>Text Box: </strong>\nAdds text box to the form. Text box is a single line text field that users can type. You can modify the label of the text box, set as required field and define a max character limit.\n</p><p><strong>Text Area: </strong>\nAdds text area to the form. Text area is a multi line text field that users can type. You can modify the label of the text area, set as required field and define a max character limit.\n</p><p><strong>Dropdown: </strong>\nAdds dropdown element to the form. Dropdown is a set of options and allows the user to choose one value from a list. You can modify the label text of the dropdown element, set as required and define the option values and their order.\n</p><p><strong>Radio Button: </strong>\nAdds radio button element to the form. Radio button is a set of options, only one of which can be selected at any time by user. You can set the item as required, define the option values and their order in the options set and display type of the option set as horizontal or vertical.\n</p><p><strong>Checkbox: </strong>\nAdds checkbox element to the form. Check boxes are set of options displayed as square box on the form that can be selected to indicate an answer to a question by the user. It allows user to select more than one option in the form. You can define the option values and their order in the options set and display type of the option set as horizontal or vertical.\n</p><p><strong>Image: </strong>\nAdds image field to the form. You can modify the image, its dimensions and alignment. Image fields are used to display a static image in the form such as your logo in the top of the form or any other purpose.\n</p><p><strong>Line: </strong>Adds a single horizontal line to the form.</p><p><strong>Date: </strong>\nAdds a date element to the form. You can modify the label of the date element, set as required field and define min-max date values.\n</p><p><strong>Time: </strong>\nAdds a time element to the form. You can modify the label of the time element and set as required field.</p><p><strong>\nNumeric: </strong>\nAdds a numeric element to the form. You can modify the label of the numeric element, set as required field and define min-max numeric values.\n</p><p><strong>Email: </strong>\nAdds an email element to the form. You can modify the label of the email element and set as required field.</p><p>\n<strong>Phone Number: </strong>\nAdds a phone number element to the form. You can modify the label of the phone number element, set as required field and define the mask character.\n</p><p><strong>File Upload: </strong>Adds a file upload element to the form.</p><p><strong>Table: </strong>\nAdds a table element to the form. You can define the default row numbers of the table, modify the column names and order. You can allow users to add/delete rows in the table and this will make the table dynamic. If not users will see the table with the exact number of rows you defined and will not be able to add new row or delete any row.\n</p><p><md-button class=\"md-fab md-mini\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\" class=\"s16\">\n</md-icon></md-button>Saves the form design.</p><p><md-button class=\"md-fab md-mini\" aria-label=\"Up\"><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"s16\"></md-icon></md-button>Moves the selected form item upwards each time.</p><p>\n<md-button class=\"md-fab md-mini\" aria-label=\"Down\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s16\"></md-icon>\n</md-button>Moves the selected form item downwards each time.</p><p><md-button class=\"md-fab md-mini\" \naria-label=\"Copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s16\"></md-icon></md-button>\nClones the selected form item. New item appears at the bottom of the form.</p><p><md-button class=\"md-fab md-mini\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button>\nRemoves the selected form item.</p><p><md-button class=\"md-fab md-mini\" aria-label=\"Settings\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s16\"></md-icon></md-button>Displays the settings panel on the right side of the window.\n</p><p><md-button class=\"md-fab md-mini\" aria-label=\"Preview\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>\n</md-button>Displays a form preview panel.</p><p><md-button class=\"md-fab md-mini\" aria-label=\"Import Template\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button>\nOpens a panel and displays a list of form templates to let user to import a template into the form.</p><p><md-button \nclass=\"md-fab md-mini\" aria-label=\"Upload Template\"><md-icon md-font-icon=\"icon-cloud-upload\" class=\"s16\"></md-icon>\n</md-button>Uploads the existing form as a form template and lets other users to import into their forms.</p><img \nsrc=\"assets/images/etc/my_form_design.png\" alt=\"my_form_design\"></v-pane-content></v-pane><v-pane><v-pane-header><h2>\nManage approval process</h2></v-pane-header><v-pane-content><p>\nYou can manage form approval process. When you define the approval flow, forms submitted by the users will follow these process rules to take action. Forms will be forwarded to a specific user you define here for approval action. Similarly when a user approves or rejects a form then it will check the process rules and will be forwarded to other user for approval process or will terminate the form process according to the flow here.\n</p><p>\nStatus of forms waiting for approval is shown as \"Pending\". The form status is indicated as \"Completed\" if the form process is completely finished.\n</p><p>\nYou do not have to define a process for each form. Use form process when you want a process flow for the form. If no process is defined for the submitted form, the status will be \"Completed\" after the form is submitted.\n</p><img src=\"assets/images/etc/my_form_process.png\" alt=\"my_form_process\"><p>\nUsers can view the forms waiting for their approval on the \"Waiting For Me / Pending Forms\" section.</p><p><img \nsrc=\"assets/images/etc/process_online_button.png\" alt=\"process_online_button\">\nbutton indicates the current status of the process. When you switch on the process is activated and upcoming form submissions follow this process flow. When you switch off the button the process is deactivated and upcoming form submissions do not follow this process flow and status of the new submissions are \"Completed\".\n</p><table><tr><th></th><th></th></tr><tr><td style=\"vertical-align: top\"><md-button class=\"md-fab md-mini\" \naria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\" class=\"s16\"></md-icon></md-button></td><td><p>\nSaves the form process.</p></td></tr><tr><td style=\"vertical-align: top\"><md-button class=\"md-fab md-mini\" \naria-label=\"Add approval\"><md-icon md-font-icon=\"icon-account-plus\" class=\"s16\"></md-icon></md-button></td><td><p>\nDisplays the \"New approval\" window where you can define the flow rules. This button is disabled by default and is enabled when you select either \"new form\" widget or an existing \"approval\" widget.\n</p><p><strong>Parent object: </strong>It is the current object that process action would affect.</p><p><strong>\nProcess action: </strong>Select an action from the list.</p><p><strong>Select user: </strong>\nDefine the user as next approval step.</p><img src=\"assets/images/etc/new_approval_window.png\" \nalt=\"new_approval_window\"></td></tr><tr><td style=\"vertical-align: top\"><md-button class=\"md-fab md-mini\" \naria-label=\"Add termination object\"><md-icon md-font-icon=\"icon-flag-checkered\" class=\"s16\"></md-icon></md-button></td>\n<td><p>\nDisplays the \"Add termination object\" window where you can define the flow rules. This button is disabled by default and is enabled when you select either \"new form\" widget or an existing \"approval\" widget.\n</p><p><strong>Parent object: </strong>It is the current object that process action would affect.</p><p><strong>\nProcess action: </strong>Select an action from the list.</p><img src=\"assets/images/etc/new_termination_window.png\" \nalt=\"new_termination_window\"></td></tr><tr><td style=\"vertical-align: top\"><md-button class=\"md-fab md-mini\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td><td><p>\nRemoves the selected process widget. This button is disabled by default and is enabled when you select either existing \"approval\" or \"termination\" widget.\n</p></td></tr><tr><td style=\"vertical-align: top\"><md-button class=\"md-fab md-mini\" aria-label=\"edit\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s16\"></md-icon></md-button></td><td><p>\nDisplays the settings window of the selected process widget. This button is disabled by default and is enabled when you select either existing \"approval\" or \"termination\" widget.\n</p></td></tr></table></v-pane-content></v-pane><v-pane><v-pane-header><h2>Share forms</h2></v-pane-header>\n<v-pane-content><p>You can share your forms to specific users. To share your form with a user, click on the <img \nsrc=\"assets/images/etc/add_user_button.png\" alt=\"add_user_button\">\nbutton in the \"Users\" panel. Type the email address of the user you want to share the form with and click on the \"Add User\" button. Notification message will be sent to this email address. Notefield will save the email even if the user is not a member yet and send an email message to inform and they will be able to see the forms you have shared with after becoming a member.\n</p><p>Users can access forms shared with them from the \"Shared With Me\" menu in the toolbar.</p><img \nsrc=\"assets/images/etc/share_forms.png\" alt=\"share_forms\"></v-pane-content></v-pane><v-pane><v-pane-header><h2>\nMy submissions</h2></v-pane-header><v-pane-content><p>\nClick on the \"My Submissions\" button on the toolbar. You will see a list of all the forms you have submitted.</p><img \nsrc=\"assets/images/etc/my_submissions_menu.png\" alt=\"my_submissions_menu\"><p>Click on the<md-icon \nmd-font-icon=\"icon-eye\"></md-icon>button to display a form.</p><p>\nIf you select a row of form submission you will see the process of the form on the right side.</p><img \nsrc=\"assets/images/etc/my_submissions_list.png\" alt=\"my_submissions_list\"></v-pane-content></v-pane><v-pane>\n<v-pane-header><h2>Shared with me</h2></v-pane-header><v-pane-content><p>\nClick on the \"Shared With Me\" button on the toolbar. You will see a list of all the forms that other users shared with you.\n</p><img src=\"assets/images/etc/shared_with_me_menu.png\" alt=\"shared_with_me_menu\"><p>\nIf you want to submit a new form just click on the <img src=\"assets/images/etc/create_form_button.png\" \nalt=\"new_form_submission\">button to open the form. Then fill in the form and click \"Submit\".</p><p>\nYou will see the number of your previous submissions for each form on the \"Submitted\" column and when you click on the number it will open the page of the submissions for that form.\n</p><img src=\"assets/images/etc/shared_with_me_list.png\" alt=\"shared_with_me_list\"></v-pane-content></v-pane><v-pane>\n<v-pane-header><h2>Waiting for me</h2></v-pane-header><v-pane-content><p>\nUsers submit forms with Notefield. If a submitted form has a pre-defined process, Notefield will check the process flow and send the form to the appropriate user for approval if necessary.\n</p><p>\nClick on the \"Waiting For Me\" and \"Pending Forms\" button on the toolbar. You will see a list of forms that waiting for your approval.\n</p><img src=\"assets/images/etc/waitingforme_pending_forms_menu.png\" alt=\"waitingforme_pending_forms_menu\"><p>\nClick on the \"Waiting For Me\" and \"Pending Forms\" button on the toolbar. You will see a list of forms that waiting for your approval.\n</p><p>You can approve or reject each form. Click on the<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\nbutton and select \"Approve\" or \"Reject\". Notefield will check the process flow again and send the form to another user for approval if necessary or will set the form status as \"Completed\". Forms will be removed from the \"Pending Forms\" list after your approval action.\n</p><img src=\"assets/images/etc/pending_forms_list.png\" alt=\"pending_forms_list\"><p>\nClick on the \"Waiting For Me\" and \"Archive\" button on the toolbar to see a list of previously approved or rejected forms by you.\n</p><img src=\"assets/images/etc/waitingforme_archive_menu.png\" alt=\"waitingforme_archive_menu\"></v-pane-content>\n</v-pane></v-accordion></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/home/features/company-dashboard/company-dashboard.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Company Dashboard</h2><p>\nSee an overview of all your activity from all forms in one place. Select from the company form list and view the dashboard panel.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/company_dashboard.png\" alt=\"company_dashboard\">\n</div><div flex layout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div\n layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box-outline\"></md-icon><h3>Dashboard Form Widgets\n</h3></div><p flex>\nDisplay form dashboard regarding your form and date selection like current date, month or year. Dashboard panel will display form data as form submissions, status, shared users and more.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-chart-bar\"></md-icon><h3>Dashboard Form Graphics</h3></div><p flex>\nDashboard form graphics let you display form statistics by your date selection. You can change graph result as grouped or stacked.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/document-workflow/document-workflow.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Document Workflow</h2><p>\nYou manage form workflow operations similar to approval process. Simply create your own custom processes without being restricted by form approval or rejection. You define the action buttons that will displayed to each user and set the process when clicked on.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/form_approval_process.png\" alt=\"document_workflow\">\n</div><div layout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-source-fork\"></md-icon><h3>Manage Form Workflow</h3></div><p \nflex>\nCreate and manage document workflow according to your needs. It is easy to use and flexible. Just decide what you need and the wizard will guide you to build the workflow. Create and name action buttons, and define what should happen when clicked.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cog-box\"></md-icon><h3>Form Operations</h3></div><p flex>\nUsers will display the forms they are linked and awaiting their action. After the user has processed the form with action buttons, the system operates the workflow and proceeds to the next step.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-eye\"></md-icon><h3>Form Workflow Tracking\n</h3></div><p flex>\nYou can review the forms you have submitted, approved or processed. Users display the operation date, time, type and user informations on a form workflow history.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-flag-variant\"></md-icon><h3>Form Notifications</h3></div><p flex>\nYou will be notified with a notification alert when any form is awaiting for your operation/approval.</p></div></div>\n</div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/dynamic-form-design/dynamic-form-design.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Dynamic Form Design</h2><p>\nCreate and design any form you want. Use our powerful form design tools.</p></div><div class=\"ft-panel-top-img\"><img \nsrc=\"assets/images/etc/dynamic_form_design.png\" alt=\"dynamic_form_design\"></div><div flex layout=\"row\" \nclass=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-format-header-1\"></md-icon><h3>Header</h3></div><p flex>\nHeader element defines the title of the form and contains information for whole or part of a document. Header is usually located at the top of the form.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-format-text\"></md-icon><h3>Label</h3></div><p flex>\nUse this plain text field when you need to display text data on the form. It is not an input field for users.</p></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><h3>Text Box\n</h3></div><p flex>\nEnable the user to input text information to be used by the program. Use this (single-line text box) when only one line of input is required.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-menu\"></md-icon><h3>Text Area</h3></div><p flex>\nText area element represents a multi-line plain-text editing control. It is similar to text box element. The only difference is that there is more than one line.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><h3>Drop Down</h3>\n</div><p flex>\nDrop down element provides a menu of options for users to choose from. The number of dropdown menu options, content and order can be defined.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-radiobox-marked\"></md-icon><h3>Radio Button</h3></div><p flex>\nRadio button allows the user to choose only one of a predefined set of options. The number of radio button menu options, content and order can be defined.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-outline\"></md-icon><h3>\nCheck Box</h3></div><p flex>\nElements of type checkbox are displayed as square boxes that are checked (ticked) when activated. They allow user to select single or multiple values for submission in the form. The number options, content and order can be defined.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><h3>Image</h3></div><p flex>\nImage item is used to display an image element such as a logo or picture to the users in the form. The size of the image and the location on the form can be adjusted.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-minus\"></md-icon><h3>Line</h3></div><p flex>\nLine element is used for a thematic change in the form. It represents a horizontal line and usually used to distinguish between sections in a form.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-window-closed\"></md-icon><h3>Page Break</h3></div><p flex>\nPage Break provides a functionality where to end the current page and begin the next. After the Page Break is inserted into the form, a symbol indicating the page break is shown.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon><h3>Date</h3></div>\n<p flex>\nDate element is an input field for the user and aims to accept data of type date only. Users can input date directly or select a date from a calendar window.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-timer\"></md-icon><h3>Time</h3></div><p flex>\nTime element is an input field for the user and represents either a time on a 24-hour or 12-hour clock. In a form time field aims to accept data of type time only. Users can input time directly or select time from a calendar window.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric\"></md-icon><h3>Numeric</h3></div><p \nflex>\nNumeric element is an input field for users and does not allow any other characters to be input in a numeric field. Decimal point and number of digits can be specified.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><h3>Email</h3></div><p flex>\nInput type of email is used to let the user enter and edit an email. The input value is automatically validated to ensure that it\'s properly-formatted email address.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-phone\"></md-icon><h3>Phone Number</h3></div>\n<p flex>\nInput type of phone number is used to allow users to enter phone numbers in a specific format. Use this element to validate a phone number field. Phone number display format can be adjusted in the form.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><h3>File Upload</h3></div><p flex>\nAllow users to upload files with their form submissions by including a file upload field on your form.</p></div></div>\n<div layout=\"column\" layout-gt-sm=\"column\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-table\"></md-icon><h3>Table</h3></div><p flex>\nTable element allows you to attach table field on your form. The table type input allows you to specify the number of rows/columns on the form and allows users to enter data into each table cell.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/form-approval-process/form-approval-process.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Form Approval Process</h2><p>\nYou can create an approval process and ensure that the filled out forms are sent by the system in sequence to authorized users you set for approval.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/form_approval_process.png\" \nalt=\"form_approval_process\"></div><div layout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div \nlayout=\"column\" flex=\"auto\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex \nlayout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-source-fork\"></md-icon>\n<h3>Create Form Approval Process</h3></div><p flex>\nYou can define the users and their order for approval process in each form. It does not matter if there are one or more users to approve the form. The system will send the forms to the users according to the order you define.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-thumb-up\"></md-icon><h3>Approve Forms</h3></div><p flex>\nYou will see the forms you have been added to the approval process and are awaiting your approval. You approve or reject the form.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-eye\"></md-icon><h3>Form Approval Tracking\n</h3></div><p flex>\nYou can review the forms you have submitted or approved and see who will approve next. Display the approval process details like approver and approval date/time.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-flag-variant\"></md-icon><h3>Approval Notifications</h3></div><p flex>\nYou will be notified with a notification alert when any form is awaiting for your approval.</p></div></div></div><div \nflex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/form-reports/form-reports.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Form Reports</h2><p>\nNotefield provides users detailed reports and access to important data required for various purposes. In Notefield, standard reports are provided in report pages, which can be either used as it is or customized as per your business requirements.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/company_dashboard.png\" alt=\"form_reports\"></div>\n<div layout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-bar\"></md-icon><h3>Form Submissions</h3></div><p flex>\nDisplay submissions on each report based on a specific date range, weekly, monthly or yearly. View process based reports on user approvals and operations, transaction period and other statistics.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-chart-pie\"></md-icon><h3>Chart Reports</h3></div><p flex>\nView chart reports for your multiple choice questions on your forms. You can view reports for those multiple-choice form elements such as drop down radio button or checkbox that users select the answer. (e.g. Gender: Male/Female)\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-table-large\"></md-icon><h3>Text Reports</h3>\n</div><p flex>\nDisplay text type question answers on your forms as a list. Select the form and the question then display the text answers.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon><h3>Export Report</h3></div><p flex>\nExport your reports as PDF, CSV or Google spreadsheet and take your data with you.</p></div></div></div><div flex=\"5\" \nhide-xs></div></div>");
$templateCache.put("app/home/features/form-templates/form-templates.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Form Templates</h2><p>\nWhen designing your forms, you can choose one from our form templates and quickly create a form.</p></div><div \nclass=\"ft-panel-top-img\"><img src=\"assets/images/etc/form_templates.png\" alt=\"form_templates\"></div><div layout=\"row\" \nclass=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon><h3>Using Form Templates</h3></div><p\n flex>Choose from a large number of form templates to suit you and use it for free. Edit and publish your forms easily.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-find\"></md-icon><h3>Search From Templates</h3></div><p flex>\nWhether you’re a web designer looking for a contact form or a business professional looking for a customer feedback form, you can browse by industry or keywords to find the one that best suits your needs.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/messaging/messaging.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Messaging</h2><p>\nNotefield allows you to send and receive instant messages between other members. Send messages to other users or companies.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/messaging.png\" alt=\"messaging\"></div><div \nlayout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-comment-text-outline\"></md-icon><h3>Messaging With Users</h3>\n</div><p flex>Users can send and receive instant messages between other users.</p></div><div class=\"ft-panel\" flex \nlayout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-comment-text-outline\">\n</md-icon><h3>Messaging With Companies</h3></div><p flex>\nAs a user you can use instant message service on Notefield to send message to companies. As a company page owner you can send and receive messages to other users.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/notification-messages/notification-messages.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Notification Messages</h2><p>\nNotefield will help you to get notified when any action occurs regarding you or awaiting for your operation. When someone shared you a form, submitted a form which you shared or when any form is awaiting for your approval you will be notified.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/notifications.png\" alt=\"notification_messages\">\n</div><div layout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\"></md-icon><h3>Manage Notification Rules</h3></div><p flex>\nDefine notification rules for your forms. You can set both notification alerts and email messages on your form you published. Meanwhile you can add or remove alerts for forms you have been shared.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon><h3>Get Notified</h3></div><p flex>\nNotefield will send you notification alerts when any action is required on any form regarding you like approval. By the way you receive emails or alerts when you mark a form for tracking. You can change settings and receive more or less alerts and messages.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><h3>Email Messages</h3>\n</div><p flex>You will be notified and informed by email messages.</p></div><div class=\"ft-panel\" flex layout=\"column\">\n<div flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-flag-variant\"></md-icon><h3>\nNotification Alerts</h3></div><p flex>\nYou will see notification alerts and messages on Notefield. These notifications will inform you about some important transactions.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/private-forms/private-forms.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Private Forms</h2><p>\nYou can publish your form as private and restrict accessibility. Ensure that each user only gets access to the form that you have authorized and prevent users from reaching unauthorized forms. Thus, employees in companies may be authorized to display different forms depending on the authorities.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/private_forms.png\" alt=\"private_forms\"></div><div \nlayout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-key\"></md-icon><h3>Publishing Private Forms</h3></div>\n<p flex>\nIf you publish a form as private, you prevent that form from being accessed by unauthorized users. Each form has a separate authority list. Each user can display the forms they have been authorized in their shared forms panel.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><h3>Authorize Users</h3></div><p flex>\nShare your form with people you want to authorize just typing their email addresses. Do not worry if the person you are sharing the form with is not a Notefield member yet because we will send them a notification message. When the user accepts the invitation, he or she will be able to see all forms they have been authorized.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\"></md-icon><h3>Link From Your Web Page\n</h3></div><p flex>\nNotefield creates a link for your private form for your use. You can put this link on your website or your intranet system. Don\'t worry about authorization as Notefield checks the users if they are allowed to display the form even if they click on the link of the form.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><h3>Link Via Email</h3></div><p flex>\nShare the forms to users by email just adding the form link which Notefield created. When users click on the link they will be directed to form page and will display the form if user has authority.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share-variant\"></md-icon><h3>\nDisplaying Shared Forms</h3></div><p flex>\nYou can display and submit a form shared by others. When a user shares any form with you, you have the authority to display and to fill in that form.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-flag-variant\"></md-icon><h3>Get Notified</h3></div><p flex>\nNotefield will notify you by email or notification alert depending on your preferences when someone fills your form. If you share a form to anybody Notefield will send a notification message to that user.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/public-forms/public-forms.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Public Forms</h2><p>\nPublish your forms as public and make them accessible to everyone. Customer complaint form, contact form, survey form and job application form are good examples for public forms as they need to be accessed by everyone.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/public_forms.png\" alt=\"public_forms\"></div><div \nlayout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><h3>Publishing Public Forms</h3>\n</div><p flex>\nMake a form public so that everyone can fill the form. Everybody will display and fill in the form without requiring you to authorize them. You simply create forms like registration form, product order form, feedback form, online booking form, cv submission form etc.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><h3>Link From Your Web Page</h3></div><p flex>\nOnce you have created your form, you can now link to it from your own website. Notefield creates a link for your public form so anybody can display and fill in the form by clicking on the link.\n</p></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><h3>Link Via Email</h3>\n</div><p flex>\nSince Notefield creates a link for your public forms you can use this link in your emails. Anyone clicking on the link will directly reach your form page.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-flag-variant\"></md-icon><h3>Get Notified</h3></div><p flex>\nNotefield will notify you by email or notification alert depending on your preferences when someone fills your form.\n</p></div></div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/share-forms/share-forms.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Share Forms</h2><p>\nPublish your form as private and share it to users just adding their emails. No problem if they are not already a Notefield member because Notefield will inform and generate shared forms for them after they accept.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/share_forms.png\" alt=\"share_forms\"></div><div \nlayout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><h3>Share To Users</h3></div><p flex>\nShare your private web forms to people and authorize them to display and fill out the form by typing email addresses.\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon><h3>Share To Group</h3></div><p flex>\nYou can create user groups and share forms to user groups instead of typing email addresses one by one.</p></div></div>\n</div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/features/track-process/track-process.html","<div layout=\"row\" class=\"ft-panel-top\"><h2>Track Process</h2><p>\nMonitor the process transactions in a form. Display who performed the previous operations, adding and editing date or approvals. Follow the status of the form and who needs to act on the form now if you have defined a process for the form.\n</p></div><div class=\"ft-panel-top-img\"><img src=\"assets/images/etc/track_process.png\" alt=\"track_process\"></div><div \nlayout=\"row\" class=\"ft-panel-wrapper\"><div flex=\"5\" hide-xs></div><div layout=\"column\" flex=\"auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex=\"auto\"><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-history\"></md-icon><h3>Display Transactions</h3></div><p flex>\nYou can display form and process transactions for answers to (Who did submit? When was submitted? When was approved?)\n</p></div><div class=\"ft-panel\" flex layout=\"column\"><div flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><h3>See Next Step</h3></div><p flex>\nSee what will happen next. Monitor the next operation or next approval. The process has finished or not.</p></div>\n</div></div><div flex=\"5\" hide-xs></div></div>");
$templateCache.put("app/home/about/privacy-policy/privacy-policy.html","<div id=\"privacy-policy\"><div layout=\"row\" class=\"header-panel\"><h1>Privacy Policy</h1></div><div \nclass=\"privacy-policy-content\"><h3>General</h3><p>\nWe respect your need for online privacy and protect any Personal Information that you may share with us, in an appropriate manner. Our practice with respect to use of your Personal Information is as set forth below in this Privacy Policy Statement. As a condition to use of Notefield Services, you consent to the terms of the Privacy Policy Statement as it may be updated from time to time. This Privacy Policy Statement applies exclusively to www.notefield.com.\n</p><h3>Federated Authentication</h3><p>\nYou can log in to our site using federated authentication providers such as Google or Facebook. These services will authenticate your identity and provide you the option to share certain Personal Information with us such as your name and email address to pre-populate our sign up form.\n</p><h3>Cookies and Other Tracking Technologies</h3><p>\nWe use cookies and similar technologies (e.g., web beacons, pixels, ad tags and device identifiers) to recognize you and/or your device(s) on, off and across different Services and devices. You can control cookies through your browser settings and other tools. You can also opt out from our use of cookies and similar technologies that track your behavior on the sites of others for third party advertising.\n</p><h3>Your Device and Location</h3><p>\nWhen you visit or leave our Services (including our plugins or cookies or similar technology on the sites of others), we receive the URL of both the site you came from and the one you go to next. We also get information about your IP address, proxy server, operating system, web browser and add-ons, device identifier and features, and/or ISP or your mobile carrier. If you use our Services from a mobile device, that device will send us data about your location. Most devices allow you to prevent location data from being sent to us and we honor your settings.\n</p><h3>User Data</h3><p>\nTo obtain access to certain areas of our website or to receive certain services we provide, you may be required to register with us and, in connection with such registration, to provide certain Personal Data (e.g., your email address). We use such information to provide the service you requested, to monitor internally usage of our website, and to contact you from time to time about us, our website, and our products and services. In addition, if you wish to make a purchase from our website, you are required to register with us and, in connection with such registration, to provide certain Personal Data (e.g., your full name, email address, and billing information). We use such information to fulfill your order and to contact you from time to time about us, our website, and our products and services.\n</p><h3>Form Submissions</h3><p>\nWe respect the privacy of our users and the privacy of their form data. All user information contained within the forms you may use or build on the Notefield Site are governed by our Terms of Service. You retain all rights to your data. We will not access your data for non-administrative reasons.\n</p><h3>Payment Information</h3><p>\nIn case of services requiring payment, we request credit card or other payment account information, which will be used solely for processing payments. Your financial information will not be stored by us except for the name and address of the card holder, the expiry date and the last four digits of the Credit Card number. Subject to your prior consent and where necessary for processing future payments, your financial information will be stored in encrypted form on secure servers of our reputed Payment Gateway Service Provider who is beholden to treating your Personal Information in accordance with this Privacy Policy Statement.\n</p></div></div>");
$templateCache.put("app/home/about/terms/terms.html","<div id=\"terms\"><div layout=\"row\" class=\"header-panel\"><h1>Terms</h1></div><div class=\"terms-content\"><h2>\n1. Introduction</h2><h3>1.1 Contract</h3><p>\nYou agree that by clicking “Join Now” or “Get Started”, you are agreeing to enter into a legally binding contract with Notefield (even if you are using our Services on behalf of a company). If you do not agree to this contract (“Contract” or “User Agreement”), do not click “Join Now” (or similar) and do not access or otherwise use any of our Services.\n</p><h4>Services</h4><p>\nThis Contract applies to Notefield.com sites, apps, communications and other services. Registered users of our Services are “Members” and unregistered users are “Visitors”. This Contract applies to both.\n</p><h4>Notefield</h4><p>You are entering into this Contract with Notefield (also referred to as “we” and “us”).</p>\n<h3>1.2 Members and Visitors</h3><p>\nWhen you register and join the Notefield Service, you become a Member. If you have chosen not to register for our Services, you may access certain features as a visitor.\n</p><h3>1.3 Change</h3><p>\nWe may modify this Contract and our Privacy Policy from time to time. If we make material changes to it, we will provide you notice through our Services, or by other means, to provide you the opportunity to review the changes before they become effective. If you object to any changes, you may close your account. Your continued use of our Services after we publish or send a notice about our changes to these terms means that you are consenting to the updated terms.\n</p><h2>2. Obligations</h2><h3>2.1 Service Eligibility</h3><p>\nThe Services are not for use by anyone under the age of 16.</p><p>\nTo use the Services, you agree that: (1) you must be the “Minimum Age of 16” or older; (2) you will only have one Notefield account, which must be in your real name; and (3) you are not already restricted by Notefield from using the Services.\n</p><h3>2.2 Your Account</h3><p>\nMembers are account holders. You agree to: (1) try to choose a strong and secure password; (2) keep your password secure and confidential; (3) not transfer any part of your account and (4) follow the law and our list of Dos and Don’ts. You are responsible for anything that happens through your account unless you close it.\n</p><p>\nAs between you and others (including your employer), your account belongs to you. However, if the Services were purchased by another party for you to use (e.g. Recruiter seat bought by your employer), the party paying for such Service has the right to control access to and get reports on your use of such paid Service; however, they do not have rights to your personal account.\n</p><h3>2.3 Payment</h3><p>\nIf you buy any of our paid Services you agree to pay us the applicable fees and taxes. Failure to pay these fees will result in the termination of your paid Services. Also, you agree that:\n</p><ul><li>\nYour purchase may be subject to foreign exchange fees or differences in prices based on location (e.g. exchange rates).\n</li><li>\nWe may store and continue billing your payment method (e.g. credit card) even after it has expired, to avoid interruptions in your Services and to use to pay other Services you may buy.\n</li><li>\nIf you purchase a subscription, your payment method automatically will be charged at the start of each subscription period for the fees and taxes applicable to that period. To avoid future charges, cancel before the renewal date.\n</li><li>\nWe may calculate taxes payable by you based on the billing information that you provide us at the time of purchase.\n</li></ul><p>You can get a copy of your invoice through your Notefield account settings under “Purchase History”.</p>\n<h3>2.4 Notices and Service Messages</h3><p>\nYou agree that we will provide notices to you in the following ways: (1) a notice within the Service, or (2) a message sent to the contact information you provided us (e.g., email, mobile number, physical address). You agree to keep your contact information up to date.\n</p><p>Please review your settings to control and limit the messages you receive from us.</p><h3>2.5 Sharing</h3><p>\nOur Services allow messaging and sharing of information in many ways, such as your profile, postings and messaging. Information and content that you share or post may be seen by other Members or Visitors.\n</p><p>\nWe are not obligated to publish any information or content on our Service and can remove it in our sole discretion, with or without notice.\n</p><h2>3. Rights and Limits</h2><h3>3.1 Your License to Notefield</h3><p>\nAs between you and Notefield, you own the content and information that you submit or post to the Services and you are only granting Notefield and our affiliates the following non-exclusive license: A worldwide, transferable and sublicensable right to use, copy, modify, distribute, publish, and process, information and content that you provide through our Services, without any further consent, notice and/or compensation to you or others. These rights are limited in the following ways:\n</p><ul><li>\nYou can end this license for specific content by deleting such content from the Services, or generally by closing your account, except (a) to the extent you shared it with others as part of the Service and they copied, re-shared it or stored it and (b) for the reasonable time it takes to remove from backup and other systems.\n</li><li>\nWe will not include your content in advertisements for the products and services of third parties to others without your separate consent (including sponsored content). However, we have the right, without payment to you or others, to serve ads near your content and information, and your social actions on sponsored content and company pages may be visible, as noted in the Privacy Policy.\n</li><li>\nWe will get your consent if we want to give third parties the right to publish your posts beyond the Service. However, other Members and/or Visitors may access and share your content and information.\n</li><li>\nWhile we may edit and make formatting changes to your content (such as translating it, modifying the size, layout or file type or removing metadata), we will not modify the meaning of your expression.\n</li></ul><p>\nYou agree that we may access, store and use any information that you provide in accordance with the terms of the Privacy Policy and your choices (including settings).\n</p><p>\nBy submitting suggestions or other feedback regarding our Services to Notefield, you agree that Notefield can use and share (but does not have to) such feedback for any purpose without compensation to you.\n</p><p>\nYou agree to only provide content or information that does not violate the law nor anyone’s rights (including intellectual property rights). You also agree that your profile information will be truthful. Notefield may be required by law to remove certain information or content in certain countries.\n</p><h3>3.2 Service Availability</h3><p>\nWe may change or discontinue any of our Services. We don’t promise to store or keep showing any information and content that you’ve posted.\n</p><p>\nNotefield is not a storage service. You agree that we have no obligation to store, maintain or provide you a copy of any content or information that you or others provide, except to the extent required by applicable law and as noted in our Privacy Policy.\n</p><p>\nNotefield makes no warranty that forms provided by Notefield Service will be available 100% of the time and will be error free. YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE ARISING FROM ANY ERRORS ON A FORM OR UNAVAILABILITY OF A FORM.\n</p><p>\nWhen someone submits your forms, you may receive the results as an email notification. WE DO NOT GUARANTEE SUCCESSFUL DELIVERY OF YOUR EMAIL NOTIFICATIONS.\n</p><h3>3.3 Forms and Submissions</h3><p>\nNotefield does not claim ownership of any information, data, text, software, music, sound, photographs, graphics, video, messages, tags, or other materials you submit or make available for inclusion on or through the Notefield Service (\"Forms and Submissions\"). As between Notefield and you, you own all rights to your Forms and Submissions. When you make a Form as \"public\", you grant Notefield a worldwide and fully sublicensable license to use, distribute, reproduce, modify, adapt, publish, translate, publicly perform, and publicly display your Forms (in whole or in part) in any format or medium now known or later developed. You agree that you are solely responsible for all of your Form Submissions.\n</p><h3>3.4 Other Content, Sites and Apps</h3><p>\nBy using the Services, you may encounter content or information that might be inaccurate, incomplete, delayed, misleading, illegal, offensive or otherwise harmful. Notefield generally does not review content provided by our Members or others. You agree that we are not responsible for others’ (including other Members’) content or information. We cannot always prevent this misuse of our services, and you agree that we are not responsible for any such misuse. You also acknowledge the risk that you or your organization may be mistakenly associated with content about others when we let connections and followers know you or your organization were mentioned in the news.\n</p><h3>3.5 Limits</h3><p>\nNotefield reserves the right to limit your use of the Services, including your ability to contact other Members. Notefield reserves the right to restrict, suspend, or terminate your account if Notefield believes that you may be in breach of this Contract or law or are misusing the Services (e.g. violating any Do and Don’ts).\n</p><h3>3.6 Intellectual Property Rights</h3><p>\nNotefield reserves all of its intellectual property rights in the Services. Using the Services does not give you any ownership in our Services or the content or information made available through our Services. Trademarks and logos used in connection with the Services are be the trademarks of their respective owners.\n</p><h2>4. Disclaimer and Limit of Liability</h2><h3>4.1 No Warranty</h3><p>\nTO THE EXTENT ALLOWED UNDER LAW, NOTEFIELD AND ITS AFFILIATES (AND THOSE THAT NOTEFIELD WORKS WITH TO PROVIDE THE SERVICES) (A) DISCLAIM ALL IMPLIED WARRANTIES AND REPRESENTATIONS (E.G. WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY OF DATA, AND NONINFRINGEMENT); (B) DO NOT GUARANTEE THAT THE SERVICES WILL FUNCTION WITHOUT INTERRUPTION OR ERRORS, AND (C) PROVIDE THE SERVICE (INCLUDING CONTENT AND INFORMATION) ON AN “AS IS” AND “AS AVAILABLE” BASIS.\n</p><p>SOME LAWS DO NOT ALLOW CERTAIN DISCLAIMERS, SO SOME OR ALL OF THESE DISCLAIMERS MAY NOT APPLY TO YOU.</p><h3>\n4.2 Exclusion of Liability</h3><p>\nTO THE EXTENT PERMITTED UNDER LAW (AND UNLESS NOTEFIELD HAS ENTERED INTO A SEPARATE WRITTEN AGREEMENT THAT OVERRIDES THIS CONTRACT), NOTEFIELD AND ITS AFFILIATES (AND THOSE THAT NOTEFIELD WORKS WITH TO PROVIDE THE SERVICES) SHALL NOT BE LIABLE TO YOU OR OTHERS FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF DATA, OPPORTUNITIES, REPUTATION, PROFITS OR REVENUES, RELATED TO THE SERVICES (E.G. OFFENSIVE OR DEFAMATORY STATEMENTS, DOWN TIME OR LOSS, USE OF, OR CHANGES TO, YOUR INFORMATION OR CONTENT).\n</p><p>\nTHIS LIMITATION OF LIABILITY IS PART OF THE BASIS OF THE BARGAIN BETWEEN YOU AND NOTEFIELD AND SHALL APPLY TO ALL CLAIMS OF LIABILITY (E.G. WARRANTY, TORT, NEGLIGENCE, CONTRACT, LAW) AND EVEN IF NOTEFIELD OR ITS AFFILIATES HAS BEEN TOLD OF THE POSSIBILITY OF ANY SUCH DAMAGE, AND EVEN IF THESE REMEDIES FAIL THEIR ESSENTIAL PURPOSE.\n</p><p>SOME LAWS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY, SO THESE LIMITS MAY NOT APPLY TO YOU.</p><h2>\n5. Termination</h2><p>\nBoth you and Notefield may terminate this Contract at any time with notice to the other. On termination, you lose the right to access or use the Services. The following shall survive termination:\n</p><ul><li>Our rights to use and disclose your feedback;</li><li>\nMembers and/or Visitors’ rights to further re-share content and information you shared through the Service to the extent copied or re-shared prior to termination;\n</li><li>Sections 4 and 6 of this Contract;</li><li>\nAny amounts owed by either party prior to termination remain owed after termination.</li></ul><h2>6. General Terms</h2>\n<p>\nIf a court with authority over this Contract finds any part of it not enforceable, you and us agree that the court should modify the terms to make that part enforceable while still achieving its intent. If the court cannot do that, you and us agree to ask the court to remove that unenforceable part and still enforce the rest of this Contract. To the extent allowed by law, the English language version of this Contract is binding and other translations are for convenience only. This Contract (including additional terms that may be provided by us when you engage with a feature of the Services) is the only agreement between us regarding the Services and supersedes all prior agreements for the Services.\n</p><p>\nIf we don\'t act to enforce a breach of this Contract, that does not mean that Notefield has waived its right to enforce this Contract. You may not assign or transfer this Contract (or your membership or use of Services) to anyone without our consent. However, you agree that Notefield may assign this Contract to its affiliates or a party that buys it without your consent. There are no third party beneficiaries to this Contract.\n</p><p>\nWe reserve the right to change the terms of this Contract and will provide you notice if we do and we agree that changes cannot be retroactive. If you don\'t agree to these changes, you must stop using the Services.\n</p><p>You agree that the only way to provide us legal notice is at the addresses provided in Section 10.</p><h2>\n7. Notefield “Dos” and “Don’ts”</h2><h3>7.1 Dos</h3><h4>You agree that you will:</h4><ul><li>\nComply with all applicable laws, including, without limitation, privacy laws, intellectual property laws, anti-spam laws, export control laws, tax laws, and regulatory requirements;\n</li><li>Provide accurate information to us and keep it updated;</li><li>Use your real name on your profile;</li><li>\nUse the Services in a professional manner.</li></ul><h3>7.2. Don’ts</h3><h4>You agree that you will not:</h4><ul><li>\nAct in an unlawful or unprofessional manner in connection with our Services, including being dishonest, abusive or discriminatory;\n</li><li>\nPost inaccurate, defamatory obscene, shocking, hateful, threatening or otherwise inappropriate content or airing personal grievances or disputes;\n</li><li>Use an image that is not your likeness or a head-shot photo for your profile;</li><li>\nCreate a false identity on Notefield.</li><li>\nMisrepresent your identity (e.g. by using a pseudonym), your current or previous positions, qualifications or affiliations with a person or entity;\n</li><li>Create a Member profile for anyone other than yourself (a real person);</li><li>\nUse or attempt to use another\'s account;</li><li>Harass, abuse or harm another person;</li><li>\nSend or post any unsolicited or unauthorized advertising, “junk mail,” “spam,” “chain letters,” “pyramid schemes,” or any form of solicitation unauthorized by Notefield;\n</li><li>\nDevelop, support or use software, devices, scripts, robots, or any other means or processes (including crawlers, browser plugins and add-ons, or any other technology or manual work) to scrape the Services or otherwise copy profiles and other data from the Services;\n</li><li>Bypass or circumvent any access controls or Service use limits (such as caps on keyword searches);</li><li>\nCopy, use, disclose or distribute any information obtained from the Services, whether directly or through third parties (such as search engines), without the consent of Notefield;\n</li><li>Solicit email addresses or other personal information from Members you don’t know, without authorization.</li>\n<li>Use, disclose or distribute any data obtained in violation of this policy;</li><li>\nDisclose information that you do not have the consent to disclose (such as confidential information of others (including your employer));\n</li><li>\nViolate the intellectual property rights of others, including copyrights, patents, trademarks, trade secrets, or other proprietary rights. For example, do not copy or distribute (except through the available sharing functionality) the posts or other content of others without their permission, which they may give by posting under a Creative Commons license;\n</li><li>\nViolate the intellectual property or other rights of Notefield, including, without limitation, (i) copying or distributing our learning videos or other materials or (ii) copying or distributing our technology, unless it is released under open source licenses;\n</li><li>Post anything that contains software viruses, worms, or any other harmful code;</li><li>\nManipulate identifiers in order to disguise the origin of any message or post transmitted through the Services.</li>\n<li>Create profiles or provide content that promotes escort services or prostitution.</li><li>\nCreate or operate a pyramid scheme, fraud or other similar practice;</li><li>\nReverse engineer, decompile, disassemble, decipher or otherwise attempt to derive the source code for the Services or any related technology that is not open source;\n</li><li>\nImply or state that you are affiliated with or endorsed by Notefield without our express consent (e.g., representing yourself as an accredited Notefield trainer);\n</li><li>Rent, lease, loan, trade, sell/re-sell access to the Services or related data;</li><li>\nSell, sponsor, or otherwise monetize any Service without Notefield\'s consent;</li><li>\nDeep-link to our Services for any purpose other than to promote your profile or a Group on our Services, without Notefield\'s consent;\n</li><li>Remove any copyright, trademark or other proprietary rights notices contained in or on our Service;</li><li>\nRemove, cover or obscure any advertisement included on the Services;</li><li>\nUse bots or other automated methods to access the Services, add or download contacts, send or redirect messages;</li>\n<li>Monitor the Services’ availability, performance or functionality for any competitive purpose;</li><li>\nEngage in “framing,” “mirroring,” or otherwise simulating the appearance or function of the Services;</li><li>\nOverlaying or otherwise modifying the Services or their appearance;</li><li>\nAccess the Services except through the interfaces expressly provided by Notefield;</li><li>\nUse a Service for tasks that it is not intended for;</li><li>Override any security feature of the Services;</li><li>\nInterfere with the operation of, or place an unreasonable load on, the Services (e.g., spam, denial of service attack, viruses, gaming algorithms); and/or\n</li><li>\nYou agree that Notefield may terminate your Notefield Service immediately if a form created or Notefield is found to be used inside an unsolicited email.\n</li><li>\nYou agree that you will not use Notefield or any form(s) you create using Notefield for scamming purposes to attract, lure, or illegally obtain payment of any sort from others by unjustifiable means such as posting a Notefield as a money-making program on a classified ads site as an example of that. Any account reported or found doing so will be immediately suspended.\n</li><li>\nYou agree that Notefield may terminate your Notefield Service immediately if a form\'s purpose is found to be deceptively obtaining: sensitive credit card information, social security numbers, user login credentials, or other sensitive personal information. All these activities are considered as Phishing and any account along with the violating forms will be suspended immediately.\n</li><li>\nYou may not use the Notefield to collect certain types of sensitive information, including but not limited to credit card information and any type of login credentials. You may collect some sensitive information such as social security numbers or driver’s license numbers. You are solely responsible for compliance with any data protection and privacy laws and rules applicable to the sensitive information.\n</li></ul></div></div>");
$templateCache.put("app/main/apps/messaging/messaging.html","<div id=\"messaging-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\"><div class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/messaging/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" class=\"s128 md-accent\" \nmd-font-icon=\"icon-hangouts\"></md-icon></div></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar \nclass=\"chat-toolbar\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.gotoContactPublicProfile()\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).PhotoURL}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).DisplayName}}\"></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).DisplayName}}</div></div><md-menu md-position-mode=\"target-right target\" \nng-if=\"vm.contacts.getById(vm.chatContactId).LastMessage\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-if=\"vm.contacts.getById(vm.chatContactId).IsRead\"><md-button ng-click=\"vm.markUnread()\" \ntranslate=\"MESSAGING.MARK_AS_UNREAD\">Mark as unread</md-button></md-menu-item><md-menu-item \nng-if=\"!vm.contacts.getById(vm.chatContactId).IsRead\"><md-button ng-click=\"vm.markRead()\" \ntranslate=\"MESSAGING.MARK_AS_READ\">Mark as read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteChatConfirm($event)\" translate=\"MESSAGING.DELETE\">Delete</md-button></md-menu-item><md-menu-item \nng-if=\"!vm.contacts.getById(vm.chatContactId).IsArchived\"><md-button ng-click=\"vm.sendtoArchive()\" \ntranslate=\"MESSAGING.ARCHIVE\">Archive</md-button></md-menu-item><md-menu-item \nng-if=\"vm.contacts.getById(vm.chatContactId).IsArchived\"><md-button ng-click=\"vm.restore()\" \ntranslate=\"MESSAGING.RESTORE\">Restore</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar>\n<md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" ng-if=\"vm.chat\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.Type\"><img ng-if=\"dialog.Type ===\'I\'\" \nng-src=\"{{vm.contacts.getById(vm.chatContactId).PhotoURL}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).DisplayName}}\"> <img ng-if=\"dialog.Type ===\'O\'\" class=\"avatar\" \nng-src=\"{{vm.user.photoURL}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.Text}}</div><div \nclass=\"time secondary-text\">{{dialog.Date | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"MESSAGING.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"MESSAGING.SEND_MESSAGE\"><md-icon \nmd-font-icon=\"icon-send\"></md-icon></md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/pages/app-console/app-console.html","<div id=\"app-console\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"md-title font-weight-300\"><span translate=\"APP-CONSOLE.WELCOME_TO_NOTEFIELD\">\nWelcome to Notefield!</span></div><div class=\"md-display-1 font-weight-400\"><span \ntranslate=\"APP-CONSOLE.GET_STARTED_HERE\">Get started here.</span></div></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"space-around center\" class=\"create-company-row\"><div layout=\"column\" layout-align=\"space-between center\">\n<md-button class=\"md-fab md-primary create-company-btn\" aria-label=\"Create company page\" flex=\"none\" \nui-sref=\"app.my-company_create-company-page\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nlayout=\"column\" flex><span class=\"md-title\" translate=\"APP-CONSOLE.CREATE_A_COMPANY_PAGE\">Create a company page</span> \n<small>Design forms</small> <small>Share with users</small> <small>Add approval process</small></div></div><iframe \nclass=\"video-frame\" data-autohide=\"1\" data-showinfo=\"0\" frameborder=\"0\" allowfullscreen=\"\" id=\"\" data-enablejsapi=\"1\" \nsrc=\"//www.youtube.com/embed/G9hw08X46R8?enablejsapi=1\" origin=\"https://www.notefield.com\"></iframe></div></div><div \nclass=\"content\"><div flex-xs layout-xs=\"column\" layout-gt-xs=\"row\" layout-wrap layout-align=\"center center\"><md-card \nclass=\"info-card\"><img ng-src=\"/assets/images/etc/console_mys.png\" class=\"md-card-image\" alt=\"My Submissions\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">My Submissions</span></md-card-title-text></md-card-title>\n<md-card-content><p>Display all the forms you have submitted. Preview forms and track the form process.</p>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ui-sref=\"app.home.guides\">\nLearn more</md-button><md-button ui-sref=\"app.pages_my-submissions\">Get Started</md-button></md-card-actions></md-card>\n<md-card class=\"info-card\"><img ng-src=\"/assets/images/etc/console_shw.png\" class=\"md-card-image\" alt=\"Shared With Me\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">Shared With Me</span></md-card-title-text></md-card-title>\n<md-card-content><p>View a list of forms shared by other users with you and fill out a new form.</p></md-card-content>\n<md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ui-sref=\"app.home.guides\">Learn more</md-button>\n<md-button ui-sref=\"app.pages_shared-withme\">Get Started</md-button></md-card-actions></md-card><md-card \nclass=\"info-card\"><img ng-src=\"/assets/images/etc/console_wfm.png\" class=\"md-card-image\" alt=\"Waiting For Me\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">Waiting For Me</span></md-card-title-text></md-card-title>\n<md-card-content><p>View a list of pending forms for approval or access the archives of your approved forms.</p>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ui-sref=\"app.home.guides\">\nLearn more</md-button><md-button ui-sref=\"app.pages_waiting-forme.pending-forms\">Get Started</md-button>\n</md-card-actions></md-card></div></div></div></div>");
$templateCache.put("app/main/pages/my-submissions/my-submissions.html","<div id=\"my-submissions\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" \nflex><div class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><div class=\"right-side\" layout=\"row\"><md-button \nng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"MFS.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"MFS.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"MFS.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"MFS.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"form-header text-truncate\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"MFS.MY_SUBMISSIONS\">My Submissions</span></div></div></div>\n<md-content class=\"content\" flex ms-scroll><table class=\"simple\"><thead><tr><th translate=\"MFS.PREVIEW\">Preview</th><th\n translate=\"MFS.CREATED\">Created</th><th translate=\"MFS.FORM_NAME\">Form Name</th><th translate=\"MFS.COMPANY_NAME\">\nCompany Name</th><th translate=\"MFS.FORM_ID\">Form Id</th><th translate=\"MFS.STATUS\">Status</th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"form in vm.forms | orderBy:\'-DateCreated\' | filter:global.search\" ng-click=\"vm.select(form)\" \nng-class=\"{\'selected\' : vm.selected === form}\"><td><md-button class=\"md-icon-button\" \nng-click=\"vm.openViewFormDialog(form, $event)\" aria-label=\"Preview form\" translate \ntranslate-attr-aria-label=\"MFS.PREVIEW_FORM\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span \ntranslate=\"MFS.PREVIEW_FORM\">Preview form</span></md-tooltip></md-button></td><td>{{form.DateCreated | altDate}}</td>\n<td>{{form.DesignFormName}}</td><td>{{form.CompanyName}}</td><td class=\"form-key\">{{form.FormKey}}</td><td \nclass=\"form-status\"><md-icon class=\"status-pending\" ng-if=\"form.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon>\n<md-icon class=\"status-completed\" ng-if=\"form.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></td><td \nclass=\"show-details\"><md-button hide-gt-md class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" \naria-label=\"Details\" translate translate-attr-aria-label=\"MFS.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table><div \nclass=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.forms.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"MFS.NO_DATA_MSG\" \ntranslate-attr-aria-label=\"MFS.NO_DATA_MSG\">There is no data to show right now.</span></div></div></md-content></div>\n<md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"form-detail-sidenav\" ng-include=\"\'app/main/pages/my-submissions/sidenavs/form-process-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/pages/notifications/notifications.html","<div id=\"notifications\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<div class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div></div>\n<div class=\"form-header text-truncate\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"NOTIFICATIONS.NOTIFICATIONS\">Notifications</span></div></div></div><md-content class=\"content\" layout=\"row\" \nms-scroll><div flex-xs=\"100\" flex-gt-xs=\"66\" flex-offset-gt-xs=\"15\" class=\"notification-panel\"><div \nclass=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.notifications.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"NOTIFICATIONS.NO_NOTIFICATION_MSG\" \ntranslate-attr-aria-label=\"NOTIFICATIONS.NO_NOTIFICATION_MSG\">There is no notification to show right now.</span></div>\n</div><div class=\"notification-item md-whiteframe-1dp\" \nng-repeat=\"notification in vm.notifications | orderBy:\'-data.Date\'\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div ng-if=\"notification.data.Type==\'fa\'\" class=\"user\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"/person/{{notification.data.UID}}\"><img class=\"avatar\" \nng-src=\"{{notification.userPhotoURL}}\"></a><div layout=\"column\"><div class=\"title\"><a \nhref=\"/my-company/{{notification.data.CompanyKey}}/my-forms/{{notification.data.DesignFormKey}}/submissions\"><span \nclass=\"username md-accent-color\">{{notification.userDisplayName}}</span> <span translate \ntranslate-attr-aria-label=\"NOTIFICATIONS.TYPE_FA\">submitted a new form </span>\n&nbsp({{notification.data.DesignFormName}})</a></div><div class=\"time\">{{notification.data.Date | altDate}}</div></div>\n</div><div ng-if=\"notification.data.Type==\'shw\'\" class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/company/{{notification.companyURL}}\"><img class=\"avatar\" ng-src=\"{{notification.companyPhotoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/pages/shared-withme\"><span class=\"username md-accent-color\">\n{{notification.companyName}}</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_SHW\">\nshared a form with you </span>&nbsp({{notification.data.DesignFormName}})</a></div><div class=\"time\">\n{{notification.data.Date | altDate}}</div></div></div><div \nng-if=\"notification.data.Type==\'wfm\' && !notification.data.Action\" class=\"user\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"/person/{{notification.data.UID}}\"><img class=\"avatar\" \nng-src=\"{{notification.userPhotoURL}}\"></a><div layout=\"column\"><div class=\"title\"><a \nhref=\"/pages/waiting-forme/pending-forms\"><span class=\"username md-accent-color\">{{notification.userDisplayName}}\n</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_WFM\">submitted a new form </span><span>\n({{notification.data.DesignFormName}})</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_WFM2\">\nand now it\'s waiting for your approval.</span></a></div><div class=\"time\">{{notification.data.Date | altDate}}</div>\n</div></div><div ng-if=\"notification.data.Type==\'wfm\' && notification.data.Action ==\'Approve\'\" class=\"user\" \nlayout=\"row\" layout-align=\"start center\"><a href=\"/person/{{notification.data.UID}}\"><img class=\"avatar\" \nng-src=\"{{notification.userPhotoURL}}\"></a><div layout=\"column\"><div class=\"title\"><a \nhref=\"/pages/waiting-forme/pending-forms\"><span class=\"username md-accent-color\">{{notification.userDisplayName}}\n</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_WFM3\">approved a form </span><span>\n({{notification.data.DesignFormName}})</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_WFM\">\nand now it\'s waiting for your approval.</span></a></div><div class=\"time\">{{notification.data.Date | altDate}}</div>\n</div></div><div ng-if=\"notification.data.Type==\'cmp\' && notification.data.Action ==\'Approve\'\" class=\"user\" \nlayout=\"row\" layout-align=\"start center\"><a href=\"/person/{{notification.data.UID}}\"><img class=\"avatar\" \nng-src=\"{{notification.userPhotoURL}}\"></a><div layout=\"column\"><div class=\"title\"><a href=\"/pages/my-submissions\">\n<span class=\"username md-accent-color\">{{notification.userDisplayName}}</span> <span translate \ntranslate-attr-aria-label=\"NOTIFICATIONS.TYPE_CMP\">approved your form</span> <span>\n({{notification.data.DesignFormName}})</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_CMP2\">\nand now process complete.</span></a></div><div class=\"time\">{{notification.data.Date | altDate}}</div></div></div><div \nng-if=\"notification.data.Type==\'cmp\' && notification.data.Action ==\'Reject\'\" class=\"user\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"/person/{{notification.data.UID}}\"><img class=\"avatar\" \nng-src=\"{{notification.userPhotoURL}}\"></a><div layout=\"column\"><div class=\"title\"><a href=\"/pages/my-submissions\">\n<span class=\"username md-accent-color\">{{notification.userDisplayName}}</span> <span translate \ntranslate-attr-aria-label=\"NOTIFICATIONS.TYPE_CMP3\">rejected your form</span> <span>\n({{notification.data.DesignFormName}})</span> <span translate translate-attr-aria-label=\"NOTIFICATIONS.TYPE_CMP2\">\nand now process complete.</span></a></div><div class=\"time\">{{notification.data.Date | altDate}}</div></div></div>\n<md-menu><md-button class=\"md-icon-button\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"NOTIFICATIONS.OPTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deleteNotification(notification.key)\" translate=\"NOTIFICATIONS.DELETE\">Delete</md-button></md-menu-item>\n</md-menu-content></md-menu></header><div class=\"content\"><div layout=\"row\" layout-align=\"start center\"></div></div>\n</div></div></md-content></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between end\"><div class=\"user-info\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\">\n<img class=\"profile-image avatar huge\" src=\"{{vm.profile.photoURL}}\"><div class=\"img-buttons\" layout=\"row\" \nlayout-align=\"center center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"Menu\" translate \ntranslate-attr-aria-label=\"PROFILE.Menu\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nng-click=\"vm.openMenu($mdMenu, $event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.changeProfilePicture($event)\" translate=\"PROFILE.CHANGE_PICTURE\">Change picture</md-button></md-menu-item>\n<md-menu-item ng-show=\"vm.showRemoveProfilePictureMenu\"><md-button ng-click=\"vm.removeProfilePicture($event)\" \ntranslate=\"PROFILE.REMOVE_PICTURE\">Remove picture</md-button></md-menu-item><md-menu-item \nng-show=\"vm.showRemoveProfileBgPictureMenu\"><md-button ng-click=\"vm.removeProfileBg($event)\" \ntranslate=\"PROFILE.REMOVE_BACKGROUND\">Remove background</md-button></md-menu-item></md-menu-content></md-menu></div>\n</div><div class=\"name\">{{vm.profile.firstName}} {{vm.profile.lastName}}</div></div></div><div class=\"content\" flex>\n<md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.ACCOUNT\">Account</span></md-tab-label>\n<md-tab-body><md-content class=\"account-tab\" ng-include=\"\'app/main/pages/profile/tabs/account/account.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/public-company/public-company.html","<div id=\"public-company\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div layout=\"column\">\n<img class=\"profile-image avatar huge\" src=\"{{vm.companyPage.photoURL}}\"></div><div class=\"name\">\n{{vm.companyPage.companyName}}</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-accent follow-unfollow-btn\" aria-label=\"Unfollow\" ng-if=\"vm.isFollow\" \nng-click=\"vm.unFollowCompanyPage()\"><span ng-hide=\"vm.isFollowingMouseOver\" translate=\"PUBLIC_COMPANY.FOLLOWING\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.FOLLOWING\" ng-mouseover=\"vm.followingOnMouseOver()\">Following </span><span \nng-show=\"vm.isFollowingMouseOver\" translate=\"PUBLIC_COMPANY.UNFOLLOW\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.UNFOLLOW\" ng-mouseleave=\"vm.followingOnMouseLeave()\">Unfollow</span>\n</md-button><md-button class=\"md-raised md-accent follow-unfollow-btn\" aria-label=\"Follow\" \ntranslate=\"PUBLIC_COMPANY.FOLLOW\" translate-attr-aria-label=\"PUBLIC_COMPANY.FOLLOW\" ng-if=\"!vm.isFollow\" \nng-click=\"vm.followCompanyPage()\">Follow</md-button><md-button class=\"md-raised md-primary\" \ntranslate=\"PUBLIC_COMPANY.SEND_MESSAGE\" translate-attr-aria-label=\"PUBLIC_COMPANY.SEND_MESSAGE\" \nng-click=\"vm.gotoMessaging()\">Send Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height>\n<md-tab><md-tab-label><span translate=\"PUBLIC_COMPANY.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content \nclass=\"timeline-tab\" ng-include=\"\'app/main/pages/public-company/tabs/timeline/timeline.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/public-person/public-person.html","<div id=\"public-person\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div layout=\"column\">\n<img class=\"profile-image avatar huge\" src=\"{{vm.personPage.photoURL}}\"></div><div class=\"name\">\n{{vm.personPage.displayName}}</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.user.uid!=vm.personPage.key\"><md-button class=\"md-raised md-accent follow-unfollow-btn\" \naria-label=\"Unfollow\" ng-if=\"vm.isFollow\" ng-click=\"vm.unFollowPersonPage()\"><span ng-hide=\"vm.isFollowingMouseOver\" \ntranslate=\"PUBLIC_PERSON.FOLLOWING\" translate-attr-aria-label=\"PUBLIC_PERSON.FOLLOWING\" \nng-mouseover=\"vm.followingOnMouseOver()\">Following </span><span ng-show=\"vm.isFollowingMouseOver\" \ntranslate=\"PUBLIC_PERSON.UNFOLLOW\" translate-attr-aria-label=\"PUBLIC_PERSON.UNFOLLOW\" \nng-mouseleave=\"vm.followingOnMouseLeave()\">Unfollow</span></md-button><md-button \nclass=\"md-raised md-accent follow-unfollow-btn\" aria-label=\"Follow\" translate=\"PUBLIC_PERSON.FOLLOW\" \ntranslate-attr-aria-label=\"PUBLIC_PERSON.FOLLOW\" ng-if=\"!vm.isFollow\" ng-click=\"vm.followPersonPage()\">Follow\n</md-button><md-button class=\"md-raised md-primary\" translate=\"PUBLIC_PERSON.SEND_MESSAGE\" \ntranslate-attr-aria-label=\"PUBLIC_PERSON.SEND_MESSAGE\" ng-click=\"vm.gotoMessaging()\">Send Message</md-button></div>\n</div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab ng-if=\"vm.user\"><md-tab-label><span \ntranslate=\"PUBLIC_PERSON.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/public-person/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"form-header text-truncate\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"SEARCH.SEARCH\">Search</span></div></div></div><md-content class=\"content\" \nflex ms-scroll><md-tabs md-dynamic-height md-autoselect md-selected=\"vm.activeTab\"><md-tab \nui-sref=\"app.pages_search.company\"><md-tab-label><span translate=\"SEARCH.COMPANY\">Company</span></md-tab-label>\n<md-tab-body><div class=\"company-tab\" ui-view=\"company\"></div></md-tab-body></md-tab><md-tab \nui-sref=\"app.pages_search.person\"><md-tab-label><span translate=\"SEARCH.PERSON\">Person</span></md-tab-label>\n<md-tab-body><div class=\"person-tab\" ui-view=\"person\"></div></md-tab-body></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/pages/shared-withme/shared-withme.html","<div id=\"shared-withme\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<div class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><div class=\"right-side\" layout=\"row\"><md-button \nng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"SW.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SW.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"SW.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"SW.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"form-header\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"SW.SHARED_WITH_ME\">Shared With Me</span></div></div></div><md-content \nclass=\"content\" flex ms-scroll><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/main/pages/shared-withme/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" \nng-include=\"\'app/main/pages/shared-withme/views/list/list-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation ng-if=\"vm.user\" class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>\n<div ng-if=\"!vm.user\" layout=\"column\" class=\"btn-section text-center\"><p>Login to Notefield now</p><md-button \nclass=\"md-raised login-button\" ui-sref=\"app.pages_auth_login\" translate=\"HOME.LOGIN\">Log in</md-button><p>OR</p><p>\nJoin Notefield now and start to use web forms online.</p><md-button class=\"md-raised join-button\" \nui-sref=\"app.pages_auth_signup\" translate=\"HOME.GET_STARTED\">Get Started</md-button></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div hide-xs \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" ui-sref=\"app.home\"><img \nsrc=\"assets/images/logos/notefield-logo.png\" alt=\"Notefield\" style=\"width:32px\"> <span class=\"logo-text\">Notefield\n</span></div><div class=\"toolbar-separator\"></div><md-button ng-if=\"vm.uid\" id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button ng-if=\"vm.uid\" class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button><div\n class=\"toolbar-separator\"></div></div><div ng-if=\"vm.uid\" layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><div class=\"search-panel\" hide-xs><md-autocomplete \nng-disabled=\"vm.search.isDisabled\" md-no-cache=\"vm.search.noCache\" md-selected-item=\"vm.search.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.profileSearch(vm.searchText)\" \nmd-item-text=\"item.displayName\" md-min-length=\"1\" md-clear-button=\"true\" placeholder=\"Search\" \nmd-menu-class=\"search-autocomplete-template\"><md-item-template><span class=\"item-title\" \nng-if=\"item.type==\'profile-person\' || item.type==\'profile-company\'\"><img ng-src=\"{{item.photoURL}}\" \nclass=\"md-avatar avatar\" alt=\"{{item.displayName}}\"> <span>{{item.displayName}} </span><span class=\"country\">\n{{item.countryName}} </span></span><span class=\"show-all\" ng-if=\"item.type==\'search-person\'\"><span class=\"link\" \ntranslate=\"TOOLBAR.SEARCH_PEOPLE\">Search person for</span>\"{{vm.searchText}}\" </span><span class=\"show-all\" \nng-if=\"item.type==\'search-company\'\"><span class=\"link\" translate=\"TOOLBAR.SEARCH_COMPANIES\">Search company for</span>\n\"{{vm.searchText}}\"</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div\n class=\"shortcut\"><md-button class=\"md-icon-button shortcut\" aria-label=\"\" ui-sref=\"app.pages_app-console\"><md-icon \nmd-font-icon=\"icon-home\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\"><div translate=\"TOOLBAR.HOME\">\nHome</div></md-tooltip></md-button></div><div class=\"shortcut\" ui-sref=\"app.messaging\"><md-button \nclass=\"md-icon-button\" aria-label=\"\"><md-icon md-font-icon=\"icon-hangouts\" class=\"icon s24\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><div translate=\"TOOLBAR.MESSAGING\">Messaging</div></md-tooltip></md-button><span \nng-if=\"vm.newMessageTotal>0\" class=\"badge\">{{vm.newMessageTotal}}</span></div><div class=\"shortcut\" \nui-sref=\"app.pages_notifications\"><md-button class=\"md-icon-button shortcut\" aria-label=\"\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\"><div \ntranslate=\"TOOLBAR.NOTIFICATIONS\">Notifications</div></md-tooltip></md-button><span ng-if=\"vm.newNotificationTotal>0\" \nclass=\"badge\">{{vm.newNotificationTotal}}</span></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.user.PhotoURL}}\"></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.MY_PROFILE\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.messaging\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.MESSAGING\">Messaging</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.my-company_create-company-page\"><md-icon md-font-icon=\"icon-plus-box\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.CREATE_COMPANY_PAGE\">Create Company Page</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\" hidden><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div></div><div ng-if=\"!vm.uid\" class=\"login-panel\"><md-button md-no-ink \nui-sref=\"app.pages_auth_login\" translate=\"HOME.LOGIN\">Log in</md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/dashboards/main/dashboard-main.html","<div id=\"dashboard-main\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"md-display-1 font-weight-300\"><span translate=\"DASHBOARD.WELCOME_BACK\">\nWelcome back,</span>{{vm.user.displayName}}</div></div><div layout=\"row\"><div class=\"selected-form\">\n{{vm.selectedForm.Name}}</div><md-menu id=\"forms-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button form-selector\" ng-click=\"$mdMenu.open()\" aria-label=\"Select form\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"form in vm.forms\"><md-button ng-click=\"vm.selectForm(form)\" \naria-label=\"{{form.Name}}\"><span ng-class=\"{\'secondary-text\': vm.selectedForm == form}\">{{form.Name}}</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height>\n<md-tab label=\"Home\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget_SubmittedForms.currentRange\" ng-change=\"vm.loadSubmittedFormsWidget()\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget_SubmittedForms.ranges\" value=\"{{key}}\">{{range}}</md-option>\n</md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.widget_SubmittedForms.data.count[vm.widget_SubmittedForms.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget_SubmittedForms.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget_SubmittedForms.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget_SubmittedForms.data.extra.count[vm.widget_SubmittedForms.currentRange]}}</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap>\n<div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" \nng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div>\n<div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" \nconfig=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\">\n</nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}\n</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">{{vm.widget10.title}}</div><table \nclass=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">\n{{cell.value}} </span><i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/apps/my-company/create-company-page/create-company-page.html","<div id=\"create-company-page\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header md-accent-bg\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"info-panel\" layout=\"column\" layout-align=\"start-center\"><md-icon md-font-icon=\"icon-file-document\"></md-icon>\n<div class=\"title\">Create forms</div><p class=\"desc\">Create forms and define approval process for users on forms.</p>\n</div><div class=\"info-panel\" layout=\"column\" layout-align=\"start-center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><div class=\"title\">Build Relationships</div><p class=\"desc\">\nPost on your company wall and engage your audience</p></div><div class=\"info-panel\" layout=\"column\" \nlayout-align=\"start-center\"><md-icon md-font-icon=\"icon-chart-bar\"></md-icon><div class=\"title\">Analyze Submissions\n</div><p class=\"desc\">View submitted form reports and statistics.</p></div></div></div><md-content class=\"content\" \nflex ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"createCompanyForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.submitForm($event, createCompanyForm)\"><div class=\"form-title\" \ntranslate=\"CCP.CREATE_COMPANY_PAGE\">Create company page</div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"companyName\" ng-model=\"vm.form.companyName\" placeholder=\"Company Name\" translate \ntranslate-attr-placeholder=\"CCP.COMPANY_NAME\" ng-minlength=\"3\" ng-maxlength=\"100\" required><div \nng-messages=\"createCompanyForm.companyName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CCP.REQUIRED\">Required.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"CCP.CREATE_COMPANY_NAME_MIN_LENGTH_WARNING\">Company name can\'t be shorter than 3 characters</span></div><div\n ng-message=\"maxlength\"><span translate=\"CCP.CREATE_COMPANY_NAME_MAX_LENGTH_WARNING\">\nCompany name can\'t be longer than 100 characters</span></div></div></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" value=\"notefield.com/company/\" \naria-label=\"notefield.com/company\" disabled=\"disabled\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"companyURL\" ng-model=\"vm.form.companyURL\" aria-label=\"Your Company URL\" translate \ntranslate-attr-placeholder=\"CCP.YOUR_COMPANY_URL\" required ng-pattern=\"/^[a-z0-9._-]*$/\" ng-minlength=\"3\" \nng-maxlength=\"40\"><div ng-messages=\"createCompanyForm.companyURL.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"CCP.CREATE_COMPANY_URL_VALIDATION_WARNING\">Validation error</span></div><div ng-message=\"minlength\"><span \ntranslate=\"CCP.CREATE_COMPANY_URL_MIN_LENGTH_WARNING\">URL can\'t be shorter than 3 characters</span></div><div \nng-message=\"maxlength\"><span translate=\"CCP.CREATE_COMPANY_URL_MAX_LENGTH_WARNING\">\nURL can\'t be longer than 40 characters</span></div></div></md-input-container></div><div class=\"url-info\" \ntranslate=\"CCP.CREATE_COMPANY_URL_INFO_MSG\">\nNotefield members and search engines will use this unique URL to find your page. Once set, this URL cannot be changed later.\n</div><md-divider></md-divider><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><span class=\"terms-info\" \ntranslate=\"CCP.CREATE_COMPANY_READ_ACCEPT_MSG\">\nI verify that I am the official representative of this company and have the right to act on behalf of the company in the creation of this page.\n</span></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Create\" \nng-disabled=\"createCompanyForm.$invalid || createCompanyForm.$pristine\" translate=\"CCP.CREATE\">CREATE</md-button>\n</form></div></md-content></div></div>");
$templateCache.put("app/main/apps/my-company/my-company-dashboard/my-company-dashboard.html","<div id=\"dashboard-main\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"md-display-1 font-weight-300\"><span translate=\"MCD.DASHBOARD\">Dashboard</span>\n</div></div><div layout=\"row\"><div class=\"selected-form\">{{vm.selectedForm.Name}}</div><md-menu id=\"forms-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button form-selector\" ng-click=\"$mdMenu.open()\" aria-label=\"Select form\" \nmd-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content\n width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"form in vm.forms\"><md-button \nng-click=\"vm.selectForm(form)\" aria-label=\"{{form.Name}}\"><span ng-class=\"{\'secondary-text\': vm.selectedForm == form}\">\n{{form.Name}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"Home\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget_SubmittedForms.currentRange\" ng-change=\"vm.loadSubmittedFormsWidget()\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget_SubmittedForms.ranges\" value=\"{{key}}\">{{range}}</md-option>\n</md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.widget_SubmittedForms.data.count[vm.widget_SubmittedForms.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget_SubmittedForms.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget_SubmittedForms.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget_SubmittedForms.data.extra.count[vm.widget_SubmittedForms.currentRange]}}</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget_ApprovalsWaiting.title}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget_ApprovalsWaiting.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget_ApprovalsWaiting.data.label}}</div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget_SharedUsers.title}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget_SharedUsers.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget_SharedUsers.data.label}}</div></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget_ResponseDistribution.title}}</div><div class=\"pv-16\">\n<md-select class=\"simplified\" ng-model=\"vm.widget_ResponseDistribution.currentQuestion\" \nng-change=\"vm.widget_ResponseDistribution.changeQuestion(vm.widget_ResponseDistribution.currentQuestion)\" \naria-label=\"Change Question\" placeholder=\"Select Question\"><md-option \nng-repeat=\"(key, text) in vm.widget_ResponseDistribution.questions\" value=\"{{key}}\">{{text}}</md-option></md-select>\n</div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget_ResponseDistribution.mainChart.config\" \noptions=\"vm.widget_ResponseDistribution.mainChart.options\" data=\"vm.widget_ResponseDistribution.mainChart.data\"></nvd3>\n</div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-32\">{{vm.widget_ResponseDistribution.footerLeft.count}}</span> <span class=\"h4\">\n{{vm.widget_ResponseDistribution.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget_ResponseDistribution.footerRight.count}}</span> <span class=\"h4\">\n{{vm.widget_ResponseDistribution.footerRight.title}}</span></div></div></ms-widget-front></ms-widget></div></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/apps/my-company/my-company-messages/my-company-messages.html","<div id=\"my-company-messages\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\"><div class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/my-company/my-company-messages/sidenavs/left/left-sidenav.html\'\" layout=\"column\">\n</md-sidenav><div class=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" class=\"s128 md-accent\" \nmd-font-icon=\"icon-hangouts\"></md-icon></div></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar \nclass=\"chat-toolbar\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.gotoContactPublicProfile()\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).PhotoURL}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).DisplayName}}\"></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).DisplayName}}</div></div><md-menu md-position-mode=\"target-right target\" \nng-if=\"vm.contacts.getById(vm.chatContactId).LastMessage\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-if=\"vm.contacts.getById(vm.chatContactId).IsRead\"><md-button ng-click=\"vm.markUnread()\" \ntranslate=\"MCM.MARK_AS_UNREAD\">Mark as unread</md-button></md-menu-item><md-menu-item \nng-if=\"!vm.contacts.getById(vm.chatContactId).IsRead\"><md-button ng-click=\"vm.markRead()\" translate=\"MCM.MARK_AS_READ\">\nMark as read</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteChatConfirm($event)\" \ntranslate=\"MCM.DELETE\">Delete</md-button></md-menu-item><md-menu-item \nng-if=\"!vm.contacts.getById(vm.chatContactId).IsArchived\"><md-button ng-click=\"vm.sendtoArchive()\" \ntranslate=\"MCM.ARCHIVE\">Archive</md-button></md-menu-item><md-menu-item \nng-if=\"vm.contacts.getById(vm.chatContactId).IsArchived\"><md-button ng-click=\"vm.restore()\" translate=\"MCM.RESTORE\">\nRestore</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex \nms-scroll><div class=\"chat-messages\" ng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" \nclass=\"md-padding message-row\" ng-class=\"dialog.Type\"><img ng-if=\"dialog.Type ===\'I\'\" \nng-src=\"{{vm.contacts.getById(vm.chatContactId).PhotoURL}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).DisplayName}}\"> <img ng-if=\"dialog.Type ===\'O\'\" class=\"avatar\" \nng-src=\"{{vm.companyPage.photoURL}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.Text}}</div><div \nclass=\"time secondary-text\">{{dialog.Date | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"MCM.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"MCM.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\">\n</md-icon></md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/apps/my-company/my-company-page/my-company-page.html","<div id=\"my-company-page\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between end\"><div class=\"user-info\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\">\n<img class=\"company-image avatar huge\" src=\"{{vm.company.Photo.PhotoURL}}\"><div class=\"img-buttons\" layout=\"row\" \nlayout-align=\"center center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"Menu\" translate \ntranslate-attr-aria-label=\"MCP.Menu\"><md-icon md-menu-origin md-font-icon=\"icon-menu\" \nng-click=\"vm.openMenu($mdMenu, $event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.changeCompanyPicture($event)\" translate=\"MCP.CHANGE_PICTURE\">Change picture</md-button></md-menu-item>\n<md-menu-item ng-show=\"vm.showRemoveCompanyPictureMenu\"><md-button ng-click=\"vm.removeCompanyPicture($event)\" \ntranslate=\"MCP.REMOVE_PICTURE\">Remove picture</md-button></md-menu-item><md-menu-item \nng-show=\"vm.showRemoveCompanyBgPictureMenu\"><md-button ng-click=\"vm.removeCompanyBg($event)\" \ntranslate=\"MCP.REMOVE_BACKGROUND\">Remove background</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<div class=\"name\">{{vm.company.CompanyName}}</div></div></div><div class=\"content\" flex><div \nclass=\"company-about-container md-background-bg md-whiteframe-1dp\"><form id=\"companyForm\" name=\"companyForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\"><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float><input type=\"text\" value=\"notefield.com/company/\" aria-label=\"notefield.com/company\" disabled=\"disabled\">\n</md-input-container><md-input-container flex><label translate=\"MCP.YOUR_COMPANY_URL\">Your company URL</label><input \ntype=\"text\" name=\"url\" ng-value=\"vm.company.CompanyURL\" disabled=\"disabled\"></md-input-container></div>\n<md-input-container flex><label translate=\"MCP.COMPANY_NAME\">Company Name</label><input type=\"text\" name=\"companyName\" \nng-model=\"vm.company.CompanyName\" required ng-minlength=\"3\" ng-maxlength=\"100\"><div \nng-messages=\"companyForm.companyName.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MCP.REQUIRED\">Required\n</div><div ng-message=\"minlength\"><span translate=\"MCP.COMPANY_NAME_MIN_LENGTH_WARNING\">\nCompany name can\'t be shorter than 3 characters</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"MCP.COMPANY_NAME_MAX_LENGTH_WARNING\">Company name can\'t be longer than 100 characters</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"MCP.ABOUT_US\">About Us</label><textarea type=\"text\" \nname=\"aboutus\" ng-model=\"vm.company.AboutUs\" md-maxlength=\"2000\" rows=\"4\" max-rows=\"10\"></textarea><div class=\"hint\" \ntranslate=\"MCP.ABOUT_US_HINT\">Write description to show on your company page</div><div \nng-messages=\"companyForm.aboutus.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span \ntranslate=\"MCP.COMPANY_ABOUTUS_MAX_LENGTH_WARNING\">About us can\'t be longer than 2000 characters</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"MCP.INDUSTRY\">\nIndustry</label><md-select ng-model=\"vm.company.IndustryCode\"><md-option \nng-repeat=\"item in vm.industryCodes | orderBy:\'name\'\" ng-value=\"item.code\">{{item.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"MCP.PHONE\">Phone</label><input type=\"text\" \naria-label=\"Phone Number\" name=\"phone\" ui-mask-placeholder-char=\"-\" ng-model=\"vm.company.Phone\" \nui-mask=\"(999) 999-9999\" ui-mask-placeholder ui-options=\"{addDefaultPlaceholder:false}\"><div \nng-messages=\"companyForm.phone.$error\"><div ng-message=\"valid\" translate=\"MCP.PHONE_VALID_WARNING\">\nPhone number is not valid</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"MCP.WEBSITE\">Website</label><input type=\"url\" name=\"website\" \nng-model=\"vm.company.Website\" ng-pattern=\"/^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}/\">\n<div ng-messages=\"companyForm.website.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"MCP.ERRORS.WEBSITE_MUST_VALID\">Website must be a valid url</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MCP.EMAIL\">Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.company.Email\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"companyForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"MCP.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"MCP.ADDRESS\">Address</label><textarea type=\"text\" \nname=\"address\" ng-model=\"vm.company.Address\" ng-maxlength=\"200\" rows=\"2\" max-rows=\"4\"></textarea><div \nng-messages=\"companyForm.address.$error\" role=\"alert\"><div ng-message=\"maxlength\"><span \ntranslate=\"MCP.COMPANY_ADDRESS_MAX_LENGTH_WARNING\">Company name can\'t be longer than 200 characters</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"MCP.COUNTRY\">Country</label><md-select \nng-model=\"vm.company.CountryCode\"><md-option ng-repeat=\"item in vm.countryCodes | orderBy:\'name\'\" ng-value=\"item.code\">\n{{item.name}}</md-option></md-select></md-input-container></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Save\" ng-click=\"vm.saveCompany($event)\" translate=\"MCP.SAVE\" \nng-disabled=\"companyForm.$invalid || companyForm.$pristine\">Save</md-button></form></div></div></div>");
$templateCache.put("app/main/apps/my-company/my-forms/my-forms.html","<div id=\"my-forms\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><div class=\"right-side\" layout=\"row\"><md-button \nng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"MF.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"MF.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"MF.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"MF.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"form-header\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"MF.MY_FORMS\">My Forms</span></div></div><div id=\"file-uploader\"><md-button\n class=\"add-file-button md-fab md-warn\" aria-label=\"Add form\" translate translate-attr-aria-label=\"FM.ADD_FILE\" \nng-click=\"vm.openAddFormDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-content\n class=\"content\" flex ms-scroll><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/main/apps/my-company/my-forms/views/grid/grid-view.html\'\"></div><div \nng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/my-company/my-forms/views/list/list-view.html\'\"></div>\n</md-content></div><md-sidenav ng-show=\"vm.selected\" class=\"sidenav details-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"details-sidenav\" \nng-include=\"\'app/main/apps/my-company/my-forms/sidenavs/details/details-sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\" \nng-if=\"!vm.finalPanel\"><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Find your Notefield account</div><form \nname=\"forgotPasswordSearchForm\" novalidate ng-submit=\"vm.checkEmail($event)\"><md-input-container class=\"md-block\" \nmd-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordSearchForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"SEARCH\" \nng-disabled=\"forgotPasswordSearchForm.$invalid || forgotPasswordSearchForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SEARCH\" translate-attr-aria-label=\"FORGOTPASSWORD.SEARCH\">SEARCH</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div><div id=\"final-panel\" class=\"md-whiteframe-8dp\" \nng-if=\"vm.finalPanel\"><div class=\"title\" translate=\"FORGOTPASSWORD.MESSAGES.FINAL_TITLE\">Email sent</div><div \nclass=\"instructions\" translate=\"FORGOTPASSWORD.MESSAGES.FINAL_INSTRUCTIONS\">\nWe just sent you an email to reset your password. Please follow the instructions in the email. If you don’t see our email, check your spam folder.\n</div><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><img \nui-sref=\"app.home\" src=\"assets/images/logos/notefield-logo.png\"></div><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to Notefield</div><form ng-submit=\"vm.login($event)\" name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span\n translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><div \nclass=\"text-center\" style=\"color:red\"><span class=\"text\">{{vm.signinErrorMsg}}</span></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\" \nng-click=\"vm.loginWithGoogle($event)\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon \nmd-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span>\n</span></div></md-button><md-button class=\"md-raised facebook\" ng-click=\"vm.loginWithFacebook($event)\"><div \nlayout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_signup\" translate=\"LOGIN.JOIN_NOW\">Join Now</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/signup/signup.html","<div id=\"signup\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"signup-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"signup-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><img \nui-sref=\"app.home\" src=\"assets/images/logos/notefield-logo.png\"></div><div class=\"title\" translate=\"SIGNUP.TITLE\">\nJoin Notefield for free</div><form ng-submit=\"vm.signup()\" name=\"signupForm\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" \nng-model=\"vm.form.firstname\" placeholder=\"First name\" translate translate-attr-placeholder=\"SIGNUP.FIRST_NAME\" \nrequired ng-maxlength=\"40\"><div ng-messages=\"signupForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"SIGNUP.ERRORS.FIRST_NAME_REQUIRED\">First name field is required</span></div><div ng-message=\"maxlength\">\n<span translate=\"SIGNUP.ERRORS.FIRST_NAME_MAX_LENGTH\">First name can\'t be longer than 40 characters</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input name=\"lastname\" \nng-model=\"vm.form.lastname\" placeholder=\"Last name\" translate translate-attr-placeholder=\"SIGNUP.LAST_NAME\" required \nng-maxlength=\"40\"><div ng-messages=\"signupForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SIGNUP.ERRORS.LAST_NAME_REQUIRED\">Last name field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"SIGNUP.ERRORS.LAST_NAME_MAX_LENGTH\">Last name can\'t be longer than 40 characters</span></div></div>\n</md-input-container></div><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"SIGNUP.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"signupForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"SIGNUP.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"SIGNUP.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"SIGNUP.PASSWORD\" required><div\n ng-messages=\"signupForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SIGNUP.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"terms\"><span translate=\"SIGNUP.READ_ACCEPT\">By clicking Join now, you agree to the Notefield </span><a \nhref=\"terms\" class=\"md-accent-color\" translate=\"SIGNUP.TERMS_COND\">terms and conditions</a></div><div \nclass=\"text-center\" style=\"color:red\"><span class=\"text\">{{vm.signupErrorMsg}}</span></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"JOIN NOW\" \nng-disabled=\"signupForm.$invalid || signupForm.$pristine\" translate=\"SIGNUP.JOIN_NOW\" \ntranslate-attr-aria-label=\"SIGNUP.JOIN_NOW\">JOIN NOW</md-button></form><div class=\"login\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"SIGNUP.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"SIGNUP.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/user-actions/user-actions.html","<div id=\"user-actions\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"user-actions-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"user-actions-form\" class=\"md-whiteframe-8dp\"><div \nng-if=\"vm.action_verifyEmail\"><div class=\"email-verify\" \nng-include=\"\'app/main/pages/auth/user-actions/views/email-verify.html\'\"></div></div><div ng-if=\"vm.action_resetEmail\">\n<div class=\"email-reset\" ng-include=\"\'app/main/pages/auth/user-actions/views/email-reset.html\'\"></div></div><div \nng-if=\"vm.action_emailUnverified\"><div class=\"email-unverified\" \nng-include=\"\'app/main/pages/auth/user-actions/views/email-unverified.html\'\"></div></div><div ng-if=\"vm.action_error\">\n<div class=\"error\" ng-include=\"\'app/main/pages/auth/user-actions/views/error.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><a \nclass=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR404.GO_BACK\">Go back to home</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/pages/my-submissions/sidenavs/form-process-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"></div><div layout=\"row\" layout-align=\"start center\"><div class=\"title\" \ntranslate=\"MFS.PROCESS\">Process</div><div class=\"status-icon\"><md-icon ng-if=\"vm.selected.Status==\'Pending\'\" \nmd-font-icon=\"icon-clock\"></md-icon><md-icon ng-if=\"vm.selected.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\">\n</md-icon></div></div><div class=\"subtitle secondary-text\"><span translate=\"MFS.FORM_ID\">Form Id</span>\n: {{vm.selected.FormKey}}</div></div><md-content class=\"content\" flex ms-scroll><md-list class=\"md-dense\" flex>\n<md-list-item class=\"md-3-line\" ng-repeat=\"item in vm.formTransactions[vm.selected.FormKey] | orderBy:\'DateTime\'\"><img \nng-src=\"{{item.PhotoURL}}\" class=\"md-avatar\" alt=\"\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.UserName }}</h3><h4>{{ item.DateTime | altDate }}</h4><p>{{ item.Action }}</p></div><md-divider></md-divider>\n</md-list-item></md-list></md-content>");
$templateCache.put("app/main/pages/shared-withme/dialogs/fillform-dialog.html","<md-dialog class=\"fillform-dialog\" aria-label=\"Fill Form\"><form id=\"fillForm\" name=\"fillForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"form-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\" ng-init=\"parentIndex = $index\"><div bind-html-compile=\"item.html\">\n</div></li></ul></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submitForm()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"fillForm.$invalid || fillForm.$pristine\" aria-label=\"Submit\" \ntranslate=\"SW.SUBMIT\" translate-attr-aria-label=\"SW.SUBMIT\">SUBMIT</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/waiting-forme/archive/archive.html","<div id=\"waiting-forme-archive\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header md-accent-bg\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" \nflex><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" translate=\"WFM.ARCHIVE\">Archive</div><div \nclass=\"subtitle secondary-text\"><span translate=\"WFM.WAITING_FORME\">Waiting For Me</span></div></div></div></div>\n<md-content class=\"content\" flex ms-scroll><table class=\"simple\"><thead><tr><th translate=\"WFM.PREVIEW\">Preview</th><th\n translate=\"WFM.CREATED\">Created</th><th translate=\"WFM.FORM_NAME\">Form Name</th><th translate=\"WFM.USER_NAME\">\nUser Name</th><th translate=\"WFM.COMPANY_NAME\">Company Name</th><th translate=\"WFM.STATUS\">Status</th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"form in vm.forms | orderBy:\'-DateCreated\' | filter:global.search\" \nng-click=\"vm.select(form)\" ng-class=\"{\'selected\' : vm.selected === form}\"><td><md-button class=\"md-icon-button\" \nng-click=\"vm.openViewFormDialog(form, $event)\" aria-label=\"Preview form\" translate \ntranslate-attr-aria-label=\"WFM.PREVIEW_FORM\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span \ntranslate=\"WFM.PREVIEW_FORM\">Preview form</span></md-tooltip></md-button></td><td>{{form.DateCreated | altDate}}</td>\n<td>{{form.DesignFormName}}</td><td>{{form.UserName}}</td><td>{{form.CompanyName}}</td><td class=\"form-status\"><md-icon\n class=\"status-pending\" ng-if=\"form.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nclass=\"status-completed\" ng-if=\"form.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></td><td \nclass=\"show-details\"><md-button hide-gt-md class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" \naria-label=\"Details\" translate translate-attr-aria-label=\"WFM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table><div \nclass=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.forms.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"WFM.NO_DATA_MSG\" \ntranslate-attr-aria-label=\"WFM.NO_DATA_MSG\">There is no data to show right now.</span></div></div></md-content></div>\n<md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"form-detail-sidenav\" ng-include=\"\'app/main/pages/waiting-forme/sidenavs/form-process-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/pages/waiting-forme/pending-forms/pending-forms.html","<div id=\"waiting-forme-pending-forms\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div ng-if=\"vm.showLoadingPanel\" class=\"overlay\" layout=\"row\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1\"></md-progress-circular></div><div \nclass=\"header md-accent-bg\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\" translate=\"WFM.PENDING_FORMS\">Pending Forms</div><div \nclass=\"subtitle secondary-text\"><span translate=\"WFM.WAITING_FORME\">Waiting For Me</span></div></div></div></div>\n<md-content class=\"content\" flex ms-scroll><table class=\"simple\"><thead><tr><th translate=\"WFM.PREVIEW\">Preview</th><th\n translate=\"WFM.CREATED\">Date</th><th translate=\"WFM.FORM_NAME\">Form Name</th><th translate=\"WFM.USER_NAME\">User Name\n</th><th translate=\"WFM.COMPANY_NAME\">Company Name</th><th translate=\"WFM.STATUS\">Status</th><th \ntranslate=\"WFM.ACTIONS\">Actions</th><th></th></tr></thead><tbody><tr \nng-repeat=\"form in vm.forms | orderBy:\'-DateCreated\' | filter:global.search\" ng-click=\"vm.select(form)\" \nng-class=\"{\'selected\' : vm.selected === form}\"><td><md-button class=\"md-icon-button\" \nng-click=\"vm.openViewFormDialog(form, $event)\" aria-label=\"Preview form\" translate \ntranslate-attr-aria-label=\"WFM.PREVIEW_FORM\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span \ntranslate=\"WFM.PREVIEW_FORM\">Preview form</span></md-tooltip></md-button></td><td>{{form.DateCreated | altDate}}</td>\n<td>{{form.DesignFormName}}</td><td>{{form.UserName}}</td><td>{{form.CompanyName}}</td><td class=\"form-status\"><md-icon\n class=\"status-pending\" ng-if=\"form.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nclass=\"status-completed\" ng-if=\"form.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></td><td><md-menu \nclass=\"md-secondary\"><md-button class=\"md-icon-button\" aria-label=\"Actions\" translate \ntranslate-attr-aria-label=\"WFM.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openActionFormDialog(form, \'Approve\', $event)\" translate=\"WFM.APPROVE\">Approve</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.openActionFormDialog(form, \'Reject\', $event)\" translate=\"WFM.REJECT\">Reject\n</md-button></md-menu-item></md-menu-content></md-menu></td><td class=\"show-details\"><md-button hide-gt-md \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"WFM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td>\n</tr></tbody></table><div class=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.forms.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"WFM.NO_DATA_MSG\" \ntranslate-attr-aria-label=\"WFM.NO_DATA_MSG\">There is no data to show right now.</span></div></div></md-content></div>\n<md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"form-detail-sidenav\" ng-include=\"\'app/main/pages/waiting-forme/sidenavs/form-process-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/pages/waiting-forme/sidenavs/form-process-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"title\" translate=\"WFM.PROCESS\">Process</div><div class=\"status-icon\"><md-icon \nng-if=\"vm.selected.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nng-if=\"vm.selected.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></div></div><div \nclass=\"subtitle secondary-text\"><span translate=\"WFM.FORM_ID\">Form Id</span>: {{vm.selected.FormKey}}</div></div>\n<md-content class=\"content\" flex ms-scroll><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.formTransactions[vm.selected.FormKey] | orderBy:\'DateTime\'\"><img ng-src=\"{{item.PhotoURL}}\" \nclass=\"md-avatar\" alt=\"\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.UserName }}</h3><h4>\n{{ item.DateTime | altDate}}</h4><p>{{ item.Action }}</p></div><md-divider></md-divider></md-list-item></md-list>\n</md-content>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/messaging/sidenavs/left/left-sidenav.html","<div ng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/messaging/sidenavs/left/views/messages/messages-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/pages/auth/user-actions/views/email-reset.html","<div ng-if=\"vm.action_resetEmailCodeValid && !vm.resetPasswordIsSuccess\" class=\"code-valid\"><div class=\"title\" \ntranslate=\"USER-ACTIONS.RESET_PASSWORD_TITLE\">Choose a new password for your account</div><form \nng-submit=\"vm.saveResetPassword()\" name=\"resetForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"New password\" ng-minlength=\"8\" translate \ntranslate-attr-placeholder=\"USER-ACTIONS.NEW_PASSWORD\" required><div ng-messages=\"resetForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"USER-ACTIONS.REQUIRED\">Required</div><div ng-message=\"minlength\" \ntranslate=\"USER-ACTIONS.MIN_LENGTH_WARNING\">Password should be at least 8 characters</div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordRetype\" \nng-model=\"vm.form.passwordRetype\" placeholder=\"Retype new password\" ng-minlength=\"8\" translate \ntranslate-attr-placeholder=\"USER-ACTIONS.RETYPE_NEW_PASSWORD\" required><div \nng-messages=\"resetForm.passwordRetype.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"USER-ACTIONS.REQUIRED\">Required</div><div ng-message=\"minlength\" \ntranslate=\"USER-ACTIONS.MIN_LENGTH_WARNING\">Password should be at least 8 characters</div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"SAVE\" \nng-disabled=\"resetForm.$invalid || resetForm.$pristine || vm.form.password!=vm.form.passwordRetype\" \ntranslate=\"USER-ACTIONS.SAVE\" translate-attr-aria-label=\"USER-ACTIONS.SAVE\">SAVE</md-button></form></div><div \nng-if=\"vm.resetPasswordIsSuccess\" class=\"reset-password-success\"><div class=\"title\" \ntranslate=\"USER-ACTIONS.RESET_PASSWORD_SUCCESS_TITLE\">Your password has been changed successfully</div><div \nclass=\"desc\" translate=\"USER-ACTIONS.RESET_PASSWORD_SUCCESS_DESC\">Click on the link below to go to the application.\n</div><div layout=\"row\" layout-align=\"center center\" class=\"continue-link\"><md-button class=\"md-raised md-accent\" \naria-label=\"CONTINUE\" translate=\"USER-ACTIONS.CONTINUE\" translate-attr-aria-label=\"USER-ACTIONS.CONTINUE\" \nui-sref=\"app.pages_profile\">CONTINUE</md-button></div></div><div ng-if=\"vm.action_resetEmailCodeInvalid\" \nclass=\"code-invalid\"><div class=\"title\" translate=\"USER-ACTIONS.RESET_PASSWORD_ERROR\">Reset password error</div><div \nclass=\"desc\" translate=\"USER-ACTIONS.RESET_PASSWORD_CODE_ERROR\">\nThe action code is invalid. This can happen if the code is malformed, expired, or has already been used.</div><div \nlayout=\"row\" layout-align=\"center center\" class=\"continue-link\"><md-button class=\"md-raised md-accent\" \naria-label=\"CONTINUE\" translate=\"USER-ACTIONS.CONTINUE\" translate-attr-aria-label=\"USER-ACTIONS.CONTINUE\" \nui-sref=\"app.pages_auth_forgot-password\">CONTINUE</md-button></div></div>");
$templateCache.put("app/main/pages/auth/user-actions/views/email-unverified.html","<div class=\"logo\"><md-icon md-font-icon=\"icon-email-secure s60\"></md-icon></div><div flex layout=\"column\" \nlayout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\" translate=\"USER-ACTIONS.TITLE\">\nPlease check your email</div><div class=\"desc\" translate=\"USER-ACTIONS.SUBTITLE\">\nYou must click on the link in the email we sent you in order to complete your registration for:</div><div \nclass=\"email\">\"{{vm.email}}\"</div></div><div flex layout=\"row\" layout-align=\"center center\" class=\"continue-link\">\n<md-button class=\"md-raised md-accent\" aria-label=\"GO BACK TO LOGIN\" translate=\"USER-ACTIONS.GO_BACK_TO_LOGIN\" \ntranslate-attr-aria-label=\"USER-ACTIONS.GO_BACK_TO_LOGIN\" ui-sref=\"app.pages_auth_login\">GO BACK TO LOGIN</md-button>\n<md-button class=\"md-raised md-accent\" aria-label=\"SEND EMAIL AGAIN\" translate=\"USER-ACTIONS.SEND_EMAIL_AGAIN\" \ntranslate-attr-aria-label=\"USER-ACTIONS.SEND_EMAIL_AGAIN\" ng-click=\"vm.resendVerificationEmail()\">SEND EMAIL AGAIN\n</md-button></div>");
$templateCache.put("app/main/pages/auth/user-actions/views/email-verify.html","<div flex layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div ng-if=\"vm.verifyEmailIsSuccess\">\n<div class=\"title-success\" translate=\"USER-ACTIONS.EMAIL_VERIFY_TITLE_SUCCESS\">Email Verification Success</div><div \nclass=\"desc\" translate=\"USER-ACTIONS.EMAIL_VERIFY_DESC_SUCCESS\">You have successfully verified the email address:</div>\n</div><div ng-if=\"vm.verifyEmailIsError\"><div class=\"title-error\" translate=\"USER-ACTIONS.EMAIL_VERIFY_TITLE_ERROR\">\nEmail Verification Error</div><div class=\"desc\" translate=\"USER-ACTIONS.EMAIL_VERIFY_DESC_ERROR\">\nThe action code is invalid. This can happen if the code is malformed, expired, or has already been used.</div></div>\n</div><div ng-if=\"vm.verifyEmailIsSuccess\" flex layout=\"row\" layout-align=\"center center\" class=\"continue-link\">\n<md-button class=\"md-raised md-accent\" aria-label=\"CONTINUE\" translate=\"USER-ACTIONS.CONTINUE\" \ntranslate-attr-aria-label=\"USER-ACTIONS.CONTINUE\" ui-sref=\"app.pages_profile\">CONTINUE</md-button></div>");
$templateCache.put("app/main/pages/auth/user-actions/views/error.html","<div flex layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title-error\" \ntranslate=\"USER-ACTIONS.PAGE_ERROR\">Page Error</div><div class=\"desc\" translate=\"USER-ACTIONS.PAGE_DESC_ERROR\">\nUnauthorized Request</div></div>");
$templateCache.put("app/main/pages/my-submissions/dialogs/view-form/view-form-dialog.html","<md-dialog class=\"view-form-dialog\" aria-label=\"View Form\"><form id=\"viewForm\" name=\"viewForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"view-form-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\"><div bind-html-compile=\"item.html\"></div></li></ul></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" \naria-label=\"Close\" translate=\"SW.CLOSE\" translate-attr-aria-label=\"SW.CLOSE\">CLOSE</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/dialogs/upload-bg/uploadbg-dialog.html","<md-dialog class=\"upload-bg-dialog\" aria-label=\"Upload Background\"><md-toolbar class=\"md-accent md-tall\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PROFILE.CHANGE_BACKGROUND\" translate-attr-aria-label=\"PROFILE.CHANGE_BACKGROUND\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Cancel dialog\" translate \ntranslate-attr-aria-label=\"PROFILE.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div>Select an image file: <input type=\"file\" ng-model-instant \nonchange=\"angular.element(this).scope().imageUpload(this)\" id=\"fileInput\"></div><div class=\"cropArea\"><img-crop \nimage=\"myImage\" result-image=\"vm.myCroppedImage\" result-image-size=\"200\" area-type=\"square\" area-min-size=\"150\">\n</img-crop></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.executeImgSave(vm.myCroppedImage)\" \nng-show=\"vm.showSaveButton\" class=\"md-accent md-raised\" aria-label=\"Save\" translate=\"PROFILE.SAVE\" \ntranslate-attr-aria-label=\"PROFILE.SAVE\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/profile/dialogs/upload-picture/uploadpicture-dialog.html","<md-dialog class=\"upload-picture-dialog\" aria-label=\"Update Picture\"><md-toolbar class=\"md-accent md-tall\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PROFILE.CHANGE_PICTURE\" translate-attr-aria-label=\"PROFILE.CHANGE_PICTURE\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Cancel dialog\" translate \ntranslate-attr-aria-label=\"PROFILE.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div>Select an image file: <input type=\"file\" ng-model-instant \nonchange=\"angular.element(this).scope().imageUpload(this)\" id=\"fileInput\"></div><div class=\"cropArea\"><img-crop \nimage=\"myImage\" result-image=\"vm.myCroppedImage\"></img-crop></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.executeImgSave(vm.myCroppedImage)\" ng-disabled=\"!vm.showSaveButton\" class=\"md-accent md-raised\" \naria-label=\"Save\" translate=\"PROFILE.SAVE\" translate-attr-aria-label=\"PROFILE.SAVE\">Save</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div class=\"profile-about-container md-background-bg md-whiteframe-1dp\"><form id=\"profileAbout\" name=\"profileAbout\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\"><md-input-container flex><label translate=\"PROFILE.EMAIL\">Email\n</label><input type=\"text\" name=\"email\" ng-value=\"vm.profile.email\" disabled=\"disabled\"></md-input-container><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PROFILE.FIRST_NAME\">First Name</label>\n<input type=\"text\" name=\"firstName\" ng-model=\"vm.profile.firstName\" required ng-maxlength=\"40\"><div \nng-messages=\"profileAbout.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"PROFILE.REQUIRED\">\nRequired</span></div><div ng-message=\"maxlength\"><span translate=\"PROFILE.FIRST_NAME_MAX_LENGTH\">\nFirst name can\'t be longer than 40 characters</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"PROFILE.LAST_NAME\">Last Name</label><input type=\"text\" name=\"lastName\" ng-model=\"vm.profile.lastName\" \nrequired ng-maxlength=\"40\"><div ng-messages=\"profileAbout.lastName.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"PROFILE.REQUIRED\">Required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"PROFILE.LAST_NAME_MAX_LENGTH\">Last name can\'t be longer than 40 characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"PROFILE.PHONE\">Phone</label><input type=\"text\" name=\"phone\" ng-model=\"vm.profile.phone\" \nui-mask-placeholder-char=\"-\" ui-mask=\"(999) 999-9999\" ui-mask-placeholder ui-options=\"{addDefaultPlaceholder:false}\">\n</md-input-container><md-input-container flex><label translate=\"PROFILE.COUNTRY\">Country</label><md-select \nng-model=\"vm.profile.countryCode\"><md-option ng-repeat=\"item in vm.countryCodes | orderBy:\'name\'\" ng-value=\"item.code\">\n{{item.name}}</md-option></md-select></md-input-container></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Save\" ng-click=\"vm.saveProfileAbout($event)\" translate=\"PROFILE.SAVE\" \nng-disabled=\"profileAbout.$invalid || profileAbout.$pristine\">Save</md-button></form></div>");
$templateCache.put("app/main/pages/profile/tabs/account/account.html","<div id=\"profile-account-container\" class=\"profile-account-container md-background-bg md-whiteframe-1dp\"><form \nid=\"profileAccount\" name=\"profileAccount\" class=\"md-inline-form\" novalidate><div layout=\"column\"><md-input-container \nflex><label translate=\"PROFILE.CURRENT_PASSWORD\">Current Password</label><input type=\"password\" name=\"currentPass\" \nng-model=\"vm.currentPass\" required><div ng-messages=\"profileAccount.currentPass.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"PROFILE.REQUIRED\">Required</div></div></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"PROFILE.NEW_PASSWORD\">New Password</label><input \ntype=\"password\" name=\"newPass\" ng-model=\"vm.newPass\" ng-minlength=\"8\" required><div \nng-messages=\"profileAccount.newPass.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"PROFILE.REQUIRED\">\nRequired</div><div ng-message=\"minlength\" translate=\"PROFILE.MIN_LENGTH_WARNING\">\nPassword should be at least 8 characters</div></div></md-input-container><md-input-container flex><label \ntranslate=\"PROFILE.CONFIRM_NEW_PASSWORD\">Confirm New Password</label><input type=\"password\" name=\"newPassConfirm\" \nng-model=\"vm.newPassConfirm\" ng-minlength=\"8\" required><div ng-messages=\"profileAccount.newPassConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"PROFILE.REQUIRED\">Required</div><div ng-message=\"minlength\" \ntranslate=\"PROFILE.MIN_LENGTH_WARNING\">Password should be at least 8 characters</div></div></md-input-container></div>\n</div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Change Password\" \nng-click=\"vm.updatePassword($event,profileAccount)\" translate=\"PROFILE.CHANGE_PASSWORD\" \nng-disabled=\"profileAccount.$invalid || profileAccount.$pristine\">Change Password</md-button></form></div>");
$templateCache.put("app/main/pages/public-company/dialogs/fillform/fillform-dialog.html","<md-dialog class=\"fillform-dialog\" aria-label=\"Fill Form\"><form id=\"fillForm\" name=\"fillForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"form-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\" ng-init=\"parentIndex = $index\"><div bind-html-compile=\"item.html\">\n</div></li></ul></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submitForm()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"fillForm.$invalid || fillForm.$pristine\" aria-label=\"Submit\" \ntranslate=\"SW.SUBMIT\" translate-attr-aria-label=\"SW.SUBMIT\">SUBMIT</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/public-company/dialogs/sharepost/share-company-post-dialog.html","<md-dialog class=\"share-company-post-dialog\" aria-label=\"Share Post\"><form name=\"addTerminationForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"timeline-item-wrapper\"><div class=\"share-post-comment\" layout=\"row\" layout-fill><img \nng-src=\"{{vm.user.photoURL}}\" class=\"avatar\"><textarea placeholder=\"Write something...\" translate \nng-model=\"vm.newSharedPost.message\" translate-attr-placeholder=\"PUBLIC_COMPANY.WRITE_SOMETHING\">\n                    \n</textarea></div><div id=\"{{vm.sharedPost.key}}\" class=\"timeline-item md-whiteframe-1dp\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/company/{{vm.companyPage.url}}\"><img class=\"avatar\" ng-src=\"{{vm.companyPage.photoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/company/{{vm.companyPage.url}}\"><span class=\"username md-accent-color\">\n{{vm.companyPage.companyName}}</span></a></div><div class=\"time\">{{vm.sharedPost.date | altDate}}</div></div></div>\n</header><div class=\"content\"><div ng-if=\"vm.sharedPost.message\" class=\"message\" \nng-text-truncate=\"vm.sharedPost.message\" ng-tt-words-threshold=\"40\"></div><div ng-if=\"vm.sharedPost.media\" \nclass=\"media\"><img ng-if=\"vm.sharedPost.media.Type === \'Image\'\" ng-src=\"{{vm.sharedPost.media.Preview}}\"><div \nng-if=\"vm.sharedPost.media.type === \'video\'\" ng-bind-html=\"vm.sharedPost.media.embed | toTrusted\"></div></div><div \nng-if=\"vm.sharedPost.article\" layout=\"column\" class=\"article\"><div class=\"media\"><img \nng-src=\"{{vm.sharedPost.article.media.preview}}\"></div><div class=\"title\">{{vm.sharedPost.article.title}}</div><div \nclass=\"subtitle\">{{vm.sharedPost.article.subtitle}}</div><div class=\"excerpt\">{{vm.sharedPost.article.excerpt}}</div>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-menu><md-button class=\"md-icon-button\" aria-label=\"settings\" translate \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.SETTINGS\"><md-icon md-menu-origin md-font-icon=\"icon-cog\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-if=\"!vm.newSharedPost.commentsEnabled\"><md-button ng-click=\"vm.enableComments()\" \ntranslate=\"PUBLIC_COMPANY.ENABLE_COMMENTS\">Enable Comments</md-button></md-menu-item><md-menu-item \nng-if=\"vm.newSharedPost.commentsEnabled\"><md-button ng-click=\"vm.disableComments()\" \ntranslate=\"PUBLIC_COMPANY.DISABLE_COMMENTS\">Disable Comments</md-button></md-menu-item></md-menu-content></md-menu>\n<md-button ng-click=\"vm.submitSharedPost()\" class=\"share-post-button md-accent md-raised\" aria-label=\"Share post\" \ntranslate=\"PUBLIC_COMPANY.POST\" translate-aria-label=\"PUBLIC_COMPANY.POST\">POST</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/public-company/dialogs/showlikes/showlikes-dialog.html","<md-dialog class=\"showlikes-dialog\" aria-label=\"Post Likes\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span>{{vm.likeCount}}\n</span>&nbsp; <span ng-if=\"vm.likeCount==1\" translate=\"PUBLIC_COMPANY.LIKE\">Like</span> <span ng-if=\"vm.likeCount>1\" \ntranslate=\"PUBLIC_COMPANY.LIKES\">Likes</span></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-content ms-scroll><md-list flex><md-list-item class=\"users md-2-line\" \nng-repeat=\"user in vm.users | orderBy: \'displayName\'\" ng-click=\"vm.gotoUserPage(user.key)\"><img \nng-src=\"{{user.photoURL}}\" class=\"md-avatar\" alt=\"{{user.displayName}}\"><div class=\"md-list-item-text\"><h3 \nclass=\"name\">{{user.displayName}}</h3></div><md-divider></md-divider></md-list-item></md-list></md-content></md-dialog>");
$templateCache.put("app/main/pages/public-company/directives/ms-profile-formnote/ms-profile-formnote.html","<md-card ng-class=\"MsProfileFormnote.note.WidgetColor\"><img ng-if=\"MsProfileFormnote.msProfileFormnote.WidgetImageURL\" \nclass=\"md-card-image\" ng-src=\"{{MsProfileFormnote.msProfileFormnote.WidgetImageURL}}\"><md-card-content \nng-class=\"MsProfileFormnote.note.WidgetColor\"><md-card-title><md-card-title-text>\n{{MsProfileFormnote.msProfileFormnote.Name}}</md-card-title-text></md-card-title><md-description><span \nng-bind-html=\"MsProfileFormnote.msProfileFormnote.Description\"></span></md-description></md-card-content></md-card>");
$templateCache.put("app/main/pages/public-company/tabs/about/about.html","<div class=\"about\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><div class=\"content\" \nng-class=\"{more: vm.aboutSeeMore}\" layout=\"row\"><div class=\"company-info\" flex=\"grow\"><div class=\"title\" \ntranslate=\"PUBLIC_COMPANY.ABOUT\">About</div><div class=\"info-line\" ng-bind-html=\"vm.companyPage.aboutUs\"></div><div \nclass=\"info-line\"><div class=\"sub-title\" translate=\"PUBLIC_COMPANY.ADDRESS\">Address</div><div class=\"info\">\n{{vm.companyPage.address}}</div></div><div class=\"info-line\"><div class=\"sub-title\" translate=\"PUBLIC_COMPANY.PHONE\">\nPhone</div><div class=\"info\">{{vm.companyPage.phone}}</div></div><div class=\"info-line\"><div class=\"sub-title\" \ntranslate=\"PUBLIC_COMPANY.WEBSITE\">Website</div><div class=\"info\">{{vm.companyPage.website}}</div></div><div \nclass=\"info-line\"><div class=\"sub-title\" translate=\"PUBLIC_COMPANY.EMAIL\">Email</div><div class=\"info\">\n{{vm.companyPage.email}}</div></div></div><div class=\"last-post\" layout=\"column\" flex=\"30\" hide-xs \nng-show=\"vm.lastPost\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PUBLIC_COMPANY.LAST_POST\">Last Post</div><div ng-click=\"vm.scrollToPost(vm.lastPost.PostKey)\" \nclass=\"see-all secondary-text\" translate=\"PUBLIC_COMPANY.SEE_ALL\">See All</div></div><div \nclass=\"md-whiteframe-1dp post-content\" layout=\"column\" ng-click=\"vm.scrollToPost(vm.lastPost.PostKey)\"><div \nng-if=\"vm.lastPost.Media\" class=\"media\"><img ng-if=\"vm.lastPost.Media.Type === \'Image\'\" \nng-src=\"{{vm.lastPost.Media.Preview}}\"></div><div class=\"message\">{{vm.lastPost.Message | limitTo:50}} ...</div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"counts\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.getLastPostLikeCount()>0\" class=\"item\"><span>{{vm.getLastPostLikeCount()}}</span>&nbsp; <span \nng-show=\"vm.getLastPostLikeCount()==1\" translate=\"PUBLIC_COMPANY.LIKE\">Like</span> <span \nng-show=\"vm.getLastPostLikeCount()>1\" translate=\"PUBLIC_COMPANY.LIKES\">Likes</span></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.getLastPostCommentCount()>0\" class=\"item\"><span>{{vm.getLastPostCommentCount()}}\n</span>&nbsp; <span ng-if=\"vm.getLastPostCommentCount()==1\" translate=\"PUBLIC_COMPANY.COMMENT\">Comment</span> <span \nng-if=\"vm.getLastPostCommentCount()>1\" translate=\"PUBLIC_COMPANY.COMMENTS\">Comments</span></div><div \nclass=\"time secondary-text\">{{vm.lastPost.Date | altDate}}</div></div></div></div></div><div class=\"action\"><md-button \nclass=\"md-icon-button\" aria-label=\"See More\" ng-click=\"vm.toggleAboutMoreLess()\"><md-icon ng-show=\"!vm.aboutSeeMore\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-show=\"vm.aboutSeeMore\" md-font-icon=\"icon-chevron-up\"></md-icon>\n</md-button></div></div></div>");
$templateCache.put("app/main/pages/public-company/tabs/public-forms/public-forms.html","<div id=\"notes\" layout=\"column\"><md-content class=\"md-padding\"><div layout=\"row\" layout-wrap \nlayout-align=\"center center\"><md-card ng-repeat=\"note in vm.publicForms\" class=\"{{note.WidgetColor}}\"><img \nng-if=\"note.WidgetImageURL\" ng-src=\"{{note.WidgetImageURL}}\" class=\"md-card-image\" alt=\"note.Name\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">{{note.Name}}</span></md-card-title-text></md-card-title>\n<md-card-content><div bind-html-compile=\"note.Description\"></div></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.openFillFormDialog($event,note.Key,note.Name)\" aria-label=\"Add form\" translate \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.ADD_FORM\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</md-card-actions></md-card></div></md-content><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" \nid=\"loginDialog\"><md-dialog layout-padding><div id=\"login-form\"><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to Notefield</div><form ng-submit=\"vm.login($event)\" name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span\n translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><div \nclass=\"text-center\" style=\"color:red\"><span class=\"text\">{{vm.signinErrorMsg}}</span></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\" \nng-click=\"vm.loginWithGoogle($event)\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon \nmd-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span>\n</span></div></md-button><md-button class=\"md-raised facebook\" ng-click=\"vm.loginWithFacebook($event)\"><div \nlayout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_signup\" translate=\"LOGIN.JOIN_NOW\">Join Now</a>\n</div></div></md-dialog></div></div></div>");
$templateCache.put("app/main/pages/public-company/tabs/timeline/timeline.html","<div ng-include=\"\'app/main/pages/public-company/tabs/public-forms/public-forms.html\'\"></div><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" style=\"width:800px\"><div \nng-include=\"\'app/main/pages/public-company/tabs/about/about.html\'\"></div><div layout=\"row\" layout-wrap><div \nclass=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div \nclass=\"profile-box add-post md-whiteframe-1dp\" ng-if=\"vm.isOwner\"><form class=\"form\" flex flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-file-added=\"vm.imageUpload($file)\" name=\"postForm\"><textarea required \nplaceholder=\"Write something..\" ng-model=\"vm.newPost.message\" translate \ntranslate-attr-placeholder=\"PUBLIC_COMPANY.WRITE_SOMETHING\"></textarea><div ng-show=\"$flow.files.length\" \nclass=\"image-wrapper\" layout=\"column\" layout-align=\"center center\"><md-button ng-click=\"vm.cancelFile($flow)\" \nclass=\"md-icon-button text-right\" aria-label=\"remove\" translate translate-attr-aria-label=\"PUBLIC_COMPANY.REMOVE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button><img flow-img=\"$flow.files[0]\"></div><footer layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button flow-btn \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PUBLIC_COMPANY.INSERT_PHOTO\">\n<md-icon md-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PUBLIC_COMPANY.INSERT_PHOTO\">\ninsert photo</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"settings\" translate \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.SETTINGS\"><md-icon md-menu-origin md-font-icon=\"icon-cog\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-if=\"!vm.newPost.commentsEnabled\"><md-button ng-click=\"vm.enableComments()\" \ntranslate=\"PUBLIC_COMPANY.ENABLE_COMMENTS\">Enable Comments</md-button></md-menu-item><md-menu-item \nng-if=\"vm.newPost.commentsEnabled\"><md-button ng-click=\"vm.disableComments()\" \ntranslate=\"PUBLIC_COMPANY.DISABLE_COMMENTS\">Disable Comments</md-button></md-menu-item></md-menu-content></md-menu>\n</div><md-button name=\"postBtn\" ng-click=\"vm.submitPost(postForm)\" class=\"post-button md-accent md-raised\" \naria-label=\"POST\" translate=\"PUBLIC_COMPANY.POST\" translate-attr-aria-label=\"PUBLIC_COMPANY.POST\" \nng-disabled=\"postForm.$invalid || postForm.$pristine\">POST</md-button></footer></form></div><md-divider></md-divider>\n<div class=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.posts.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"PUBLIC_COMPANY.NO_POST_MSG\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.NO_POST_MSG\">There are no posts to show right now.</span></div></div><div \nid=\"{{post.key}}\" class=\"timeline-item md-whiteframe-1dp\" \nng-repeat=\"post in vm.posts | orderBy:\'-date\' | limitTo: vm.postDisplayLimit\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/company/{{vm.companyPage.url}}\"><img class=\"avatar\" ng-src=\"{{vm.companyPage.photoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/company/{{vm.companyPage.url}}\"><span class=\"username md-accent-color\">\n{{vm.companyPage.companyName}}</span></a></div><div class=\"time\">{{post.date | altDate}}</div></div></div><md-menu \nng-show=\"vm.isOwner\"><md-button class=\"md-icon-button\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.OPTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deletePost($event, post)\" translate=\"PUBLIC_COMPANY.DELETE\">Delete</md-button></md-menu-item>\n</md-menu-content></md-menu></header><div class=\"content\"><div ng-if=\"post.message\" class=\"message\" \nng-text-truncate=\"post.message\" ng-tt-words-threshold=\"40\"></div><div ng-if=\"post.media\" class=\"media\"><img \nng-if=\"post.media.Type === \'Image\'\" ng-src=\"{{post.media.Preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"post.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showPostLikes($event, post.key)\"><div layout=\"row\" layout-align=\"start center\"><span>{{post.likeCount}}\n</span>&nbsp; <span ng-if=\"post.likeCount==1\" translate=\"PUBLIC_COMPANY.LIKE\">Like</span> <span \nng-if=\"post.likeCount>1\" translate=\"PUBLIC_COMPANY.LIKES\">Likes</span></div></md-button><md-button \nng-if=\"post.commentCount>0\" class=\"comment-count-button\" ng-click=\"vm.showPostComments($event,post.key)\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{post.commentCount}}</span>&nbsp; <span ng-if=\"post.commentCount==1\" \ntranslate=\"PUBLIC_COMPANY.COMMENT\">Comment</span> <span ng-if=\"post.commentCount>1\" \ntranslate=\"PUBLIC_COMPANY.COMMENTS\">Comments</span></div></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"like-button\" ng-click=\"vm.togglePostLike(post.key)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-heart\" class=\"s16\" ng-show=\"post.isLike\"></md-icon><md-icon \nmd-font-icon=\"icon-heart-outline\" class=\"s16\" ng-hide=\"post.isLike\"></md-icon><span translate=\"PUBLIC_COMPANY.LIKE\">\nLike</span></div></md-button><md-button class=\"share-button\" ng-click=\"vm.sharePost($event, post)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span \ntranslate=\"PUBLIC_COMPANY.SHARE\">Share</span></div></md-button><md-button class=\"comment-button\" \nng-show=\"post.commentsEnabled\" ng-click=\"vm.showPostComments($event,post.key)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-comment-text-outline\" class=\"s16\"></md-icon><span \ntranslate=\"PUBLIC_COMPANY.COMMENT\">Comment</span></div></md-button></div></div><footer ng-show=\"post.showComments\" \nclass=\"\" layout=\"column\" layout-align=\"start start\"><md-button ng-show=\"post.commentDisplayLimit<post.commentCount\" \nclass=\"previous-comments-button\" ng-click=\"vm.showPreviousComments(post.key)\"><span \ntranslate=\"PUBLIC_COMPANY.SHOW_PREVIOUS_COMMENTS\">Show previous comments</span></md-button><div \nng-show=\"post.showComments\" class=\"comments\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments | orderBy:\'date\' | limitTo: -post.commentDisplayLimit\"><a \nhref=\"/person/{{comment.userKey}}\"><img ng-src=\"{{comment.photoURL}}\" class=\"comments-avatar\"></a><div flex \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\"><a \nhref=\"/person/{{comment.userKey}}\">{{comment.displayName}} </a></span><span class=\"time\">{{comment.date | altDate}}\n</span></div><div class=\"message\" ng-text-truncate=\"comment.message\" ng-tt-words-threshold=\"30\"></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\" \nng-click=\"vm.toggleCommentLike(comment.key, post.key)\"><span translate=\"PUBLIC_COMPANY.LIKE\" \nng-class=\"{iscommentlike:comment.isLike}\">Like</span></md-button><md-button class=\"reply-button\" \nng-click=\"vm.showCommentReplyPanel(comment.key, post.key)\"><span translate=\"PUBLIC_COMPANY.REPLY\">Reply</span>\n</md-button><md-button ng-if=\"comment.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showCommentLikes($event, comment.key, post.key)\"><div layout=\"row\" layout-align=\"start center\"><span>\n{{comment.likeCount}}</span>&nbsp; <span ng-if=\"comment.likeCount==1\" translate=\"PUBLIC_COMPANY.LIKE\">Like</span> <span\n ng-if=\"comment.likeCount>1\" translate=\"PUBLIC_COMPANY.LIKES\">Likes</span></div></md-button><md-button \nng-if=\"comment.replyCount>0\" class=\"reply-count-button\" ng-click=\"vm.showCommentReplies(comment.key, post.key)\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{comment.replyCount}}</span>&nbsp; <span ng-if=\"comment.replyCount==1\" \ntranslate=\"PUBLIC_COMPANY.REPLY\">Reply</span> <span ng-if=\"comment.replyCount>1\" translate=\"PUBLIC_COMPANY.REPLIES\">\nReplies</span></div></md-button></div><md-button \nng-show=\"comment.showReplies && comment.replyDisplayLimit<comment.replyCount\" class=\"previous-replies-button\" \nng-click=\"vm.showPreviousReplies(comment.key, post.key)\"><span translate=\"PUBLIC_COMPANY.SHOW_PREVIOUS_REPLIES\">\nShow previous replies</span></md-button><div ng-show=\"comment.showReplies\" class=\"replies\" layout=\"row\" \nng-repeat=\"reply in comment.replies | orderBy:\'date\' | limitTo: -comment.replyDisplayLimit\"><a \nhref=\"/person/{{reply.userKey}}\"><img ng-src=\"{{reply.photoURL}}\" class=\"replies-avatar\"></a><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\"><a href=\"/person/{{reply.userKey}}\">\n{{reply.displayName}} </a></span><span class=\"time\">{{reply.date | altDate}}</span></div><div class=\"message\" \nng-text-truncate=\"reply.message\" ng-tt-words-threshold=\"30\"></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"like-button\" \nng-click=\"vm.toggleReplyLike(reply.key, comment.key, post.key)\"><span translate=\"PUBLIC_COMPANY.LIKE\" \nng-class=\"{isreplylike:reply.isLike}\">Like</span></md-button><md-button class=\"reply-button\" \nng-click=\"vm.showCommentReplyPanel(comment.key, post.key)\"><span translate=\"PUBLIC_COMPANY.REPLY\">Reply</span>\n</md-button><md-button ng-if=\"reply.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showReplyLikes($event, reply.key, comment.key, post.key)\"><div layout=\"row\" layout-align=\"start center\">\n<span>{{reply.likeCount}}</span>&nbsp; <span ng-if=\"reply.likeCount==1\" translate=\"PUBLIC_COMPANY.LIKE\">Like</span> \n<span ng-if=\"reply.likeCount>1\" translate=\"PUBLIC_COMPANY.LIKES\">Likes</span></div></md-button></div></div><md-menu \nng-show=\"reply.userKey == vm.user.uid\"><md-button class=\"md-icon-button\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.OPTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deleteReply($event, reply, comment, post)\" translate=\"PUBLIC_COMPANY.DELETE\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"reply\" layout=\"row\" ng-show=\"comment.showReplyPanel\"><img \nng-src=\"{{vm.user.photoURL}}\" class=\"reply-avatar\"><form flex name=\"replyForm\"><textarea placeholder=\"Add a reply...\" \ntranslate ng-model=\"vm.replyForm[comment.key].message\" required translate-attr-placeholder=\"PUBLIC_COMPANY.ADD_REPLY\">\n</textarea><md-button \nng-click=\"vm.submitCommentReply(replyForm, post.key, comment.key, vm.replyForm[comment.key].message)\" \nclass=\"comment-reply-button md-accent md-raised\" aria-label=\"Reply Comment\" translate=\"PUBLIC_COMPANY.REPLY\" \ntranslate-aria-label=\"PUBLIC_COMPANY.REPLY\" ng-disabled=\"replyForm.$invalid || replyForm.$pristine\">Reply</md-button>\n</form></div></div><md-menu ng-show=\"comment.userKey == vm.user.uid\"><md-button class=\"md-icon-button\" \naria-label=\"Options\" translate translate-attr-aria-label=\"PUBLIC_COMPANY.OPTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.deleteComment($event, comment, post)\" translate=\"PUBLIC_COMPANY.DELETE\">Delete\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"comment\" layout=\"row\" layout-fill \nng-show=\"post.showComments\"><img ng-src=\"{{vm.user.photoURL}}\" class=\"comment-avatar\"><form flex name=\"commentForm\">\n<textarea placeholder=\"Add a comment...\" translate ng-model=\"vm.commentForm[post.key].message\" required \ntranslate-attr-placeholder=\"PUBLIC_COMPANY.ADD_COMMENT\"></textarea><md-button \nng-click=\"vm.submitPostComment(commentForm, post.key, vm.commentForm[post.key].message)\" \nclass=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PUBLIC_COMPANY.POST_COMMENT\" \ntranslate-aria-label=\"PUBLIC_COMPANY.POST_COMMENT\" ng-disabled=\"commentForm.$invalid || commentForm.$pristine\">\nPost Comment</md-button></form></div></footer></div><md-button ng-show=\"vm.postDisplayLimit<vm.companyPage.postCount\" \nclass=\"previous-posts-button\" ng-click=\"vm.showPreviousPosts()\"><span translate=\"PUBLIC_COMPANY.SHOW_PREVIOUS_POSTS\">\nShow previous posts</span></md-button></div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"30\" \nflex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div class=\"md-whiteframe-1dp\" layout=\"column\" \nlayout-align=\"center stretch\"><header class=\"md-accent-bg\"><div class=\"title\">{{vm.companyPage.companyName}}</div>\n</header><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"item\">\n{{vm.companyPage.postCount}} Posts</div><div class=\"item\">{{vm.companyPage.followerCount}} Followers</div><md-button \nclass=\"md-raised md-accent follow-unfollow-btn\" aria-label=\"Unfollow\" ng-if=\"vm.isFollow\" \nng-click=\"vm.unFollowCompanyPage()\"><span ng-hide=\"vm.isFollowingMouseOver\" translate=\"PUBLIC_COMPANY.FOLLOWING\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.FOLLOWING\" ng-mouseover=\"vm.followingOnMouseOver()\">Following </span><span \nng-show=\"vm.isFollowingMouseOver\" translate=\"PUBLIC_COMPANY.UNFOLLOW\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.UNFOLLOW\" ng-mouseleave=\"vm.followingOnMouseLeave()\">Unfollow</span>\n</md-button><md-button class=\"md-raised follow-unfollow-btn\" aria-label=\"Follow\" translate=\"PUBLIC_COMPANY.FOLLOW\" \ntranslate-attr-aria-label=\"PUBLIC_COMPANY.FOLLOW\" ng-if=\"!vm.isFollow\" ng-click=\"vm.followCompanyPage()\">Follow\n</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/public-person/dialogs/sharepost/share-person-post-dialog.html","<md-dialog class=\"share-person-post-dialog\" aria-label=\"Share Post\"><form name=\"addTerminationForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"timeline-item-wrapper\"><div class=\"share-post-comment\" layout=\"row\" layout-fill><img \nng-src=\"{{vm.user.photoURL}}\" class=\"avatar\"><textarea placeholder=\"Write something...\" translate \nng-model=\"vm.newSharedPost.message\" translate-attr-placeholder=\"PUBLIC_PERSON.WRITE_SOMETHING\">\n                    \n</textarea></div><div id=\"{{vm.sharedPost.key}}\" class=\"timeline-item md-whiteframe-1dp\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/person/{{vm.sharedPost.personKey}}\"><img class=\"avatar\" ng-src=\"{{vm.sharedPost.photoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/person/{{vm.sharedPost.personKey}}\"><span \nclass=\"username md-accent-color\">{{vm.sharedPost.displayName}}</span></a></div><div class=\"time\">\n{{vm.sharedPost.date | altDate}}</div></div></div></header><div class=\"content\"><div ng-if=\"vm.sharedPost.message\" \nclass=\"message\" ng-text-truncate=\"vm.sharedPost.message\" ng-tt-words-threshold=\"40\"></div><div \nng-if=\"vm.sharedPost.media\" class=\"media\"><img ng-if=\"vm.sharedPost.media.Type === \'Image\'\" \nng-src=\"{{vm.sharedPost.media.Preview}}\"><div ng-if=\"vm.sharedPost.media.type === \'video\'\" \nng-bind-html=\"vm.sharedPost.media.embed | toTrusted\"></div></div><div ng-if=\"vm.sharedPost.article\" layout=\"column\" \nclass=\"article\"><div class=\"media\"><img ng-src=\"{{vm.sharedPost.article.media.preview}}\"></div><div class=\"title\">\n{{vm.sharedPost.article.title}}</div><div class=\"subtitle\">{{vm.sharedPost.article.subtitle}}</div><div \nclass=\"excerpt\">{{vm.sharedPost.article.excerpt}}</div></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"settings\" \ntranslate translate-attr-aria-label=\"PUBLIC_COMPANY.SETTINGS\"><md-icon md-menu-origin md-font-icon=\"icon-cog\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-if=\"!vm.newSharedPost.commentsEnabled\"><md-button ng-click=\"vm.enableComments()\" \ntranslate=\"PUBLIC_COMPANY.ENABLE_COMMENTS\">Enable Comments</md-button></md-menu-item><md-menu-item \nng-if=\"vm.newSharedPost.commentsEnabled\"><md-button ng-click=\"vm.disableComments()\" \ntranslate=\"PUBLIC_COMPANY.DISABLE_COMMENTS\">Disable Comments</md-button></md-menu-item></md-menu-content></md-menu>\n<md-button ng-click=\"vm.submitSharedPost()\" class=\"share-post-button md-accent md-raised\" aria-label=\"Share post\" \ntranslate=\"PUBLIC_PERSON.POST\" translate-aria-label=\"PUBLIC_PERSON.POST\">POST</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/public-person/dialogs/showlikes/showlikes-dialog.html","<md-dialog class=\"showlikes-dialog\" aria-label=\"Post Likes\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span>{{vm.likeCount}}\n</span>&nbsp; <span ng-if=\"vm.likeCount==1\" translate=\"PUBLIC_PERSON.LIKE\">Like</span> <span ng-if=\"vm.likeCount>1\" \ntranslate=\"PUBLIC_PERSON.LIKES\">Likes</span></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-content ms-scroll><md-list flex><md-list-item class=\"users md-2-line\" \nng-repeat=\"user in vm.users | orderBy: \'displayName\'\" ng-click=\"vm.gotoUserPage(user.key)\"><img \nng-src=\"{{user.photoURL}}\" class=\"md-avatar\" alt=\"{{user.displayName}}\"><div class=\"md-list-item-text\"><h3 \nclass=\"name\">{{user.displayName}}</h3></div><md-divider></md-divider></md-list-item></md-list></md-content></md-dialog>");
$templateCache.put("app/main/pages/public-person/tabs/timeline/timeline.html","<div layout=\"row\" layout-align=\"center center\"><div layout=\"column\" style=\"width:800px\"><div layout=\"row\" layout-wrap>\n<div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\">\n<div class=\"profile-box add-post md-whiteframe-1dp\" ng-if=\"vm.isOwner\"><form class=\"form\" flex \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-file-added=\"vm.imageUpload($file)\" name=\"postForm\">\n<textarea required placeholder=\"Write something..\" ng-model=\"vm.newPost.message\" translate \ntranslate-attr-placeholder=\"PUBLIC_PERSON.WRITE_SOMETHING\"></textarea><div ng-show=\"$flow.files.length\" \nclass=\"image-wrapper\" layout=\"column\" layout-align=\"center center\"><md-button ng-click=\"$flow.cancel()\" \nclass=\"md-icon-button text-right\" aria-label=\"remove\" translate translate-attr-aria-label=\"PUBLIC_PERSON.REMOVE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button><img flow-img=\"$flow.files[0]\"></div><footer layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button flow-btn \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PUBLIC_PERSON.INSERT_PHOTO\">\n<md-icon md-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PUBLIC_PERSON.INSERT_PHOTO\">\ninsert photo</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"settings\" translate \ntranslate-attr-aria-label=\"PUBLIC_PERSON.SETTINGS\"><md-icon md-menu-origin md-font-icon=\"icon-cog\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item \nng-if=\"!vm.newPost.commentsEnabled\"><md-button ng-click=\"vm.enableComments()\" \ntranslate=\"PUBLIC_PERSON.ENABLE_COMMENTS\">Enable Comments</md-button></md-menu-item><md-menu-item \nng-if=\"vm.newPost.commentsEnabled\"><md-button ng-click=\"vm.disableComments()\" \ntranslate=\"PUBLIC_PERSON.DISABLE_COMMENTS\">Disable Comments</md-button></md-menu-item></md-menu-content></md-menu>\n</div><md-button name=\"postBtn\" ng-click=\"vm.submitPost(postForm)\" class=\"post-button md-accent md-raised\" \naria-label=\"POST\" translate=\"PUBLIC_PERSON.POST\" translate-attr-aria-label=\"PUBLIC_PERSON.POST\" \nng-disabled=\"postForm.$invalid || postForm.$pristine\">POST</md-button></footer></form></div><md-divider></md-divider>\n<div class=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.posts.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"PUBLIC_PERSON.NO_POST_MSG\" \ntranslate-attr-aria-label=\"PUBLIC_PERSON.NO_POST_MSG\">There are no posts to show right now.</span></div></div><div \nid=\"{{post.key}}\" class=\"timeline-item md-whiteframe-1dp\" \nng-repeat=\"post in vm.posts | orderBy:\'-date\' | limitTo: vm.postDisplayLimit\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/person/{{vm.personPage.key}}\"><img class=\"avatar\" ng-src=\"{{post.photoURL}}\"></a><div layout=\"column\"><div \nclass=\"title\"><a href=\"/person/{{vm.personPage.key}}\"><span class=\"username md-accent-color\">{{post.displayName}}\n</span></a></div><div class=\"time\">{{post.date | altDate}}</div></div></div><md-menu ng-show=\"vm.isOwner\"><md-button \nclass=\"md-icon-button\" aria-label=\"Options\" translate translate-attr-aria-label=\"PUBLIC_PERSON.OPTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.deletePost($event, post)\" translate=\"PUBLIC_PERSON.DELETE\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></header><div class=\"content\"><div ng-if=\"post.message\" class=\"message\" \nng-text-truncate=\"post.message\" ng-tt-words-threshold=\"40\"></div><div ng-if=\"post.media\" class=\"media\"><img \nng-if=\"post.media.Type === \'Image\'\" ng-src=\"{{post.media.Preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nng-if=\"post.sharedPost\" class=\"shared-item md-whiteframe-1dp\"><header ng-if=\"post.sharedPost.group == \'p\'\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/person/{{post.sharedPost.personKey}}\"><img class=\"avatar\" ng-src=\"{{post.sharedPost.photoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/person/{{post.sharedPost.personKey}}\"><span \nclass=\"username md-accent-color\">{{post.sharedPost.displayName}}</span></a></div><div class=\"time\">\n{{post.sharedPost.date | altDate}}</div></div></div></header><header ng-if=\"post.sharedPost.group == \'c\'\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><a \nhref=\"/company/{{post.sharedPost.companyURL}}\"><img class=\"avatar\" ng-src=\"{{post.sharedPost.photoURL}}\"></a><div \nlayout=\"column\"><div class=\"title\"><a href=\"/company/{{post.sharedPost.companyURL}}\"><span \nclass=\"username md-accent-color\">{{post.sharedPost.companyName}}</span></a></div><div class=\"time\">\n{{post.sharedPost.date | altDate}}</div></div></div></header><div class=\"content\"><div ng-if=\"post.sharedPost.message\" \nclass=\"message\" ng-text-truncate=\"post.sharedPost.message\" ng-tt-words-threshold=\"40\"></div><div \nng-if=\"post.sharedPost.media\" class=\"media\"><img ng-if=\"post.sharedPost.media.Type === \'Image\'\" \nng-src=\"{{post.sharedPost.media.Preview}}\"><div ng-if=\"post.sharedPost.media.Type === \'video\'\" \nng-bind-html=\"post.sharedPost.media.embed | toTrusted\"></div></div><div ng-if=\"post.sharedPost.article\" \nlayout=\"column\" class=\"article\"><div class=\"media\"><img ng-src=\"{{post.sharedPost.article.media.preview}}\"></div><div \nclass=\"title\">{{post.sharedPost.article.title}}</div><div class=\"subtitle\">{{post.sharedPost.article.subtitle}}</div>\n<div class=\"excerpt\">{{post.sharedPost.article.excerpt}}</div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"post.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showPostLikes($event, post.key)\"><div layout=\"row\" layout-align=\"start center\"><span>{{post.likeCount}}\n</span>&nbsp; <span ng-if=\"post.likeCount==1\" translate=\"PUBLIC_PERSON.LIKE\">Like</span> <span \nng-if=\"post.likeCount>1\" translate=\"PUBLIC_PERSON.LIKES\">Likes</span></div></md-button><md-button \nng-if=\"post.commentCount>0\" class=\"comment-count-button\" ng-click=\"vm.showPostComments($event, post.key)\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{post.commentCount}}</span>&nbsp; <span ng-if=\"post.commentCount==1\" \ntranslate=\"PUBLIC_PERSON.COMMENT\">Comment</span> <span ng-if=\"post.commentCount>1\" translate=\"PUBLIC_PERSON.COMMENTS\">\nComments</span></div></md-button></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\" \nng-click=\"vm.togglePostLike(post.key)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-heart\" class=\"s16\" ng-show=\"post.isLike\"></md-icon><md-icon md-font-icon=\"icon-heart-outline\" \nclass=\"s16\" ng-hide=\"post.isLike\"></md-icon><span translate=\"PUBLIC_PERSON.LIKE\">Like</span></div></md-button>\n<md-button class=\"share-button\" ng-if=\"vm.user.uid!=post.personKey\" ng-click=\"vm.sharePost($event, post)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span \ntranslate=\"PUBLIC_PERSON.SHARE\">Share</span></div></md-button><md-button class=\"comment-button\" \nng-show=\"post.commentsEnabled\" ng-click=\"vm.showPostComments($event, post.key)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-comment-text-outline\" class=\"s16\"></md-icon><span \ntranslate=\"PUBLIC_PERSON.COMMENT\">Comment</span></div></md-button></div></div><footer ng-show=\"post.showComments\" \nclass=\"\" layout=\"column\" layout-align=\"start start\"><md-button ng-show=\"post.commentDisplayLimit<post.commentCount\" \nclass=\"previous-comments-button\" ng-click=\"vm.showPreviousComments(post.key)\"><span \ntranslate=\"PUBLIC_PERSON.SHOW_PREVIOUS_COMMENTS\">Show previous comments</span></md-button><div \nng-show=\"post.showComments\" class=\"comments\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments | orderBy:\'date\' | limitTo: -post.commentDisplayLimit\"><a \nhref=\"/person/{{comment.userKey}}\"><img ng-src=\"{{comment.photoURL}}\" class=\"comments-avatar\"></a><div flex \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\"><a \nhref=\"/person/{{comment.userKey}}\">{{comment.displayName}} </a></span><span class=\"time\">{{comment.date | altDate}}\n</span></div><div class=\"message\" ng-text-truncate=\"comment.message\" ng-tt-words-threshold=\"30\"></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\" \nng-click=\"vm.toggleCommentLike(comment.key, post.key)\"><span translate=\"PUBLIC_PERSON.LIKE\" \nng-class=\"{iscommentlike:comment.isLike}\">Like</span></md-button><md-button class=\"reply-button\" \nng-click=\"vm.showCommentReplyPanel(comment.key, post.key)\"><span translate=\"PUBLIC_PERSON.REPLY\">Reply</span>\n</md-button><md-button ng-if=\"comment.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showCommentLikes($event, comment.key, post.key)\"><div layout=\"row\" layout-align=\"start center\"><span>\n{{comment.likeCount}}</span>&nbsp; <span ng-if=\"comment.likeCount==1\" translate=\"PUBLIC_PERSON.LIKE\">Like</span> <span \nng-if=\"comment.likeCount>1\" translate=\"PUBLIC_PERSON.LIKES\">Likes</span></div></md-button><md-button \nng-if=\"comment.replyCount>0\" class=\"reply-count-button\" ng-click=\"vm.showCommentReplies(comment.key, post.key)\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{comment.replyCount}}</span>&nbsp; <span ng-if=\"comment.replyCount==1\" \ntranslate=\"PUBLIC_PERSON.REPLY\">Reply</span> <span ng-if=\"comment.replyCount>1\" translate=\"PUBLIC_PERSON.REPLIES\">\nReplies</span></div></md-button></div><md-button \nng-show=\"comment.showReplies && comment.replyDisplayLimit<comment.replyCount\" class=\"previous-replies-button\" \nng-click=\"vm.showPreviousReplies(comment.key, post.key)\"><span translate=\"PUBLIC_PERSON.SHOW_PREVIOUS_REPLIES\">\nShow previous replies</span></md-button><div ng-show=\"comment.showReplies\" class=\"replies\" layout=\"row\" \nng-repeat=\"reply in comment.replies | orderBy:\'date\' | limitTo: -comment.replyDisplayLimit\"><a \nhref=\"/person/{{reply.userKey}}\"><img ng-src=\"{{reply.photoURL}}\" class=\"replies-avatar\"></a><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\"><a href=\"/person/{{reply.userKey}}\">\n{{reply.displayName}} </a></span><span class=\"time\">{{reply.date | altDate}}</span></div><div class=\"message\" \nng-text-truncate=\"reply.message\" ng-tt-words-threshold=\"30\"></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"like-button\" \nng-click=\"vm.toggleReplyLike(reply.key, comment.key, post.key)\"><span translate=\"PUBLIC_PERSON.LIKE\" \nng-class=\"{isreplylike:reply.isLike}\">Like</span></md-button><md-button class=\"reply-button\" \nng-click=\"vm.showCommentReplyPanel(comment.key, post.key)\"><span translate=\"PUBLIC_PERSON.REPLY\">Reply</span>\n</md-button><md-button ng-if=\"reply.likeCount>0\" class=\"like-count-button\" \nng-click=\"vm.showReplyLikes($event, reply.key, comment.key, post.key)\"><div layout=\"row\" layout-align=\"start center\">\n<span>{{reply.likeCount}}</span>&nbsp; <span ng-if=\"reply.likeCount==1\" translate=\"PUBLIC_PERSON.LIKE\">Like</span> \n<span ng-if=\"reply.likeCount>1\" translate=\"PUBLIC_PERSON.LIKES\">Likes</span></div></md-button></div></div><md-menu \nng-show=\"reply.userKey == vm.user.uid\"><md-button class=\"md-icon-button\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"PUBLIC_PERSON.OPTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"vm.deleteReply($event, reply, comment, post)\" translate=\"PUBLIC_PERSON.DELETE\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"reply\" layout=\"row\" ng-show=\"comment.showReplyPanel\"><img \nng-src=\"{{vm.user.photoURL}}\" class=\"reply-avatar\"><form flex name=\"replyForm\"><textarea placeholder=\"Add a reply...\" \ntranslate ng-model=\"vm.replyForm[comment.key].message\" required translate-attr-placeholder=\"PUBLIC_PERSON.ADD_REPLY\">\n</textarea><md-button \nng-click=\"vm.submitCommentReply(replyForm, post.key, comment.key, vm.replyForm[comment.key].message)\" \nclass=\"comment-reply-button md-accent md-raised\" aria-label=\"Reply Comment\" translate=\"PUBLIC_PERSON.REPLY\" \ntranslate-aria-label=\"PUBLIC_PERSON.REPLY\" ng-disabled=\"replyForm.$invalid || replyForm.$pristine\">Reply</md-button>\n</form></div></div><md-menu ng-show=\"comment.userKey == vm.user.uid\"><md-button class=\"md-icon-button\" \naria-label=\"Options\" translate translate-attr-aria-label=\"PUBLIC_PERSON.OPTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"vm.deleteComment($event, comment, post)\" translate=\"PUBLIC_PERSON.DELETE\">Delete\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"comment\" layout=\"row\" layout-fill \nng-show=\"post.showComments\"><img ng-src=\"{{vm.user.photoURL}}\" class=\"comment-avatar\"><form flex name=\"commentForm\">\n<textarea placeholder=\"Add a comment...\" translate ng-model=\"vm.commentForm[post.key].message\" required \ntranslate-attr-placeholder=\"PUBLIC_PERSON.ADD_COMMENT\"></textarea><md-button \nng-click=\"vm.submitPostComment(commentForm, post.key, vm.commentForm[post.key].message)\" \nclass=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PUBLIC_PERSON.POST_COMMENT\" \ntranslate-aria-label=\"PUBLIC_PERSON.POST_COMMENT\" ng-disabled=\"commentForm.$invalid || commentForm.$pristine\">\nPost Comment</md-button></form></div></footer></div><md-button ng-show=\"vm.postDisplayLimit<vm.personPage.postCount\" \nclass=\"previous-posts-button\" ng-click=\"vm.showPreviousPosts()\"><span translate=\"PUBLIC_PERSON.SHOW_PREVIOUS_POSTS\">\nShow previous posts</span></md-button></div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"30\" \nflex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div class=\"md-whiteframe-1dp\" layout=\"column\" \nlayout-align=\"center stretch\"><header class=\"md-accent-bg\"><div class=\"title\">{{vm.personPage.displayName}}</div>\n</header><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"item\">\n{{vm.personPage.postCount}} Posts</div><div class=\"item\">{{vm.personPage.followerCount}} Followers</div><div \nng-if=\"vm.user.uid != vm.personPage.key\"><md-button class=\"md-raised md-accent follow-unfollow-btn\" \naria-label=\"Unfollow\" ng-if=\"vm.isFollow\" ng-click=\"vm.unFollowPersonPage()\"><span ng-hide=\"vm.isFollowingMouseOver\" \ntranslate=\"PUBLIC_PERSON.FOLLOWING\" translate-attr-aria-label=\"PUBLIC_PERSON.FOLLOWING\" \nng-mouseover=\"vm.followingOnMouseOver()\">Following </span><span ng-show=\"vm.isFollowingMouseOver\" \ntranslate=\"PUBLIC_PERSON.UNFOLLOW\" translate-attr-aria-label=\"PUBLIC_PERSON.UNFOLLOW\" \nng-mouseleave=\"vm.followingOnMouseLeave()\">Unfollow</span></md-button><md-button class=\"md-raised follow-unfollow-btn\" \naria-label=\"Follow\" translate=\"PUBLIC_PERSON.FOLLOW\" translate-attr-aria-label=\"PUBLIC_PERSON.FOLLOW\" \nng-if=\"!vm.isFollow\" ng-click=\"vm.followPersonPage()\">Follow</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/company/search-company.html","<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"65\" flex-gt-md=\"70\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><div class=\"md-whiteframe-1dp\" layout=\"column\"><div class=\"content\"><div class=\"no-results\" \nng-show=\"vm.noResultsFound\" translate=\"SEARCH.NO_RESULTS_FOUND\" translate-attr-aria-label=\"SEARCH.NO_RESULTS_FOUND\">\nNo results found</div><md-list-item class=\"md-2-line company-item\" ng-repeat=\"item in vm.companyPages\"><img \nng-src=\"{{item.photoURL}}\" class=\"md-avatar\" alt=\"{{item.companyName}}\"><div class=\"md-list-item-text\"><h3><a \nhref=\"/company/{{item.companyURL}}\">{{item.companyName}}</a></h3><div class=\"industry-name\">{{item.industryName}}</div>\n</div><md-button class=\"md-secondary md-raised md-accent follow-unfollow-btn\" aria-label=\"Unfollow\" \nng-if=\"item.isFollowing\" ng-click=\"vm.unFollowCompanyPage(item.key)\"><span translate=\"SEARCH.UNFOLLOW\" \ntranslate-attr-aria-label=\"SEARCH.UNFOLLOW\">Unfollow</span></md-button><md-button \nclass=\"md-secondary md-raised md-accent follow-unfollow-btn\" aria-label=\"Follow\" ng-if=\"!item.isFollowing\" \nng-click=\"vm.followCompanyPage(item.key)\"><span translate=\"SEARCH.FOLLOW\" translate-attr-aria-label=\"SEARCH.FOLLOW\">\nFollow</span></md-button><md-divider></md-divider></md-list-item><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"show-more-button\" ng-click=\"vm.showMore()\" ng-show=\"vm.showMoreBtnVisible\"><span \ntranslate=\"SEARCH.SHOW_MORE\" translate-attr-aria-label=\"SEARCH.SHOW_MORE\">Show more</span></md-button></div></div>\n</div></div><div class=\"search-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-md=\"30\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"\" layout=\"column\"><header class=\"md-primary-bg\"><div class=\"title\" \ntranslate=\"SEARCH.FILTER\">Filter</div></header><div class=\"content\"><div layout=\"column\" layout-wrap><div layout=\"row\" \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"SEARCH.INDUSTRY\">Industry</label><md-select \nng-model=\"vm.searchKeys.industryCode\"><md-option selected=\"selected\" ng-value=\"null\"><em><span translate=\"SEARCH.ALL\">\nAll</span></em></md-option><md-option ng-repeat=\"item in vm.industryCodes | orderBy:\'name\'\" ng-value=\"item.key\">\n{{item.name}}</md-option></md-select></md-input-container><md-input-container flex><label translate=\"SEARCH.COUNTRY\">\nCountry</label><md-select ng-model=\"vm.searchKeys.countryCode\"><md-option selected=\"selected\" ng-value=\"null\"><em><span\n translate=\"SEARCH.ALL\">All</span></em></md-option><md-option ng-repeat=\"item in vm.countryCodes | orderBy:\'name\'\" \nng-value=\"item.key\">{{item.name}}</md-option></md-select></md-input-container></div><md-input-container flex><label \ntranslate=\"SEARCH.COMPANY_NAME\">Company Name</label><input type=\"text\" ng-model=\"vm.searchKeys.companyName\" \nng-maxlength=\"100\"></md-input-container></div><md-button class=\"md-raised md-primary md-hue-1\" ng-click=\"vm.search()\">\n<span translate=\"SEARCH.SEARCH\" translate-attr-aria-label=\"SEARCH.SEARCH\">Search</span></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/pages/search/tabs/person/search-person.html","<div layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"65\" flex-gt-md=\"70\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><div class=\"md-whiteframe-1dp\" layout=\"column\" ng-class=\"{loading:vm.loadingProgress}\"><div \nclass=\"content\"><div class=\"no-results\" ng-show=\"vm.noResultsFound\" translate=\"SEARCH.NO_RESULTS_FOUND\" \ntranslate-attr-aria-label=\"SEARCH.NO_RESULTS_FOUND\">No results found</div><md-list-item class=\"md-2-line person-item\" \nng-repeat=\"item in vm.personPages\"><img ng-src=\"{{item.photoURL}}\" class=\"md-avatar\" alt=\"{{item.displayName}}\"><div \nclass=\"md-list-item-text\"><h3><a href=\"/person/{{item.key}}\">{{item.displayName}}</a></h3><div class=\"industry-name\">\n{{item.countryName}}</div></div><md-button class=\"md-secondary md-raised md-accent follow-unfollow-btn\" \naria-label=\"Unfollow\" ng-if=\"item.isFollowing\" ng-click=\"vm.unFollowPersonPage(item.key)\"><span \ntranslate=\"SEARCH.UNFOLLOW\" translate-attr-aria-label=\"SEARCH.UNFOLLOW\">Unfollow</span></md-button><md-button \nclass=\"md-secondary md-raised md-accent follow-unfollow-btn\" aria-label=\"Follow\" ng-if=\"!item.isFollowing\" \nng-click=\"vm.followPersonPage(item.key)\"><span translate=\"SEARCH.FOLLOW\" translate-attr-aria-label=\"SEARCH.FOLLOW\">\nFollow</span></md-button><md-divider></md-divider></md-list-item><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"show-more-button\" ng-click=\"vm.showMore()\" ng-show=\"vm.showMoreBtnVisible\"><span \ntranslate=\"SEARCH.SHOW_MORE\" translate-attr-aria-label=\"SEARCH.SHOW_MORE\">Show more</span></md-button></div></div>\n</div></div><div class=\"search-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-md=\"30\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"\" layout=\"column\"><header class=\"md-primary-bg\"><div class=\"title\" \ntranslate=\"SEARCH.FILTER\">Filter</div></header><div class=\"content\"><div layout=\"column\" layout-wrap><div layout=\"row\" \nlayout-gt-sm=\"column\"><md-input-container flex><label translate=\"SEARCH.COUNTRY\">Country</label><md-select \nng-model=\"vm.searchKeys.countryCode\"><md-option selected=\"selected\" ng-value=\"null\"><em><span translate=\"SEARCH.ALL\">\nAll</span></em></md-option><md-option ng-repeat=\"item in vm.countryCodes | orderBy:\'name\'\" ng-value=\"item.key\">\n{{item.name}}</md-option></md-select></md-input-container></div><md-input-container flex><label \ntranslate=\"SEARCH.FULLNAME\">Full Name</label><input type=\"text\" ng-model=\"vm.searchKeys.displayName\" \nng-maxlength=\"100\"></md-input-container></div><md-button class=\"md-raised md-primary md-hue-1\" ng-click=\"vm.search()\">\n<span translate=\"SEARCH.SEARCH\" translate-attr-aria-label=\"SEARCH.SEARCH\">Search</span></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/pages/shared-withme/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-2\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><i md-font-icon=\"icon-{{file.type}}\"></i> </span><span class=\"name\">{{file.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/shared-withme/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th class=\"file-icon\"></th><th translate=\"SW.NAME\">Name</th><th hide-xs \ntranslate=\"SW.COMPANY\">Company</th><th hide-xs translate=\"SW.SUBMITTED\">Submitted</th><th class=\"show-details\"></th>\n</tr></thead><tbody><tr ng-repeat=\"form in vm.sharedForms | filter:global.search\" ng-click=\"vm.select(form)\" \nng-class=\"{\'selected\' : vm.selected === form}\"><td class=\"file-icon\"><div id=\"file-uploader\"><md-button \nclass=\"add-file-button md-fab md-mini md-warn\" aria-label=\"Add form\" translate translate-attr-aria-label=\"SW.ADD_FORM\" \nng-click=\"vm.openFillFormDialog($event,form.Key,form.Name,form.CompanyKey)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div></td><td class=\"name\">{{form.Name}}</td><td class=\"owner\" hide-xs><p \nui-sref=\"app.public-company({companyKey:form.CompanyKey, companyURL:form.CompanyURL})\">{{form.CompanyName}}</p></td><td\n class=\"total\" hide-xs ng-click=\"vm.viewFormList(form, ev)\"><span>{{form.FormTotal}}</span></td><td \nclass=\"show-details\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"SW.OPTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.openFillFormDialog($event,form.Key,form.Name,form.CompanyKey)\" translate=\"SW.NEW_FORM\">New Form\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.viewFormList(form, ev)\" \ntranslate=\"SW.VIEW_SUBMISSIONS\">View Submissions</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><div class=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.sharedForms.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"SW.NO_DATA_MSG\" \ntranslate-attr-aria-label=\"SW.NO_DATA_MSG\">There is no data to show right now.</span></div></div>");
$templateCache.put("app/main/pages/shared-withme/views/view-formlist/view-formlist.html","<div id=\"view-formlist\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex>\n<div class=\"header md-accent-bg\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-forms-button md-icon-button\" aria-label=\"Go to forms\" ng-click=\"vm.goSharedWithMe()\" translate \ntranslate-attr-aria-label=\"SW.GO_TO_FORMS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"form-header\">{{vm.designFormName}} <span \ntranslate=\"SW.SUBMISSIONS\">Submissions</span></div><div class=\"subtitle secondary-text\"><span \ntranslate=\"SW.SHARED_WITH_ME\">Shared With Me</span></div></div></div></div><md-content class=\"content\" flex ms-scroll>\n<table class=\"simple\"><thead><tr><th translate=\"SW.PREVIEW\">Preview</th><th hide-xs translate=\"SW.FORM_NAME\">Name</th>\n<th translate=\"SW.CREATED\">Created</th><th translate=\"SW.FORM_ID\">Form Id</th><th translate=\"SW.STATUS\">Status</th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"form in vm.forms | orderBy:\'-DateCreated\' | filter:global.search\" \nng-click=\"vm.select(form)\" ng-class=\"{\'selected\' : vm.selected === form}\"><td><md-button class=\"md-icon-button\" \nng-click=\"vm.openViewFormDialog(form, $event)\" aria-label=\"Preview form\" translate \ntranslate-attr-aria-label=\"SW.PREVIEW_FORM\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span \ntranslate=\"SW.PREVIEW_FORM\">Preview form</span></md-tooltip></md-button></td><td hide-xs>{{form.DesignFormName}}</td>\n<td>{{form.DateCreated | altDate}}</td><td class=\"form-key\">{{form.FormKey}}</td><td class=\"form-status\"><md-icon \nclass=\"status-pending\" ng-if=\"form.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nclass=\"status-completed\" ng-if=\"form.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></td><td \nclass=\"show-details\"><md-button hide-gt-md class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" \naria-label=\"Details\" translate translate-attr-aria-label=\"SW.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon></md-button></td></tr></tbody></table><div class=\"md-whiteframe-1dp no-results-item\" \nng-show=\"vm.forms.length==0\"><div><md-icon md-font-icon=\"icon-comment-account-outline\"></md-icon><span \ntranslate=\"SW.NO_DATA_MSG\" translate-attr-aria-label=\"SW.NO_DATA_MSG\">There is no data to show right now.</span></div>\n</div></md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"form-detail-sidenav\" \nng-include=\"\'app/main/pages/shared-withme/views/view-formlist/sidenav/form-process-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/pages/waiting-forme/dialogs/view-form/view-form-dialog.html","<md-dialog class=\"view-form-dialog\" aria-label=\"View Form\"><form id=\"viewForm\" name=\"viewForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"view-form-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\"><div bind-html-compile=\"item.html\"></div></li></ul></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" \naria-label=\"Close\" translate=\"SW.CLOSE\" translate-attr-aria-label=\"SW.CLOSE\">CLOSE</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/my-company/my-company-messages/sidenavs/left/left-sidenav.html","<div ng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/my-company/my-company-messages/sidenavs/left/views/messages/messages-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/apps/my-company/my-company-page/dialogs/upload-bg/uploadbg-dialog.html","<md-dialog class=\"upload-bg-dialog\" aria-label=\"Upload Background\"><md-toolbar class=\"md-accent md-tall\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PROFILE.CHANGE_BACKGROUND\" translate-attr-aria-label=\"PROFILE.CHANGE_BACKGROUND\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Cancel dialog\" translate \ntranslate-attr-aria-label=\"PROFILE.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div>Select an image file: <input type=\"file\" ng-model-instant \nonchange=\"angular.element(this).scope().imageUpload(this)\" id=\"fileInput\"></div><div class=\"cropArea\"><img-crop \nimage=\"myImage\" result-image=\"vm.myCroppedImage\" result-image-size=\"200\" area-type=\"square\" area-min-size=\"150\">\n</img-crop></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.executeImgSave(vm.myCroppedImage)\" \nng-show=\"vm.showSaveButton\" class=\"md-accent md-raised\" aria-label=\"Save\" translate=\"PROFILE.SAVE\" \ntranslate-attr-aria-label=\"PROFILE.SAVE\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-company-page/dialogs/upload-picture/uploadpicture-dialog.html","<md-dialog class=\"upload-picture-dialog\" aria-label=\"Update Picture\"><md-toolbar class=\"md-accent md-tall\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"PROFILE.CHANGE_PICTURE\" translate-attr-aria-label=\"PROFILE.CHANGE_PICTURE\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Cancel dialog\" translate \ntranslate-attr-aria-label=\"PROFILE.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div>Select an image file: <input type=\"file\" ng-model-instant \nonchange=\"angular.element(this).scope().imageUpload(this)\" id=\"fileInput\"></div><div class=\"cropArea\"><img-crop \nimage=\"myImage\" result-image=\"vm.myCroppedImage\"></img-crop></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.executeImgSave(vm.myCroppedImage)\" ng-disabled=\"!vm.showSaveButton\" class=\"md-accent md-raised\" \naria-label=\"Save\" translate=\"PROFILE.SAVE\" translate-attr-aria-label=\"PROFILE.SAVE\">Save</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/myform/adduser-dialog.html","<md-dialog class=\"myform-dialog\" aria-label=\"New User\"><form name=\"addUserForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MF.NEW_USER\">New User</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"MF.EMAIL\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.newUser\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired><div ng-messages=\"addUserForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MF.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"MF.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submitForm($event,vm.newUser)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"addUserForm.$invalid || addUserForm.$pristine\" \naria-label=\"Add User\" translate=\"MF.ADD_USER\" translate-attr-aria-label=\"MF.ADD_USER\">ADD USER</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/myform/myform-dialog.html","<md-dialog class=\"myform-dialog\" aria-label=\"New Form\"><form name=\"myForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"MF.NAME\">Name</label><input ng-model=\"vm.myForm.Name\" type=\"text\" name=\"formName\" required ng-minlength=\"4\" \nng-maxlength=\"40\" md-autofocus><div ng-messages=\"myForm.formName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MF.REQUIRED\">Required</div><div ng-message=\"minlength\"><span translate=\"MF.FORM_NAME_MIN_LENGTH_WARNING\">\nForm name can\'t be shorter than 4 characters</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"MF.FORM_NAME_MAX_LENGTH_WARNING\">Form name can\'t be longer than 50 characters</span></div></div>\n</md-input-container><md-select class=\"account-selection simplified\" ng-model=\"vm.myForm.Type\" required \nplaceholder=\"Type\"><md-option value=\"Public\" translate=\"MF.PUBLIC\">Public</md-option><md-option value=\"Private\" \ntranslate=\"MF.PRIVATE\">Private</md-option></md-select></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.newForm\" ng-click=\"vm.addNewForm()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"myForm.$invalid || myForm.$pristine\" aria-label=\"Add Form\" translate=\"MF.ADD_FORM\" \ntranslate-attr-aria-label=\"MF.ADD_FORM\">ADD FORM</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/sidenavs/design-form-settings/design-form-settings.html","<div class=\"header md-accent-bg\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><h1>\nSettings ({{vm.settingsItem.Type}})</h1></div></div><md-content id=\"settings-content\" class=\"content\" flex ms-scroll>\n<form id=\"settingsForm\" name=\"settingsForm\" class=\"md-inline-form\"><div id=\"setPanel\" \nclass=\"form-wrapper md-whiteframe-1dp\" flex><nftext-value \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'text-value\')\"></nftext-value><nfalign-item \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'align-item\')\"></nfalign-item><nflabel-text \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'label-text\')\"></nflabel-text><nfmax-char \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'max-char\')\"></nfmax-char><nfrequired-field \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'required-field\')\"></nfrequired-field><nfselect-options \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'select-options\')\"></nfselect-options><nfselect-optionorder \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'option-order\')\"></nfselect-optionorder><nfimage-file \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'image-file\')\"></nfimage-file><nfminmax-date \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'minmax-date\')\"></nfminmax-date><nfdate-hideicons \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'date-hideicons\')\"></nfdate-hideicons><nfminmax-value \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'minmax-value\')\"></nfminmax-value><nfphonenumber-mask \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'phonenumber-mask\')\"></nfphonenumber-mask><nfrow-number \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'row-number\')\"></nfrow-number><nfallow-adddeleterows \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'allow-adddeleterows\')\"></nfallow-adddeleterows><nftable-columns \nng-if=\"vm.checkSettingsItem(vm.settingsItem.Type, \'table-columns\')\"></nftable-columns></div><md-button \nid=\"btnSetPanelSave\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Save\" ng-click=\"vm.btnSettingsPanelSave()\" \ntranslate=\"MF.SAVE\" translate-attr-aria-label=\"MF.SAVE\" ng-disabled=\"settingsForm.$invalid\">Save</md-button></form>\n</md-content>");
$templateCache.put("app/main/apps/my-company/my-forms/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.gotoFormDetail(vm.selected.Key)\" \naria-label=\"Edit\" translate translate-attr-aria-label=\"MF.EDIT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip><span translate=\"MF.EDIT\">Edit</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.gotoFormSubmissions(vm.selected.Key)\" aria-label=\"View Submissions\" translate \ntranslate-attr-aria-label=\"MF.VIEW_SUBMISSIONS\"><md-icon md-font-icon=\"icon-file-find\"></md-icon><md-tooltip><span \ntranslate=\"MF.VIEW_SUBMISSIONS\">View Submissions</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteFormConfirm()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"MF.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MF.DELETE\">Delete</span></md-tooltip></md-button>\n</div><div><div class=\"title\">{{vm.selected.Name}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"MF.EDITED\">Edited</span>: {{vm.selected.DateEdited | altDate}}</div></div></div><md-content class=\"content\" \nflex ms-scroll><div class=\"form-details\"><div class=\"widget-group\" layout=\"column\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget_SubmittedForms.currentRange\" ng-change=\"vm.loadSubmittedFormsWidget(key)\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget_SubmittedForms.ranges\" value=\"{{key}}\">\n{{range}}</md-option></md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.widget_SubmittedForms.data.count[vm.widget_SubmittedForms.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget_SubmittedForms.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget_SubmittedForms.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget_SubmittedForms.data.extra.count[vm.widget_SubmittedForms.currentRange]}}</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget_SharedUsers.title}}</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.widget_SharedUsers.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{vm.widget_SharedUsers.data.label}}</div></div></ms-widget-front></ms-widget></div></div></md-content>");
$templateCache.put("app/main/apps/my-company/my-forms/sidenavs/main-sidenav/main-sidenav.html","<div layout=\"column\" ms-scroll flex><div layout=\"row\" layout-align=\"center center\"><div id=\"image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-success=\"vm.imageSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" \nflow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\"><md-button flow-btn \nclass=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate translate-attr-aria-label=\"NOTES.ADD_IMAGE\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon></md-button></div><ms-material-color-picker \nng-model=\"vm.form.WidgetColor\"><md-button class=\"md-icon-button\" aria-label=\"Widget color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-button \nng-if=\"vm.form.WidgetImageURL\" class=\"delete-img-button md-icon-button\" ng-click=\"vm.deleteImage()\" \naria-label=\"Delete image\" translate translate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20\"></md-icon></md-button></div><md-card class=\"note {{vm.form.WidgetColor}}\"><img \nng-if=\"vm.form.WidgetImageURL\" ng-src=\"{{vm.form.WidgetImageURL}}\" class=\"md-card-image\" alt=\"vm.form.Name\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">{{vm.form.Name}}</span></md-card-title-text>\n</md-card-title><md-card-content><div bind-html-compile=\"vm.form.Description\"></div></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"chats button\"><md-icon\n md-font-icon=\"icon-plus-circle-outline s36\"></md-icon></md-button></md-card-actions></md-card></div>");
$templateCache.put("app/main/apps/my-company/my-forms/sidenavs/search-template/search-template.html","<div class=\"header md-accent-bg\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><h1>\nSearch Template</h1><md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchTemplateDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></div><md-content id=\"templates-content\" class=\"content\" flex ms-scroll><md-list class=\"\" flex>\n<md-list-item class=\"\" ng-repeat=\"template in vm.templates\"><img ng-src=\"{{template.UserPhotoURL}}\" class=\"md-avatar\" \nalt=\"{{template.UserDisplayName}}\"><div class=\"md-list-item-text\" layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"form-name\">{{ template.Name }}</div><p ng-text-truncate=\"template.Description\" ng-tt-words-threshold=\"20\"></p>\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"user-name\">{{ template.UserDisplayName }}</div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Preview\" translate \ntranslate-attr-aria-label=\"MF.HEADER\" ng-click=\"vm.btnPreviewTemplate($event, template.Key, template.Name)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"MF.HEADER\" ng-click=\"vm.btnDownloadTemplate($event, template.Key, template.Name)\">\n<md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon></md-button></div></div></div><md-divider></md-divider>\n</md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/my-company/my-forms/sidenavs/toolbar-left/toolbar-left.html","<md-toolbar class=\"md-theme-light\"><h3 class=\"md-toolbar-tools\">Toolbar</h3></md-toolbar><div class=\"content\"><div \nclass=\"navigation-simple\" layout=\"column\"><div class=\"item subheader\" translate=\"MF.BASIC_TOOLS\">Basic Tools</div>\n<md-button class=\"item\" aria-label=\"Header\" translate translate-attr-aria-label=\"MF.HEADER\" \nng-click=\"vm.toolbarClick(\'Header\')\"><md-icon md-font-icon=\"icon-format-header-1\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"MF.HEADER\">Header</span></md-button><md-button class=\"item\" aria-label=\"Label\" translate \ntranslate-attr-aria-label=\"MF.LABEL\" ng-click=\"vm.toolbarClick(\'Label\')\"><md-icon md-font-icon=\"icon-format-text\" \nclass=\"s16\"></md-icon><span class=\"title\" translate=\"MF.LABEL\">Label</span></md-button><md-button class=\"item\" \naria-label=\"Text Box\" translate translate-attr-aria-label=\"MF.TEXTBOX\" ng-click=\"vm.toolbarClick(\'Text Box\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MF.TEXTBOX\">Text Box\n</span></md-button><md-button class=\"item\" aria-label=\"Text Area\" translate translate-attr-aria-label=\"MF.TEXTAREA\" \nng-click=\"vm.toolbarClick(\'Text Area\')\"><md-icon md-font-icon=\"icon-menu\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"MF.TEXTAREA\">Text Area</span></md-button><md-button class=\"item\" aria-label=\"Dropdown\" translate \ntranslate-attr-aria-label=\"MF.DROPDOWN\" ng-click=\"vm.toolbarClick(\'Dropdown\')\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MF.DROPDOWN\">Dropdown</span>\n</md-button><md-button class=\"item\" aria-label=\"Radio Button\" translate translate-attr-aria-label=\"MF.RADIO_BUTTON\" \nng-click=\"vm.toolbarClick(\'Radio Button\')\"><md-icon md-font-icon=\"icon-radiobox-marked\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"MF.RADIO_BUTTON\">Radio Button</span></md-button><md-button class=\"item\" aria-label=\"Checkbox\" \ntranslate translate-attr-aria-label=\"MF.CHECKBOX\" ng-click=\"vm.toolbarClick(\'Checkbox\')\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MF.CHECKBOX\">Checkbox\n</span></md-button><md-button class=\"item\" aria-label=\"Image\" translate translate-attr-aria-label=\"MF.IMAGE\" \nng-click=\"vm.toolbarClick(\'Image\')\"><md-icon md-font-icon=\"icon-image-area\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"MF.IMAGE\">Image</span></md-button><md-button class=\"item\" aria-label=\"Line\" translate \ntranslate-attr-aria-label=\"MF.LINE\" ng-click=\"vm.toolbarClick(\'Line\')\"><md-icon md-font-icon=\"icon-minus\" class=\"s16\">\n</md-icon><span class=\"title\" translate=\"MF.LINE\">Line</span></md-button><md-button class=\"item\" \naria-label=\"Page Break\" hide translate translate-attr-aria-label=\"MF.PAGE_BREAK\" \nng-click=\"vm.toolbarClick(\'Page Break\')\"><md-icon md-font-icon=\"icon-window-closed\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"MF.PAGE_BREAK\">Page Break</span></md-button><div class=\"item subheader\" \ntranslate=\"MF.QUICK_TOOLS\">Quick Tools</div><md-button class=\"item\" aria-label=\"Date\" translate \ntranslate-attr-aria-label=\"MF.DATE\" ng-click=\"vm.toolbarClick(\'Date\')\"><md-icon md-font-icon=\"icon-calendar-blank\" \nclass=\"s16\"></md-icon><span class=\"title\" translate=\"MF.DATE\">Date</span></md-button><md-button class=\"item\" \naria-label=\"Time\" translate translate-attr-aria-label=\"MF.TIME\" ng-click=\"vm.toolbarClick(\'Time\')\"><md-icon \nmd-font-icon=\"icon-timer\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MF.TIME\">Time</span></md-button>\n<md-button class=\"item\" aria-label=\"Numeric\" translate translate-attr-aria-label=\"MF.NUMERIC\" \nng-click=\"vm.toolbarClick(\'Numeric\')\"><md-icon md-font-icon=\"icon-numeric\" class=\"s16\"></md-icon><span class=\"title\" \ntranslate=\"MF.NUMERIC\">Numeric</span></md-button><md-button class=\"item\" aria-label=\"Email\" translate \ntranslate-attr-aria-label=\"MF.EMAIL\" ng-click=\"vm.toolbarClick(\'Email\')\"><md-icon md-font-icon=\"icon-email\" \nclass=\"s16\"></md-icon><span class=\"title\" translate=\"MF.EMAIL\">Email</span></md-button><md-button class=\"item\" \naria-label=\"Phone Number\" translate translate-attr-aria-label=\"MF.PHONE_NUMBER\" \nng-click=\"vm.toolbarClick(\'Phone Number\')\"><md-icon md-font-icon=\"icon-phone\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"MF.PHONE_NUMBER\">Phone Number</span></md-button><md-button class=\"item\" \naria-label=\"File Upload\" translate translate-attr-aria-label=\"MF.FILE_UPLOAD\" \nng-click=\"vm.toolbarClick(\'File Upload\')\"><md-icon md-font-icon=\"icon-upload\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"MF.FILE_UPLOAD\">File Upload</span></md-button><md-button class=\"item\" aria-label=\"Table\" \ntranslate translate-attr-aria-label=\"MF.TABLE\" ng-click=\"vm.toolbarClick(\'Table\')\"><md-icon md-font-icon=\"icon-table\" \nclass=\"s16\"></md-icon><span class=\"title\" translate=\"MF.TABLE\">Table</span></md-button></div></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/myform.html","<div id=\"my-form\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"\" md-component-id=\"design-form-settings\" \nng-include=\"\'app/main/apps/my-company/my-forms/sidenavs/design-form-settings/design-form-settings.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><md-sidenav class=\"sidenav md-sidenav-left\" md-is-locked-open=\"\" \nmd-component-id=\"search-template\" \nng-include=\"\'app/main/apps/my-company/my-forms/sidenavs/search-template/search-template.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-forms-button md-icon-button\" \naria-label=\"Go to forms\" ng-click=\"vm.gotoForms()\" translate translate-attr-aria-label=\"MF.GO_TO_FORMS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.form.Name}}</div><div class=\"subtitle secondary-text\"><span translate=\"MF.MY_FORMS\">My Forms</span></div></div>\n</div></div><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height><md-tab \nui-sref=\"app.my-company_my-forms.detail.main\"><md-tab-label><span translate=\"MF.MAIN\">Main</span></md-tab-label>\n<md-tab-body><div ui-view=\"main\"></div></md-tab-body></md-tab><md-tab ui-sref=\"app.my-company_my-forms.detail.users\">\n<md-tab-label><span translate=\"MF.USERS\">Users</span></md-tab-label><md-tab-body><div ui-view=\"users\"></div>\n</md-tab-body></md-tab><md-tab ui-sref=\"app.my-company_my-forms.detail.design\"><md-tab-label><span \ntranslate=\"MF.DESIGN\">Design</span></md-tab-label><md-tab-body><div ui-view=\"design\"></div></md-tab-body></md-tab>\n<md-tab ui-sref=\"app.my-company_my-forms.detail.process\"><md-tab-label><span translate=\"MF.PROCESS\">Process</span>\n</md-tab-label><md-tab-body><div ui-view=\"process\"></div></md-tab-body></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-2\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><i md-font-icon=\"icon-{{file.type}}\"></i> </span><span class=\"name\">{{file.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th translate=\"MF.NAME\">Name</th><th hide show-gt-sm translate=\"MF.TYPE\">\nType</th><th hide-xs translate=\"MF.CREATED\">Created</th><th hide show-gt-md translate=\"MF.LAST_MODIFIED\">Last Modified\n</th><th hide-gt-md class=\"show-details\"></th></tr></thead><tbody><tr \nng-repeat=\"form in vm.myForms | filter:global.search\" ng-click=\"vm.select(form)\" \nng-class=\"{\'selected\' : vm.selected === form}\"><td>{{form.Name}}</td><td hide show-gt-sm>{{form.Type}}</td><td hide-xs>\n{{form.DateCreated | altDate}}</td><td hide show-gt-md>{{form.DateEdited | altDate}}</td><td hide-gt-md \nclass=\"show-details\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" \naria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon></md-button></td></tr></tbody></table><div class=\"md-whiteframe-1dp no-results-item\" \nng-show=\"vm.myForms.length==0\"><div><md-icon md-font-icon=\"icon-comment-account-outline\"></md-icon><span \ntranslate=\"MF.NO_DATA_MSG\" translate-attr-aria-label=\"MF.NO_DATA_MSG\">There is no data to show right now.</span></div>\n</div>");
$templateCache.put("app/main/pages/shared-withme/views/view-formlist/dialog/viewform-dialog.html","<md-dialog class=\"viewform-dialog\" aria-label=\"View Form\"><form id=\"viewForm\" name=\"viewForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"viewform-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\"><div bind-html-compile=\"item.html\"></div></li></ul></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" \naria-label=\"Close\" translate=\"SW.CLOSE\" translate-attr-aria-label=\"SW.CLOSE\">CLOSE</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/shared-withme/views/view-formlist/sidenav/form-process-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"title\" translate=\"SW.PROCESS\">Process</div><div class=\"status-icon\"><md-icon \nng-if=\"vm.selected.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nng-if=\"vm.selected.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></div></div><div \nclass=\"subtitle secondary-text\"><span translate=\"SW.FORM_ID\">Form Id</span>: {{vm.selected.FormKey}}</div></div>\n<md-content class=\"content\" flex ms-scroll><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.formTransactions[vm.selected.FormKey] | orderBy:\'DateTime\'\"><img ng-src=\"{{item.PhotoURL}}\" \nclass=\"md-avatar\" alt=\"\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.UserName }}</h3><h4>\n{{ item.DateTime | altDate}}</h4><p>{{ item.Action }}</p></div><md-divider></md-divider></md-list-item></md-list>\n</md-content>");
$templateCache.put("app/main/apps/messaging/sidenavs/left/views/messages/messages-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><span translate=\"MESSAGING.MESSAGING\">\nMessaging</span><md-menu md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.setChatGroupFilter(\'ALL\')\" \ntranslate=\"MESSAGING.ALL_MESSAGES\">All Messages</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setChatGroupFilter(\'UNREAD\')\" translate=\"MESSAGING.UNREAD\">Unread</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.setChatGroupFilter(\'ARCHIVED\')\" translate=\"MESSAGING.ARCHIVED\">Archived</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div \nclass=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"vm.chatSearch\" type=\"text\" placeholder=\"Search or start new chat\" translate=\"\" \ntranslate-attr-placeholder=\"MESSAGING.CHAT_SEARCH_PLACEHOLDER\"></div></div></div></md-toolbar><md-content flex \nms-scroll><md-list class=\"chat-list\"><div ng-show=\"vm.chatSearch && filteredChat.length > 0\" \nclass=\"md-accent-fg subheader\" ng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length+1}\" \ntranslate=\"MESSAGING.FILTER_MSG_{{vm.chatFilterGroupName}}\">Filter Group Message</div><md-list-item \nclass=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index+1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length - $index}\" \nng-repeat=\"contact in vm.contacts | orderBy:\'-LastDate\' | filter: {DisplayName: vm.chatSearch} | filter: vm.chatFilterByGroup | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.MsgUID); vm.markRead()\" ng-class=\"{\'unread\':!contact.IsRead}\"><div class=\"avatar-wrapper\">\n<img ng-src=\"{{contact.PhotoURL}}\" class=\"md-avatar avatar\" alt=\"{{contact.DisplayName}}\"> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">\n{{contact.DisplayName}}</h3><p class=\"last-message text-truncate\">{{contact.LastMessage}}</p></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"last-message-time\">{{contact.LastDate | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"filteredChat.length > 0\" class=\"no-results-message\" \ntranslate=\"MESSAGING.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/design/preview-form/preview-form-dialog.html","<md-dialog class=\"preview-form-dialog\" aria-label=\"Preview Form\"><form id=\"previewForm\" name=\"previewForm\" novalidate>\n<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"form-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.previewFormItems track by $index\" ng-init=\"parentIndex = $index\"><div \nbind-html-compile=\"item.html\"></div></li></ul></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nng-click=\"vm.cancelDialog()\" class=\"md-accent md-raised\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"MF.CLOSE\">CLOSE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/design/preview-template/preview-template-dialog.html","<md-dialog class=\"preview-template-dialog\" aria-label=\"Preview Template\"><form id=\"previewTemplate\" \nname=\"previewTemplate\" novalidate><md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"form-content\" \nclass=\"md-whiteframe-2dp\"><ul><li ng-repeat=\"item in vm.formItems track by $index\" ng-init=\"parentIndex = $index\"><div \nbind-html-compile=\"item.html\"></div></li></ul></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nng-click=\"vm.cancelDialog()\" class=\"md-accent md-raised\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"MF.CLOSE\">CLOSE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/design/upload-template/upload-template-dialog.html","<md-dialog class=\"upload-template-dialog\" aria-label=\"Upload Template\"><form name=\"uploadTemplateForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \ntranslate=\"MF.UPLOAD_TEMPLATE_DESC1\" class=\"desc\">\nUpload your form as a template and let other users download and use it.</div><div translate=\"MF.UPLOAD_TEMPLATE_DESC2\" \nclass=\"desc\">Make sure you save the form first, because the last saved form will be uploaded.</div><md-divider>\n</md-divider><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"name\" ng-model=\"vm.form.name\" \nrequired md-maxlength=\"50\" translate translate-attr-placeholder=\"Name\" aria-label=\"name\"><div \nng-messages=\"uploadTemplateForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MF.REQUIRED\">Required</span></div><div ng-message=\"md-maxlength\"><span translate=\"MF.MAX_LENGTH_WARNING\">\nMax length error</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><textarea \ntype=\"text\" name=\"description\" ng-model=\"vm.form.description\" required md-maxlength=\"500\" rows=\"1\" max-rows=\"10\" \ntranslate translate-attr-placeholder=\"Description\" aria-label=\"description\"></textarea><div \nng-messages=\"uploadTemplateForm.description.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MF.REQUIRED\">Required</span></div><div ng-message=\"md-maxlength\"><span translate=\"MF.MAX_LENGTH_WARNING\">\nMax length error</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.submitForm($event)\" class=\"send-button md-accent md-raised\" ng-disabled=\"uploadTemplateForm.$invalid\" \naria-label=\"Upload\" translate=\"MF.UPLOAD\" translate-attr-aria-label=\"MF.ADD\">UPLOAD</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/add-approval/add-approval-dialog.html","<md-dialog class=\"add-approval-dialog\" aria-label=\"New approval process\"><form name=\"addApprovalForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MF.PARENT_OBJECT\">Parent object</label><md-select ng-model=\"vm.form.parentName\" \nng-disabled=\"true\"><md-option ng-value=\"vm.form.parentName\">{{vm.form.parentName}}-{{vm.form.parentUserEmail}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.form.parentName==\'0\'\">\n<label translate=\"MF.PROCESS_ACTION\">Process action</label><md-select ng-model=\"vm.form.parentAction\" required>\n<md-option value=\"Submission\" translate=\"MF.SUBMISSION\">Submission</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.form.parentName!=\'0\'\"><label translate=\"MF.APPROVAL_OPTION\">\nApproval option</label><md-select ng-model=\"vm.form.parentAction\" required><md-option value=\"Approve\" \ntranslate=\"MF.APPROVE\">Approve</md-option><md-option value=\"Reject\" translate=\"MF.REJECT\">Reject</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"MF.SELECT_USER\">Select user\n</label><md-select ng-model=\"vm.form.selectedUser\" required><md-option ng-value=\"user\" \nng-repeat=\"user in vm.formUsers | orderBy:\'Email\'\">{{ user.Email }}</md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addNewApproval($event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"addApprovalForm.$invalid\" aria-label=\"Add\" translate=\"MF.ADD\" \ntranslate-attr-aria-label=\"MF.ADD\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/add-termination/add-termination-dialog.html","<md-dialog class=\"add-termination-dialog\" aria-label=\"New Termination Object\"><form name=\"addTerminationForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MF.PARENT_OBJECT\">Parent object</label><md-select ng-model=\"vm.form.parentName\" \nng-disabled=\"true\"><md-option ng-value=\"vm.form.parentName\">{{vm.form.parentName}}-{{vm.form.parentUserEmail}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.form.parentName==\'0\'\">\n<label translate=\"MF.PROCESS_ACTION\">Process action</label><md-select ng-model=\"vm.form.parentAction\" required>\n<md-option value=\"Submission\" translate=\"MF.SUBMISSION\">Submission</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.form.parentName!=\'0\'\"><label translate=\"MF.APPROVAL_OPTION\">\nApproval option</label><md-select ng-model=\"vm.form.parentAction\" required><md-option value=\"Approve\" \ntranslate=\"MF.APPROVE\">Approve</md-option><md-option value=\"Reject\" translate=\"MF.REJECT\">Reject</md-option>\n</md-select></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.submitForm($event)\" class=\"send-button md-accent md-raised\" ng-disabled=\"addTerminationForm.$invalid\" \naria-label=\"Add\" translate=\"MF.ADD\" translate-attr-aria-label=\"MF.ADD\">ADD</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/delete-object/delete-object-dialog.html","<md-dialog class=\"delete-object-dialog\" aria-label=\"Delete object\"><form name=\"deleteObjectForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"message\">\n{{vm.textContent}}</div><div ng-if=\"vm.childNumber>0\"><md-radio-group ng-model=\"vm.form.selection\" \nng-change=\"vm.onSelectionChanged(vm.form.selection)\" required><md-radio-button value=\"self\">\nDelete only the selected process object</md-radio-button><md-radio-button value=\"all\">\nDelete together with the following process objects</md-radio-button></md-radio-group></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.submitForm($event)\" class=\"send-button md-accent md-raised\" \nng-disabled=\"deleteObjectForm.$invalid\" aria-label=\"Delete\" translate=\"MF.DELETE\" \ntranslate-attr-aria-label=\"MF.DELETE\">DELETE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/duplicate-process/duplicate-process-dialog.html","<md-dialog class=\"duplicate-process-dialog\" aria-label=\"Duplicate Process Warning\"><form name=\"duplicateProcessForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-warn\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div>{{vm.warningMsg}}\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submitForm($event)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Continue\" translate=\"MF.CONTINUE\" \ntranslate-attr-aria-label=\"MF.CONTINUE\">CONTINUE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/edit-approval/edit-approval-dialog.html","<md-dialog class=\"edit-approval-dialog\" aria-label=\"Edit approval process\"><form name=\"editApprovalForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MF.PARENT_OBJECT\">Parent object</label><md-select ng-model=\"vm.form.parentName\" \nrequired ng-change=\"vm.onParentChanged(vm.form.parentName)\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.allowedObjects\">{{ key }} - {{value.UserEmail}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.parentType==\'Submission\'\"><label \ntranslate=\"MF.ACTION\">Action</label><md-select ng-model=\"vm.form.parentAction\" required><md-option value=\"Submission\" \ntranslate=\"MF.SUBMISSION\">Submission</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.parentType==\'Approval\'\"><label translate=\"MF.ACTION\">Action</label><md-select \nng-model=\"vm.form.parentAction\" required><md-option value=\"Approve\" translate=\"MF.APPROVE\">Approve</md-option>\n<md-option value=\"Reject\" translate=\"MF.REJECT\">Reject</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"vm.type!=\'Termination\'\"><label translate=\"MF.SELECT_USER\">Select user</label><md-select \nng-model=\"vm.form.userEmail\" required><md-option ng-value=\"user.Email\" \nng-repeat=\"user in vm.formUsers | orderBy:\'Email\'\">{{ user.Email }}</md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submitForm($event)\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"editApprovalForm.$invalid\" aria-label=\"Save\" translate=\"MF.SAVE\" \ntranslate-attr-aria-label=\"MF.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/dialogs/process/verification-warning/verification-warning-dialog.html","<md-dialog class=\"verification-warning-dialog\" aria-label=\"Verification warning\"><form name=\"verificationWarningForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-warn\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MF.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \ntranslate=\"MF.PROCESS_VERIFICATION_WARNING_MSG\">\nThere are some incomplete sections that could cause unwanted results in the process. Please check the following warning list. Do you want to save it anyway?\n</div><table><tr ng-repeat=\"(key, value) in vm.unverifiedList\"><td>{{key}}</td><td>{{value.Type}}</td><td>\n{{value.UserEmail}}</td><td ng-if=\"value.Error!=\'No Parent\'\">Requires termination</td><td \nng-if=\"value.Error==\'No Parent\'\">Connect to a parent object</td></tr></table></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.submit($event)\" class=\"send-button md-accent md-raised\" aria-label=\"Save\" \ntranslate=\"MF.SAVE\" translate-attr-aria-label=\"MF.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/design/myformdesign.html","<div id=\"my-form-design\" flex layout=\"row\"><md-content flex><div class=\"page-layout\" flex layout=\"row\"><md-sidenav \nclass=\"toolbar-left\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-xs\')\" md-whiteframe=\"4\" \nng-include=\"\'app/main/apps/my-company/my-forms/sidenavs/toolbar-left/toolbar-left.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" aria-label=\"Save\" \nng-click=\"vm.btnDesignFormDbSave()\"><md-icon md-font-icon=\"icon-content-save\" class=\"s16\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MF.SAVE\">Save</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Up\" ng-click=\"vm.btnElementUp()\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s16\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MF.UP\">Up</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Down\" ng-click=\"vm.btnElementDown()\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s16\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MF.DOWN\">Down</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Copy\" ng-click=\"vm.btnElementClone()\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.CLONE\">Clone</span></md-tooltip>\n</md-button><md-button class=\"md-fab md-mini\" aria-label=\"Delete\" ng-click=\"vm.btnElementDelete()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.DELETE\">Delete\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Settings\" \nng-click=\"vm.btnElementSettings()\"><md-icon md-font-icon=\"icon-cog\" class=\"s16\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate=\"MF.EDIT\">Edit</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Preview\" ng-click=\"vm.btnPreviewForm($event)\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>\n<md-tooltip md-direction=\"bottom\"><span translate=\"MF.PREVIEW\">Preview</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Import Template\" ng-click=\"vm.btnSearchTemplate()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MF.SEARCH_TEMPLATE\">Search template</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" \naria-label=\"Upload Template\" ng-click=\"vm.btnUploadTemplateDialog($event)\"><md-icon md-font-icon=\"icon-cloud-upload\" \nclass=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.UPLOAD_TEMPLATE\">Upload template</span>\n</md-tooltip></md-button></div><div class=\"content\" layout=\"row\" flex><form id=\"formDiv\" name=\"formDiv\" \nclass=\"md-whiteframe-2dp\"><ul ng-if=\"vm.showForm\"><li ng-repeat=\"item in vm.formItems track by $index\"><div \nbind-html-compile=\"item.html\"></div></li></ul></form></div></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/main/main-content.html","<div layout=\"column\" layout-gt-xs=\"row\" ng-init=\"vm.showMyFormMain()\"><form id=\"myForm\" name=\"myForm\" flex=\"65\" \nnovalidate class=\"md-inline-form md-whiteframe-1dp\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label translate=\"MF.NAME\">Name</label><input type=\"text\" name=\"Name\" ng-model=\"vm.form.Name\" ng-minlength=\"4\" \nng-maxlength=\"50\" required><div ng-messages=\"myForm.Name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MF.REQUIRED\">Required</div><div ng-message=\"minlength\"><span translate=\"MF.FORM_NAME_MIN_LENGTH_WARNING\">\nForm name can\'t be shorter than 4 characters</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"MF.FORM_NAME_MAX_LENGTH_WARNING\">Form name can\'t be longer than 50 characters</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"MF.TYPE\">Type</label><md-select \nng-model=\"vm.form.Type\" name=\"Type\" required><md-option value=\"Public\">Public</md-option><md-option value=\"Private\">\nPrivate</md-option></md-select><div ng-messages=\"myForm.Type.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MF.REQUIRED\">Required</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"MF.DESCRIPTION\">Description</label><textarea type=\"text\" name=\"Description\" \nng-model=\"vm.form.Description\" md-maxlength=\"200\" rows=\"3\" max-rows=\"6\">\n                </textarea><div \nng-messages=\"myForm.Description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" translate=\"MF.MAX_LENGTH_WARNING\">\nThe description must be less than the max length</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"MF.CREATED\">Created</label><input type=\"text\" \nname=\"DateCreated\" ng-value=\"vm.form.DateCreated | altDate\" placeholder=\"Created\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><label translate=\"MF.EDITED\">Edited</label><input type=\"text\" \nname=\"DateEdited\" ng-value=\"vm.form.DateEdited | altDate\" placeholder=\"Edited\" readonly=\"readonly\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Save\" \nng-click=\"vm.saveMyFormMain($event)\" translate=\"MF.SAVE\" ng-disabled=\"myForm.$invalid\">Save</md-button></form></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/main/myformmain.html","<div class=\"page-layout simple right-sidenav inner-sidenav form-main-container\"><div class=\"content\" layout=\"row\" \nms-scroll><div flex ng-include=\"\'app/main/apps/my-company/my-forms/views/form/main/main-content.html\'\"></div>\n<md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"sidenav\" ms-sidenav-helper><div\n md-whiteframe-1dp ng-include=\"\'app/main/apps/my-company/my-forms/sidenavs/main-sidenav/main-sidenav.html\'\"></div>\n</md-sidenav></div></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/process/myformprocess.html","<div id=\"my-form-process\" flex layout=\"row\"><md-content flex><div class=\"page-layout\" flex layout=\"row\"><div \nclass=\"center\" layout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" \naria-label=\"Save\" ng-disabled=\"!vm.isProcessAllowed\" ng-click=\"vm.saveProcess($event)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.SAVE\">Save\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Add approval\" \nng-click=\"vm.addApprovalDialog($event)\" ng-disabled=\"!vm.selectedNode || vm.selectedNode.type==\'Termination\'\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"MF.ADD_APPROVAL_OBJECT\">Add approval object</span></md-tooltip></md-button><md-button \nclass=\"md-fab md-mini\" aria-label=\"Add termination object\" ng-click=\"vm.addTerminationDialog($event)\" \nng-disabled=\"!vm.selectedNode || vm.selectedNode.type==\'Termination\'\"><md-icon md-font-icon=\"icon-flag-checkered\" \nclass=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.ADD_TERMINATION_OBJECT\">\nAdd termination object</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Delete\" \nng-click=\"vm.deleteObjectDialog($event)\" ng-disabled=\"!vm.selectedNode || vm.selectedNode.type==\'Submission\'\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.DELETE\">Delete\n</span></md-tooltip></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Settings\" \nng-click=\"vm.editApprovalDialog($event)\" ng-disabled=\"!vm.selectedNode || vm.selectedNode.type==\'Submission\'\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s16\"></md-icon><md-tooltip md-direction=\"bottom\"><span translate=\"MF.EDIT\">Edit</span>\n</md-tooltip></md-button></div><div class=\"process-status\"><md-switch ng-model=\"vm.processActive\" \nng-change=\"vm.changeProcessStatus(vm.processActive)\" ng-disabled=\"!vm.isProcessAllowed\" aria-label=\"Process Status\" \nclass=\"md-warn\"><span translate=\"MF.PROCESS\">Process</span> {{vm.processStatusMsg}}</md-switch></div></div><div \nclass=\"content\" layout=\"row\" layout-align=\"center start\" flex><div ng-if=\"!vm.isUserExist\" class=\"empty-users-div\" \nlayout=\"column\" layout-align=\"center center\"><div translate=\"MF.PROCESS_NO_USER_WARNING\">\nNo users Yet. You need to add at least 1 user to go on process design.</div></div><div \nng-if=\"vm.isUserExist && !vm.isProcessExist\" class=\"empty-process-div\" layout=\"column\" layout-align=\"center center\">\n<div translate=\"MF.NO_PROCESS_YET\">No Process Yet</div><md-button translate=\"MF.START_NOW\" \nng-click=\"vm.startFirstProcess($event)\">Start now</md-button></div><div id=\"chart_div\"></div></div></div></div></div>\n</md-content></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/submissions/myformsubmissions.html","<div id=\"my-form-submissions\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"header md-accent-bg\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" \nflex><md-button class=\"goto-forms-button md-icon-button\" aria-label=\"Go to forms\" ng-click=\"vm.gotoForms()\" translate \ntranslate-attr-aria-label=\"MF.GO_TO_FORMS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"form-header\">{{vm.designForm.Name}} <span \ntranslate=\"MF.SUBMISSIONS\">Submissions</span></div><div class=\"subtitle secondary-text\"><span translate=\"MF.MY_FORMS\">\nMy Forms</span></div></div></div></div><md-content class=\"content\" flex ms-scroll><table class=\"simple\"><thead><tr><th \ntranslate=\"MF.PREVIEW\">Preview</th><th translate=\"MF.CREATED\">Created</th><th translate=\"MF.USER_NAME\">User name</th>\n<th translate=\"MF.FORM_ID\">Form Id</th><th translate=\"MF.STATUS\">Status</th><th hide-gt-md></th></tr></thead><tbody><tr\n ng-repeat=\"form in vm.formSubmissions | filter:global.search | orderBy:\'-DateCreated\'\" ng-click=\"vm.select(form)\" \nng-class=\"{\'selected\' : vm.selected === form}\"><td class=\"eye-icon\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openViewFormDialog(form, $event)\" aria-label=\"Preview form\" translate \ntranslate-attr-aria-label=\"SW.PREVIEW_FORM\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip><span \ntranslate=\"MF.PREVIEW_FORM\">Preview form</span></md-tooltip></md-button></td><td>{{form.DateCreated | altDate}}</td>\n<td>{{form.UserName}}</td><td class=\"form-key\">{{form.FormKey}}</td><td class=\"form-status\"><md-icon \nclass=\"status-pending\" ng-if=\"form.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nclass=\"status-completed\" ng-if=\"form.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></td><td \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(form)\" \naria-label=\"Details\" translate translate-attr-aria-label=\"MF.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\">\n</md-icon></md-button></td></tr></tbody></table><div class=\"md-whiteframe-1dp no-results-item\" \nng-show=\"vm.formSubmissions.length==0\"><div><md-icon md-font-icon=\"icon-comment-account-outline\"></md-icon><span \ntranslate=\"MF.NO_DATA_MSG\" translate-attr-aria-label=\"MF.NO_DATA_MSG\">There is no data to show right now.</span></div>\n</div></md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"process-sidenav\" \nng-include=\"\'app/main/apps/my-company/my-forms/views/form/submissions/sidenavs/process/form-process-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/users/myformusers.html","<div id=\"my-form-users\" flex><md-content><md-list flex><md-subheader class=\"md-no-sticky\">({{vm.users.length}}) Users\n</md-subheader><md-list-item class=\"md-1-line\" ng-repeat=\"user in vm.users\" ng-click=\"null\"><img \nng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar avatar mr-16\" alt=\"user.Email\"><div \nclass=\"md-list-item-text\" layout=\"column\"><p>{{ user.Email }}</p></div><md-divider></md-divider><md-menu \nclass=\"md-secondary\"><md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"MF.MORE\">\n<md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.deleteUserConfirm(user, ev)\" translate=\"MF.DELETE\">Delete User\n</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></md-list><div \nclass=\"md-whiteframe-1dp no-results-item\" ng-show=\"vm.users.length==0\"><div><md-icon \nmd-font-icon=\"icon-comment-account-outline\"></md-icon><span translate=\"MF.NO_DATA_MSG\" \ntranslate-attr-aria-label=\"MF.NO_DATA_MSG\">There is no data to show right now.</span></div></div></md-content>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-user-button\" ng-click=\"vm.openAddUserDialog($event)\" \naria-label=\"add user\" translate translate-attr-aria-label=\"MF.ADD_USER\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/apps/my-company/my-company-messages/sidenavs/left/views/messages/messages-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><span \ntranslate=\"MCM.COMPANY_PAGE_MESSAGES\">Company Page Messages</span><md-menu md-position-mode=\"target-right target\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.setChatGroupFilter(\'ALL\')\" translate=\"MCM.ALL_MESSAGES\">All Messages</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.setChatGroupFilter(\'UNREAD\')\" translate=\"MCM.UNREAD\">Unread</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setChatGroupFilter(\'ARCHIVED\')\" translate=\"MCM.ARCHIVED\">Archived\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div\n class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"vm.chatSearch\" type=\"text\" placeholder=\"Search or start new chat\" translate=\"\" \ntranslate-attr-placeholder=\"MCM.CHAT_SEARCH_PLACEHOLDER\"></div></div></div></md-toolbar><md-content flex ms-scroll>\n<md-list class=\"chat-list\"><div ng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length+1}\" \ntranslate=\"MCM.FILTER_MSG_{{vm.chatFilterGroupName}}\">Filter Group Message</div><md-list-item \nclass=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index+1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length - $index}\" \nng-repeat=\"contact in vm.contacts | orderBy:\'-LastDate\' | filter: {DisplayName: vm.chatSearch} | filter: vm.chatFilterByGroup | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.MsgUID); vm.markRead()\" ng-class=\"{\'unread\':!contact.IsRead}\"><div class=\"avatar-wrapper\">\n<img ng-src=\"{{contact.PhotoURL}}\" class=\"md-avatar avatar\" alt=\"{{contact.DisplayName}}\"> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">\n{{contact.DisplayName}}</h3><p class=\"last-message text-truncate\">{{contact.LastMessage}}</p></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"last-message-time\">{{contact.LastDate | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"filteredChat.length > 0\" class=\"no-results-message\" \ntranslate=\"MCM.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/submissions/dialog/myformview-dialog.html","<md-dialog class=\"viewform-dialog\" aria-label=\"View Form\"><form id=\"viewForm\" name=\"viewForm\" novalidate><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"SW.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div id=\"viewform-content\" class=\"md-whiteframe-2dp\"><ul><li \nng-repeat=\"item in vm.formItems track by $index\"><div bind-html-compile=\"item.html\"></div></li></ul></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" \naria-label=\"Close\" translate=\"SW.CLOSE\" translate-attr-aria-label=\"SW.CLOSE\">CLOSE</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/my-company/my-forms/views/form/submissions/sidenavs/process/form-process-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"title\" translate=\"MF.PROCESS\">Process</div><div class=\"status-icon\"><md-icon \nng-if=\"vm.selected.Status==\'Pending\'\" md-font-icon=\"icon-clock\"></md-icon><md-icon \nng-if=\"vm.selected.Status==\'Completed\'\" md-font-icon=\"icon-check-circle\"></md-icon></div></div><div \nclass=\"subtitle secondary-text\"><span translate=\"MF.FORM_ID\">Form Id</span>: {{vm.selected.FormKey}}</div></div>\n<md-content class=\"content\" flex ms-scroll><md-list class=\"md-dense\" flex><md-list-item class=\"md-3-line\" \nng-repeat=\"item in vm.formTransactions[vm.selected.FormKey] | orderBy:\'DateTime\'\"><img ng-src=\"{{item.PhotoURL}}\" \nclass=\"md-avatar\" alt=\"\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.UserName }}</h3><h4>\n{{ item.DateTime | altDate }}</h4><p>{{ item.Action }}</p></div><md-divider></md-divider></md-list-item></md-list>\n</md-content>");}]);